var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _defs, _path58, _path59, _path60, _path61, _path62, _defs2, _path63, _path64, _path65, _path66, _path67, _defs3, _path68, _path69, _path70, _path71, _path72, _defs4, _path73, _path74, _path75, _path76, _path77, _path78, _g, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _defs5, _path96, _path97, _path98, _path99, _path100, _path101, _defs6, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _defs7, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _defs8, _path117, _path118, _path119, _path120, _path121, _path122, _defs9, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _g2, _path150, _path151, _g3, _path152, _g4, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _g5, _path165, _path166, _g6, _path167, _g7, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _g8, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _defs10, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _defs11, _path208, _defs12, _path209, _path210, _path211, _g9, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _g10, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _g11, _g12, _g13, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _defs13, _path296, _defs14, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _g14, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _g15, _g16, _g17, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _defs15, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _defs16, _path408, _path409, _path410, _path411, _path412, _path413, _defs17, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _defs18, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _defs19, _path429, _path430, _path431, _path432, _path433, _path434, _defs20, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _g18, _path462, _path463, _g19, _path464, _g20, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _g21, _path477, _path478, _g22, _path479, _g23, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _g24, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _defs21, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _defs22, _path521, _path522, _path523, _path524, _path525, _defs23, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _defs24, _path561, _path562, _path563, _path564, _path565, _defs25, _path566, _path567, _path568, _path569, _path570, _defs26, _path571, _path572, _path573, _path574, _path575, _defs27, _path576, _path577, _path578, _path579, _path580, _path581, _g25, _path582, _defs28, _path583, _defs29, _path584, _path585, _path586, _g26, _path587, _g27, _g28, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _g29, _path596, _path597, _g30, _defs30, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _g31, _g32, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _g33, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _g34, _g35, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _g36, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _g37, _g38, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _g39, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _g40, _g41, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _g42, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _g43, _g44, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _g45, _path848, _path849, _path850, _path851, _path852, _defs31, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _g46, _path896, _path897, _path898, _path899, _path900, _path901, _g47, _path902, _g48, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _defs32, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _g49, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _g50, _g51, _g52, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _defs33, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _g53, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _g54, _g55, _g56, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _defs34, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _g57, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _g58, _g59, _g60, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _defs35, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _g61, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _g62, _path1204, _g63, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _defs36, _path1228, _defs37, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _g64, _g65, _path1249, _path1250, _path1251, _path1252, _g66, _g67, _path1253, _g68, _g69, _path1254, _defs38, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _g70, _g71, _path1275, _path1276, _path1277, _path1278, _g72, _g73, _path1279, _g74, _g75, _path1280, _defs39, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _g76, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _g77, _g78, _g79, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _defs40, _path1356, _path1357;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 792.333 544.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    x: 8.319,
    y: 67.564,
    width: 777.675,
    height: 453.334,
    viewBox: "0 0 777.71 453.354",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M777.71 238.298L405.375 453.354 0 219.969l48.705-28.02L359.062 3.756 364.153 0 777.71 238.298z",
    fill: "#CDCCCF"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 8.319,
    y: 52.798,
    width: 777.675,
    height: 448.648,
    viewBox: "0 0 777.712 448.645",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M777.712 233.582L405.379 448.645l-21.793-12.534-1.893-1.089-146.503-84.53-1.903-1.089L0 215.253l48.708-28.023L330.985 24.088 372.295 0l405.417 233.582z",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 57.206,
    y: 252.003,
    width: 148.642,
    height: 88.051,
    viewBox: "0 0 148.613 88.053",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.339v-2.283l131.243 75.571v2.426L0 12.339z",
    fill: "#C19424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.243 85.627l17.37-9.996v2.371l-17.37 10.051v-2.426z",
    fill: "#EAC72F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.056l131.246 75.571 17.367-9.995L17.367 0 0 10.056z",
    fill: "#FFEF75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23 10.047l126.016 72.569 12.137-6.984-28.223-16.373-59.233-34.094L17.375 3.019 5.23 10.047z",
    fill: "#DBDBDB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 112.274,
    y: 232.824,
    width: 133.429,
    height: 77.372,
    viewBox: "0 0 133.434 77.39",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.013L75.131 77.39l54.925-31.711 1.541.89 1.837-1.056-5.484-3.169-1.837 1.056 2.107 1.218-53.089 30.65L40.077 55.03 93.18 24.471l1.883 1.088 1.837-1.056-5.484-3.169-1.837 1.056 1.762 1.018-53.103 30.56-34.589-19.97L56.173 3.142l1.873 1.083 1.837-1.056L54.4 0l-1.837 1.056 1.782 1.03L0 34.013z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 472.151,
    y: 269.385,
    width: 268.125,
    height: 156.814,
    viewBox: "0 0 268.122 156.805",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268.122 12.339v-2.283L17.37 154.379v2.426L268.122 12.339z",
    fill: "#EAC72F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.37 154.379L0 144.383v2.371l17.37 10.051v-2.426z",
    fill: "#C19424"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268.122 10.056L17.367 154.379.001 144.384 250.755 0l17.367 10.056z",
    fill: "#FFEF75"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.892 10.047L17.367 151.368 5.23 144.384l147.732-85.125 59.233-34.094L250.747 3.02l12.145 7.027z",
    fill: "#DBDBDB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 375.883,
    y: 80.532,
    width: 268.125,
    height: 156.814,
    viewBox: "0 0 268.122 156.805",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M.001 12.339L0 10.056l250.752 144.323v2.426L.001 12.339z",
    fill: "#EAC72F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M250.752 154.38l17.37-9.997v2.371l-17.37 10.051v-2.425z",
    fill: "#C19424"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.056l250.755 144.323 17.367-9.995L17.367 0 0 10.056z",
    fill: "#FFEF75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23 10.048l245.525 141.321 12.137-6.985-147.731-85.125-59.233-34.093L17.376 3.02 5.23 10.048z",
    fill: "#DBDBDB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 580.939,
    y: 236.202,
    width: 133.429,
    height: 77.372,
    viewBox: "0 0 133.433 77.39",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.433 34.013L58.302 77.39 3.377 45.679l-1.541.89L0 45.513l5.483-3.169L7.32 43.4l-2.107 1.217 53.089 30.651L93.356 55.03 40.253 24.471l-1.883 1.088-1.837-1.056 5.484-3.169 1.837 1.056-1.762 1.018 53.103 30.56 34.589-19.97L77.26 3.142l-1.873 1.083-1.837-1.056L79.033 0l1.837 1.056-1.782 1.029 54.345 31.928z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 507.41,
    y: 278.539,
    width: 133.429,
    height: 77.372,
    viewBox: "0 0 133.434 77.39",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M133.434 34.013L58.303 77.39 3.377 45.679l-1.54.89L0 45.513l5.483-3.169L7.32 43.4l-2.106 1.218 53.089 30.65L93.356 55.03 40.254 24.471l-1.883 1.088-1.837-1.056 5.483-3.169 1.837 1.056-1.761 1.018 53.103 30.56 34.588-19.97L77.261 3.142l-1.874 1.083-1.836-1.056L79.034 0l1.837 1.056-1.782 1.03 54.345 31.927z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 433.882,
    y: 320.875,
    width: 133.429,
    height: 77.372,
    viewBox: "0 0 133.434 77.39",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.434 34.013L58.302 77.39 3.377 45.679l-1.54.89L0 45.513l5.483-3.169L7.32 43.4l-2.107 1.218 53.089 30.651L93.356 55.03 40.254 24.471l-1.883 1.088-1.837-1.056 5.483-3.169 1.837 1.056-1.762 1.018 53.103 30.56 34.589-19.97L77.261 3.142l-1.874 1.083-1.837-1.056L79.034 0l1.837 1.056-1.782 1.03 54.345 31.927z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 43.816,
    y: 67.837,
    width: 708.029,
    height: 421.023,
    viewBox: "0 0 708.032 421.025",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M708.032 213.16l-1.43.823-358.546 207.042-1.893-1.089L704.235 213.16 338.145 2.187l-39.026 22.618L3.797 195.454l140.557 80.839 83.423-48.026.474.275 78.282 45.186-106.873 61.678-1.903-1.089 104.99-60.589-74.97-43.274-83.423 48.026-.474-.274L0 195.454 338.145 0l.473.275L708.032 213.16z",
    fill: "#FFEF75"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 340.386,
    y: 350.734,
    width: 146.819,
    height: 139.76,
    viewBox: "0 0 48.43 29.748",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M.475 0l47.954 27.58-.476.27L0 .27.475 0z",
    fill: "#F9F9F9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.953 27.85l.002 1.898L.001 2.167 0 .27l47.953 27.58z",
    fill: "#DADADA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.429 27.58l-.476.27.002 1.898.475-.271-.001-1.897z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 379.686,
    y: 352.696,
    width: 46.193,
    height: 26.808,
    viewBox: "0 0 2.544 1.91",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2.544.738L1.285 1.91 0 1.172 1.259 0l1.285.738z",
    fill: "#B0131F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 380.954,
    y: 352.696,
    width: 1.981,
    height: 0.872,
    viewBox: "0 0 1.923 0.915",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1.923.738l-.638.177L0 .177.638 0l1.285.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 382.776,
    y: 354.439,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.181 2.089",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.543.917L1.284 2.089 0 1.352 1.259.18l1.284.737z",
    fill: "#B0131F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.181.738l-.639.177L1.258.178 1.896 0l1.285.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 385.866,
    y: 356.183,
    width: 3.169,
    height: 2.125,
    viewBox: "0 0 3.18 2.089",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.542.916L1.283 2.089 0 1.351 1.259.179l1.283.737z",
    fill: "#B0131F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18.738l-.639.177L1.258.177 1.896 0 3.18.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 388.956,
    y: 357.981,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.179 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.541.916L1.283 2.088 0 1.351 1.259.179l1.282.737z",
    fill: "#B0131F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.179.737L2.54.914 1.258.177 1.896 0l1.283.737z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 392.046,
    y: 359.724,
    width: 3.169,
    height: 2.125,
    viewBox: "0 0 3.178 2.089",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54.916L1.282 2.089 0 1.351 1.259.179 2.54.916z",
    fill: "#B0131F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M3.178.738l-.639.177L1.257.177 1.896 0l1.282.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 395.057,
    y: 361.523,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.178 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.539.915L1.281 2.088 0 1.351 1.258.179l1.281.736z",
    fill: "#B0131F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M3.178.737l-.64.177L1.257.177 1.896 0l1.282.737z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 398.147,
    y: 363.266,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.178 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.539.916L1.281 2.088 0 1.351 1.259.179l1.28.737z",
    fill: "#B0131F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M3.178.738l-.64.176-1.28-.737L1.897 0l1.281.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 401.237,
    y: 365.064,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.177 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2.538.915L1.28 2.088 0 1.351 1.259.179l1.279.736z",
    fill: "#B0131F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M3.177.738l-.64.176L1.258.177 1.897 0l1.28.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 404.328,
    y: 366.808,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.176 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.537.915L1.279 2.088 0 1.351 1.259.179l1.278.736z",
    fill: "#B0131F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.176.738l-.64.176L1.258.178 1.896 0l1.28.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 407.338,
    y: 368.551,
    width: 3.169,
    height: 2.125,
    viewBox: "0 0 3.175 2.087",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2.536.914L1.279 2.087 0 1.351 1.259.179l1.277.735z",
    fill: "#B0131F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M3.175.738l-.64.176L1.258.177 1.896 0l1.279.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 410.428,
    y: 370.349,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.175 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2.535.915L1.278 2.088 0 1.352 1.259.18l1.276.735z",
    fill: "#B0131F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3.175.738l-.641.176L1.258.178 1.896 0l1.279.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 413.519,
    y: 372.093,
    width: 3.169,
    height: 2.125,
    viewBox: "0 0 3.174 2.087",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2.534.914L1.277 2.087 0 1.351 1.259.179l1.275.735z",
    fill: "#B0131F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.174.738l-.641.175L1.257.177 1.896 0l1.278.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 416.609,
    y: 373.891,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.173 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2.533.914L1.276 2.088 0 1.352 1.258.18l1.275.734z",
    fill: "#B0131F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.173.738l-.64.176L1.257.178 1.896 0l1.277.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 419.62,
    y: 375.635,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.172 2.087",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2.532.913L1.275 2.087 0 1.351 1.258.179l1.274.734z",
    fill: "#B0131F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3.172.738l-.641.175L1.257.177 1.896 0l1.276.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.71,
    y: 377.378,
    width: 3.169,
    height: 2.125,
    viewBox: "0 0 3.173 2.086",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2.532.913L1.275 2.086 0 1.351 1.259.179l1.273.734z",
    fill: "#B0131F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M3.173.737l-.641.176L1.258.177 1.897 0l1.276.737z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 386.896,
    y: 354.494,
    width: 1.347,
    height: 2.125,
    viewBox: "0 0 0.476 0.967",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.811V.12L.207.274v.693L.476.811z",
    fill: "#DDD"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M.207.274L0 .155v.692l.207.12V.274z",
    fill: "#B3B3B3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.12L.207.274 0 .155.269 0l.207.12z",
    fill: "#DDD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 386.896,
    y: 354.494,
    width: 1.347,
    height: 1.58,
    viewBox: "0 0 1.374 1.616",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M.16.143L.347.45l.461.752.228.37.163-.093.007-.004.01-.005V1.47a.344.344 0 00.138-.21.281.281 0 00.007-.03l.004-.021a.417.417 0 00.004-.035l.002-.02.002-.058C1.369.72 1.096.265.764.079A.68.68 0 00.708.052C.566-.014.439-.015.342.038V.037L.158.143z",
    fill: "url(#paint0_linear_0_9779)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .519c.005.376.278.83.611 1.018.333.186.6.033.594-.343C1.2.818.927.363.595.176.26-.01-.006.143 0 .519z",
    fill: "#D98B2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9779",
    x1: 1.304,
    x2: 0.465,
    y1: 1.42,
    y2: -0.034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#E3AD38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FFC340"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 396.087,
    y: 359.724,
    width: 1.347,
    height: 2.179,
    viewBox: "0 0 0.475 0.967",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M.475.811V.12L.207.274v.693L.475.811z",
    fill: "#DDD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M.207.274L0 .155v.692l.207.12V.274z",
    fill: "#B3B3B3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M.475.12L.207.274 0 .155.268 0l.207.12z",
    fill: "#DDD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 396.087,
    y: 359.724,
    width: 1.347,
    height: 1.635,
    viewBox: "0 0 1.374 1.618",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M.16.144l.188.308.461.752.228.37.163-.093.007-.004.01-.005V1.47a.344.344 0 00.145-.24l.004-.021.004-.035.002-.02a1.09 1.09 0 00.002-.058C1.369.72 1.096.266.764.079A.68.68 0 00.708.052C.566-.014.439-.015.342.038V.037L.158.144z",
    fill: "url(#paint0_linear_0_9776)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .52c.005.377.278.832.611 1.019.333.186.6.033.595-.343C1.201.82.928.365.596.178.261-.008-.005.145 0 .52z",
    fill: "#D98B2A"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9776",
    x1: 1.305,
    x2: 0.465,
    y1: 1.422,
    y2: -0.033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#E3AD38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FFC340"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 405.278,
    y: 365.01,
    width: 1.347,
    height: 2.179,
    viewBox: "0 0 0.476 0.967",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.811V.12L.207.275v.692L.476.811z",
    fill: "#DDD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M.207.275L0 .155v.692l.207.12V.275z",
    fill: "#B3B3B3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.12L.207.275 0 .155.268 0l.208.12z",
    fill: "#DDD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 405.278,
    y: 365.01,
    width: 1.347,
    height: 1.635,
    viewBox: "0 0 1.374 1.615",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M.16.142L.347.45l.461.752.228.37.163-.093.007-.004.01-.005V1.47a.344.344 0 00.138-.21.282.282 0 00.007-.03l.004-.021a.417.417 0 00.004-.035l.002-.02.002-.057C1.369.72 1.096.266.764.079A.68.68 0 00.708.052C.566-.014.438-.015.342.038V.037L.158.142z",
    fill: "url(#paint0_linear_0_9769)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .518c.004.376.278.83.611 1.018.333.186.6.033.595-.343C1.201.817.928.362.596.175.26-.011-.005.143 0 .518z",
    fill: "#D98B2A"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9769",
    x1: 1.304,
    x2: 0.465,
    y1: 1.419,
    y2: -0.035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#E3AD38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FFC340"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 414.469,
    y: 370.295,
    width: 1.347,
    height: 2.125,
    viewBox: "0 0 0.476 0.967",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.811V.12L.208.274v.693L.476.811z",
    fill: "#DDD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M.208.274L0 .155v.692l.208.12V.274z",
    fill: "#B3B3B3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.12L.208.274 0 .155.269 0l.207.12z",
    fill: "#DDD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 414.469,
    y: 370.295,
    width: 1.347,
    height: 1.635,
    viewBox: "0 0 1.374 1.617",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M.16.144l.188.308.461.752.228.37.163-.093.007-.004.01-.005V1.47a.344.344 0 00.138-.21.281.281 0 00.007-.03l.004-.021.004-.035.002-.02.002-.058C1.369.722 1.096.266.764.079A.68.68 0 00.708.052C.566-.014.438-.015.342.038V.037L.158.144z",
    fill: "url(#paint0_linear_0_10727)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .52c.005.376.278.83.611 1.018.333.186.6.033.595-.343C1.201.819.928.364.596.177.261-.01-.005.144 0 .52z",
    fill: "#D98B2A"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_10727",
    x1: 1.305,
    x2: 0.465,
    y1: 1.421,
    y2: -0.033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#E3AD38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FFC340"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 397.197,
    y: 360.16,
    width: 7.844,
    height: 11.115,
    viewBox: "0 0 7.804 11.067",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85 2.147L2.098 0 .531 1.29.508 4.864l1.947 3.74 3.758 2.143 1.574-1.261.017-3.571L5.85 2.147z",
    fill: "#EEE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M5.697 2.255L1.945.109.024 1.61 0 5.185l1.948 3.74 3.758 2.142 1.928-1.472.017-3.571-1.954-3.769z",
    fill: "#A80808"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M2.153 8.718L.282 5.11l.023-3.337L1.946.434l3.545 2.028 1.878 3.637-.016 3.332-1.648 1.311-3.552-2.024z",
    fill: "#DADADA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M2.359 8.511L.565 5.036l.021-3.1L1.947.759l3.338 1.91 1.802 3.505-.016 3.094-1.367 1.15-3.345-1.907z",
    fill: "#A80808"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M7.804 5.915l-.153.109-.017 3.571.153-.109.017-3.571z",
    fill: "#C4C4C4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85 2.147l-.153.108 1.954 3.769.153-.109L5.85 2.147z",
    fill: "#DEDEDE"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 398.227,
    y: 363.593,
    width: 5.626,
    height: 4.631,
    viewBox: "0 0 5.662 4.652",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DADADA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.089 1.915c0 .193-.052.311-.155.355-.103.043-.253.009-.447-.102A2.006 2.006 0 010 1.783v-.38c.164.194.314.33.451.409.077.045.136.058.175.04.04-.017.059-.062.059-.132a.475.475 0 00-.07-.23 2.527 2.527 0 00-.232-.322 2.407 2.407 0 01-.214-.3A1.247 1.247 0 01.057.617.868.868 0 01.017.35C.017.174.069.063.173.02c.104-.044.245-.015.42.085.168.096.329.232.484.41l-.135.23A3.147 3.147 0 00.792.59.855.855 0 00.623.462C.557.424.506.415.471.436.436.456.418.502.418.573c0 .07.021.142.064.219.042.076.117.177.222.304.143.172.242.32.298.447a.877.877 0 01.087.372zM2.03 3.023l-.406-.232V1.064l-.419-.24V.487l1.244.713v.337l-.419-.24v1.726zM4.149 3.202c0 .342-.068.565-.204.67-.136.107-.33.088-.583-.057a1.472 1.472 0 01-.584-.61 1.938 1.938 0 01-.204-.907c0-.342.068-.564.204-.67.136-.104.331-.082.587.063.253.145.446.347.581.608.136.26.203.56.203.903zm-1.158-.664c0 .236.031.433.094.592a.66.66 0 00.277.344c.246.14.369-.03.369-.512s-.122-.793-.366-.932c-.124-.071-.217-.063-.28.024-.062.087-.094.248-.094.484zM5.662 3.674c0 .22-.059.354-.176.403-.118.05-.287.012-.509-.115l-.102-.058v.748l-.407-.233V2.355l.556.319c.425.242.638.577.638 1zm-.787-.103l.078.045c.1.057.174.074.223.05.049-.024.073-.094.073-.212a.549.549 0 00-.067-.279.553.553 0 00-.208-.198l-.099-.057v.65z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 425.324,
    y: 407.673,
    width: 37.794,
    height: 21.849,
    viewBox: "0 0 37.789 21.823",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .586l36.804 21.237.985-.55L.983 0 0 .586z",
    fill: "#FFEF75"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 367.484,
    y: 416.5,
    width: 44.688,
    height: 25.827,
    viewBox: "0 0 44.676 25.784",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M44.676.585L.985 25.784 0 25.234 43.694 0l.982.585z",
    fill: "#FFEF75"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 340.386,
    y: 403.205,
    width: 146.819,
    height: 87.288,
    viewBox: "0 0 146.874 87.311",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M146.87 33.922v-2.568L54.297 84.582v2.729l92.573-53.389z",
    fill: "#EAC72F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M54.297 84.582L0 53.293v2.667l54.297 31.351v-2.729z",
    fill: "#C19424"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M146.874 31.356l-92.58 53.226L.001 53.294l14.841-8.546 2.937 1.703L84.416 8.096 81.47 6.392 92.581 0l54.293 31.356z",
    fill: "#FFEF75"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M140.991 31.346L54.294 81.195 5.884 53.294l11.895-6.843L84.416 8.096l8.155-4.699 48.42 27.949z",
    fill: "#DBDBDB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M84.416 8.096L17.779 46.451l-2.937-1.703L81.47 6.392l2.946 1.704z",
    fill: "#C19424"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M96.272 15.506a.942.942 0 01-.49.852L34.617 51.65a7.81 7.81 0 01-3.906 1.047 7.8 7.8 0 01-3.896-1.047l-9.036-5.198L84.417 8.096l11.366 6.559a.96.96 0 01.489.851z",
    fill: "#C3C2C2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 368.435,
    y: 379.994,
    width: 92.861,
    height: 95.788,
    viewBox: "0 0 92.826 95.798",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M92.826 20.134v42.13L34.874 95.798V53.564l57.952-33.43z",
    fill: "#CFC091"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M34.874 53.564v42.234L.002 75.666V33.475l34.872 20.089z",
    fill: "#998C62"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M92.822 20.133L34.869 53.567 0 33.472 57.955 0l34.867 20.133z",
    fill: "#FACB6B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 405.516,
    y: 431.975,
    width: 13.866,
    height: 29.205,
    viewBox: "0 0 13.804 29.215",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.976v21.239l13.804-7.976V0L0 7.976z",
    fill: "#FFDE9C"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13.067 1.354v19.264l-.087.044-.104.06-.998.582-1.815 1.059-2.691 1.563L.74 27.763V8.473l5.747-3.325 5.391-3.116.998-.573.07-.044.121-.061z",
    fill: "#90C7C7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M12.876 1.459v19.265l-.997.579V2.036l.997-.577z",
    fill: "url(#paint0_linear_0_12873)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M12.979 20.664L.738 27.763V26.46l11.141-6.431 1.1.635z",
    fill: "url(#paint1_linear_0_12873)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.371l-.001-18.702.553-.318.001 19.263L.739 27.763v-.268l11.773-7.124z",
    fill: "#CF9219"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.371l.553.243L.739 27.763v-.576l11.773-6.816z",
    fill: "#FFEF75"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12873",
    x1: 11.407,
    x2: 12.806,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_12873",
    x1: 6.22,
    x2: 7.357,
    y1: 23.038,
    y2: 25.131
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 418.59,
    y: 424.455,
    width: 13.866,
    height: 29.205,
    viewBox: "0 0 13.804 29.216",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.976v21.24l13.804-7.977V0L0 7.976z",
    fill: "#FFDE9C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M13.067 1.351v19.263l-.095.044-.096.069-.998.573-.478.278-4.027 2.344-2.414 1.398L.74 27.759V8.478l7.101-4.106 4.037-2.336.998-.581.191-.104z",
    fill: "#90C7C7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 1.459v19.265l-.996.579V2.036l.996-.577z",
    fill: "url(#paint0_linear_0_14558)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12.979 20.664L.738 27.763V26.46l11.141-6.43 1.1.634z",
    fill: "url(#paint1_linear_0_14558)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M12.511 20.371V1.669l.553-.318v19.263L.739 27.763v-.268l11.772-7.124z",
    fill: "#CF9219"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12.511 20.371l.553.243L.739 27.763v-.576l11.772-6.816z",
    fill: "#FFEF75"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_14558",
    x1: 11.407,
    x2: 12.806,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_14558",
    x1: 6.22,
    x2: 7.357,
    y1: 23.038,
    y2: 25.131
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 385.153,
    y: 430.721,
    width: 13.866,
    height: 29.205,
    viewBox: "0 0 13.804 29.215",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M13.804 7.976v21.239L0 21.239V0l13.804 7.976z",
    fill: "#D9A234"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 8.478v19.29h-.009v-.009l-6.554-3.794-.078-.043L1.93 21.3l-1.007-.573-.096-.069-.086-.044V1.35l.182.105 1.007.581 1.693.981 6.45 3.733 2.995 1.728z",
    fill: "#538B94"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M.928 1.459v19.265l.996.579V2.036l-.996-.577z",
    fill: "url(#paint0_linear_0_12239)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M.824 20.664l12.241 7.099V26.46L1.924 20.029l-1.1.635z",
    fill: "url(#paint1_linear_0_12239)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1.292 20.371V1.669l-.553-.318v19.263l12.326 7.149v-.268L1.292 20.371z",
    fill: "#EAC72F"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 8.478v8.299l-6.563 7.188-.078-.043L1.93 21.3l-1.007-.573-.096-.069-.086-.044v-3.646L10.073 6.75l2.995 1.728zM3.623 3.017L.741 6.168V1.35l.182.105 1.007.581 1.693.981z",
    fill: "#21362E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1.292 20.371l-.553.243 12.326 7.149v-.576L1.292 20.371z",
    fill: "#FFEF75"
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12239",
    x1: 2.397,
    x2: 0.997,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#0A7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#24828E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#35848C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_12239",
    x1: 7.583,
    x2: 6.447,
    y1: 23.038,
    y2: 25.13
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#0A7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#24828E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#35848C"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 372.08,
    y: 423.148,
    width: 13.866,
    height: 29.205,
    viewBox: "0 0 13.804 29.216",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M13.804 7.976v21.24L0 21.239V0l13.804 7.976z",
    fill: "#D9A234"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 8.474v19.29h-.009l-1.45-.842-5.182-3.004-1.268-.738-3.229-1.875-.999-.582-.104-.06-.087-.053V1.355l.191.104.999.573 6.806 3.933 2.083 1.207.738.425 1.511.877z",
    fill: "#538B94"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M10.819 7.172v4.427l-.086.044-.096.069-1.007.573-4.497 2.622L.74 17.45V1.355l.191.104.999.573 8.889 5.14zM13.068 8.474v1.858l-1.502.868h-.009V7.597l1.511.877z",
    fill: "#B5D6C7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M.928 1.459v19.265l.996.579V2.036l-.996-.577z",
    fill: "url(#paint0_linear_0_13725)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M.825 20.664l12.24 7.099V26.46L1.924 20.029l-1.099.635z",
    fill: "url(#paint1_linear_0_13725)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1.292 20.371V1.669l-.553-.318v19.263l12.326 7.149v-.268L1.292 20.371z",
    fill: "#EAC72F"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 8.474v6.051L5.159 23.18 1.93 21.305l-.999-.582-.104-.06-.087-.053v-5.894l7.996-8.751 2.083 1.207.738.425 1.511.877z",
    fill: "#21362E"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1.292 20.371l-.553.243 12.326 7.149v-.576L1.292 20.371z",
    fill: "#FFEF75"
  })), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_13725",
    x1: 2.397,
    x2: 0.998,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#0A7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#24828E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#35848C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_13725",
    x1: 7.584,
    x2: 6.447,
    y1: 23.038,
    y2: 25.131
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#0A7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#24828E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#35848C"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 431.663,
    y: 416.882,
    width: 13.787,
    height: 29.205,
    viewBox: "0 0 13.805 29.216",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.977v21.239l13.805-7.976V0L0 7.977z",
    fill: "#FFDE9C"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M13.069 1.349v19.264l-.096.052-.095.061-.999.581-.017.009-4.488 2.604-1.068.617-5.565 3.22v.009H.733V8.476l7.561-4.375 3.585-2.066.999-.573.191-.113z",
    fill: "#90C7C7"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M12.876 1.459v19.266l-.996.579V2.036l.996-.577z",
    fill: "url(#paint0_linear_0_12859)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M12.98 20.664l-12.241 7.1v-1.303L11.88 20.03l1.1.634z",
    fill: "url(#paint1_linear_0_12859)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.372V1.67l.553-.319v19.264L.74 27.764v-.268l11.772-7.124z",
    fill: "#CF9219"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.372l.553.243L.74 27.764v-.577l11.772-6.815z",
    fill: "#FFEF75"
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12859",
    x1: 11.408,
    x2: 12.807,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_12859",
    x1: 6.221,
    x2: 7.357,
    y1: 23.039,
    y2: 25.131
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 444.816,
    y: 410.289,
    width: 12.043,
    height: 41.519,
    viewBox: "0 0 12.041 41.479",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M12.041 34.508V0L0 6.954v34.525l12.041-6.971z",
    fill: "#FFDE9C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M11.398 1.177v33.666l-.077.041-.087.057-.872.503-3.928 2.286-5.788 3.348v.006H.641V7.392l9.721-5.62.872-.503.164-.092z",
    fill: "#E5E6E5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M11.398 31.043v3.8l-.077.041-.087.057-.872.503-3.928 2.286-5.788 3.348v.006H.641v-3.827l9.721-5.619.872-.503.164-.092z",
    fill: "#C9C9C9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M10.916 34.631l-.001-33.178.483-.278v33.668L.643 41.081v-.234l10.273-6.216z",
    fill: "#CF9219"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M10.916 34.631l.721.296L.643 41.249v-.671l10.273-5.947z",
    fill: "#DBDBDB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 368.435,
    y: 397.484,
    width: 92.861,
    height: 39.285,
    viewBox: "0 0 92.825 39.256",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M92.825 0v6.222L39.83 36.796c-.061.035-5.134 3.148-7.119 2.32-.517-.216-1.042-.408-1.528-.695L4.271 22.916 0 20.459V13.34l34.873 20.089L92.825 0z",
    fill: "#CFCECB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 365.899,
    y: 365.282,
    width: 97.932,
    height: 68.272,
    viewBox: "0 0 97.95 68.29",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M97.95 22.222v11.952l-.078.009a2.548 2.548 0 01-.972 1.476 1.929 1.929 0 01-.26.174L42.395 67.128c-.06.035-.113.061-.174.096a8.608 8.608 0 01-6.945.599 8.274 8.274 0 01-1.528-.695L6.836 51.623l-5.53-3.186a2.562 2.562 0 01-1.189-1.528H.108v-.026s-.104-.59-.104-1.155V34.661l6.832-.877 9.602 1.387 14.064-8.117 25.05-17.09a8.66 8.66 0 018.655 0L85.572 24.92l1.094.634L96.71 22.3l1.24-.078z",
    fill: "#D9D7D0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9 22.3v10.739c-.078 2.681-.165 2.741-.26 2.793L42.395 67.127c-.06.035-.113-9.417-.174-12.003L45.906 22.3H96.9z",
    fill: "#E6E4DD"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M35.253 43.006l.022 24.815s-1.042-.408-1.528-.695L2.555 49.156l.01-11.422 13.872-2.563 14.064-8.117 4.752 15.952z",
    fill: "#B6B4AE"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M2.556 34.331v14.826l-1.25-.72a2.562 2.562 0 01-1.189-1.528H.108v-.026s-.104-.59-.104-1.155V34.661l2.552-.33z",
    fill: "#ADABA5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1.304 32.49L55.547 1.161a8.66 8.66 0 018.663 0l32.433 18.728c1.74 1.004 1.74 3.515 0 4.519L42.398 55.702a8.66 8.66 0 01-8.652.001L1.307 37.008c-1.742-1.002-1.743-3.513-.003-4.518z",
    fill: "#F4F4F4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M38.071 55.125a6.937 6.937 0 01-3.458-.925L2.173 35.505a.857.857 0 01-.438-.755c0-.151.042-.528.436-.756L56.414 2.665a6.939 6.939 0 013.464-.928c1.214 0 2.411.321 3.463.928l32.433 18.728a.857.857 0 01.436.756.855.855 0 01-.436.755L41.53 54.198a6.932 6.932 0 01-3.459.927z",
    fill: "#898989"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M96.214 22.151c0 .148-.043.53-.443.755l-1.884 1.085-30.549-17.64a6.907 6.907 0 00-3.455-.92c-.45 0-.894.043-1.337.13a6.698 6.698 0 00-2.127.79L4.06 36.595l-1.885-1.094a.836.836 0 01-.434-.755.85.85 0 01.434-.755L56.42 2.662a6.698 6.698 0 012.127-.79 6.914 6.914 0 014.792.79l32.433 18.734c.4.225.443.599.443.755z",
    fill: "#D9D7D0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M96.214 22.151c0 .148-.043.53-.443.755l-1.884 1.085-30.549-17.64a6.907 6.907 0 00-3.455-.92c-.45 0-.894.043-1.337.13v-3.69a6.914 6.914 0 014.792.79l32.433 18.734c.4.226.443.6.443.756z",
    fill: "#B6B4AE"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 406.229,
    y: 372.583,
    width: 25.909,
    height: 14.875,
    viewBox: "0 0 25.899 14.901",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.782L15.31 0l10.589 6.119-15.311 8.782L0 8.782z",
    fill: "#545454"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 420.65,
    y: 379.885,
    width: 23.849,
    height: 14.875,
    viewBox: "0 0 23.779 14.901",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.872L13.19 0l10.589 6.119-15.311 8.782L0 9.872z",
    fill: "#545454"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 410.112,
    y: 370.186,
    width: 25.909,
    height: 19.561,
    viewBox: "0 0 25.899 14.901",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.781L15.31 0l10.589 6.118-15.311 8.783L0 8.781z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 419.54,
    y: 372.42,
    width: 11.568,
    height: 7.628,
    viewBox: "0 0 11.541 7.623",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01.253C5.09-.498 1.701.48.466 2.436a2.95 2.95 0 00-.34.72 2.499 2.499 0 00.08 1.777c.152.367.387.71.692 1.02.616.64 1.528 1.134 2.633 1.417.184.048.371.09.56.122a8.583 8.583 0 003.896-.214c1.343-.402 2.474-1.128 3.087-2.09.035-.052.066-.106.097-.16.43-.761.485-1.571.162-2.343C10.864 1.56 9.653.672 8.01.253z",
    fill: "#849FA1"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 419.936,
    y: 372.529,
    width: 11.568,
    height: 7.628,
    viewBox: "0 0 11.542 7.622",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01.253C5.09-.498 1.701.48.466 2.435c-.15.235-.266.476-.34.722a2.498 2.498 0 00.08 1.776c.152.367.387.71.693 1.02.616.64 1.527 1.134 2.633 1.417a8.583 8.583 0 004.457-.093c1.342-.402 2.473-1.128 3.087-2.09.035-.052.066-.106.097-.16.43-.761.484-1.571.162-2.343C10.865 1.56 9.652.673 8.01.253z",
    fill: "#C3C9C9"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 420.887,
    y: 376.888,
    width: 3.169,
    height: 3.16,
    viewBox: "0 0 3.193 3.109",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M3.193 1.677L0 0v1.572c.616.639 1.527 1.133 2.633 1.416.184.048.371.09.56.121V1.677z",
    fill: "#AEBABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 424.057,
    y: 378.523,
    width: 3.882,
    height: 1.635,
    viewBox: "0 0 3.898 1.628",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M3.898 0L.001.065 0 1.497a8.583 8.583 0 003.897-.214L3.898 0z",
    fill: "#C3C9C9"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 427.939,
    y: 376.343,
    width: 3.169,
    height: 3.487,
    viewBox: "0 0 3.184 3.448",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M3.184 0L.001 2.165 0 3.448c1.342-.402 2.473-1.128 3.087-2.09a2.62 2.62 0 00.097-.16V0z",
    fill: "#DCE0E0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 419.936,
    y: 375.689,
    width: 0.951,
    height: 2.779,
    viewBox: "0 0 0.899 2.797",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M.126 0a2.498 2.498 0 00.08 1.776c.152.367.387.71.693 1.021V1.225L.126 0z",
    fill: "#9CADAD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 410.112,
    y: 378.958,
    width: 10.538,
    height: 10.788,
    viewBox: "0 0 10.588 10.79",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M10.588 6.12L0 0v4.671l10.588 6.119V6.12z",
    fill: "#B4BABD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 420.65,
    y: 376.289,
    width: 15.371,
    height: 13.458,
    viewBox: "0 0 15.311 13.453",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M15.311 4.67V0L0 8.783v4.67L15.311 4.67z",
    fill: "#CDCFCE"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 420.333,
    y: 372.42,
    width: 10.696,
    height: 7.029,
    viewBox: "0 0 10.741 7.018",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.779C.56 6.077-.727 4.045.419 2.239c1.145-1.806 4.29-2.701 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.146 1.806-4.292 2.7-7.027 2z",
    fill: "#B3B8B8"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 421.6,
    y: 373.946,
    width: 8.636,
    height: 5.449,
    viewBox: "0 0 8.659 5.457",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M8.322 3.852c-.825 1.301-4.688 1.563-5.504 1.605-.071-.086-.208-.118-.3-.034C.41 4.824-.567 3.228.337 1.804 1.26.348 3.797-.373 6.003.193c2.204.565 3.243 2.203 2.319 3.659z",
    fill: "#555D69"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 420.808,
    y: 372.747,
    width: 9.508,
    height: 6.266,
    viewBox: "0 0 9.478 6.242",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#BFC4C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.245 4.582c-1.123-.574-2.523-1.485-2.523-1.485s1.991.212 3.323.56c.76.199 1.884.297 1.243 1.038-.698.807-1.457.187-2.043-.113zM2.233 1.662c1.122.574 2.523 1.486 2.523 1.486s-1.99-.213-3.323-.561C.674 2.387-.452 2.29.19 1.549c.698-.806 1.457-.188 2.043.113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.071 1.444C6.15 2.193 4.7 3.134 4.7 3.134s.394-1.302.975-2.18c.332-.5.518-1.235 1.64-.843 1.217.427.24.94-.243 1.333zM2.407 4.8c.922-.75 2.371-1.691 2.371-1.691s-.394 1.302-.975 2.179c-.33.5-.518 1.235-1.639.843-1.217-.425-.239-.94.243-1.331z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 424.77,
    y: 375.417,
    width: 1.505,
    height: 0.981,
    viewBox: "0 0 1.469 0.972",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M.46.92C.084.797-.098.504.054.265c.15-.24.58-.335.956-.213.376.122.558.414.406.654-.152.24-.58.334-.956.212z",
    fill: "#BFC4C4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 420.333,
    y: 372.42,
    width: 10.696,
    height: 7.029,
    viewBox: "0 0 10.741 7.018",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    height: 8,
    id: "a",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    width: 11,
    x: 0,
    y: 0
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.779C.56 6.077-.727 4.045.419 2.239c1.145-1.806 4.29-2.701 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.146 1.806-4.292 2.7-7.027 2z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83 9.335l.18-.044-.266-1.043 1.468-.363.267 1.043.18-.044-.267-1.044 1.468-.362.267 1.043.18-.044-.267-1.043 1.469-.362.266 1.044.18-.045-.267-1.043 1.468-.363.266 1.044.18-.045-.265-1.043 1.467-.362.267 1.044.18-.045-.266-1.043 1.468-.363.266 1.044.18-.045-.266-1.043 1.429-.353-.034-.131-1.43.353-.273-1.072 1.429-.353-.034-.131-1.43.352-.272-1.072 1.429-.353-.034-.131-1.428.352-.274-1.072 1.428-.352-.034-.132-1.43.352-.272-1.072L11.83.64l-.034-.132-1.43.353-.272-1.073 1.428-.352-.033-.131-1.43.352-.272-1.072 1.428-.353-.034-.132-1.43.353-.265-1.044-.181.045.267 1.043-1.468.362-.267-1.043-.18.045.266 1.043-1.468.362-.267-1.043-.18.043.267 1.044-1.467.362-.267-1.043-.18.044.267 1.043L3.16.078 2.894-.965l-.18.044L2.98.122 1.513.484 1.247-.56l-.181.044.267 1.043L-.135.89-.402-.153l-.18.044.267 1.044-1.43.353.035.13 1.429-.352.274 1.072-1.43.353.035.132L.027 2.27.3 3.342l-1.43.352.035.132 1.429-.353.274 1.072-1.43.352.035.132 1.428-.352.274 1.072-1.43.353.035.132L.95 5.88l.274 1.07-1.43.354.035.132 1.429-.353.274 1.072-1.43.352.034.132 1.429-.352.266 1.047zm1.528-1.626l-.274-1.072 1.468-.363.274 1.072-1.468.363zm2.374-4.425l-.274-1.072 1.468-.363.274 1.073-1.468.362zm1.502-.23l.274 1.072-1.47.362-.273-1.071 1.469-.363zm-1.682.275l-1.468.362-.274-1.072 1.468-.363.274 1.073zm.033.132l.275 1.072-1.468.362-.275-1.072 1.468-.362zm.308 1.203l.274 1.072-1.468.362-.274-1.072 1.468-.362zm.18-.045l1.467-.361.274 1.072-1.468.363-.273-1.074zm1.648-.406l1.468-.362.274 1.073-1.467.362-.275-1.073zm-.034-.132l-.274-1.072 1.467-.362.274 1.072-1.467.362zm-.308-1.203l-.273-1.072 1.468-.363.274 1.073-1.47.362zm-.306-1.204L6.799.602 8.267.24l.274 1.072-1.468.362zm-.181.044l-1.468.363-.274-1.072L6.618.647l.274 1.07zm-1.648.407l-1.468.362-.274-1.072 1.468-.362.274 1.072zm-1.648.407l-1.468.362-.274-1.072 1.468-.362.274 1.072zm.034.13l.273 1.074-1.467.362-.274-1.072 1.468-.363zm.308 1.205l.273 1.072-1.468.362-.273-1.072 1.468-.362zm.307 1.204l.274 1.072-1.468.363-.274-1.073 1.468-.362zm.762 2.23L4.732 6.23 6.2 5.867l.274 1.072-1.467.363zm1.648-.406l-.273-1.072 1.467-.362.274 1.072-1.468.362zm1.648-.406l-.274-1.072 1.468-.362.274 1.072-1.468.362zm3.116-.77l-1.468.363-.274-1.072 1.468-.362.274 1.072zm-.308-1.203l-1.467.362-.274-1.072 1.468-.362.273 1.072zm-.307-1.204l-1.468.362-.274-1.072 1.469-.362.273 1.072zm-.308-1.203l-1.468.362-.274-1.072 1.468-.363.274 1.073zM10.188.905l-1.468.362L8.446.195l1.468-.362.274 1.072zM9.606-1.37L9.88-.298 8.413.064l-.274-1.072 1.467-.362zm-1.647.407L8.232.109 6.765.47 6.49-.601l1.468-.362zm-1.65.406L6.585.515 5.116.877 4.842-.196 6.31-.557zM4.663-.15L4.936.922l-1.47.362L3.194.212 4.662-.15zM3.014.256l.274 1.072-1.468.363L1.546.618 3.014.256zm-3.115.769L1.367.663l.274 1.072-1.468.362-.274-1.072zm.307 1.204l1.468-.362.274 1.073-1.467.362-.275-1.073zm.308 1.203L1.98 3.07l.274 1.072-1.468.362-.273-1.072zM.82 4.636l1.468-.362.274 1.072-1.468.363L.82 4.636zm.308 1.204l1.468-.362.275 1.072-1.468.362-.275-1.072zm.307 1.204l1.468-.362.274 1.072-1.468.362-.274-1.072z",
    fill: "#DCE0E0"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 420.333,
    y: 372.42,
    width: 10.696,
    height: 7.029,
    viewBox: "0 0 10.741 7.018",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    height: 8,
    id: "b",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    width: 11,
    x: 0,
    y: 0
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.779C.56 6.077-.727 4.045.419 2.239c1.145-1.806 4.29-2.701 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.146 1.806-4.292 2.7-7.027 2z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.933 8.846l.18-.044-.267-1.043 1.468-.363.267 1.043.18-.044-.267-1.044 1.468-.362.267 1.043.18-.044-.267-1.043 1.469-.362.266 1.044.18-.045-.266-1.043 1.468-.362.266 1.043.18-.045-.265-1.043 1.467-.362.267 1.044.18-.045-.266-1.043 1.468-.363.266 1.044.18-.045-.266-1.043 1.429-.353-.034-.131-1.43.353-.273-1.073 1.429-.352-.034-.131-1.43.353-.273-1.072 1.429-.353-.034-.131-1.43.352-.272-1.072 1.429-.352-.035-.132-1.43.353L9.506.506l1.428-.353-.034-.132-1.43.353-.272-1.072 1.428-.352-.033-.132-1.43.352-.272-1.072 1.428-.353-.034-.132-1.43.353-.265-1.044-.181.045.267 1.044-1.468.362L6.94-2.67l-.18.045.266 1.043-1.468.362-.266-1.043-.18.043.266 1.044-1.468.362-.267-1.043-.18.044L3.73-.77l-1.468.362-.267-1.043-.18.044.267 1.043-1.468.362-.266-1.043-.181.044L.434.042l-1.468.362L-1.3-.64l-.18.044.266 1.044-1.43.353.035.13L-1.18.58l.274 1.072-1.43.352.035.132 1.429-.353.274 1.072-1.43.352.035.132 1.429-.353.273 1.072-1.428.352.034.132 1.428-.352.274 1.072-1.43.353.035.132L.05 5.394l.274 1.072-1.43.353.035.132 1.429-.353.274 1.072-1.43.352.035.132L.667 7.8l.266 1.045zM2.46 7.22l-.274-1.072 1.468-.363.274 1.073-1.468.362zm2.374-4.424L4.56 1.725l1.468-.363.274 1.073-1.468.36zm1.502-.23l.274 1.072L5.143 4l-.274-1.072 1.468-.362zm-1.682.275l-1.468.362-.274-1.072 1.468-.362.274 1.072zm.033.13l.275 1.073-1.468.362-.274-1.072 1.467-.362zm.308 1.205l.274 1.072-1.468.362-.274-1.072 1.468-.362zm.18-.045l1.468-.362.274 1.072-1.468.363-.273-1.073zm1.648-.406l1.468-.362.274 1.072-1.468.362-.274-1.072zm-.034-.132L6.516 2.52l1.468-.362.274 1.072-1.468.362zM6.483 2.39l-.274-1.072L7.677.955l.274 1.072-1.468.363zm-.308-1.204L5.9.114l1.468-.362.274 1.072-1.468.362zm-.18.044l-1.468.363L4.253.52 5.72.159l.274 1.07zm-1.648.407L2.879 2 2.605.928 4.073.566l.274 1.07zm-1.648.407l-1.468.362-.274-1.072L2.425.972l.274 1.072zm.034.13l.273 1.074-1.467.36-.274-1.071 1.468-.362zM3.04 3.38l.273 1.072-1.468.362-.274-1.072 1.469-.362zm.307 1.204l.274 1.072-1.468.363-.274-1.073 1.468-.362zm.762 2.23l-.274-1.071 1.468-.363.274 1.073-1.468.362zm1.647-.406l-.273-1.072 1.467-.362.274 1.072-1.468.362zM7.406 6l-.274-1.072L8.6 4.566l.275 1.072L7.405 6zm3.116-.77l-1.468.363L8.78 4.52l1.468-.362.274 1.072zm-.308-1.202l-1.468.362-.274-1.072 1.468-.362.274 1.072zm-.308-1.204l-1.468.362-.274-1.072 1.469-.362.273 1.072zM9.599 1.62l-1.468.362L7.857.91 9.325.548l.274 1.073zM9.29.416L7.823.779 7.549-.293l1.468-.362.274 1.07zM8.71-1.86l.274 1.072-1.468.362-.274-1.072L8.71-1.86zm-1.648.407L7.335-.38l-1.467.362-.274-1.072 1.468-.362zm-1.65.407L5.688.027 4.219.389 3.945-.683l1.468-.362zM3.766-.64L4.04.433 2.572.795 2.298-.277 3.765-.64zm-1.648.407L2.39.84l-1.468.363L.649.13l1.468-.363zM-.998.536L.47.174l.274 1.072-1.468.362L-.998.536zm.307 1.204l1.468-.362.274 1.072-1.467.362-.275-1.072zm.308 1.204l1.467-.362.274 1.072-1.468.362-.273-1.072zm.307 1.204l1.468-.362.275 1.072-1.468.363-.275-1.073zM.232 5.35L1.7 4.989l.275 1.072-1.468.363L.232 5.35zm.307 1.204l1.468-.362.274 1.072-1.468.362-.274-1.072z",
    fill: "#DCE0E0"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 419.936,
    y: 372.148,
    width: 11.489,
    height: 7.628,
    viewBox: "0 0 11.54 7.621",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53 7.37c2.923.748 6.306-.23 7.545-2.182.514-.81.604-1.676.259-2.502C10.864 1.56 9.653.674 8.009.252 5.088-.498 1.703.482.465 2.435c-.514.81-.604 1.675-.26 2.502.47 1.124 1.682 2.01 3.326 2.433zM1.039 2.596C2.132.87 5.138.016 7.753.686c2.614.67 3.845 2.613 2.75 4.339-1.095 1.725-4.101 2.58-6.714 1.91-2.615-.67-3.846-2.613-2.751-4.34z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.472,
    y: 377.433,
    width: 25.909,
    height: 19.561,
    viewBox: "0 0 25.9 14.901",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.782L15.31 0 25.9 6.119l-15.311 8.782L0 8.782z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 431.901,
    y: 379.721,
    width: 11.568,
    height: 7.628,
    viewBox: "0 0 11.542 7.623",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01.253C5.09-.498 1.701.48.466 2.436c-.15.235-.266.476-.34.72a2.498 2.498 0 00.08 1.777c.152.367.387.71.693 1.02.616.64 1.528 1.134 2.633 1.417.184.049.371.09.56.122a8.582 8.582 0 003.896-.214c1.343-.402 2.474-1.128 3.087-2.09.035-.052.066-.106.097-.16.43-.761.485-1.571.162-2.343C10.864 1.56 9.652.673 8.01.253z",
    fill: "#849FA1"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 432.297,
    y: 379.83,
    width: 11.568,
    height: 7.628,
    viewBox: "0 0 11.543 7.623",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01.253C5.09-.498 1.703.482.468 2.436c-.15.235-.265.476-.34.722a2.493 2.493 0 00.079 1.776c.153.367.388.71.694 1.02.616.64 1.527 1.134 2.633 1.417.184.048.37.09.56.122a8.583 8.583 0 003.897-.214c1.343-.402 2.473-1.128 3.087-2.09.035-.052.066-.106.097-.16.43-.761.484-1.57.162-2.343C10.865 1.56 9.653.673 8.01.253z",
    fill: "#C3C9C9"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 433.168,
    y: 384.189,
    width: 3.249,
    height: 3.106,
    viewBox: "0 0 3.193 3.11",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M3.193 1.677L0 0v1.572c.616.64 1.527 1.133 2.633 1.416.184.048.371.09.56.122V1.677z",
    fill: "#AEBABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 436.417,
    y: 385.824,
    width: 3.882,
    height: 1.635,
    viewBox: "0 0 3.898 1.628",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M3.898 0L.001.065 0 1.497a8.583 8.583 0 003.897-.214L3.898 0z",
    fill: "#C3C9C9"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 440.299,
    y: 383.644,
    width: 3.169,
    height: 3.433,
    viewBox: "0 0 3.184 3.448",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M3.184 0L.001 2.165 0 3.448c1.343-.402 2.473-1.128 3.087-2.09.035-.052.066-.106.097-.16V0z",
    fill: "#DCE0E0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 432.297,
    y: 382.991,
    width: 0.872,
    height: 2.779,
    viewBox: "0 0 0.9 2.797",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M.127 0a2.493 2.493 0 00.079 1.776c.153.367.388.71.694 1.021V1.225L.127 0z",
    fill: "#9CADAD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.472,
    y: 386.205,
    width: 10.538,
    height: 10.788,
    viewBox: "0 0 10.589 10.789",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M10.589 6.119L0 0l.001 4.671 10.588 6.118v-4.67z",
    fill: "#B4BABD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 433.01,
    y: 383.535,
    width: 15.371,
    height: 13.458,
    viewBox: "0 0 15.311 13.452",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M15.311 4.67V0L0 8.782v4.67L15.311 4.67z",
    fill: "#CDCFCE"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 432.693,
    y: 379.721,
    width: 10.696,
    height: 7.029,
    viewBox: "0 0 10.741 7.017",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.778C.56 6.076-.727 4.044.419 2.238c1.145-1.806 4.29-2.7 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.147 1.806-4.292 2.701-7.027 2z",
    fill: "#B3B8B8"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 433.961,
    y: 381.247,
    width: 8.636,
    height: 5.449,
    viewBox: "0 0 8.658 5.457",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32 3.852c-.824 1.301-4.687 1.563-5.502 1.605-.071-.086-.208-.118-.3-.034C.41 4.824-.566 3.228.337 1.804 1.26.348 3.797-.373 6.002.193 8.206.757 9.244 2.396 8.32 3.852z",
    fill: "#555D69"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 433.168,
    y: 380.048,
    width: 9.508,
    height: 6.266,
    viewBox: "0 0 9.478 6.242",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#BFC4C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.245 4.58c-1.122-.573-2.523-1.484-2.523-1.484s1.991.212 3.323.56c.76.199 1.884.297 1.243 1.039-.698.806-1.457.187-2.043-.114zM2.233 1.66c1.122.576 2.523 1.487 2.523 1.487s-1.99-.213-3.323-.561C.674 2.386-.452 2.29.19 1.548c.698-.806 1.457-.187 2.043.113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.071 1.444C6.15 2.193 4.7 3.134 4.7 3.134s.394-1.302.975-2.18c.332-.5.52-1.235 1.64-.843 1.217.427.24.94-.243 1.333zM2.407 4.8c.922-.75 2.371-1.691 2.371-1.691s-.394 1.3-.975 2.179c-.33.5-.519 1.235-1.639.843-1.217-.426-.239-.94.243-1.331z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 437.13,
    y: 382.718,
    width: 1.505,
    height: 0.926,
    viewBox: "0 0 1.469 0.972",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M.46.92C.084.797-.098.504.054.265c.15-.24.579-.335.956-.213.376.122.558.414.406.654-.152.24-.58.334-.956.212z",
    fill: "#BFC4C4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 432.693,
    y: 379.721,
    width: 10.696,
    height: 7.029,
    viewBox: "0 0 10.741 7.017",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    height: 8,
    id: "c",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    width: 11,
    x: 0,
    y: 0
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.778C.56 6.076-.727 4.044.419 2.238c1.145-1.806 4.29-2.7 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.147 1.806-4.292 2.701-7.027 2z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83 9.334l.18-.044-.267-1.043 1.468-.363.267 1.043.18-.044-.266-1.044 1.468-.362.267 1.043.18-.044-.267-1.043 1.469-.362.266 1.044.18-.045-.266-1.042 1.468-.363.266 1.043.18-.045-.265-1.043 1.467-.362.267 1.044.18-.045-.266-1.043 1.468-.363.266 1.044.18-.045-.266-1.043 1.429-.353-.034-.13-1.43.352-.273-1.072 1.428-.353-.034-.13-1.43.352-.273-1.072 1.429-.353-.034-.13-1.428.351-.274-1.072 1.429-.352-.034-.132-1.43.352-.272-1.072L11.83.64l-.034-.132-1.43.353-.272-1.072 1.428-.352-.033-.13-1.43.351-.272-1.072 1.428-.353-.034-.132-1.43.353-.265-1.044-.181.045.267 1.044-1.468.362-.267-1.043-.18.045.266 1.043-1.468.362-.267-1.043-.18.044.266 1.044-1.467.362-.267-1.043-.18.044.267 1.043L3.16.081 2.893-.962l-.18.044L2.98.125 1.512.487 1.246-.556l-.181.044.267 1.043-1.468.362L-.403-.15l-.18.044.267 1.044-1.43.353.035.131 1.429-.352.274 1.072-1.43.353.035.132 1.429-.353L.3 3.346l-1.43.352.035.132 1.429-.353.274 1.072-1.428.352.034.132 1.428-.352.274 1.072-1.43.353.035.132L.95 5.885l.274 1.072-1.43.353.035.132 1.429-.353.274 1.073-1.43.352.034.132 1.429-.352.265 1.04zm1.528-1.627l-.273-1.072 1.468-.362.274 1.072-1.47.362zM5.73 3.283l-.274-1.072 1.468-.363.274 1.073-1.468.362zm1.503-.23l.274 1.072-1.468.362-.274-1.072 1.468-.362zm-1.682.275l-1.468.362-.274-1.072 1.468-.363.274 1.073zm.033.131l.275 1.072-1.468.362-.275-1.072 1.468-.362zm.308 1.204l.274 1.072-1.468.362-.274-1.072 1.468-.362zm.18-.045l1.467-.36.274 1.07-1.468.363-.273-1.073zm1.648-.406l1.468-.362.274 1.072-1.468.362-.274-1.072zm-.034-.132l-.274-1.072 1.468-.362.274 1.072-1.468.362zm-.308-1.203l-.273-1.072 1.468-.363.274 1.072-1.47.363zm-.307-1.204L6.798.601 8.266.24l.274 1.072-1.468.362zm-.18.044l-1.468.362-.274-1.072L6.617.645l.275 1.072zm-1.648.407l-1.468.363-.274-1.073 1.468-.362.274 1.072zm-1.648.407l-1.468.362-.274-1.072 1.468-.362.274 1.072zm.034.131l.273 1.073-1.467.361-.275-1.072 1.469-.362zm.307 1.204l.273 1.072-1.468.362-.273-1.072 1.468-.362zm.308 1.203l.274 1.072-1.468.363-.274-1.073 1.468-.362zM5.007 7.3l-.275-1.072L6.2 5.865l.274 1.072-1.467.363zm1.647-.406L6.38 5.822l1.467-.363.274 1.072-1.468.363zm1.649-.407l-.275-1.072 1.468-.362.274 1.072-1.467.362zm3.116-.769L9.95 6.08l-.274-1.072 1.468-.362.274 1.072zm-.31-1.203l-1.466.362-.274-1.072 1.468-.362.273 1.072zm-.306-1.204l-1.468.362-.274-1.072 1.469-.362.273 1.072zm-.307-1.203l-1.468.362-.275-1.072 1.468-.363.275 1.073zM10.188.904l-1.468.362L8.446.194l1.468-.362.274 1.072zm-.582-2.276L9.88-.3 8.413.062 8.139-1.01l1.467-.362zm-1.647.407L8.232.107 6.765.47 6.49-.602l1.468-.363zm-1.65.407L6.586.514 5.117.876 4.843-.196 6.31-.558zM4.663-.15L4.936.921l-1.47.362L3.194.211 4.662-.15zM3.014.255l.274 1.072-1.468.363L1.546.618 3.014.255zm-3.115.768L1.367.661l.274 1.072-1.468.362-.274-1.072zm.307 1.204l1.468-.362.274 1.073L.48 3.3.206 2.227zm.308 1.204L1.98 3.07l.274 1.072-1.468.362-.273-1.072zM.82 4.635l1.468-.362.275 1.072-1.468.363L.82 4.635zm.307 1.203l1.468-.362.274 1.072-1.468.363-.274-1.073zm.308 1.204l1.468-.362.274 1.072-1.468.362-.274-1.072z",
    fill: "#DCE0E0"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 432.693,
    y: 379.721,
    width: 10.696,
    height: 7.029,
    viewBox: "0 0 10.741 7.017",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    height: 8,
    id: "d",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    width: 11,
    x: 0,
    y: 0
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.778C.56 6.076-.727 4.044.419 2.238c1.145-1.806 4.29-2.7 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.147 1.806-4.292 2.701-7.027 2z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.933 8.845l.18-.045-.267-1.043 1.468-.363.267 1.044.18-.044-.266-1.044 1.468-.362.267 1.043.18-.044-.267-1.043 1.469-.362.266 1.044.18-.045-.265-1.043 1.468-.363.266 1.044.18-.045-.266-1.043 1.467-.362.267 1.044.18-.045-.266-1.043 1.468-.363.267 1.044.18-.045-.266-1.043 1.429-.353-.034-.13-1.43.352-.273-1.072 1.429-.353-.034-.13-1.43.352-.273-1.072 1.429-.353-.034-.13-1.43.351-.272-1.072 1.429-.352-.034-.132-1.43.353L9.509.505l1.428-.353-.034-.132-1.43.353L9.2-.699l1.428-.352-.033-.132-1.43.352-.272-1.072 1.428-.353-.034-.132-1.43.353-.265-1.044-.181.045.267 1.044-1.468.362-.267-1.043-.18.045.266 1.043-1.468.362-.267-1.043-.18.044.267 1.044-1.468.362-.267-1.043-.18.044.267 1.043-1.468.362-.267-1.043-.18.044.267 1.043-1.468.362L.35-1.045.17-1 .437.042l-1.47.362-.265-1.043-.18.044.266 1.044-1.43.353.035.131L-1.18.58l.274 1.072-1.43.353.035.132 1.429-.353.274 1.072-1.43.352.035.132 1.429-.353.273 1.072-1.428.352.034.132 1.428-.352.274 1.072-1.43.353.035.132 1.429-.353.274 1.072-1.43.352.034.132L.359 6.6l.274 1.072-1.43.352.035.132 1.429-.352.266 1.042zM2.46 7.22l-.274-1.072 1.468-.363.274 1.072-1.468.363zm2.373-4.424l-.274-1.07 1.468-.364.274 1.073-1.468.361zm1.503-.23l.274 1.071-1.468.362-.274-1.072 1.468-.362zm-1.682.274l-1.468.362-.274-1.072 1.468-.362.274 1.072zm.033.132l.275 1.072-1.468.362-.274-1.072 1.467-.362zm.308 1.204l.274 1.072-1.468.362-.274-1.072 1.468-.362zm.18-.045l1.467-.36.274 1.07-1.468.363-.273-1.073zm1.648-.407l1.468-.362.274 1.072-1.467.362-.275-1.072zm-.034-.13L6.516 2.52l1.468-.362.274 1.072-1.468.362zm-.308-1.205l-.274-1.072L7.676.953l.274 1.072-1.468.363zm-.307-1.204L5.9.112 7.369-.25 7.642.822l-1.467.362zm-.18.045l-1.468.363L4.253.52 5.72.158l.274 1.071zm-1.648.406l-1.468.363L2.605.926 4.073.564l.274 1.071zm-1.648.407l-1.468.362-.274-1.072L2.425.97l.274 1.072zm.034.132l.273 1.073-1.467.361-.274-1.072 1.468-.362zm.307 1.204l.273 1.072-1.468.362L1.57 3.74l1.469-.362zm.308 1.203l.274 1.072-1.468.363-.274-1.073 1.468-.362zm.762 2.231L3.835 5.74l1.468-.363.274 1.073-1.467.362zm1.647-.407l-.273-1.072 1.467-.362.274 1.072-1.468.362zM7.406 6l-.274-1.072L8.6 4.565l.274 1.072L7.406 6zm3.116-.769l-1.468.362L8.78 4.52l1.468-.362.274 1.072zm-.308-1.203l-1.468.362-.274-1.072 1.468-.362.274 1.072zm-.308-1.204l-1.468.362-.274-1.072 1.469-.362.273 1.072zM9.599 1.62l-1.468.362L7.857.91 9.325.546l.274 1.073zM9.29.415L7.823.778 7.549-.294l1.468-.362L9.29.415zM8.709-1.86l.274 1.072-1.468.362-.275-1.072 1.469-.362zm-1.647.407L7.335-.38l-1.467.362-.274-1.072 1.468-.362zm-1.65.407L5.688.026 4.219.388 3.945-.684l1.468-.362zM3.766-.64L4.04.432 2.57.794 2.298-.278 3.765-.64zm-1.648.407L2.39.84l-1.468.362L.649.13l1.468-.362zM-.998.535L.47.173l.274 1.072-1.468.362L-.998.535zm.307 1.204l1.468-.362.274 1.072-1.467.362-.275-1.072zm.308 1.204l1.467-.362.274 1.072-1.468.362-.273-1.072zm.307 1.204l1.468-.362.274 1.072-1.468.362-.274-1.072zM.23 5.35l1.468-.362.275 1.072-1.468.363L.23 5.35zm.308 1.204l1.468-.362.274 1.072-1.468.362-.274-1.072z",
    fill: "#DCE0E0"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 432.297,
    y: 379.394,
    width: 11.489,
    height: 7.628,
    viewBox: "0 0 11.54 7.621",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53 7.37c2.923.749 6.306-.23 7.545-2.182.514-.81.604-1.676.259-2.502C10.864 1.56 9.653.674 8.009.252 5.087-.498 1.703.482.465 2.435c-.514.81-.604 1.675-.26 2.502.47 1.124 1.682 2.01 3.326 2.433zM1.039 2.596C2.132.87 5.138.016 7.752.686c2.614.67 3.845 2.613 2.75 4.339C9.407 6.75 6.4 7.605 3.788 6.935c-2.614-.67-3.845-2.613-2.75-4.34z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 401.158,
    y: 438.458,
    width: 44.688,
    height: 31.003,
    viewBox: "0 0 44.677 30.967",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M44.677 6.367V.586L2.174 25.085l.008 5.882 42.495-24.6z",
    fill: "#EAC72F"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M44.677.586L.986 25.785 0 25.235 43.694 0l.983.586z",
    fill: "#FFEF75"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 366.533,
    y: 441.728,
    width: 37.794,
    height: 27.734,
    viewBox: "0 0 37.789 27.705",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.367V.586l36.803 21.237.008 5.882L0 6.367z",
    fill: "#CF9219"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .586l36.804 21.237.985-.551L.983 0 0 .586z",
    fill: "#FFEF75"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 456.859,
    y: 428.433,
    width: 6.418,
    height: 9.426,
    viewBox: "0 0 6.369 9.433",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M6.369 6.355V.574L.986 3.643l-.007 5.79 5.39-3.078z",
    fill: "#EAC72F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M6.369.574L.985 3.643 0 3.093 5.367 0l1.002.574z",
    fill: "#FFEF75"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M.983 9.433L0 8.883v-5.79l.983.55v5.79z",
    fill: "#CF9219"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 406.308,
    y: 437.151,
    width: 17.273,
    height: 17.218,
    viewBox: "0 0 17.284 17.215",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#273D3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.747 0l6.58 7.197v8.273l-.087.044-.104.06-.998.582-1.815 1.059L0 7.006V3.325L5.747 0zM17.284 12.623l-4.219 2.439V8.004l4.219 4.619z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 418.51,
    y: 428.814,
    width: 19.491,
    height: 17.218,
    viewBox: "0 0 19.489 17.206",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.592l.121-.061v.191L0 4.592z",
    fill: "#517777"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96 0l5.226 5.712v10.53l-.095.044-.096.069-.998.573-.478.278L.859 5.53V4.106L7.96 0zM19.489 12.614l-5.565 3.22v.009h-.008V6.511l5.573 6.103z",
    fill: "#273D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 383.727,
    y: 447.721,
    width: 1.426,
    height: 2.452,
    viewBox: "0 0 1.459 2.44",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.598L1.459 0v2.44H1.45L0 1.598z",
    fill: "#21362E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 432.376,
    y: 420.968,
    width: 12.36,
    height: 17.218,
    viewBox: "0 0 12.336 17.215",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M12.336 5.226v11.286l-.096.052-.095.061-.999.581-.017.009L0 5.026v-.651L7.561 0l4.775 5.226z",
    fill: "#273D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.638,
    y: 416.882,
    width: 7.923,
    height: 14.33,
    viewBox: "0 0 7.982 14.319",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.591v9.728l7.982-4.59V0L0 4.591z",
    fill: "#A7A7A7"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M7.494.979v8.413l-.043.017-.035.026-.443.26-.139.079-3.246 1.883-.209.122-.46.269-2.431 1.398V5.034l1.302-.756 1.164-.677.833-.477 1.719-.99 1.467-.851.443-.252.078-.052z",
    fill: "#90C7C7"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M7.413 1.03v8.408l-.435.253V1.282l.435-.252z",
    fill: "url(#paint0_linear_0_14432)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M7.458 9.412l-6.97 4.041v-.569l6.49-3.749.48.277z",
    fill: "url(#paint1_linear_0_14432)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M7.254 9.284V1.122l.241-.139V9.39L.488 13.453v-.117l6.766-4.052z",
    fill: "#7D7D7D"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M7.231 9.261l.241.106L.465 13.43v-.252l6.766-3.917z",
    fill: "#CDCDCD"
  })), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_14432",
    x1: 6.772,
    x2: 7.382,
    y1: 5.361,
    y2: 5.361
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_14432",
    x1: 3.681,
    x2: 4.217,
    y1: 10.895,
    y2: 11.881
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.163,
    y: 434.917,
    width: 3.486,
    height: 4.141,
    viewBox: "0 0 1.077 3.965",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1.077.13v1.558L.982 3.366a.32.32 0 01-.161.272l-.357.206-.108.063-.07.04a.125.125 0 01-.12.004l-.011-.006a.126.126 0 01-.06-.104L0 2.962V.722A.325.325 0 01.161.435L.885.017a.13.13 0 01.129 0l.004.003a.124.124 0 01.059.11z",
    fill: "#A8A7A2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.242,
    y: 434.917,
    width: 1.188,
    height: 4.087,
    viewBox: "0 0 1.185 4.082",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1.185.265l-.206.774-.006.032-.607 2.757-.043.254-.255-.148-.011-.006L0 1.573l.169-.497L.315.65.817.401.916 0l.005.003.256.257.008.005z",
    fill: "#A8A7A2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.4,
    y: 435.189,
    width: 1.109,
    height: 3.869,
    viewBox: "0 0 1.076 3.858",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1.076.129v1.453L.981 3.26a.32.32 0 01-.16.272l-.535.309a.125.125 0 01-.133-.003.127.127 0 01-.059-.104L.09 3.646 0 2.854V.723A.321.321 0 01.162.436l.486-.28L.81.062.886.018a.124.124 0 01.13.002c.035.02.06.06.06.109z",
    fill: "#C7C7C7"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.163,
    y: 434.917,
    width: 1.347,
    height: 1.689,
    viewBox: "0 0 1.344 1.652",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1.344.391v.506l-.267.19-.006.002-.658.346-.146.217L0 1.496V.722A.325.325 0 01.161.435L.885.017a.13.13 0 01.129 0l.004.003.257.257a.022.022 0 01.008.005c.036.021.061.06.061.11z",
    fill: "#A8A7A2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.163,
    y: 434.917,
    width: 1.347,
    height: 1.035,
    viewBox: "0 0 1.344 1.014",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .73l.491.284.853-.07V.392a.126.126 0 00-.061-.11L1.275.279 1.018.02 1.014.018a.127.127 0 00-.129 0L.161.436A.324.324 0 000 .723V.73z",
    fill: "#D1D1D1"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.242,
    y: 434.917,
    width: 1.109,
    height: 1.035,
    viewBox: "0 0 1.109 1.036",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M.797 0C.789.003.781.005.773.01L.049.428A.295.295 0 000 .464l.802.572.307-.731L.797 0z",
    fill: "#F5F5F5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.4,
    y: 435.189,
    width: 1.109,
    height: 1.417,
    viewBox: "0 0 1.077 1.382",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M.001.735A.306.306 0 01.155.461L.929.014A.099.099 0 01.978 0c.016 0 .031.004.046.011l.006.004c.03.018.047.049.047.084v.662L0 1.382V.735h.001z",
    fill: "#C7C7C7"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.4,
    y: 435.026,
    width: 0.792,
    height: 0.49,
    viewBox: "0 0 0.841 0.509",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M.78 0L.77.005.046.423A.317.317 0 000 .456l.075.053A.327.327 0 01.123.474L.841.059.78 0z",
    fill: "#F5F5F5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.717,
    y: 436.17,
    width: 2.932,
    height: 1.471,
    viewBox: "0 0 0.717 0.824",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M.21.796L.08.722C.003.677-.019.558.017.422.02.408.025.393.03.378A.325.325 0 00.036.361L.041.348C.042.343.045.339.047.334A.567.567 0 01.063.298L.071.283.086.257A.226.226 0 01.102.231l.01-.014.021-.032a.49.49 0 01.01-.013l.01-.011.011-.014.032-.034.018-.016C.225.087.236.077.248.069L.26.06.29.041.302.033A.26.26 0 01.345.014L.357.01A.138.138 0 01.383.004.099.099 0 01.407.001h.018l.018.002.003.001.008.002.005.001A.12.12 0 01.49.02l.128.074C.685.133.71.226.694.336L.687.375c0 .006-.003.012-.004.018a.666.666 0 01-.178.309C.402.8.288.842.21.796z",
    fill: "#A8A7A2"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M.501.702L.505.697.018.416c0 .002 0 .005-.002.007-.035.135-.014.255.064.3l.128.074C.288.842.402.8.501.702z",
    fill: "#A8A7A2"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M.635.501C.652.465.671.428.68.393L.684.375.691.336C.707.225.682.132.615.094L.487.02a.12.12 0 00-.03-.013L.452.006.443.004.441.003.423.001H.405a.099.099 0 00-.024.003A1.053 1.053 0 01.355.01L.343.014a.26.26 0 00-.042.019L.287.041a.48.48 0 00-.04.028C.233.077.222.087.211.097L.194.113a.346.346 0 00-.032.034L.15.161.141.172l-.01.013-.014.019.518.297z",
    fill: "#C7C7C7"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M.69.28C.69.197.67.125.614.093L.487.019a.12.12 0 00-.03-.013L.452.005.443.003.441.002.423 0H.405a.099.099 0 00-.024.003L.355.009.343.013a.26.26 0 00-.042.019L.287.04.282.044.69.28z",
    fill: "#FDFDFD"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M.228.805c.11.064.29-.043.403-.237C.743.373.745.164.635.101S.345.144.232.339C.12.532.118.742.228.805z",
    fill: "#A8A7A2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 446.876,
    y: 436.17,
    width: 2.773,
    height: 1.471,
    viewBox: "0 0 2.761 1.453",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M.496.607a.165.165 0 00-.13-.008v.632a.645.645 0 00.125-.157C.604.88.606.67.496.607z",
    fill: "#C7C7C7"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M.12.789l.062.17.353-.201L.46.588S.265.534.12.789z",
    fill: "#F5F5F5"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M.182.96v.223l-.112.119s-.082-.07-.068-.214c.017-.18.117-.3.117-.3L.182.96zM2.76.156c-.046.01-.08.054-.104.102a.387.387 0 00-.352.017l-1.383.8a.216.216 0 01-.216 0L.182.96v.223l.315.174a.767.767 0 00.728.008L2.69.515A.136.136 0 002.76.39V.156z",
    fill: "#C7C7C7"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M.66 1.425a.766.766 0 00.407.002V1.14H.66v.284z",
    fill: "#A8A7A2"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M.66 1.067L.183.96v.223l.315.174a.775.775 0 00.164.067v-.357z",
    fill: "#A8A7A2"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M.182.96l.315.175a.767.767 0 00.728.008L2.69.293a.139.139 0 000-.241.388.388 0 00-.387 0L.92.852a.216.216 0 01-.216 0L.535.759.182.96z",
    fill: "#FDFDFD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.57,
    y: 419.007,
    width: 4.279,
    height: 6.157,
    viewBox: "0 0 4.3 6.153",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 1.9L2.552 0 .833.99 0 1.467l4.3 4.686V1.9z",
    fill: "#273D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 447.114,
    y: 421.132,
    width: 6.18,
    height: 7.192,
    viewBox: "0 0 6.199 7.216",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M6.199 5.334L1.303 0 0 .756v3.246l2.949 3.214 3.25-1.882z",
    fill: "#273D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 396.563,
    y: 411.923,
    width: 0.872,
    height: 6.756,
    viewBox: "0 0 0.902 6.71",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v6.455c0 .1.103.187.253.229.016.005.033.008.05.012a.155.155 0 01.021.004l.015.003.017.002.043.004.019.001h.068l.018-.001a.571.571 0 00.043-.004l.018-.002L.58 6.7a.47.47 0 00.142-.041l.015-.006c.012-.006.024-.011.034-.018l.015-.009a.338.338 0 00.041-.031l.01-.009.021-.021a.292.292 0 00.026-.038.142.142 0 00.009-.021l.003-.009.001-.005a.15.15 0 00.005-.037V0H0z",
    fill: "url(#paint0_linear_0_12640)"
  })), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12640",
    x1: 0.902,
    x2: 0,
    y1: 3.355,
    y2: 3.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#CBD7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#C3CDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BEC8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#98A3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#98A3C1"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 374.615,
    y: 399.5,
    width: 0.872,
    height: 6.702,
    viewBox: "0 0 0.903 6.71",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v6.455c0 .101.103.187.253.229a.405.405 0 00.085.018l.017.002.043.004a.121.121 0 00.019.001l.034.001.034-.001.019-.001a.571.571 0 00.043-.004l.018-.002L.58 6.7a.47.47 0 00.142-.041l.015-.006c.012-.006.024-.011.034-.018l.015-.009a.334.334 0 00.041-.03l.01-.009.021-.021a.293.293 0 00.026-.038.142.142 0 00.008-.018l.001-.003.003-.009.002-.005a.15.15 0 00.005-.037V.001H0V0z",
    fill: "url(#paint0_linear_0_12634)"
  })), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12634",
    x1: 0.902,
    x2: 0,
    y1: 3.355,
    y2: 3.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#CBD7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#C3CDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BEC8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#98A3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#98A3C1"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 371.129,
    y: 395.414,
    width: 31.218,
    height: 23.756,
    viewBox: "0 0 31.221 23.718",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.355V.574l30.235 17.354.007 5.79L0 6.355z",
    fill: "#CF9219"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .574l30.235 17.354.986-.55L1.002 0 0 .574z",
    fill: "#FFEF75"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M30.238 23.718l.983-.55v-5.79l-.983.55v5.79z",
    fill: "#F1C839"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#2A3443"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.498 7.911c0 .354-.094.572-.284.652-.189.08-.462.019-.82-.186l-.164-.094V9.49l-.658-.376v-3.33l.897.513c.686.393 1.029.93 1.029 1.614zM7.23 7.744l.125.073c.161.092.281.119.36.08.079-.038.119-.152.119-.342a.889.889 0 00-.109-.451.877.877 0 00-.336-.318l-.159-.092v1.05zM10.515 11.371l-.202-.956-.921-.528-.202.725-.657-.376.874-2.843.892.511.877 3.845-.661-.378zm-.326-1.576L10 8.912l-.076-.397a10.41 10.41 0 01-.072-.421 7.634 7.634 0 01-.079.386c-.032.139-.116.45-.251.933l.667.382zM12.143 11.007v1.296l-.658-.376v-3.33l.86.493c.364.208.633.444.805.705.173.262.26.559.26.893 0 .421-.15.628-.452.623l.679 1.848-.703-.402-.558-1.616-.233-.134zm0-.533l.169.097c.154.088.266.111.333.066.068-.043.102-.148.102-.312a.782.782 0 00-.107-.424.917.917 0 00-.333-.299l-.164-.095v.967zM16.16 14.604l-.7-.401-.58-1.755-.264.097v1.175l-.657-.377v-3.33l.657.376v1.651l.23-.367.601-.808.703.402-.817.974.827 2.363zM16.591 14.85v-3.33l.618.354v3.33l-.618-.354zM20.428 17.048l-.802-.459-1.092-3.038-.031-.018c.041.207.061.416.061.626v1.82l-.609-.349V12.3l.808.463 1.082 3.006.027.015a3.464 3.464 0 01-.047-.596V13.37l.604.346v3.332h-.001zM22.12 16.17l1.08.619v1.708a3.004 3.004 0 01-.977-.375 2.403 2.403 0 01-.948-.984c-.221-.421-.332-.909-.332-1.463 0-.535.126-.88.38-1.037.254-.156.608-.105 1.064.156.282.161.551.384.807.667l-.208.387a2.377 2.377 0 00-.561-.485c-.25-.143-.447-.151-.593-.024-.146.127-.219.372-.219.734 0 .374.053.69.159.95.105.259.258.446.461.562.106.06.214.109.323.146v-.764l-.437-.25.001-.547z"
  }))), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M28.699 19.883l-1.898-3.138-1.898.946 1.023.591v1.974l1.675.967v-1.974l1.098.634zM4.856 6.162L2.958 3.024 1.06 3.97l1.023.59v1.974l1.675.968V5.528l1.098.634z",
    fill: "#2A3443"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 150.226,
    y: 302.458,
    width: 120.276,
    height: 60.208,
    viewBox: "0 0 120.294 60.204",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M119.802 22.166L83.228 1.047A7.817 7.817 0 0079.323 0c-1.37 0-2.72.362-3.906 1.047L69.59 4.413l-.119-.067a7.816 7.816 0 00-7.811 0L.492 39.674a.968.968 0 00-.492.852c0 .171.048.596.492.852l6.244 3.463a7.815 7.815 0 007.801-.001l5.719-3.299 30.576 17.62a7.825 7.825 0 003.899 1.043 7.824 7.824 0 003.902-1.044l61.169-35.289a.966.966 0 00.492-.852.968.968 0 00-.492-.853z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 396.008,
    y: 276.087,
    width: 384.519,
    height: 222.144,
    viewBox: "0 0 384.535 222.16",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 222.16L384.535 7.135 372.335 0 0 215.038l12.2 7.122z",
    fill: "#5C5C5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 8.319,
    y: 40.647,
    width: 377.784,
    height: 230.535,
    viewBox: "0 0 377.83 230.561",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M377.83 3.163v12.342L5.495 230.561v-12.372L377.83 3.163z",
    fill: "#CFC091"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M5.495 218.189v12.372L0 227.398v-12.36l5.495 3.151z",
    fill: "#998C62"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M5.495 218.189L377.83 3.163 372.334 0 0 215.038l5.495 3.151z",
    fill: "#EBDDB2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 380.637,
    y: 43.808,
    width: 399.89,
    height: 242.577,
    viewBox: "0 0 399.879 242.582",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.164v12.342l394.384 227.076v-12.373L0 3.164zM394.384 230.209v12.373l5.495-3.164v-12.36l-5.495 3.151z",
    fill: "#998C62"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M394.384 230.209L0 3.164 5.496 0l394.383 227.058-5.495 3.151z",
    fill: "#EBDDB2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 520.484,
    y: 298.208,
    width: 70.359,
    height: 49.529,
    viewBox: "0 0 70.372 49.556",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M29.862 18.982c.242.154.49.305.745.453.17.414 1.958 1.136 2.518 1.461l2.676 1.552c1.532.89 2.849 1.846 4.351 2.76l.121.073c1.977 1.205 3.91 2.481 5.831 3.772l1.479.997c.539.363.652.337.664.95.02 1.012-41.414-17.215-41.639-16.235-.941 4.107-4.361 4.045-6.607 7.592-.247.391 45.292 26.301 46.259 26.724.555.242 1.133.49 1.738.474.546-.014 1.061-.24 1.56-.462l13.068-5.82c2.674-1.19 6.783-5.814 7.331-6.162.03-.019.18-.045.415-.077.009-.233-.259-.567-.25-.8a249.107 249.107 0 01-19.5-11.723c-2.73-1.816-5.429-3.69-7.93-5.81-1.596-1.354-3.113-2.808-4.818-4.02-1.443-1.027-3.007-1.87-4.566-2.709-1.315-.708-2.66-1.427-4.132-1.68-1.935-.332-3.294.217-4.135 2.074-.88 1.942-.738 2.736.859 4.033 1.23 1 2.632 1.737 3.962 2.583z",
    fill: "url(#paint0_linear_0_10017)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M52.496 17.008s-.935-1.145.25-2.897c1.011-1.495 1.774-1.003 1.774-1.003s1.16.803.406 2.211c-.478.894-.946 2.111-1.274 2.11-.329-.002-.507 1.092-.507 1.092l-.952-.989.303-.524z",
    fill: "#066C7F"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M37.924 41.145l6.53-3.624-7.881-3.292 1.351 6.916zM3.464 21.376l6.53-3.624-7.88-3.292 1.35 6.916z",
    fill: "#293237"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M39.46 38.292l1.147 1.872 2.797 4.564 1.381 2.254 1.83-1.06.044-.026.054-.032-.002-.004c.4-.26.693-.69.844-1.267a3.374 3.374 0 00.066-.316c.011-.069.02-.14.027-.214.004-.038.008-.076.01-.115.009-.115.014-.232.012-.355-.028-2.279-1.688-5.044-3.708-6.175a4.416 4.416 0 00-.33-.166c-.867-.399-1.644-.407-2.223-.083l-.005-.008-1.944 1.131z",
    fill: "url(#paint1_linear_0_10017)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M38.493 40.575c.028 2.28 1.688 5.044 3.708 6.175 2.02 1.131 3.635.2 3.608-2.079-.028-2.279-1.688-5.044-3.708-6.175-2.02-1.13-3.635-.2-3.608 2.08z",
    fill: "#414C5C"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M39.56 41.171c.003.215.026.44.068.662.123.67.412 1.361.806 1.978.247.39.539.75.857 1.056.281.273.583.504.896.68.247.14.489.234.714.286.405.097.77.06 1.064-.092l.026-.016c.11-.06.21-.137.3-.234.068-.074.129-.155.181-.247a.622.622 0 00.063-.123c.047-.089.081-.184.11-.286a2.07 2.07 0 00.078-.404c.013-.113.021-.23.018-.357 0-.039-.003-.076-.005-.116a3.676 3.676 0 00-.132-.857 5.21 5.21 0 00-.192-.59 5.933 5.933 0 00-.392-.818c0-.003-.003-.003-.003-.005a5.887 5.887 0 00-.812-1.104l-.005-.005a1.714 1.714 0 00-.15-.158 4.455 4.455 0 00-.938-.723 2.76 2.76 0 00-.738-.29c-.1-.022-.2-.038-.294-.043a1.512 1.512 0 00-.389.018 1.227 1.227 0 00-.373.131c-.352.19-.602.546-.707 1.051a2.934 2.934 0 00-.051.606z",
    fill: "#A1A1A1"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M41.485 40.223c.003.215.026.44.068.662.123.67.412 1.361.806 1.978.247.39.539.75.857 1.056.281.273.583.504.896.68.181.102.362.181.533.236.01-.029.05-.21.057-.24.024-.098.011-.052.021-.165.013-.113.021-.23.018-.357a3.907 3.907 0 00-.137-.972 5.77 5.77 0 00-.586-1.413 5.788 5.788 0 00-.817-1.109 1.713 1.713 0 00-.15-.158 4.289 4.289 0 00-.938-.722 2.76 2.76 0 00-.536-.236c-.016.05-.029.103-.039.155a2.912 2.912 0 00-.053.605z",
    fill: "#293237"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M40.483 39.442c-.345.302-.55.814-.54 1.501.02 1.615 1.196 3.574 2.628 4.376.623.35 1.191.42 1.633.257-.467.41-1.193.433-2.016-.028-1.432-.8-2.608-2.76-2.628-4.376-.012-.912.349-1.519.923-1.73z",
    fill: "url(#paint2_linear_0_10017)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M40.264 41.373l1.616.933-.749 2.407c.041.122.479-.139.479-.139l1.113-1.197.814 1.997c.258.063.084.474.302.43.308-.109.489-.354.489-.354l-.48-2.007.889.515a3.3 3.3 0 00-.045-.46c-.021-.13-.106-.573-.221-.834l-.764-.56.257-.512a5.887 5.887 0 00-.757-1.008l-.344.447-.64-1.268c-.088-.063-.015-.01-.109-.064a2.76 2.76 0 00-.738-.29c-.1-.022-.2-.038-.294-.043l.654 1.6-1.721-.684s-.432.218-.43.438c.005.216.637.43.679.653z",
    fill: "#A1A1A1"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M39.59 41.662l1.654 1.104-.607 1.344c.247.39.203.323.521.63l.929-.902.953 2.025c.404.097.505.094.799-.059l-.626-1.9 1.477.757c.05-.2.054-.34.052-.587-.003-.189 0-.255-.031-.45l-1.639-1.06.712-1.263c-.244-.39-.263-.41-.581-.72l-.975.911-1.024-2.113c-.358-.053-.412-.062-.723.063l.619 1.984-1.515-.705c-.039.181-.03.23-.027.45.004.216-.01.268.032.491z",
    fill: "#D3D3D3"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M41.582 42.305c.004.355.263.785.577.961.315.176.566.031.562-.324-.004-.355-.263-.785-.577-.96-.315-.177-.566-.032-.562.323z",
    fill: "#B6B6B6"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.401l1.147 1.871 2.797 4.564 1.381 2.254 1.83-1.06.044-.026.054-.032-.002-.004c.4-.26.693-.69.844-1.266a3.374 3.374 0 00.066-.316 3.47 3.47 0 00.027-.214l.011-.115c.008-.115.013-.232.011-.355-.028-2.279-1.688-5.044-3.708-6.175a4.414 4.414 0 00-.329-.166c-.868-.399-1.645-.407-2.224-.083l-.005-.008L5 18.401z",
    fill: "url(#paint3_linear_0_10017)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M4.033 20.684c.028 2.28 1.688 5.044 3.708 6.175 2.02 1.131 3.635.2 3.608-2.079-.028-2.279-1.688-5.044-3.71-6.175-2.019-1.13-3.634-.2-3.606 2.08z",
    fill: "#414C5C"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M5.099 21.28c.003.215.026.44.068.662.123.67.412 1.361.807 1.978.247.39.539.75.856 1.056.281.273.583.504.896.68.247.14.489.234.715.286.404.097.77.06 1.064-.092l.026-.016c.11-.06.21-.137.299-.234.068-.074.129-.155.181-.247a.622.622 0 00.063-.123c.047-.089.082-.184.11-.286a2.199 2.199 0 00.079-.404c.013-.113.021-.23.018-.357 0-.039-.003-.076-.005-.116a3.676 3.676 0 00-.132-.857 5.207 5.207 0 00-.192-.59 5.988 5.988 0 00-.391-.818c0-.003-.003-.003-.003-.005a5.888 5.888 0 00-.812-1.104l-.005-.005a1.713 1.713 0 00-.15-.158 4.456 4.456 0 00-.938-.723 3.086 3.086 0 00-.242-.124c-.1-.045-.2-.08-.294-.113a1.963 1.963 0 00-.496-.097 1.512 1.512 0 00-.389.018 1.217 1.217 0 00-.373.131c-.352.19-.602.546-.707 1.051a2.944 2.944 0 00-.053.607z",
    fill: "#A1A1A1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M7.025 20.332c.003.215.026.44.068.662.124.67.413 1.361.807 1.978.247.39.539.75.857 1.056.281.273.583.504.896.681.181.102.363.181.533.236.01-.029.05-.21.057-.24.024-.098.011-.052.021-.165.013-.113.021-.23.018-.357a3.907 3.907 0 00-.137-.972 5.81 5.81 0 00-.586-1.413 5.788 5.788 0 00-.817-1.109 1.713 1.713 0 00-.15-.158 4.294 4.294 0 00-.938-.723 3.086 3.086 0 00-.242-.124c-.1-.045-.2-.08-.294-.113-.016.05-.029.102-.039.155a2.794 2.794 0 00-.054.606z",
    fill: "#293237"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M6.022 19.55c-.345.302-.55.814-.54 1.501.02 1.615 1.196 3.574 2.628 4.375.623.35 1.191.42 1.633.258-.467.41-1.193.433-2.016-.028-1.432-.8-2.608-2.76-2.628-4.375-.011-.912.35-1.519.923-1.73z",
    fill: "url(#paint4_linear_0_10017)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M5.803 21.482l1.615.933-.75 2.407c.042.123.48-.139.48-.139l1.113-1.197.814 1.996c.258.063.085.474.302.43.308-.109.489-.354.489-.354l-.479-2.007.888.515a3.3 3.3 0 00-.045-.46c-.021-.13-.106-.572-.221-.834l-.764-.56.257-.512a5.888 5.888 0 00-.757-1.008l-.344.447-.638-1.269c-.09-.063-.016-.01-.11-.063a3.086 3.086 0 00-.242-.124c-.1-.045-.2-.08-.294-.113a1.963 1.963 0 00-.496-.097l.654 1.6-1.721-.684s-.432.218-.43.438c.005.218.637.432.679.655z",
    fill: "#A1A1A1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M5.129 21.771l1.654 1.104-.607 1.344c.247.39.203.323.521.63l.929-.902.953 2.025c.405.097.505.093.799-.059l-.626-1.9 1.477.758c.05-.2.054-.34.051-.587-.003-.189 0-.255-.031-.449l-1.639-1.06.712-1.263c-.244-.39-.263-.41-.581-.722l-.975.912-1.024-2.113c-.358-.053-.412-.062-.722.063l.619 1.984-1.515-.705c-.039.181-.03.23-.027.45.005.214-.01.266.032.49z",
    fill: "#D3D3D3"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M7.122 22.413c.004.355.263.785.577.961.314.176.566.031.561-.324-.004-.355-.263-.785-.577-.96-.314-.176-.566-.03-.561.323z",
    fill: "#B6B6B6"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76 13.515L1.725 15.5l2.187 3.18c.11-.168.232-.316.362-.455.232-.232.51-.417.816-.528.287-.12.603-.176.937-.176.603 0 1.252.195 1.91.556 1.13.64 2.151 1.725 2.875 2.958.695 1.187 1.13 2.513 1.14 3.737 0 .501-.055.955-.184 1.354l26.158 15.021a5.66 5.66 0 01-.037-.566c-.009-1.039.278-1.892.844-2.457a2.438 2.438 0 011.753-.714c.612 0 1.252.195 1.91.566 1.242.695 2.346 1.92 3.078 3.31.575 1.094.927 2.272.937 3.384.009.454-.046.881-.158 1.261v.01l.737.39 2.437-.568 1.576-2.235-.83-.52.992-3.979-15.523-10.326s-3.361-7.898-5.729-10.155c-3.027-2.885-14.992-8.253-14.992-8.253l-6.591 2.46-5.047-2.222-1 1.18-.523 1.803z",
    fill: "#40A6BA"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28 11.714l48.507 27.478L35.64 28.764 8.327 12.756l-5.046-2.222-1.001 1.18z",
    fill: "#6EDAE0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M11.95 24.77c0 .501-.055.955-.184 1.354l26.158 15.021a5.66 5.66 0 01-.037-.566c-.009-1.039.278-1.892.844-2.457.176-.176.371-.325.594-.436L10.812 21.033c.694 1.187 1.13 2.513 1.139 3.737z",
    fill: "#479FB4"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M32.96 37.318l.11-4.849.614-3.309-.251-.046-.616 3.33-.102 4.452-11.131-6.042-.451-4.85.778-4.23-.024-.04-4.362-7.578-.111.065-4.226 2.524-.013.053-.955 4.232.954 5.376.25-.044-.944-5.326.932-4.128 4.021-2.402 4.21 7.314-.767 4.171.001.018.467 5.005.059.031 11.557 6.273z",
    fill: "#2E8989"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M37.922 39.665c-.02.18-.038.36-.036.552 0 .186.018.38.037.566l-26.158-15.02c.1-.307.145-.656.165-1.024l25.992 14.926z",
    fill: "#546672"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M37.886 39.462c-.008-.913.226-1.67.664-2.227l.773.452c-.223.111-.417.26-.594.436-.459.46-.724 1.114-.807 1.897-.017-.184-.036-.375-.036-.558z",
    fill: "#409E4E"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M37.922 40.027c-.02.18-.038.36-.036.552 0 .185.018.38.037.566l-26.158-15.02c.1-.308.145-.656.165-1.024l25.992 14.926zM.843 15.23v1.492l.51 1.558 1.28 1.307.566 1.623.287.167a4.287 4.287 0 01-.055-.686c-.009-.788.158-1.474.482-2.012.111-.167.232-.315.362-.454.232-.232.51-.417.816-.528L2.625 16.25l-.519-.297-1.263-.724zM10.377 13.958l.814 2.04 1.836 1.048.204.111.213.13.566.343.463.278.288.176.389.232.316.186 6.5 3.903.834.501 8.763 5.258.408.241 2.206 1.326.251-1.41-3.58-6.537-.398-.732-1.178-2.152-13.111-7.204-.148-.093-.431-.233-5.205 2.588z",
    fill: "#414C5C"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M15.822 11.924l-4.31 2.7.163 1.231 22.233 13.282.13-.747-5.036-9.22-13.18-7.246z",
    fill: "#529BA3"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 17.07l.287.297.204.111.213.13 2.847-5.267-.13-.324-.148-.093-.315.158L13.3 17.07zM21.464 21.94l.835.501 1.424-6.247-.844-.418-1.415 6.164zM30.348 20.996v6.224l.408.241.093-5.677-.399-.732-.102-.056z",
    fill: "#414C5C"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M37.27 36.494v1.536L12.002 22.116l.348-.202 24.92 14.58z",
    fill: "#546672"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M36.922 36.697v1.536l-24.92-14.58v-1.537l24.92 14.581z",
    fill: "#414C5C"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M67.142 33.171l.387-3.48-16.523 9.255-.741 3.69S61.26 39.94 67.142 33.17z",
    fill: "#293237"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M50.42 42.062l.118-.587c1.319-.465 9.62-3.528 16.481-9.303.12-.1.152-.608.152-.608l.074.064-.031.52-.043-.039s-.032.508-.152.61c-7.119 5.99-15.787 9.063-16.599 9.343z",
    fill: "#293237"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M50.42 41.253l.118-.587c1.319-.465 9.62-3.528 16.481-9.303.12-.1.152-.609.152-.609l.074.064-.031.52-.043-.039s-.032.508-.152.61C59.9 37.9 51.232 40.972 50.42 41.252z",
    fill: "#293237"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M50.42 40.445l.118-.587c1.319-.465 9.62-3.528 16.481-9.303.12-.1.152-.609.152-.609l.074.064-.031.52-.043-.038s-.032.508-.152.61c-7.119 5.99-15.787 9.063-16.599 9.343z",
    fill: "#293237"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M50.42 42.207l.118-.587c1.319-.465 9.62-3.528 16.481-9.303.12-.1.152-.609.152-.609l.074.064-.031.52-.043-.039s-.032.508-.152.61c-7.119 5.992-15.787 9.064-16.599 9.344z",
    fill: "#546672"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M50.42 41.4l.118-.588c1.319-.465 9.62-3.528 16.481-9.303.12-.1.152-.609.152-.609l.074.064-.031.52-.043-.038s-.032.508-.152.61c-7.119 5.99-15.787 9.063-16.599 9.343z",
    fill: "#546672"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M50.42 40.59l.118-.587c1.319-.465 9.62-3.528 16.481-9.303.12-.1.152-.609.152-.609l.074.064-.031.52-.043-.039s-.032.508-.152.61C59.9 37.236 51.232 40.31 50.42 40.59z",
    fill: "#546672"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M50.537 39.195c1.313-.463 9.547-3.504 16.391-9.23.063.105.116.216.166.327a.32.32 0 01-.076.145c-7.12 5.992-15.787 9.065-16.6 9.344l.119-.586z",
    fill: "#546672"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M66.327 37.675l-16.754 9.536-.149-1.449 16.752-9.543.151 1.456z",
    fill: "#141E25"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M46.408 44.67c.009.453-.046.88-.158 1.26l.76.4 2.559.88-.148-1.446.529-.037c.519-.037 1.02.337 1.493.124.11-.056.223-.11.325-.167l15.568-8.837a1.39 1.39 0 00.427-.37c.167-.214.269-.474.287-.733l.12-2.126-.408.223-16.32 9.041-.445.25v.065l-5.527-2.152v.242c.576 1.091.928 2.27.938 3.382z",
    fill: "#414C5C"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M51.443 42.88v2.966c.11-.056.223-.11.325-.167 0 0 3.18-1.066 7.158-3.18a50.75 50.75 0 004.052-2.384 38.759 38.759 0 004.358-3.273c.139-.12.315-.223.427-.37v-2.634l-16.32 9.041z",
    fill: "#293237"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M50.813 39.542L53.85 38.1c.215-.098.5.103.482.338l-.093 1.122a1.007 1.007 0 01-.6.85l-2.591 1.185-.236-2.053zM64.472 32.217l2.329-1.82-.181 2.49-2.26 1.773a.289.289 0 01-.466-.248l.092-1.286c.027-.358.203-.689.486-.909z",
    fill: "#9CB7D2"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M66.62 30.538c-.078-.204.8-.705.8-.705.422 1.624-.253 2.533-.253 2.533l-.547.52s.168-1.912 0-2.348z",
    fill: "#E08A35"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M59.98 35.63c-.005.417-.31.923-.68 1.13-.37.207-.666.037-.661-.38.005-.419.309-.925.68-1.132.37-.208.666-.037.661.381z",
    fill: "#768A99"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M60.171 35.72c-.005.418-.309.924-.68 1.131-.37.207-.666.037-.661-.38.005-.419.309-.925.679-1.132.371-.207.667-.036.662.381z",
    fill: "#C4C4C4"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M45.957 40.796l-.486.246 4.898 2.23c.399.161.85.131 1.225-.08 0 0 12.276-4.879 16.365-9.28.204-.22.297-.51.069-.707l-.857-.739s-.032.508-.152.608c-7.476 6.292-16.667 9.368-16.667 9.368l-4.395-1.646zM54.165 42.825v.423a.424.424 0 01-.27.408l-1.812.704c-.146.057-.329-.08-.329-.248v-.119l1.517-.588a.424.424 0 00.27-.408v-.304l.295-.113c.146-.057.329.081.329.245z",
    fill: "#546672"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M53.541 42.693v.304a.424.424 0 01-.27.408l-1.517.588v-.3c0-.192.104-.348.27-.412l1.517-.588z",
    fill: "#BED5DF"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M67.45 34.931v.313c0 .168-.062.323-.161.407l-1.084.917c-.088.074-.197-.02-.197-.168v-.106l.908-.766c.099-.084.161-.239.161-.407v-.207l.177-.148c.087-.074.196.02.196.165z",
    fill: "#546672"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M67.077 34.914v.207c0 .168-.062.323-.161.407l-.908.766v-.204c0-.17.062-.325.16-.409l.909-.767z",
    fill: "#BED5DF"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M58.907 41.043v1.335c0 .046.009.083.019.121a50.75 50.75 0 004.052-2.383.355.355 0 00.028-.13v-1.335c0-.269-.195-.362-.436-.223l-3.227 1.882c-.241.14-.436.473-.436.733z",
    fill: "#12181D"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M62.572 40.446c.24-.14.435-.468.435-.73v-1.339c0-.262-.195-.36-.435-.22l-3.228 1.885c-.24.14-.435.468-.435.73v1.338c0 .262.195.362.435.222l3.228-1.886z",
    fill: "#D3D3D3"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M59.344 42.243l3.228-1.886c.195-.114.353-.38.353-.593v-1.338c0-.214-.158-.294-.353-.18l-3.228 1.886c-.195.114-.354.38-.354.593v1.34c0 .211.159.292.354.178z",
    fill: "#EFEC82"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#D3A944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.992 40.715a.764.764 0 01.352-.583l3.228-1.886c.192-.113.347-.035.352.172l-3.932 2.297zM62.924 39.774a.764.764 0 01-.352.583l-3.228 1.886c-.193.113-.348.034-.352-.172l3.932-2.297z"
  }))), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M20.429.611L3.28 10.534l5.047 2.222 18.2-10.535L22.599.492a2.401 2.401 0 00-2.17.12z",
    fill: "#7AF2F2"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M50.813 39.542l2.85-1.357-.076.908a1.008 1.008 0 01-.598.85l-1.875.857-.301-1.258zM63.987 33.126a1.27 1.27 0 01.485-.909l1.588-1.24-.083 1.141a1.168 1.168 0 01-.445.836l-1.624 1.274.079-1.102z",
    fill: "#BED5DF"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M26.527 2.221c-6.208 2.171-18.2 10.535-18.2 10.535l6.591-2.46L32.425.007s-4.237 1.633-5.898 2.214z",
    fill: "#414C5C"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M14.987 10.042C22.975 4.72 29.27 1.343 29.27 1.343c-1.002.374-1.955.77-2.522.967-4.551 1.592-12.008 6.548-16.051 9.232 0 0 3.344-.87 4.289-1.5z",
    fill: "#88D5DE"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M67.131 29.93c-7.063 5.441-16.344 9.262-16.344 9.262L35.64 28.703l18.207-10.527 13.624 11.492-.34.262z",
    fill: "#6EDAE0"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M51.797 20.536s-.618 2.001-5.139 4.551c-4.52 2.55-6.979 2.473-6.979 2.473l-4.039 1.204 17.994-10.587-1.837 2.36z",
    fill: "#414C5C"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M47.238 8.46s-5.213 4.983-17.327 10.09c0 0 3.075 4.92 5.729 10.154 0 0 10.82-3.955 18.207-10.527 0 0-2.978-4.526-6.609-9.717z",
    fill: "#414C5C"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M30.348 18.67c.816 1.075 3.181 5.312 5.424 9.69 1.595-.613 11.071-4.396 17.729-10.256-.436-.909-3.273-4.766-6.305-9.245-.139.121-.343.287-.603.501a49.288 49.288 0 01-4.284 3.078c-2.754 1.761-6.676 3.977-11.961 6.231z",
    fill: "#3D7D87"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M64.023 31.563L51.797 20.536s1.801-2.057 2.368-1.673c6.512 4.41 12.081 10.253 12.081 10.253l-2.223 2.447z",
    fill: "#69BBB8"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M64.023 31.563L52.03 20.228l1.816-2.052c6.512 4.41 13.681 11.514 13.681 11.514l-3.505 1.873zM51.198 39.03L35.64 28.763l4.039-1.204 15.409 9.292-3.89 2.177z",
    fill: "#7AF2F2"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.264 28.323l.278.184c.142.094.427.1.62.014l2.858-1.272c.356-.16.384-.427.06-.573l-.269-.122a.775.775 0 00-.568.01l-2.825 1.228c-.323.143-.39.375-.154.531z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6EDAE0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.525 28.464l-.23.067-1.242-.702.189-.1 1.283.735zM44.135 28.235l-.23.067-1.242-.702.189-.1 1.283.735zM44.745 28.005l-.23.068-1.242-.702.189-.102 1.283.736zM45.356 27.776l-.231.068-1.242-.702.189-.102 1.284.736zM45.926 27.526l-.23.067-1.242-.702.188-.1 1.284.735zM46.404 27.22l-.23.068-1.242-.702.188-.102 1.284.736z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.836 22.085l-.27-.194c-.138-.099-.383-.082-.533.038l-2.225 1.757c-.277.221-.255.54.048.684l.252.121a.494.494 0 00.484-.06l2.203-1.704c.252-.196.27-.477.041-.642z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6EDAE0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.733 22.028l.185-.1 1.184.724-.144.137-1.225-.76zM51.25 22.353l.186-.1 1.184.724-.144.137-1.226-.76zM50.768 22.678l.185-.1 1.185.724-.144.137-1.226-.76zM50.286 23.003l.185-.1 1.185.724-.144.137-1.226-.76zM49.84 23.35l.186-.1 1.185.723-.144.137-1.226-.76zM49.486 23.753l.185-.1 1.184.724-.144.137-1.225-.76z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#95C9B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.64 10.93l4.307 6.425-.13.748-3.298-1.966-.878-5.208zM42.309 12.438l5.795 3.46-.955-5.704-.556-.835a49.238 49.238 0 01-4.284 3.08z"
  }))), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M32.426.006c.696-.273 14.812 8.453 14.812 8.453s-5.753 5.408-17.327 10.09l-14.992-8.254S26.18 2.453 32.426.006z",
    fill: "#7AF2F2"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M.843 15.23l.906-1.073.05.76 3.906 2.398-.615.38L.843 15.23z",
    fill: "#546672"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28 11.714c.142.086.079.037.214.131.117.082.211.24.273.365.078.16.092.29.092.464v1.566a.448.448 0 01-.171.357c-.101.08-.235-.03-.324-.079-.136-.074-.26-.182-.386-.272-.146-.105-.073-.078-.219-.183v-.547l.521-1.802z",
    fill: "#E08A35"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M36.922 36.697v1.536l.348-.203v-1.536l-.348.203z",
    fill: "#293237"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M45.47 41.284s-1.911-2.842-3.5-3.525c-1.59-.683-2.851-.143-3.24.363-.388.505-.854 1.053-.83 2.038l.024.985-.176-1.953s.275-3.154 3.55-2.698c3.274.456 5.106 4.47 5.106 4.47l-.933.32z",
    fill: "#546672"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M39.047 36.904c.462-.182 1.035-.266 1.764-.164 3.274.456 5.06 4.658 5.06 4.658l-.32.043c-.407-.58-2.205-3.09-3.582-3.682-1.291-.554-2.356-.3-2.922.085-.375.133-.952 1.083-1.124 3.301l-.591-.34c.228-2.202.759-3.262 1.715-3.9z",
    fill: "#414C5C"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.731s2.107-.339 3.359.607c1.253.947 2.879 2.891 3.053 4.774l.519 1.988.217-.238s-.212-1.655-.382-2.35c-.17-.695-.536-2.816-2.953-4.474-1.683-1.155-3.108-.724-3.108-.724L5 17.731z",
    fill: "#546672"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M11.766 26.124l-.314-.22s.188-1.638-.246-3.208c-.435-1.57-1.68-3.352-3.1-4.062-1.42-.71-2.502-.83-3.105-.509-.604.321-1.307.877-1.463 1.505-.155.627-.445-.242-.445-.242l1.101-1.692.807.036s1.204-.278 2.42.094c1.218.373 3.316 2.244 4.025 4.87.553 2.048.486 2.406.486 2.406l.419.917-.585.105z",
    fill: "#414C5C"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M39.113 33.974l.539.3a.47.47 0 01.235.405v.2a.234.234 0 01-.352.203l-.539-.302a.468.468 0 01-.234-.405v-.198a.234.234 0 01.351-.203z",
    fill: "#E06E18"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M39.014 34.051l.539.3a.47.47 0 01.235.405v.2a.234.234 0 01-.352.203l-.539-.302a.468.468 0 01-.234-.406v-.197c0-.18.195-.293.351-.203z",
    fill: "#E0AB35"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M51.023 39.442l-.21.1c-.022.013-.215-.119-.256-.127-.325-.067-.368.28-.43.483-.076.248-.255.414-.331.662-.068.221-.2.721-.034.975.066.102.523.408.632.358l.656-.299s.408-1.182-.027-2.152z",
    fill: "#E08A35"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M50.17 17.608c.2.055 1.537.385 2.97-.118.169.264.295.476.361.613-6.658 5.86-16.134 9.643-17.729 10.255-.234-.456-.727-1.403-.961-1.853 3.476-2.129 7.935-4.715 15.359-8.897z",
    fill: "#5B949C"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M28.113 27.876s-.065 1.094 1.039 1.391c.185.056.408.083.658.083 1.13-.018 2.55.14 2.772-.176.232-.306 1.335.056 1.335.056a.761.761 0 00.269-.593.755.755 0 00-.27-.593l-.231-.195-.677.028s-.028-.102-.102-.26c-.222-.464-.918-1.4-2.726-1.076-2.354.426-2.067 1.335-2.067 1.335z",
    fill: "#2B8394"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M22.106 24.641l1.86 1.091c0-.357.06-.566-.308-.782 0 0-.573-.396-1.096-.662-.492-.249-.456.353-.456.353zM13.656 19.563l1.86 1.091c0-.356.06-.566-.308-.782 0 0-.573-.396-1.096-.662-.492-.249-.456.353-.456.353z",
    fill: "#414C5C"
  })), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_10017",
    x1: 56.989,
    x2: 37.449,
    y1: 11.143,
    y2: 66.294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_10017",
    x1: 46.833,
    x2: 41.736,
    y1: 45.8,
    y2: 36.973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_0_10017",
    x1: 43.181,
    x2: 39.574,
    y1: 46.193,
    y2: 39.946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint3_linear_0_10017",
    x1: 12.372,
    x2: 7.276,
    y1: 25.909,
    y2: 17.081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint4_linear_0_10017",
    x1: 8.721,
    x2: 5.114,
    y1: 26.302,
    y2: 20.055
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 593.457,
    y: 257.561,
    width: 70.359,
    height: 49.529,
    viewBox: "0 0 70.372 39.355",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M29.862 8.781c.242.154.49.305.745.453.17.414 1.958 1.136 2.518 1.461l2.676 1.553c1.532.89 2.849 1.846 4.351 2.76l.121.072c1.977 1.205 3.91 2.481 5.831 3.772l1.479.997c.539.363.652.337.664.95.02 1.012-41.414-17.215-41.639-16.235C5.666 8.671 2.247 8.61.001 12.156c-.247.391 45.292 26.301 46.259 26.724.555.243 1.133.49 1.738.474.546-.014 1.061-.24 1.56-.462l13.068-5.82c2.674-1.19 6.783-5.814 7.331-6.162.03-.019.18-.045.415-.077.009-.233-.259-.567-.25-.8A249.106 249.106 0 0150.623 14.31c-2.73-1.816-5.43-3.69-7.931-5.81-1.596-1.354-3.112-2.809-4.818-4.02-1.443-1.027-3.007-1.869-4.566-2.709-1.315-.708-2.66-1.427-4.132-1.68-1.935-.332-3.294.217-4.135 2.074-.88 1.942-.738 2.736.859 4.033 1.23 1 2.632 1.737 3.962 2.583z",
    fill: "url(#paint0_linear_0_12461)"
  })), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12461",
    x1: 56.989,
    x2: 37.449,
    y1: 0.942,
    y2: 56.093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 594.487,
    y: 257.561,
    width: 67.982,
    height: 47.676,
    viewBox: "0 0 67.937 47.661",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M52.121 17.162s-.944-1.155.253-2.924c1.021-1.508 1.79-1.012 1.79-1.012s1.171.81.41 2.231c-.482.902-.955 2.13-1.285 2.13-.332-.002-.512 1.102-.512 1.102l-.96-.998.304-.529z",
    fill: "#2A6A00"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M37.417 41.518l6.589-3.657-7.952-3.322 1.363 6.98zM2.645 21.57l6.589-3.657-7.952-3.322 1.363 6.98z",
    fill: "#293237"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M38.967 38.64l1.158 1.888 2.822 4.606 1.394 2.274 1.847-1.07.045-.026.054-.032-.002-.004c.404-.262.699-.697.852-1.278a2.686 2.686 0 00.066-.318c.011-.07.02-.142.028-.216l.011-.116c.008-.116.013-.234.011-.358-.028-2.3-1.703-5.089-3.742-6.23a4.126 4.126 0 00-.332-.168c-.876-.403-1.66-.41-2.245-.083l-.005-.008-1.962 1.138z",
    fill: "url(#paint0_linear_0_9612)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M37.992 40.944c.028 2.3 1.703 5.09 3.742 6.231 2.039 1.141 3.669.202 3.641-2.098-.028-2.3-1.703-5.089-3.742-6.23-2.039-1.143-3.669-.203-3.641 2.097z",
    fill: "#414C5C"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M39.068 41.545c.002.217.026.443.069.668.125.676.416 1.373.814 1.996.249.392.543.755.864 1.066.284.276.588.51.904.687.249.14.493.236.721.29.408.097.776.06 1.074-.094l.026-.016c.111-.06.212-.138.302-.236.07-.074.13-.156.183-.249a.587.587 0 00.063-.125c.048-.09.082-.186.112-.289a2.242 2.242 0 00.079-.408 2.612 2.612 0 00.013-.478 3.675 3.675 0 00-.132-.864 5.227 5.227 0 00-.193-.596 6.045 6.045 0 00-.395-.825c0-.003-.003-.003-.003-.005a5.942 5.942 0 00-.819-1.114l-.005-.005a1.615 1.615 0 00-.151-.159 4.537 4.537 0 00-.668-.557 2.974 2.974 0 00-.278-.172 3.137 3.137 0 00-.244-.125 3.378 3.378 0 00-.297-.114 1.983 1.983 0 00-.501-.098 1.489 1.489 0 00-.392.018c-.135.024-.26.07-.376.133-.355.191-.607.551-.713 1.06-.042.184-.06.388-.057.611z",
    fill: "#A1A1A1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M41.011 40.588c.003.217.027.443.069.668.125.676.416 1.373.814 1.996.25.392.543.756.864 1.066.284.276.589.51.904.687.183.103.366.183.538.24.01-.03.05-.212.058-.244.024-.098.011-.05.021-.165.013-.114.021-.233.018-.36a3.864 3.864 0 00-.137-.982 5.859 5.859 0 00-.591-1.426 5.89 5.89 0 00-.824-1.119 1.615 1.615 0 00-.151-.159 4.342 4.342 0 00-.946-.729 3.137 3.137 0 00-.244-.125 3.378 3.378 0 00-.297-.114 2.639 2.639 0 00-.096.766z",
    fill: "#293237"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 39.8c-.348.304-.554.821-.545 1.513.02 1.63 1.207 3.606 2.652 4.415.628.352 1.202.424 1.648.26-.471.413-1.204.437-2.034-.028-1.445-.809-2.632-2.786-2.652-4.415-.012-.92.352-1.532.931-1.746z",
    fill: "url(#paint1_linear_0_9612)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M39.778 41.748l1.63.941-.756 2.43c.041.123.483-.14.483-.14l1.124-1.209.822 2.015c.26.064.085.478.305.433.311-.109.493-.356.493-.356l-.483-2.025.896.52a3.342 3.342 0 00-.045-.464c-.021-.133-.107-.578-.223-.842l-.771-.566.26-.516a5.943 5.943 0 00-.764-1.017l-.347.451-.645-1.28c-.09-.064-.016-.01-.111-.064a3.135 3.135 0 00-.244-.125 3.378 3.378 0 00-.297-.114 1.983 1.983 0 00-.501-.098l.66 1.615-1.737-.69s-.436.22-.433.442c.004.22.642.434.684.66z",
    fill: "#A1A1A1"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M39.098 42.04l1.669 1.114-.612 1.356c.249.392.205.326.526.636l.938-.91.962 2.043c.408.098.51.094.807-.059l-.631-1.917 1.491.764a2.07 2.07 0 00.052-.592c-.002-.19 0-.258-.032-.454l-1.654-1.07.718-1.274c-.246-.395-.265-.415-.586-.728l-.983.92-1.033-2.132c-.361-.053-.416-.062-.729.064l.625 2.002-1.528-.71c-.04.182-.03.23-.028.453 0 .216-.015.268.028.494z",
    fill: "#D3D3D3"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M41.108 42.688c.004.358.265.792.582.97.317.178.571.032.567-.326-.004-.358-.265-.792-.582-.97-.317-.178-.571-.032-.567.326z",
    fill: "#B6B6B6"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M4.194 18.567l1.157 1.89 2.822 4.605 1.394 2.274 1.847-1.07.045-.026.054-.032-.002-.004c.404-.262.699-.698.852-1.278a2.686 2.686 0 00.066-.318c.011-.07.02-.142.028-.216l.011-.116c.008-.116.013-.234.011-.358-.028-2.3-1.703-5.089-3.742-6.23a4.126 4.126 0 00-.332-.168c-.876-.402-1.66-.41-2.244-.083l-.005-.008-1.962 1.138z",
    fill: "url(#paint2_linear_0_9612)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M3.218 20.872c.028 2.3 1.703 5.09 3.742 6.231 2.04 1.141 3.668.202 3.641-2.098-.028-2.3-1.703-5.089-3.742-6.23-2.039-1.143-3.668-.203-3.641 2.097z",
    fill: "#414C5C"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M4.295 21.473c.002.217.026.443.069.668.125.676.416 1.373.814 1.996.25.392.543.755.864 1.066.284.276.588.51.904.687.249.14.493.236.721.29.409.097.777.06 1.074-.094l.026-.016c.111-.06.212-.138.302-.236.069-.074.13-.156.183-.249a.642.642 0 00.064-.125 1.43 1.43 0 00.111-.289.788.788 0 00.027-.09c.024-.098.042-.204.053-.318a2.612 2.612 0 00.013-.477 3.675 3.675 0 00-.132-.864 5.044 5.044 0 00-.194-.596 6.045 6.045 0 00-.395-.825c0-.002-.003-.002-.003-.002a5.942 5.942 0 00-.819-1.116l-.005-.005a1.615 1.615 0 00-.151-.159 4.537 4.537 0 00-.668-.557 2.975 2.975 0 00-.278-.172 3.136 3.136 0 00-.244-.125 3.262 3.262 0 00-.297-.114 2.001 2.001 0 00-.501-.098 1.488 1.488 0 00-.392.02c-.135.023-.26.068-.377.131-.355.191-.607.551-.713 1.06a2.625 2.625 0 00-.056.61z",
    fill: "#A1A1A1"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M6.237 20.516c.003.217.026.443.07.668.124.676.415 1.373.813 1.996.249.392.543.756.864 1.066.284.276.589.51.904.687.183.103.366.183.538.24.011-.03.05-.212.058-.244.024-.098.011-.05.021-.165.013-.114.021-.233.018-.36a3.84 3.84 0 00-.137-.98 5.859 5.859 0 00-.59-1.427 5.89 5.89 0 00-.824-1.119 1.616 1.616 0 00-.152-.159 4.342 4.342 0 00-.946-.729 3.137 3.137 0 00-.244-.125 3.261 3.261 0 00-.297-.114c-.016.05-.029.103-.04.156-.04.182-.058.386-.056.61z",
    fill: "#293237"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M5.226 19.727c-.348.305-.553.822-.545 1.514.02 1.63 1.207 3.606 2.652 4.415.628.352 1.202.424 1.648.26-.471.412-1.204.437-2.034-.028-1.445-.809-2.632-2.786-2.652-4.415-.012-.92.352-1.532.931-1.746z",
    fill: "url(#paint3_linear_0_9612)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M5.005 21.677l1.63.941-.756 2.43c.041.123.483-.14.483-.14l1.124-1.209.821 2.015c.26.064.085.478.306.433.311-.109.493-.356.493-.356l-.483-2.025.896.52a3.342 3.342 0 00-.045-.464c-.021-.133-.107-.578-.223-.842l-.77-.566.259-.516a5.942 5.942 0 00-.764-1.017l-.347.451-.644-1.28c-.09-.064-.016-.01-.111-.064a3.137 3.137 0 00-.244-.125 3.261 3.261 0 00-.297-.114 2.001 2.001 0 00-.501-.098l.66 1.615-1.737-.69s-.436.22-.433.442c.003.218.641.433.683.66z",
    fill: "#A1A1A1"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M4.325 21.968l1.669 1.114-.612 1.356c.249.392.205.326.526.636l.938-.91.962 2.043c.408.098.51.094.807-.06l-.632-1.917 1.491.764c.05-.202.055-.343.052-.592-.002-.19 0-.258-.032-.453L7.84 22.88l.718-1.274c-.247-.395-.265-.415-.586-.728l-.984.92-1.033-2.133c-.361-.053-.416-.062-.729.064l.625 2.002-1.528-.71c-.04.182-.03.23-.028.453.002.217-.013.27.03.495z",
    fill: "#D3D3D3"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M6.335 22.617c.004.358.265.792.582.97.317.178.571.031.567-.327-.004-.358-.265-.792-.583-.97-.316-.178-.57-.03-.566.327z",
    fill: "#B6B6B6"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M.925 13.637L.89 15.64l2.206 3.208c.112-.168.234-.318.365-.458.234-.234.515-.42.823-.533a2.42 2.42 0 01.945-.178c.608 0 1.263.197 1.928.561 1.141.646 2.17 1.74 2.9 2.985.702 1.198 1.142 2.536 1.151 3.771 0 .505-.056.964-.187 1.366L37.416 41.52a5.76 5.76 0 01-.037-.57c-.01-1.049.281-1.91.851-2.48a2.455 2.455 0 011.769-.721c.618 0 1.263.197 1.928.571 1.254.702 2.367 1.937 3.106 3.34.58 1.104.936 2.293.945 3.415.009.458-.047.89-.159 1.273v.01l.744.394 2.459-.572 1.591-2.255-.837-.525 1.001-4.014-15.664-10.419s-3.392-7.969-5.781-10.247c-3.054-2.91-15.128-8.328-15.128-8.328l-6.651 2.483-5.092-2.242-1.009 1.19-.527 1.815z",
    fill: "#52A51E"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45 11.82l48.947 27.727-15.285-10.523-27.56-16.153-5.093-2.24-1.009 1.19z",
    fill: "#84CB41"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M11.209 24.994c0 .505-.056.964-.187 1.366l26.395 15.158a5.76 5.76 0 01-.037-.57c-.01-1.049.281-1.91.851-2.48a2.31 2.31 0 01.599-.44L10.058 21.224c.702 1.197 1.142 2.535 1.151 3.77z",
    fill: "#519E24"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M32.407 37.655l.005-.209.108-4.682.617-3.338-.251-.048-.62 3.36-.105 4.492-11.23-6.097-.458-4.895.784-4.266-.024-.04-4.402-7.649-4.375 2.614-.976 4.324.006.025.958 5.4.252-.046-.952-5.373.94-4.166 4.058-2.424 4.246 7.382-.773 4.225.47 5.051.063.031 11.659 6.33z",
    fill: "#477413"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M37.415 40.024a4.768 4.768 0 00-.036.557c0 .187.019.384.037.571L11.021 25.994c.101-.309.146-.66.167-1.032l26.227 15.062z",
    fill: "#546672"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M37.379 39.82c-.008-.92.228-1.685.67-2.247l.78.456a2.305 2.305 0 00-.599.44c-.463.463-.73 1.124-.815 1.914-.017-.186-.036-.379-.036-.563z",
    fill: "#409E4E"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M37.415 40.39c-.019.181-.038.362-.036.557 0 .187.019.384.037.571L11.021 26.36c.101-.309.146-.66.167-1.032L37.415 40.39zM0 15.366v1.507l.515 1.572 1.291 1.32.571 1.637.29.168a4.363 4.363 0 01-.056-.692c-.01-.795.159-1.488.486-2.03.112-.168.234-.318.365-.458.234-.234.515-.42.823-.533l-2.489-1.46-.524-.3L0 15.367zM9.62 14.084l.821 2.06 1.853 1.056.206.113.215.131.571.346.468.281.29.177.393.234.318.187 6.559 3.94.842.505 8.842 5.305.412.243L33.637 30l.252-1.422-3.611-6.596-.403-.74-1.188-2.17-13.23-7.27-.15-.094-.435-.235-5.252 2.611z",
    fill: "#414C5C"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M15.114 12.032l-4.348 2.724L10.93 16l22.435 13.403.13-.755-5.081-9.304-13.3-7.31z",
    fill: "#529BA3"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M12.569 17.225l.29.3.206.111.215.131 2.873-5.314-.131-.328-.15-.093-.318.16-2.985 5.033zM20.808 22.14l.842.504 1.437-6.304-.851-.42-1.428 6.22zM29.772 21.186v6.281l.412.243.094-5.728-.403-.74-.103-.056z",
    fill: "#414C5C"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M36.757 36.825v1.55L11.26 22.317l.351-.205 25.146 14.713z",
    fill: "#546672"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M36.406 37.03v1.55L11.26 23.865v-1.549L36.406 37.03z",
    fill: "#414C5C"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9 33.471l.39-3.512-16.674 9.34-.748 3.722s11.097-2.718 17.032-9.55z",
    fill: "#293237"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 42.443l.119-.592c1.331-.469 9.707-3.56 16.631-9.387.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.046-15.929 9.147-16.749 9.43z",
    fill: "#293237"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 41.627l.119-.592c1.331-.469 9.707-3.56 16.631-9.388.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.047-15.929 9.148-16.749 9.43z",
    fill: "#293237"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 40.811l.119-.592c1.331-.469 9.707-3.56 16.631-9.388.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.047-15.929 9.148-16.749 9.43z",
    fill: "#293237"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 42.59l.119-.592c1.331-.469 9.707-3.56 16.631-9.388.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.047-15.929 9.147-16.749 9.43z",
    fill: "#546672"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 41.774l.119-.592c1.331-.469 9.707-3.56 16.631-9.388.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.047-15.929 9.148-16.749 9.43z",
    fill: "#546672"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 40.958l.119-.592c1.331-.469 9.707-3.56 16.631-9.388.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.047-15.929 9.147-16.749 9.43z",
    fill: "#546672"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M50.145 39.55c1.325-.467 9.634-3.535 16.539-9.314a3.1 3.1 0 01.168.33.32.32 0 01-.077.147c-7.183 6.046-15.93 9.147-16.75 9.43l.12-.593z",
    fill: "#546672"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M66.078 38.017L49.171 47.64l-.149-1.462 16.904-9.63.152 1.47z",
    fill: "#141E25"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M45.978 45.074c.009.458-.047.89-.159 1.273l.767.402 2.582.89-.15-1.46.533-.038c.524-.038 1.029.34 1.506.125.112-.056.225-.112.328-.168l15.71-8.917c.168-.094.318-.225.431-.374.168-.215.271-.477.29-.739l.121-2.146-.411.224-16.468 9.123-.449.252v.066l-5.576-2.172v.244c.58 1.104.936 2.292.945 3.415z",
    fill: "#414C5C"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M51.058 43.268v2.994c.112-.056.225-.112.328-.168 0 0 3.209-1.076 7.224-3.209a51.435 51.435 0 004.089-2.405 39.107 39.107 0 004.398-3.303c.141-.12.318-.224.431-.374v-2.657l-16.47 9.122z",
    fill: "#293237"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M50.423 39.9l3.066-1.455c.217-.099.506.104.486.341l-.094 1.132a1.019 1.019 0 01-.604.858l-2.616 1.196-.238-2.072zM64.206 32.51l2.351-1.837-.183 2.512-2.28 1.79a.29.29 0 01-.47-.25l.094-1.299c.025-.36.203-.694.488-.917z",
    fill: "#9CB7D2"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M66.374 30.815c-.079-.206.808-.71.808-.71.426 1.638-.256 2.555-.256 2.555l-.552.525s.169-1.93 0-2.37z",
    fill: "#E08A35"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M59.673 35.952c-.005.421-.312.933-.686 1.142-.373.21-.672.037-.667-.384.005-.42.312-.933.686-1.142.373-.21.672-.038.667.384z",
    fill: "#768A99"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M59.865 36.044c-.005.421-.312.932-.686 1.142-.373.21-.672.037-.667-.384.005-.422.312-.932.686-1.142.374-.209.673-.037.667.384z",
    fill: "#C4C4C4"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M45.523 41.165l-.49.25 4.942 2.25c.403.162.858.132 1.236-.082 0 0 12.388-4.922 16.513-9.365.206-.222.299-.515.07-.712l-.865-.746s-.032.512-.153.614c-7.543 6.35-16.818 9.453-16.818 9.453l-4.435-1.662zM53.805 43.213v.427a.43.43 0 01-.272.412l-1.828.71c-.147.057-.331-.082-.331-.25v-.12l1.531-.593a.43.43 0 00.272-.412v-.307l.298-.114c.146-.057.33.082.33.247z",
    fill: "#546672"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M53.176 43.08v.307a.43.43 0 01-.272.412l-1.531.593v-.304a.43.43 0 01.272-.415l1.531-.593z",
    fill: "#BED5DF"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M67.211 35.248v.315c0 .17-.063.326-.163.41l-1.094.925c-.089.075-.199-.02-.199-.169v-.107l.916-.773c.1-.085.163-.24.163-.41v-.209l.178-.149c.089-.074.199.02.199.167z",
    fill: "#546672"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M66.834 35.231v.208c0 .17-.063.326-.163.411l-.916.773v-.206c0-.172.063-.328.163-.413l.916-.773z",
    fill: "#BED5DF"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M58.591 41.415v1.347c0 .047.009.084.019.122a51.435 51.435 0 004.089-2.405.364.364 0 00.028-.13V39c0-.27-.197-.365-.44-.225l-3.256 1.9c-.244.14-.44.477-.44.74z",
    fill: "#12181D"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M62.289 40.813c.242-.142.439-.472.439-.737v-1.35c0-.266-.197-.366-.439-.224l-3.257 1.903c-.242.141-.439.472-.439.736v1.35c0 .265.197.365.439.224l3.257-1.902z",
    fill: "#D3D3D3"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M59.031 42.626l3.257-1.903c.197-.115.357-.383.357-.599v-1.35c0-.215-.16-.296-.357-.18l-3.257 1.902c-.197.115-.357.383-.357.598v1.35c.001.216.16.297.357.182z",
    fill: "#EFEC82"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#D3A944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.677 41.084a.777.777 0 01.355-.589l3.257-1.903c.194-.113.351-.035.355.174l-3.967 2.318zM62.644 40.134a.777.777 0 01-.355.588l-3.257 1.903c-.194.113-.351.035-.355-.174l3.967-2.317z"
  }))), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M19.763.616L2.459 10.63l5.092 2.242 18.365-10.63L21.952.494a2.426 2.426 0 00-2.189.121z",
    fill: "#98DD49"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M50.423 39.9l2.876-1.369-.076.916a1.02 1.02 0 01-.604.858l-1.891.864-.305-1.269zM63.717 33.426c.026-.36.204-.694.489-.917l1.602-1.252-.084 1.153a1.182 1.182 0 01-.449.844l-1.639 1.286.081-1.114z",
    fill: "#BED5DF"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M25.917 2.24C19.652 4.43 7.552 12.871 7.552 12.871l6.651-2.483L31.87.005s-4.277 1.65-5.953 2.235z",
    fill: "#414C5C"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M14.272 10.133c8.06-5.37 14.414-8.778 14.414-8.778-1.011.377-1.972.776-2.544.976C21.55 3.937 14.025 8.94 9.945 11.647c0 0 3.373-.879 4.327-1.514z",
    fill: "#88D5DE"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M66.889 30.201c-7.127 5.491-16.492 9.346-16.492 9.346L35.112 28.963 53.484 18.34l13.748 11.596-.343.265z",
    fill: "#84CB41"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M51.416 20.722s-.624 2.02-5.185 4.592c-4.561 2.573-7.042 2.495-7.042 2.495l-4.076 1.215L53.27 18.34l-1.854 2.382z",
    fill: "#414C5C"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M46.815 8.536s-5.26 5.028-17.484 10.18c0 0 3.103 4.966 5.781 10.247 0 0 10.918-3.99 18.372-10.623 0 0-3.004-4.566-6.669-9.804z",
    fill: "#414C5C"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M29.772 18.838c.823 1.086 3.209 5.361 5.474 9.778 1.609-.618 11.172-4.435 17.89-10.349-.44-.917-3.303-4.809-6.362-9.328-.14.121-.346.29-.608.505a49.553 49.553 0 01-4.323 3.106c-2.78 1.778-6.738 4.014-12.071 6.288z",
    fill: "#3D7D87"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M63.753 31.85L51.416 20.722s1.817-2.075 2.39-1.688c6.571 4.45 12.191 10.346 12.191 10.346l-2.244 2.47z",
    fill: "#79A63F"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M63.753 31.85L51.652 20.412l1.832-2.07C60.055 22.79 67.29 29.958 67.29 29.958l-3.537 1.891zM50.811 39.383L35.112 29.024l4.076-1.215 15.549 9.377-3.926 2.197z",
    fill: "#98DD49"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.796 28.58l.281.186c.144.095.431.101.626.014l2.884-1.283c.359-.162.387-.43.06-.578l-.272-.123a.783.783 0 00-.573.01l-2.85 1.24c-.326.142-.394.376-.156.534z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#84CB41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.069 28.722l-.232.068-1.254-.708.191-.103 1.295.743zM43.685 28.49l-.232.068-1.254-.708.19-.102 1.296.742zM44.3 28.26l-.232.067-1.253-.708.19-.102 1.295.742zM44.916 28.028l-.232.068-1.254-.708.191-.103 1.295.743zM45.492 27.775l-.232.07-1.254-.71.19-.102 1.296.742zM45.974 27.467l-.232.068-1.254-.708.191-.103 1.295.743z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.465 22.285l-.272-.196c-.139-.1-.387-.082-.538.038L49.41 23.9c-.279.224-.257.544.049.691l.254.122a.496.496 0 00.488-.062l2.223-1.718c.254-.197.272-.48.041-.647z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#84CB41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.351 22.228l.187-.102 1.195.732-.145.138-1.237-.768zM50.865 22.556l.186-.1 1.195.73-.145.137-1.236-.767zM50.378 22.883l.187-.1 1.195.73-.145.138-1.237-.768zM49.891 23.211l.187-.1 1.195.73-.145.138-1.237-.768zM2.267 3.251l.091-.053 4.861 5.089-.092.053-4.86-5.089zM49.083 23.968l.187-.1 1.195.73-.145.138-1.237-.768z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#95C9B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.222 11.028l4.346 6.484-.131.754-3.329-1.983-.886-5.255zM41.842 12.55l5.848 3.49-.964-5.754-.561-.842a49.772 49.772 0 01-4.323 3.106z"
  }))), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M31.869.006c.702-.275 14.946 8.53 14.946 8.53s-5.806 5.457-17.484 10.18l-15.128-8.328S25.567 2.474 31.869.006z",
    fill: "#98DD49"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.366l.914-1.08.05.766 3.941 2.42-.62.383L0 15.366z",
    fill: "#546672"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45 11.82c.143.087.08.037.216.132.118.083.213.242.275.368a.961.961 0 01.093.468v1.579a.455.455 0 01-.172.361c-.102.08-.238-.03-.327-.08-.137-.075-.262-.183-.389-.274-.147-.105-.074-.079-.221-.185v-.552l.525-1.817z",
    fill: "#E08A35"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M36.406 37.03v1.55l.351-.205v-1.55l-.351.204z",
    fill: "#293237"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M45.033 41.658s-1.929-2.867-3.534-3.556c-1.604-.689-2.877-.144-3.269.366-.392.51-.862 1.063-.838 2.057l.024.994-.177-1.97s.278-3.183 3.582-2.723c3.304.46 5.152 4.51 5.152 4.51l-.94.322z",
    fill: "#546672"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M38.55 37.24c.466-.184 1.045-.269 1.781-.167 3.304.46 5.107 4.701 5.107 4.701l-.324.044c-.411-.585-2.225-3.119-3.615-3.716-1.302-.559-2.377-.303-2.949.086-.379.134-.961 1.093-1.134 3.331l-.597-.343c.231-2.223.767-3.292 1.731-3.937z",
    fill: "#414C5C"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M4.194 17.892s2.126-.342 3.39.613c1.264.955 2.905 2.917 3.08 4.818l.524 2.006.219-.24s-.214-1.67-.385-2.372-.541-2.842-2.98-4.515c-1.699-1.165-3.137-.73-3.137-.73l-.711.42z",
    fill: "#546672"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M11.022 26.36l-.317-.224s.19-1.652-.248-3.236c-.439-1.584-1.696-3.382-3.128-4.099-1.433-.716-2.524-.837-3.134-.514-.609.323-1.319.885-1.476 1.518-.157.633-.449-.244-.449-.244l1.111-1.707.814.036s1.215-.28 2.443.095c1.228.376 3.345 2.264 4.06 4.913.558 2.067.491 2.428.491 2.428l.423.925-.59.11z",
    fill: "#414C5C"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M38.617 34.282l.543.302a.47.47 0 01.237.41v.202a.237.237 0 01-.355.205l-.544-.305a.472.472 0 01-.236-.409v-.199c0-.183.197-.297.355-.206z",
    fill: "#E06E18"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M38.517 34.36l.544.301a.472.472 0 01.237.41v.202a.237.237 0 01-.355.205l-.544-.305a.473.473 0 01-.237-.409v-.199a.238.238 0 01.355-.206z",
    fill: "#E0AB35"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M50.635 39.8l-.212.1c-.022.013-.217-.12-.258-.128-.328-.067-.371.283-.434.487-.076.25-.258.418-.334.668-.068.223-.202.728-.035.983.067.102.528.411.638.362l.661-.3s.413-1.193-.026-2.173z",
    fill: "#E08A35"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M49.774 17.767c.202.055 1.552.39 2.998-.119.169.266.297.48.363.618-6.718 5.914-16.28 9.731-17.89 10.35-.236-.46-.734-1.417-.97-1.87 3.508-2.149 8.008-4.758 15.499-8.979z",
    fill: "#5B949C"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M27.517 28.13s-.066 1.103 1.048 1.403c.187.056.412.084.664.084 1.141-.019 2.573.14 2.798-.178.234-.309 1.347.056 1.347.056a.766.766 0 00.271-.599.766.766 0 00-.271-.599l-.234-.197-.683.028s-.028-.103-.103-.262c-.225-.468-.927-1.413-2.751-1.086-2.376.432-2.086 1.35-2.086 1.35z",
    fill: "#3B7E10"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M21.456 24.864l1.876 1.102c.001-.36.061-.57-.311-.789 0 0-.579-.4-1.106-.669-.496-.25-.459.356-.459.356zM12.929 19.74l1.877 1.102c.001-.36.061-.57-.311-.789 0 0-.579-.4-1.106-.668-.496-.252-.46.355-.46.355z",
    fill: "#414C5C"
  })), _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9612",
    x1: 46.407,
    x2: 41.264,
    y1: 46.216,
    y2: 37.308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_9612",
    x1: 42.722,
    x2: 39.082,
    y1: 46.612,
    y2: 40.308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_0_9612",
    x1: 11.634,
    x2: 6.49,
    y1: 26.144,
    y2: 17.236
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint3_linear_0_9612",
    x1: 7.949,
    x2: 4.309,
    y1: 26.54,
    y2: 20.236
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 408.131,
    y: 270.856,
    width: 377.864,
    height: 230.535,
    viewBox: "0 0 377.831 230.562",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M377.831 3.164v12.342L5.496 230.562v-12.373L377.831 3.164z",
    fill: "#CFC091"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M5.496 218.189v12.373L0 227.398v-12.359l5.496 3.15z",
    fill: "#998C62"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M5.496 218.189L377.831 3.164 372.334 0 0 215.039l5.496 3.15z",
    fill: "#EBDDB2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 13.787,
    y: 255.654,
    width: 170.748,
    height: 110.5,
    viewBox: "0 0 170.728 110.518",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.164v12.342l165.232 95.012V98.146L0 3.164z",
    fill: "#998C62"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M165.232 98.146v12.372l5.496-3.164V94.995l-5.496 3.151z",
    fill: "#CFC091"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M165.232 98.146L0 3.164 5.497 0l165.231 94.995-5.496 3.151z",
    fill: "#EBDDB2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 394.423,
    y: 475.019,
    width: 24.721,
    height: 26.426,
    viewBox: "0 0 24.766 26.406",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.164v12.342l19.27 10.9V14.034L0 3.164z",
    fill: "#998C62"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M19.27 14.034v12.372l5.496-3.163v-12.36l-5.496 3.151z",
    fill: "#CFC091"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M19.27 14.034L0 3.164 5.497 0l19.269 10.883-5.496 3.151z",
    fill: "#EBDDB2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 762.7,
    y: 274.016,
    width: 12.281,
    height: 6.157,
    viewBox: "0 0 12.295 6.164",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.301L12.295 0 1.59 6.164 0 5.301z",
    fill: "#7D7250"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 178.988,
    y: 272.273,
    width: 190.001,
    height: 125.266,
    viewBox: "0 0 10.158 5.871",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M10.158 3.475L5.992 5.871 0 2.404 4.167 0l5.991 3.475z",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 264.005,
    y: 314.664,
    width: 37.794,
    height: 21.849,
    viewBox: "0 0 37.788 21.823",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .586l36.803 21.237.985-.551L.982 0 0 .586z",
    fill: "#FFEF75"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 206.165,
    y: 323.545,
    width: 44.688,
    height: 25.772,
    viewBox: "0 0 44.677 25.784",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M44.677.585L.985 25.784 0 25.234 43.694 0l.983.585z",
    fill: "#FFEF75"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 178.988,
    y: 310.196,
    width: 146.899,
    height: 87.343,
    viewBox: "0 0 146.874 87.311",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M146.869 33.922v-2.568L54.296 84.582v2.729l92.573-53.389z",
    fill: "#EAC72F"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M139.972 35.316l-2.584 1.527v2.547l2.584-1.49v-2.584z",
    fill: "#858482"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M54.296 84.582L0 53.293v2.667l54.296 31.351v-2.729z",
    fill: "#C19424"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M146.874 31.356L54.293 84.582 0 53.294l14.841-8.546 2.937 1.703L84.416 8.096l-2.947-1.704L92.58 0l54.294 31.356z",
    fill: "#FFEF75"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M140.99 31.346L54.293 81.194l-48.409-27.9 11.894-6.843L84.416 8.096l8.154-4.699 48.42 27.949z",
    fill: "#DBDBDB"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M142.077 34.13l-4.698 2.702-6.757-3.91 4.699-2.711 6.756 3.919z",
    fill: "#C3C2C2"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M84.416 8.096L17.778 46.451l-2.937-1.703L81.469 6.392l2.947 1.704z",
    fill: "#C19424"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M96.271 15.506a.942.942 0 01-.49.852L34.616 51.65a7.81 7.81 0 01-3.906 1.047 7.8 7.8 0 01-3.896-1.047l-9.036-5.198L84.416 8.096l11.366 6.559a.96.96 0 01.489.851z",
    fill: "#C3C2C2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 207.116,
    y: 287.039,
    width: 92.861,
    height: 95.788,
    viewBox: "0 0 92.827 95.798",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M92.827 20.134v42.13L34.875 95.798V53.564l57.952-33.43z",
    fill: "#CFC091"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 53.564v42.234L.002 75.666V33.475l34.873 20.089z",
    fill: "#998C62"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M92.822 20.133L34.87 53.566 0 33.472 57.955 0l34.867 20.133z",
    fill: "#FACB6B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 319.469,
    y: 338.148,
    width: 7.369,
    height: 15.038,
    viewBox: "0 0 7.386 15.005",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M7.386 12.587V1.859L3.22 4.255v10.75l4.166-2.418z",
    fill: "#FF813D"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22 4.255L0 2.405v10.741l3.22 1.859V4.255z",
    fill: "#D4531C"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M7.386 1.859L3.219 4.255 0 2.405 4.167 0l3.219 1.859z",
    fill: "#FFBA81"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 319.469,
    y: 336.513,
    width: 7.369,
    height: 5.994,
    viewBox: "0 0 7.386 5.979",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M7.386 3.561V1.859L3.22 4.255v1.724l4.166-2.418z",
    fill: "#555D69"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22 4.255L0 2.404V4.12l3.22 1.859V4.255z",
    fill: "#454545"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M7.386 1.859L3.219 4.255 0 2.404 4.167 0l3.219 1.859z",
    fill: "#7A7A7A"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 244.197,
    y: 338.965,
    width: 13.866,
    height: 29.26,
    viewBox: "0 0 13.804 29.215",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.976v21.239l13.804-7.976V0L0 7.976z",
    fill: "#FFDE9C"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M13.067 1.354v19.264l-.086.043-.105.061-.998.582-1.814 1.059-2.692 1.563L.74 27.763V8.473l5.747-3.325 5.391-3.117.998-.573.07-.043.121-.061z",
    fill: "#90C7C7"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M12.876 1.459v19.265l-.997.579V2.036l.997-.577z",
    fill: "url(#paint0_linear_0_14457)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M12.979 20.664L.739 27.763V26.46l11.14-6.431 1.1.635z",
    fill: "url(#paint1_linear_0_14457)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.371V1.669l.553-.318v19.263L.739 27.763v-.268l11.773-7.124z",
    fill: "#CF9219"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.371l.553.243L.739 27.763v-.576l11.773-6.816z",
    fill: "#FFEF75"
  })), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_14457",
    x1: 11.407,
    x2: 12.806,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_14457",
    x1: 6.22,
    x2: 7.357,
    y1: 23.038,
    y2: 25.131
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 257.271,
    y: 331.446,
    width: 13.787,
    height: 29.205,
    viewBox: "0 0 13.804 29.216",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.976v21.24l13.804-7.977V0L0 7.976z",
    fill: "#FFDE9C"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 1.351v19.263l-.096.044-.095.069-.999.573-.477.278-4.028 2.344-2.414 1.398L.74 27.759V8.478l7.102-4.106 4.036-2.336.999-.581.191-.104z",
    fill: "#90C7C7"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M12.876 1.459v19.265l-.997.579V2.036l.997-.577z",
    fill: "url(#paint0_linear_0_12214)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M12.979 20.664L.739 27.763V26.46l11.14-6.431 1.1.635z",
    fill: "url(#paint1_linear_0_12214)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.371V1.669l.553-.318v19.263L.739 27.763v-.268l11.773-7.124z",
    fill: "#CF9219"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.371l.553.243L.739 27.763v-.576l11.773-6.816z",
    fill: "#FFEF75"
  })), _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12214",
    x1: 11.407,
    x2: 12.806,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_12214",
    x1: 6.22,
    x2: 7.357,
    y1: 23.038,
    y2: 25.131
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 223.834,
    y: 337.712,
    width: 13.787,
    height: 29.205,
    viewBox: "0 0 13.804 29.215",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M13.804 7.976v21.239L0 21.239V0l13.804 7.976z",
    fill: "#D9A234"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 8.478v19.29h-.008v-.009l-6.555-3.794-.078-.043L1.93 21.3l-1.007-.573-.095-.07-.087-.043V1.35l.182.104 1.007.582 1.693.981 6.45 3.733 2.995 1.728z",
    fill: "#538B94"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M.928 1.459v19.265l.997.579V2.036l-.997-.577z",
    fill: "url(#paint0_linear_0_12200)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M.825 20.664l12.241 7.099V26.46L1.925 20.029l-1.1.635z",
    fill: "url(#paint1_linear_0_12200)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M1.292 20.371l.001-18.702-.554-.318v19.263l12.326 7.149v-.268L1.292 20.371z",
    fill: "#EAC72F"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 8.478v8.299l-6.563 7.188-.078-.043L1.93 21.3l-1.007-.573-.095-.07-.087-.043v-3.646L10.073 6.75l2.995 1.728zM3.623 3.017L.741 6.168V1.35l.182.104 1.007.582 1.693.981z",
    fill: "#21362E"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M1.292 20.371l-.553.243 12.326 7.149v-.576L1.292 20.371z",
    fill: "#FFEF75"
  })), _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12200",
    x1: 2.397,
    x2: 0.998,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#0A7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#24828E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#35848C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_12200",
    x1: 7.584,
    x2: 6.447,
    y1: 23.038,
    y2: 25.13
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#0A7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#24828E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#35848C"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 210.761,
    y: 330.138,
    width: 13.787,
    height: 29.26,
    viewBox: "0 0 13.804 29.215",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M13.804 7.976v21.239L0 21.239V0l13.804 7.976z",
    fill: "#D9A234"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 8.474v19.29h-.009l-1.449-.842-5.183-3.004-1.268-.738-3.229-1.875-.998-.582-.105-.061-.086-.052V1.355l.191.104.998.573 6.806 3.933 2.084 1.207.737.425 1.511.877z",
    fill: "#538B94"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M10.82 7.172v4.427l-.087.044-.096.069-1.007.573-4.497 2.622L.741 17.45V1.355l.191.104.998.573 8.89 5.14zM13.068 8.474v1.858l-1.502.868h-.009V7.597l1.511.877z",
    fill: "#B5D6C7"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M.928 1.459v19.265l.997.579V2.036l-.997-.577z",
    fill: "url(#paint0_linear_0_15200)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M.825 20.663l12.241 7.1V26.46L1.925 20.029l-1.1.634z",
    fill: "url(#paint1_linear_0_15200)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M1.293 20.371V1.669L.74 1.351.739 20.614l12.326 7.149v-.268L1.293 20.371z",
    fill: "#EAC72F"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 8.474v6.051L5.159 23.18 1.93 21.305l-.998-.582-.105-.061-.086-.052v-5.894l7.995-8.751 2.084 1.207.737.425 1.511.877z",
    fill: "#21362E"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M1.293 20.371l-.554.243 12.326 7.149v-.576L1.293 20.371z",
    fill: "#FFEF75"
  })), _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_15200",
    x1: 2.397,
    x2: 0.998,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#0A7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#24828E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#35848C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_15200",
    x1: 7.584,
    x2: 6.447,
    y1: 23.038,
    y2: 25.13
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#0A7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#24828E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#35848C"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 270.344,
    y: 323.872,
    width: 13.787,
    height: 29.205,
    viewBox: "0 0 13.804 29.216",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.976v21.24l13.804-7.976V0L0 7.976z",
    fill: "#FFDE9C"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M13.068 1.349v19.264l-.095.052-.096.06-.998.582-.018.009-4.488 2.604-1.068.617-5.564 3.22v.009H.732V8.476l7.561-4.375 3.586-2.066.998-.573.191-.113z",
    fill: "#90C7C7"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M12.876 1.459v19.266l-.997.578V2.036l.997-.577z",
    fill: "url(#paint0_linear_0_12192)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M12.979 20.664l-12.241 7.1v-1.303l11.141-6.431 1.1.634z",
    fill: "url(#paint1_linear_0_12192)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.372l-.001-18.703.553-.318.001 19.263-12.326 7.15v-.268l11.773-7.124z",
    fill: "#CF9219"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 20.372l.553.242-12.326 7.15v-.577l11.773-6.815z",
    fill: "#FFEF75"
  })), _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12192",
    x1: 11.407,
    x2: 12.806,
    y1: 11.381,
    y2: 11.381
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_12192",
    x1: 6.22,
    x2: 7.357,
    y1: 23.038,
    y2: 25.131
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 283.497,
    y: 317.333,
    width: 12.043,
    height: 41.465,
    viewBox: "0 0 12.041 41.479",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M12.041 34.508V0L0 6.954v34.525l12.041-6.971z",
    fill: "#FFDE9C"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M11.397 1.177v33.666l-.076.041-.088.057-.872.503-3.927 2.286-5.789 3.348v.005H.64V7.392l9.721-5.62.872-.503.164-.092z",
    fill: "#E5E6E5"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M11.397 31.043v3.8l-.076.041-.088.057-.872.503-3.927 2.286-5.789 3.348v.005H.64v-3.826l9.721-5.619.872-.503.164-.092z",
    fill: "#C9C9C9"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M10.915 34.631V1.453l.482-.278.001 33.668L.643 41.081v-.234l10.272-6.216z",
    fill: "#CF9219"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M10.915 34.631l.721.296L.643 41.249v-.671l10.272-5.947z",
    fill: "#DBDBDB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 207.116,
    y: 304.529,
    width: 92.861,
    height: 39.231,
    viewBox: "0 0 92.825 39.256",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M92.825 0v6.222L39.83 36.796c-.061.035-5.133 3.148-7.119 2.32-.517-.216-1.042-.408-1.528-.695L4.271 22.916 0 20.459V13.34l34.873 20.089L92.825 0z",
    fill: "#CFCECB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 204.58,
    y: 272.273,
    width: 97.932,
    height: 68.272,
    viewBox: "0 0 97.951 68.29",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M97.95 22.222v11.952l-.078.009a2.548 2.548 0 01-.972 1.476 1.929 1.929 0 01-.26.174L42.396 67.128c-.06.035-.113.061-.174.096a8.607 8.607 0 01-6.944.599 8.305 8.305 0 01-1.529-.695L6.837 51.623l-5.53-3.186a2.562 2.562 0 01-1.19-1.528H.11v-.026s-.104-.59-.104-1.155V34.661l6.832-.877 9.6 1.387 14.064-8.117 25.05-17.09a8.66 8.66 0 018.656 0L85.572 24.92l1.093.634L96.71 22.3l1.242-.078z",
    fill: "#D9D7D0"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9 22.3v10.739c-.078 2.681-.165 2.741-.26 2.793L42.396 67.127c-.06.035-.113-9.417-.174-12.003L45.907 22.3H96.9z",
    fill: "#E6E4DD"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M35.255 43.006l.021 24.815s-1.042-.408-1.528-.695L2.558 49.156l.007-11.422 13.873-2.563 14.064-8.117 4.753 15.952z",
    fill: "#B6B4AE"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M2.557 34.331v14.826l-1.25-.72a2.562 2.562 0 01-1.19-1.528H.11v-.026s-.104-.59-.104-1.155V34.661l2.551-.33z",
    fill: "#ADABA5"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M1.304 32.49L55.548 1.161a8.66 8.66 0 018.662 0l32.434 18.728c1.738 1.004 1.738 3.515-.002 4.519L42.4 55.702a8.66 8.66 0 01-8.653.001L1.306 37.008c-1.74-1.002-1.741-3.513-.002-4.518z",
    fill: "#F4F4F4"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M38.072 55.124a6.937 6.937 0 01-3.459-.925L2.174 35.504a.857.857 0 01-.438-.755c0-.151.042-.528.436-.756L56.414 2.664a6.935 6.935 0 016.927 0l32.434 18.728a.857.857 0 01.435.756.855.855 0 01-.435.755L41.53 54.197a6.926 6.926 0 01-3.46.927z",
    fill: "#898989"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M96.215 22.151c0 .148-.044.53-.444.755l-1.883 1.085-30.55-17.64a6.907 6.907 0 00-3.455-.92c-.45 0-.894.043-1.337.13a6.698 6.698 0 00-2.127.79L4.06 36.595l-1.885-1.094a.836.836 0 01-.434-.755.85.85 0 01.435-.755L56.419 2.662a6.698 6.698 0 012.128-.79 6.914 6.914 0 014.792.79l32.433 18.734c.4.225.442.599.442.755z",
    fill: "#D9D7D0"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M96.215 22.151c0 .148-.044.53-.444.755l-1.883 1.085-30.55-17.64a6.907 6.907 0 00-3.455-.92c-.45 0-.894.043-1.337.13V1.872a6.914 6.914 0 014.792.79l32.434 18.734c.4.225.442.599.442.755z",
    fill: "#B6B4AE"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 244.91,
    y: 279.574,
    width: 25.83,
    height: 14.929,
    viewBox: "0 0 25.899 14.901",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.782L15.31 0l10.589 6.119-15.31 8.782L0 8.782z",
    fill: "#545454"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 259.331,
    y: 286.875,
    width: 23.77,
    height: 14.875,
    viewBox: "0 0 23.778 14.901",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.872L13.189 0l10.589 6.119-15.311 8.782L0 9.872z",
    fill: "#545454"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 248.793,
    y: 277.176,
    width: 25.83,
    height: 19.561,
    viewBox: "0 0 25.899 14.901",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.782L15.31 0l10.589 6.119-15.31 8.782L0 8.782z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 258.221,
    y: 279.465,
    width: 11.568,
    height: 7.628,
    viewBox: "0 0 11.542 7.623",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01.253C5.09-.498 1.703.48.468 2.436a2.95 2.95 0 00-.34.72 2.493 2.493 0 00.079 1.777c.153.367.388.71.694 1.02.616.64 1.527 1.134 2.633 1.417.184.048.37.09.559.122a8.583 8.583 0 003.897-.214c1.343-.402 2.474-1.128 3.087-2.09.035-.052.066-.106.097-.16.43-.761.485-1.571.162-2.343C10.865 1.562 9.652.673 8.01.253z",
    fill: "#849FA1"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 258.617,
    y: 279.519,
    width: 11.568,
    height: 7.628,
    viewBox: "0 0 11.543 7.622",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01.253C5.09-.498 1.701.48.466 2.435c-.15.235-.266.476-.34.722a2.498 2.498 0 00.08 1.776c.152.367.387.71.693 1.02.616.64 1.527 1.134 2.633 1.417a8.583 8.583 0 004.457-.093c1.343-.402 2.473-1.128 3.087-2.09.035-.052.066-.106.097-.16.43-.761.485-1.571.162-2.343C10.865 1.56 9.651.673 8.01.253z",
    fill: "#C3C9C9"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 259.489,
    y: 283.933,
    width: 3.249,
    height: 3.106,
    viewBox: "0 0 3.193 3.109",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M3.193 1.677L0 0v1.572c.616.639 1.527 1.133 2.633 1.416.184.048.371.09.56.121V1.677z",
    fill: "#AEBABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 262.738,
    y: 285.513,
    width: 3.882,
    height: 1.635,
    viewBox: "0 0 3.898 1.628",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M3.898 0L.001.065 0 1.497a8.583 8.583 0 003.897-.214L3.898 0z",
    fill: "#C3C9C9"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 266.62,
    y: 283.388,
    width: 3.169,
    height: 3.433,
    viewBox: "0 0 3.184 3.448",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M3.184 0L.001 2.165 0 3.448c1.343-.402 2.473-1.128 3.087-2.09a2.62 2.62 0 00.097-.16V0z",
    fill: "#DCE0E0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 258.617,
    y: 282.68,
    width: 0.872,
    height: 2.833,
    viewBox: "0 0 0.899 2.797",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M.126 0a2.498 2.498 0 00.08 1.776c.152.367.387.71.693 1.021V1.225L.126 0z",
    fill: "#9CADAD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 248.793,
    y: 285.949,
    width: 10.538,
    height: 10.788,
    viewBox: "0 0 10.589 10.79",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M10.589 6.119L0 0l.001 4.671 10.588 6.119V6.119z",
    fill: "#B4BABD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 259.331,
    y: 283.279,
    width: 15.292,
    height: 13.458,
    viewBox: "0 0 15.31 13.453",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M15.31 4.67V0L0 8.782v4.671L15.31 4.67z",
    fill: "#CDCFCE"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 259.014,
    y: 279.41,
    width: 10.696,
    height: 7.029,
    viewBox: "0 0 10.741 7.018",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.779C.56 6.077-.727 4.045.419 2.239c1.145-1.806 4.29-2.701 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.146 1.806-4.291 2.7-7.027 2z",
    fill: "#B3B8B8"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 260.281,
    y: 280.99,
    width: 8.636,
    height: 5.449,
    viewBox: "0 0 8.66 5.457",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M8.322 3.852c-.825 1.301-4.688 1.563-5.504 1.605-.071-.087-.208-.118-.3-.034C.41 4.824-.567 3.228.337 1.804 1.26.348 3.797-.373 6.003.193c2.205.565 3.243 2.203 2.319 3.659z",
    fill: "#555D69"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 259.489,
    y: 279.792,
    width: 9.508,
    height: 6.212,
    viewBox: "0 0 9.477 6.242",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#BFC4C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.244 4.582c-1.122-.574-2.523-1.485-2.523-1.485s1.991.212 3.323.56c.76.199 1.884.297 1.243 1.038-.697.806-1.456.187-2.043-.113zM2.233 1.66c1.122.575 2.523 1.487 2.523 1.487s-1.99-.213-3.323-.561C.674 2.386-.452 2.29.19 1.548c.697-.806 1.456-.187 2.043.113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07 1.444c-.922.749-2.372 1.69-2.372 1.69s.394-1.302.975-2.18c.332-.5.518-1.235 1.64-.843 1.217.427.24.94-.243 1.333zM2.407 4.8c.922-.75 2.371-1.691 2.371-1.691s-.394 1.302-.975 2.179c-.33.5-.518 1.235-1.639.843-1.218-.425-.239-.94.243-1.331z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 263.451,
    y: 282.407,
    width: 1.505,
    height: 0.981,
    viewBox: "0 0 1.469 0.972",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M.46.92C.084.797-.098.504.054.265c.15-.24.58-.335.956-.213.376.122.558.414.406.654-.151.24-.58.334-.956.212z",
    fill: "#BFC4C4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 259.014,
    y: 279.41,
    width: 10.696,
    height: 7.029,
    viewBox: "0 0 10.741 7.018",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    height: 8,
    id: "e",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    width: 11,
    x: 0,
    y: 0
  }, _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.779C.56 6.077-.727 4.045.419 2.239c1.145-1.806 4.29-2.701 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.146 1.806-4.291 2.7-7.027 2z",
    fill: "#fff"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83 9.335l.18-.044-.266-1.043 1.468-.363.267 1.043.18-.044-.266-1.044 1.468-.362.267 1.043.18-.044-.267-1.043 1.469-.362.266 1.044.18-.045-.267-1.043 1.468-.363.266 1.044.18-.045-.265-1.043 1.467-.362.267 1.044.18-.045-.266-1.043 1.468-.363.267 1.044.18-.045-.266-1.043 1.429-.353-.034-.131-1.43.353-.273-1.072 1.429-.353-.034-.131-1.43.353-.272-1.072 1.429-.353-.034-.131-1.428.352-.274-1.072 1.429-.352-.034-.132-1.43.352-.272-1.072L11.834.64 11.8.509l-1.43.353-.272-1.073 1.428-.352-.033-.131-1.43.352-.272-1.072 1.428-.353-.034-.132-1.43.353L9.49-2.59l-.181.045.267 1.044-1.468.362-.267-1.043-.18.045.266 1.043-1.468.362-.267-1.043-.18.043.267 1.044-1.468.362-.267-1.043-.18.044.267 1.043L3.163.08 2.896-.963l-.18.044.267 1.043-1.468.362-.266-1.043-.181.044L1.335.53l-1.47.362L-.4-.151l-.18.044.267 1.044-1.43.353.035.13 1.429-.352.274 1.072-1.43.353.035.132 1.429-.353.274 1.072-1.43.352.035.132 1.429-.353.274 1.072-1.428.352.034.132 1.428-.352.274 1.072-1.43.353.035.132 1.429-.353.274 1.07-1.43.354.035.132 1.429-.353.274 1.072-1.43.352.034.132 1.429-.352.264 1.045zm1.528-1.626l-.273-1.072 1.468-.363.274 1.072-1.47.363zm2.374-4.425l-.274-1.072 1.468-.363.274 1.073-1.468.362zm1.502-.23l.274 1.072-1.468.362-.274-1.072 1.468-.362zm-1.682.275l-1.468.362-.274-1.072 1.468-.363.274 1.073zm.033.132l.275 1.072-1.468.362-.275-1.072 1.468-.362zm.308 1.203l.274 1.072-1.468.362-.274-1.072 1.468-.362zm.18-.045l1.468-.361.274 1.072-1.468.363-.273-1.074zm1.649-.406L9.19 3.85l.274 1.073-1.468.362-.274-1.073zm-.035-.132l-.274-1.072 1.468-.362.274 1.072-1.468.362zM7.38 2.878l-.273-1.072 1.468-.363.274 1.073-1.47.362zm-.307-1.204L6.799.602 8.267.24l.274 1.072-1.468.362zm-.18.044l-1.468.363-.274-1.072L6.619.647l.274 1.07zm-1.648.407l-1.468.362-.274-1.072 1.468-.362.274 1.072zm-1.65.407l-1.467.362-.274-1.072 1.468-.362.274 1.072zm.035.13l.273 1.074-1.467.36-.275-1.071 1.469-.362zm.308 1.205l.273 1.072-1.468.362-.273-1.072 1.468-.362zm.307 1.204l.274 1.072-1.468.363-.274-1.073 1.468-.362zm.762 2.23L4.732 6.23 6.2 5.867l.274 1.072-1.467.363zm1.648-.406l-.273-1.072 1.467-.362.274 1.072-1.468.362zm1.648-.407l-.274-1.072 1.468-.362.274 1.072-1.468.362zm3.116-.768l-1.468.362-.274-1.072 1.468-.362.274 1.072zm-.308-1.204l-1.467.362-.274-1.072 1.468-.362.273 1.072zm-.307-1.204l-1.468.362-.274-1.072 1.469-.362.273 1.072zm-.308-1.203l-1.468.362-.275-1.072 1.468-.363.275 1.073zM10.189.905l-1.468.362L8.447.195l1.468-.362.274 1.072zM9.607-1.37l.275 1.072-1.468.362-.274-1.072 1.467-.362zm-1.648.407L8.232.109 6.765.47 6.49-.601l1.468-.362zM6.31-.557L6.585.515 5.117.877 4.843-.196 6.31-.557zM4.663-.15L4.937.922l-1.47.362L3.195.212 4.663-.15zM3.015.256l.274 1.072-1.468.363L1.547.618 3.015.256zm-3.116.769L1.367.663l.274 1.072-1.468.362-.274-1.072zm.307 1.204l1.468-.362.274 1.073-1.467.362-.275-1.073zm.308 1.203L1.98 3.07l.274 1.072-1.468.362-.273-1.072zm.308 1.204l1.468-.362.274 1.072-1.468.363-.274-1.073zm.307 1.204l1.468-.362.275 1.072-1.468.362-.275-1.072zm.308 1.203l1.468-.362.274 1.072-1.468.362-.274-1.072z",
    fill: "#DCE0E0"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 259.014,
    y: 279.41,
    width: 10.696,
    height: 7.029,
    viewBox: "0 0 10.741 7.018",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    height: 8,
    id: "f",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    width: 11,
    x: 0,
    y: 0
  }, _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.779C.56 6.077-.727 4.045.419 2.239c1.145-1.806 4.29-2.701 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.146 1.806-4.291 2.7-7.027 2z",
    fill: "#fff"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.934 8.846l.18-.044-.267-1.043 1.468-.363.267 1.043.18-.044-.267-1.044 1.468-.362.267 1.043.18-.044-.267-1.043 1.469-.362.266 1.044.18-.045-.266-1.043 1.468-.362.266 1.043.18-.045-.265-1.043 1.467-.362.267 1.044.18-.045-.266-1.043 1.468-.363.267 1.044.18-.045-.266-1.043 1.429-.353-.034-.131-1.43.353-.273-1.073 1.429-.352-.034-.131-1.43.353-.273-1.072 1.429-.353-.034-.131-1.43.352-.272-1.072 1.429-.352-.035-.132-1.43.353L9.508.506l1.428-.353L10.9.02 9.47.374 9.2-.698l1.428-.352-.033-.132-1.43.352-.272-1.072 1.428-.353-.034-.132-1.43.353-.265-1.044-.181.045.267 1.044-1.468.362-.267-1.043-.18.045.266 1.043-1.468.362-.266-1.043-.18.043.266 1.044-1.468.362-.267-1.043-.18.044.267 1.043-1.468.362-.267-1.043-.18.044.267 1.043-1.468.362L.35-1.045l-.181.044L.436.042l-1.47.362-.265-1.043-.18.044.266 1.044-1.43.353.035.13L-1.18.58l.274 1.072-1.43.353.035.132 1.429-.353.274 1.072-1.43.352.035.132 1.429-.353.273 1.072-1.428.352.034.132 1.428-.352.274 1.072-1.43.353.035.132L.05 5.395l.274 1.072-1.43.353.035.132 1.429-.353.274 1.072-1.43.352.035.132 1.429-.353.267 1.044zM2.462 7.22l-.274-1.072 1.468-.363.274 1.073-1.468.362zm2.373-4.424L4.56 1.725l1.468-.363.274 1.073-1.468.36zm1.502-.231l.274 1.072-1.468.362-.274-1.072 1.468-.362zm-1.682.276l-1.468.362-.274-1.072 1.468-.362.274 1.072zm.033.13l.275 1.073-1.468.362-.274-1.072 1.467-.362zm.308 1.205l.274 1.072-1.468.362-.274-1.072 1.468-.362zm.18-.045l1.468-.362.274 1.072-1.468.363-.273-1.073zm1.649-.407l1.468-.362.274 1.072-1.468.362-.274-1.072zm-.035-.131L6.516 2.52l1.468-.362.274 1.072-1.468.362zM6.483 2.39l-.274-1.072L7.677.955l.274 1.072-1.468.363zm-.307-1.205L5.902.113 7.37-.25 7.644.823l-1.468.362zm-.18.045l-1.468.363L4.254.52 5.72.159l.275 1.07zm-1.648.407L2.88 2 2.606.928 4.074.566l.274 1.07zm-1.65.406l-1.467.362-.274-1.072L2.425.97l.274 1.072zm.035.132l.273 1.073-1.467.36-.274-1.071 1.468-.362zm.308 1.204l.273 1.072-1.468.362-.274-1.072 1.469-.362zm.307 1.203l.274 1.072-1.468.363-.274-1.073 1.468-.362zm.762 2.232l-.274-1.072 1.468-.363.274 1.073-1.468.362zm1.648-.407l-.273-1.072 1.467-.362.274 1.072-1.468.362zM7.406 6l-.274-1.072L8.6 4.566l.274 1.072L7.406 6zm3.116-.77l-1.468.363L8.78 4.52l1.468-.362.274 1.072zm-.308-1.202l-1.468.362-.274-1.072 1.468-.362.274 1.072zm-.307-1.204l-1.468.362-.274-1.072 1.469-.362.273 1.072zM9.599 1.62l-1.468.362L7.857.91 9.325.547l.274 1.073zM9.292.416L7.824.779 7.55-.293l1.468-.362.274 1.07zM8.71-1.86l.274 1.072-1.468.362-.274-1.072L8.71-1.86zm-1.648.407L7.335-.38l-1.467.362-.274-1.072 1.468-.362zm-1.648.407L5.688.027 4.22.389 3.946-.683l1.468-.362zM3.766-.64L4.04.433 2.573.795 2.299-.277 3.766-.64zm-1.648.407L2.392.84l-1.468.363L.65.13l1.468-.363zM-.998.536L.469.174l.274 1.072-1.468.362L-.998.536zm.307 1.204l1.468-.362.274 1.072-1.467.362-.275-1.072zm.308 1.204l1.467-.362.274 1.072-1.468.362-.273-1.072zm.307 1.204l1.468-.362.275 1.072-1.468.363-.275-1.073zM.232 5.35L1.7 4.989l.274 1.072-1.468.363L.232 5.35zM.54 6.555l1.468-.362.274 1.072-1.468.362L.54 6.555z",
    fill: "#DCE0E0"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 258.538,
    y: 279.138,
    width: 11.568,
    height: 7.628,
    viewBox: "0 0 11.54 7.622",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53 7.37c2.923.749 6.306-.23 7.545-2.182.514-.81.604-1.676.259-2.502C10.864 1.56 9.653.674 8.009.252 5.087-.498 1.703.482.465 2.435c-.514.81-.604 1.675-.26 2.502.47 1.125 1.683 2.012 3.326 2.434zM1.039 2.598C2.133.872 5.138.017 7.753.687c2.614.67 3.845 2.613 2.75 4.339-1.095 1.725-4.101 2.58-6.714 1.91-2.614-.67-3.846-2.613-2.751-4.34z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 261.074,
    y: 284.423,
    width: 25.909,
    height: 19.615,
    viewBox: "0 0 25.899 14.901",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.782L15.31 0l10.589 6.119-15.311 8.782L0 8.782z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 270.582,
    y: 286.712,
    width: 11.568,
    height: 7.628,
    viewBox: "0 0 11.542 7.623",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01.253C5.09-.498 1.703.48.468 2.436c-.15.235-.266.476-.34.72a2.493 2.493 0 00.079 1.777c.153.367.388.71.694 1.02.616.64 1.527 1.134 2.633 1.417.184.049.37.09.559.122a8.582 8.582 0 003.897-.214c1.343-.402 2.474-1.128 3.087-2.09.035-.052.066-.106.097-.16.43-.761.485-1.571.162-2.343C10.865 1.56 9.652.673 8.01.253z",
    fill: "#849FA1"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 270.978,
    y: 286.821,
    width: 11.568,
    height: 7.628,
    viewBox: "0 0 11.543 7.623",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01.253C5.09-.498 1.703.482.468 2.436c-.15.235-.266.476-.34.722a2.493 2.493 0 00.079 1.776c.153.367.388.71.694 1.02.616.64 1.527 1.134 2.633 1.417.184.048.37.09.56.122a8.583 8.583 0 003.897-.214c1.343-.402 2.473-1.128 3.087-2.09.035-.052.066-.106.097-.16.43-.761.485-1.57.162-2.343C10.865 1.56 9.653.673 8.01.253z",
    fill: "#C3C9C9"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 271.849,
    y: 291.18,
    width: 3.249,
    height: 3.16,
    viewBox: "0 0 3.193 3.11",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M3.193 1.677L0 0v1.572c.616.64 1.527 1.133 2.633 1.416.184.048.371.09.56.122V1.677z",
    fill: "#AEBABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 275.098,
    y: 292.814,
    width: 3.882,
    height: 1.635,
    viewBox: "0 0 3.898 1.628",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M3.898 0L.001.065 0 1.497a8.583 8.583 0 003.897-.214L3.898 0z",
    fill: "#C3C9C9"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 278.98,
    y: 290.635,
    width: 3.169,
    height: 3.487,
    viewBox: "0 0 3.184 3.448",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M3.184 0L.001 2.165 0 3.448c1.343-.402 2.473-1.128 3.087-2.09.035-.052.066-.106.097-.16V0z",
    fill: "#DCE0E0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 270.978,
    y: 289.981,
    width: 0.872,
    height: 2.779,
    viewBox: "0 0 0.9 2.797",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M.127 0a2.493 2.493 0 00.079 1.776c.153.367.388.71.694 1.021V1.225L.127 0z",
    fill: "#9CADAD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 261.074,
    y: 293.25,
    width: 10.617,
    height: 10.788,
    viewBox: "0 0 10.589 10.789",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M10.588 6.119L0 0v4.671l10.589 6.118-.001-4.67z",
    fill: "#B4BABD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 271.691,
    y: 290.58,
    width: 15.292,
    height: 13.458,
    viewBox: "0 0 15.311 13.452",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M15.311 4.67V0L0 8.782l.001 4.67 15.31-8.782z",
    fill: "#CDCFCE"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 271.295,
    y: 286.712,
    width: 10.776,
    height: 7.029,
    viewBox: "0 0 10.741 7.017",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.778C.56 6.076-.727 4.044.419 2.238c1.145-1.806 4.29-2.7 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.146 1.806-4.292 2.701-7.027 2z",
    fill: "#B3B8B8"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 272.642,
    y: 288.237,
    width: 8.636,
    height: 5.449,
    viewBox: "0 0 8.659 5.457",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M8.322 3.852c-.825 1.301-4.688 1.563-5.504 1.605-.071-.086-.208-.118-.3-.034C.41 4.824-.567 3.228.337 1.804 1.26.348 3.797-.373 6.002.193c2.205.564 3.244 2.203 2.32 3.659z",
    fill: "#555D69"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 271.849,
    y: 287.039,
    width: 9.508,
    height: 6.266,
    viewBox: "0 0 9.477 6.242",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#BFC4C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.244 4.58c-1.122-.573-2.523-1.484-2.523-1.484s1.991.212 3.323.56c.76.199 1.884.297 1.243 1.039-.698.806-1.457.187-2.043-.114zM2.233 1.66c1.122.576 2.523 1.487 2.523 1.487s-1.99-.213-3.323-.561C.674 2.386-.452 2.29.19 1.548c.697-.806 1.456-.187 2.043.113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07 1.444c-.922.749-2.372 1.69-2.372 1.69s.394-1.302.975-2.18c.332-.5.52-1.235 1.64-.843 1.217.426.24.94-.243 1.333zM2.407 4.8c.922-.75 2.371-1.691 2.371-1.691s-.394 1.3-.975 2.179c-.33.5-.518 1.235-1.639.843-1.218-.426-.24-.94.243-1.331z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 275.811,
    y: 289.708,
    width: 1.505,
    height: 0.981,
    viewBox: "0 0 1.469 0.972",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M.46.92C.084.797-.098.504.054.265c.15-.24.58-.335.956-.213.376.122.558.414.406.654-.152.24-.58.334-.956.212z",
    fill: "#BFC4C4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 271.295,
    y: 286.712,
    width: 10.776,
    height: 7.029,
    viewBox: "0 0 10.741 7.017",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    height: 8,
    id: "g",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    width: 11,
    x: 0,
    y: 0
  }, _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.778C.56 6.076-.727 4.044.419 2.238c1.145-1.806 4.29-2.7 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.146 1.806-4.292 2.701-7.027 2z",
    fill: "#fff"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83 9.333l.18-.044-.266-1.043 1.468-.363.267 1.043.18-.044-.266-1.044 1.468-.362.267 1.043.18-.044-.267-1.043L6.51 7.07l.266 1.044.18-.045-.267-1.042 1.468-.363.266 1.043.18-.045-.265-1.043 1.467-.362.267 1.044.18-.045-.266-1.043 1.468-.363.266 1.044.18-.045-.266-1.043 1.429-.353-.034-.13-1.43.352-.273-1.072 1.429-.353-.034-.13-1.43.352-.273-1.072 1.429-.353-.034-.13-1.428.351-.274-1.072 1.429-.352-.034-.132-1.43.352-.272-1.072L11.832.64l-.034-.132-1.43.353-.272-1.072 1.428-.352-.033-.13-1.43.351-.272-1.072 1.428-.353-.034-.132-1.43.353-.265-1.044-.181.045.267 1.044-1.468.362-.267-1.043-.18.045.266 1.043-1.468.362-.267-1.043-.18.044.266 1.044-1.467.362-.267-1.043-.18.044.267 1.043L3.16.08 2.894-.963l-.18.044L2.98.124 1.513.486 1.247-.557l-.181.044L1.333.53-.135.892-.402-.15l-.18.044.267 1.044-1.43.353.035.131 1.429-.352.274 1.072-1.43.353.034.132 1.429-.353L.3 3.345l-1.43.352.035.132 1.429-.353.274 1.072L-.82 4.9l.034.132L.642 4.68l.274 1.072-1.43.353.035.132L.95 5.884l.274 1.071-1.43.353.035.132 1.429-.353.274 1.073-1.43.352.034.132 1.429-.352.266 1.041zm1.528-1.626l-.273-1.072 1.468-.362.274 1.072-1.47.362zm2.374-4.424l-.274-1.072 1.468-.363.274 1.073-1.468.362zm1.502-.23l.274 1.071-1.468.362-.274-1.072 1.468-.362zm-1.682.275l-1.468.362-.274-1.07 1.468-.364.274 1.072zm.033.131l.275 1.072-1.468.362-.275-1.072 1.468-.362zm.308 1.204l.274 1.072-1.468.362-.274-1.072 1.468-.362zm.18-.045l1.468-.36.274 1.071-1.468.363-.273-1.074zm1.649-.407L9.19 3.85l.274 1.072-1.468.362-.274-1.072zm-.035-.13l-.274-1.073 1.468-.362.274 1.072-1.468.362zM7.38 2.875l-.273-1.072 1.468-.363.274 1.073-1.47.362zm-.307-1.204L6.799.6 8.267.238 8.54 1.31l-1.468.362zm-.181.045l-1.468.362-.274-1.072L6.618.645l.274 1.072zm-1.648.407l-1.468.363-.274-1.073 1.468-.362.274 1.072zm-1.648.406l-1.468.362-.274-1.072 1.468-.362.274 1.072zm.034.132l.273 1.073-1.467.361-.275-1.072 1.469-.362zm.308 1.204l.273 1.072-1.468.362-.273-1.072 1.468-.362zm.307 1.203l.274 1.072-1.468.363-.274-1.073 1.468-.362zM5.007 7.3l-.275-1.072L6.2 5.865l.274 1.072-1.467.363zm1.648-.406l-.273-1.072 1.467-.363.274 1.072-1.468.363zm1.648-.407l-.274-1.072 1.468-.362.274 1.072-1.468.362zm3.116-.769L9.95 6.08l-.274-1.072 1.468-.362.274 1.072zm-.308-1.203l-1.467.362-.274-1.072 1.468-.362.273 1.072zm-.307-1.204l-1.468.362-.274-1.072 1.469-.362.273 1.072zm-.308-1.203l-1.468.362-.275-1.072 1.468-.363.275 1.073zM10.188.904l-1.468.363L8.446.195l1.468-.362.274 1.071zm-.582-2.276L9.88-.3 8.413.062 8.139-1.01l1.467-.362zm-1.647.407L8.232.107 6.765.47 6.49-.603l1.468-.362zm-1.65.407L6.585.514 5.116.876 4.842-.196 6.31-.558zM4.663-.15L4.936.921l-1.468.362L3.194.211 4.662-.15zM3.015.255l.274 1.072-1.468.363L1.547.618 3.015.255zm-3.116.768L1.367.661l.274 1.072-1.468.362-.274-1.072zm.307 1.204l1.468-.362.274 1.072L.48 3.3.206 2.227zm.308 1.204L1.98 3.07l.274 1.072-1.468.362-.273-1.072zM.82 4.635l1.468-.362.275 1.072-1.468.363L.82 4.635zm.308 1.203l1.468-.362.274 1.072-1.468.363-.274-1.073zm.307 1.204l1.468-.362.274 1.072-1.468.362-.274-1.072z",
    fill: "#DCE0E0"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 271.295,
    y: 286.712,
    width: 10.776,
    height: 7.029,
    viewBox: "0 0 10.741 7.017",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    height: 8,
    id: "h",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    width: 11,
    x: 0,
    y: 0
  }, _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M3.296 6.778C.56 6.076-.727 4.044.419 2.238c1.145-1.806 4.29-2.7 7.026-2 2.735.702 4.023 2.735 2.878 4.54-1.146 1.806-4.292 2.701-7.027 2z",
    fill: "#fff"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.934 8.845l.18-.045-.267-1.043 1.468-.363.267 1.044.18-.044-.266-1.044 1.468-.362.267 1.043.18-.044-.267-1.043 1.469-.362.266 1.044.18-.045-.265-1.043 1.468-.363.266 1.044.18-.045-.265-1.043L8.91 5.77l.267 1.044.18-.045-.266-1.043 1.468-.363.266 1.044.18-.045-.266-1.043 1.429-.353-.034-.13-1.43.352-.273-1.073 1.429-.353-.034-.13-1.43.352-.273-1.072 1.429-.353-.034-.13-1.428.351-.273-1.072 1.429-.352-.034-.132-1.43.353L9.51.504l1.428-.353-.034-.132-1.43.353L9.203-.7l1.428-.352-.033-.132-1.43.352-.272-1.072 1.428-.353-.034-.132-1.43.353-.265-1.044-.181.045.267 1.044-1.468.362-.267-1.043-.18.045.266 1.043-1.468.362-.267-1.042-.18.043.267 1.044-1.468.362-.267-1.043-.18.044.267 1.043-1.468.362L2-1.452l-.18.044.267 1.043-1.468.362-.266-1.043-.181.044L.439.041l-1.47.362-.265-1.043-.18.044.266 1.044-1.43.353.035.131L-1.177.58l.274 1.072-1.43.353.035.132 1.429-.353.274 1.072-1.43.352.035.132 1.429-.353.273 1.072-1.428.352.034.132 1.428-.352.274 1.072-1.43.353.035.132 1.429-.353.274 1.072-1.43.353.034.132L.36 6.6l.274 1.072-1.43.352.035.132 1.429-.353.265 1.043zM2.46 7.22l-.274-1.072 1.468-.363.274 1.072-1.468.363zm2.374-4.425l-.274-1.07 1.468-.364.274 1.073-1.468.361zm1.502-.23l.274 1.072-1.468.362-.274-1.07 1.468-.364zm-1.682.275l-1.468.362-.274-1.072 1.468-.362.274 1.072zm.033.132l.275 1.072-1.468.362-.274-1.072 1.467-.362zm.308 1.204l.274 1.072-1.468.362-.274-1.072 1.468-.362zm.18-.046l1.468-.36.274 1.07-1.468.363-.273-1.073zm1.648-.406l1.468-.362.274 1.072-1.468.362-.274-1.072zm-.034-.13L6.516 2.52l1.468-.362.274 1.072-1.468.362zm-.307-1.205l-.274-1.072L7.677.953l.274 1.072-1.468.363zm-.308-1.204L5.9.112 7.369-.25 7.643.822l-1.468.362zm-.18.045l-1.468.363L4.253.52 5.72.158l.275 1.071zm-1.648.406l-1.468.363L2.605.926 4.073.564l.274 1.071zm-1.648.407l-1.468.362-.274-1.072L2.425.97l.274 1.072zm.034.131l.273 1.073-1.467.361-.274-1.072 1.468-.362zm.308 1.205l.273 1.072-1.468.362-.274-1.072 1.469-.362zm.307 1.203l.274 1.072-1.468.363-.274-1.073 1.468-.362zm.762 2.231L3.835 5.74l1.468-.363.274 1.073-1.467.362zm1.647-.407l-.273-1.072 1.467-.362.274 1.072-1.468.362zM7.406 6l-.274-1.072L8.6 4.565l.274 1.072L7.406 6zm3.116-.769l-1.468.362L8.78 4.52l1.468-.362.274 1.072zm-.308-1.204l-1.468.362-.274-1.072 1.468-.362.274 1.072zm-.307-1.203l-1.468.362-.274-1.072 1.469-.362.273 1.072zM9.599 1.62l-1.468.362L7.857.91 9.325.546l.274 1.073zM9.29.415L7.823.778 7.549-.294l1.468-.362L9.29.415zM8.71-1.86l.274 1.072-1.468.362-.274-1.072L8.71-1.86zm-1.648.407L7.335-.38l-1.467.362-.274-1.072 1.468-.362zm-1.65.406L5.688.025 4.219.387 3.945-.685l1.468-.362zM3.766-.64L4.04.432 2.57.794 2.298-.278 3.765-.64zm-1.647.407L2.392.84l-1.468.363L.65.13l1.468-.363zM-.998.535L.469.173l.274 1.072-1.468.362L-.998.535zm.307 1.204l1.468-.362.274 1.072-1.467.362-.275-1.072zm.308 1.204l1.467-.362.274 1.072-1.468.362-.273-1.072zm.307 1.203l1.468-.362.274 1.072-1.468.362-.274-1.072zM.232 5.35L1.7 4.988l.275 1.072-1.468.363L.232 5.35zM.54 6.554l1.468-.362.274 1.072-1.468.362L.54 6.554z",
    fill: "#DCE0E0"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 270.899,
    y: 286.439,
    width: 11.568,
    height: 7.574,
    viewBox: "0 0 11.54 7.621",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53 7.37c2.923.749 6.306-.23 7.545-2.182.514-.81.604-1.676.259-2.502C10.864 1.56 9.653.674 8.009.252 5.087-.498 1.703.482.465 2.435c-.514.81-.604 1.675-.26 2.502.47 1.124 1.683 2.01 3.326 2.433zM1.039 2.596C2.133.87 5.138.016 7.752.686c2.614.67 3.845 2.613 2.75 4.339-1.095 1.725-4.1 2.58-6.714 1.91-2.614-.67-3.845-2.613-2.75-4.34z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 239.839,
    y: 345.503,
    width: 44.688,
    height: 30.949,
    viewBox: "0 0 44.676 30.967",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M44.676 6.367V.586L2.173 25.085l.008 5.882 42.495-24.6z",
    fill: "#EAC72F"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M44.676.586L.985 25.785 0 25.235 43.694 0l.982.586z",
    fill: "#FFEF75"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 205.214,
    y: 348.718,
    width: 37.794,
    height: 27.734,
    viewBox: "0 0 37.788 27.705",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.367V.586l36.802 21.237.008 5.882L0 6.367z",
    fill: "#CF9219"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .586l36.803 21.237.985-.551L.982 0 0 .586z",
    fill: "#FFEF75"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 295.54,
    y: 335.478,
    width: 6.418,
    height: 9.426,
    viewBox: "0 0 6.368 9.433",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M6.368 6.355V.574L.985 3.643l-.007 5.79 5.39-3.078z",
    fill: "#EAC72F"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M6.368.574L.985 3.643 0 3.093 5.366 0l1.002.574z",
    fill: "#FFEF75"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M.982 9.433L0 8.883v-5.79l.982.55v5.79z",
    fill: "#CF9219"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 244.989,
    y: 344.141,
    width: 17.273,
    height: 17.218,
    viewBox: "0 0 17.284 17.215",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#273D3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.747 0l6.58 7.197v8.273l-.086.043-.105.061-.998.582-1.814 1.059L0 7.006V3.325L5.747 0zM17.284 12.623l-4.219 2.439V8.004l4.219 4.619z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 257.191,
    y: 335.805,
    width: 19.491,
    height: 17.218,
    viewBox: "0 0 19.489 17.206",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.592l.121-.061v.191L0 4.592z",
    fill: "#517777"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M7.961 0l5.226 5.712v10.53l-.096.044-.095.069-.999.573-.477.278L.859 5.53V4.106L7.961 0zM19.489 12.614l-5.564 3.22v.009h-.009V6.511l5.573 6.103z",
    fill: "#273D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 222.408,
    y: 354.712,
    width: 1.426,
    height: 2.452,
    viewBox: "0 0 1.458 2.44",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.597L1.458 0v2.44h-.009L0 1.597z",
    fill: "#21362E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 271.057,
    y: 328.013,
    width: 12.36,
    height: 17.163,
    viewBox: "0 0 12.336 17.215",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M12.336 5.226v11.286l-.095.052-.096.06-.998.582-.018.009L0 5.026v-.651L7.561 0l4.775 5.226z",
    fill: "#273D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 285.319,
    y: 323.872,
    width: 7.923,
    height: 14.33,
    viewBox: "0 0 7.982 14.319",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.591v9.728l7.982-4.59V0L0 4.591z",
    fill: "#A7A7A7"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M7.494.979v8.412l-.043.018-.035.026-.442.26-.139.078-3.247 1.884-.208.122-.46.269-2.431 1.398V5.033l1.302-.755 1.163-.677.834-.477 1.718-.99 1.468-.851.442-.252.078-.052z",
    fill: "#90C7C7"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M7.413 1.03v8.408l-.435.253V1.282l.435-.252z",
    fill: "url(#paint0_linear_0_13082)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M7.458 9.411L.489 13.453v-.569l6.489-3.749.48.276z",
    fill: "url(#paint1_linear_0_13082)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M7.254 9.284V1.122l.241-.139V9.39L.489 13.453v-.117l6.765-4.052z",
    fill: "#7D7D7D"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M7.231 9.261l.241.106-7.006 4.062v-.251l6.765-3.917z",
    fill: "#CDCDCD"
  })), _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_13082",
    x1: 6.772,
    x2: 7.383,
    y1: 5.36,
    y2: 5.36
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_13082",
    x1: 3.681,
    x2: 4.217,
    y1: 10.895,
    y2: 11.881
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#43A79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#5DA69C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#88A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#8BA39F"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 284.844,
    y: 341.907,
    width: 3.486,
    height: 4.141,
    viewBox: "0 0 1.077 3.965",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M1.077.13v1.558L.982 3.366a.32.32 0 01-.161.272l-.357.206-.108.063-.07.04a.125.125 0 01-.12.004l-.011-.006a.124.124 0 01-.06-.104L0 2.962V.722A.324.324 0 01.161.435L.885.017a.13.13 0 01.129 0l.004.003c.036.022.06.061.059.11z",
    fill: "#A8A7A2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 284.923,
    y: 341.962,
    width: 1.188,
    height: 4.087,
    viewBox: "0 0 1.185 4.082",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M1.185.265l-.206.774-.005.032-.607 2.757-.044.254-.255-.148-.011-.006L0 1.573l.17-.497L.315.65.817.4l.1-.4.004.003.257.257.007.005z",
    fill: "#A8A7A2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 285.081,
    y: 342.18,
    width: 1.109,
    height: 3.869,
    viewBox: "0 0 1.076 3.858",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M1.076.129v1.453L.981 3.26a.32.32 0 01-.16.272l-.535.309a.125.125 0 01-.133-.003.127.127 0 01-.059-.104L.09 3.646 0 2.854V.723A.322.322 0 01.161.436l.486-.28L.81.062.885.018a.126.126 0 01.131.002c.035.022.06.06.06.109z",
    fill: "#C7C7C7"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 284.844,
    y: 341.907,
    width: 1.347,
    height: 1.689,
    viewBox: "0 0 1.343 1.652",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M1.343.391v.506l-.267.19-.006.002-.658.346-.145.217L0 1.496V.722A.324.324 0 01.161.435L.885.017a.13.13 0 01.13 0l.003.003.257.257a.127.127 0 01.068.114z",
    fill: "#A8A7A2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 284.844,
    y: 341.907,
    width: 1.347,
    height: 1.035,
    viewBox: "0 0 1.344 1.014",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .73l.491.284.853-.07V.392a.126.126 0 00-.06-.11c-.003 0-.006-.003-.009-.004L1.018.02 1.014.018a.127.127 0 00-.129 0L.161.436A.324.324 0 000 .723V.73z",
    fill: "#D1D1D1"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 284.923,
    y: 341.962,
    width: 1.109,
    height: 1.035,
    viewBox: "0 0 1.109 1.036",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M.797 0C.789.003.781.005.773.01L.049.428A.295.295 0 000 .464l.802.572.307-.731L.797 0z",
    fill: "#F5F5F5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 285.081,
    y: 342.234,
    width: 1.109,
    height: 1.362,
    viewBox: "0 0 1.077 1.382",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M.001.735A.306.306 0 01.155.461L.929.014A.099.099 0 01.978 0c.016 0 .031.004.046.011l.006.004c.03.018.047.049.047.084v.662L0 1.382.001.735z",
    fill: "#C7C7C7"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 285.002,
    y: 342.016,
    width: 0.872,
    height: 0.49,
    viewBox: "0 0 0.841 0.509",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M.78 0L.77.005.046.423A.317.317 0 000 .456l.075.053A.327.327 0 01.123.474L.841.059.78 0z",
    fill: "#F5F5F5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 285.398,
    y: 343.215,
    width: 2.932,
    height: 1.417,
    viewBox: "0 0 0.717 0.824",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M.21.796L.08.722C.003.677-.019.558.017.422L.03.378A.325.325 0 00.036.361L.041.348.047.334.063.298.071.283.086.257A.365.365 0 01.102.231l.01-.014C.118.206.124.195.132.185a.49.49 0 01.01-.013l.01-.011.011-.014A.515.515 0 01.248.069L.26.06.29.041.302.033A.26.26 0 01.345.014L.357.01A.138.138 0 01.383.004.099.099 0 01.407.001h.018l.018.002.003.001.008.002.005.001A.12.12 0 01.49.02l.128.074C.685.133.71.226.694.336L.687.375c0 .006-.003.012-.004.018a.666.666 0 01-.178.309C.401.8.287.841.21.796z",
    fill: "#A8A7A2"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M.501.702L.505.697.018.416c0 .002 0 .005-.002.007-.035.135-.014.255.064.3l.128.074C.288.841.401.8.501.702z",
    fill: "#A8A7A2"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M.634.501C.651.465.67.428.68.393L.683.375.69.336C.706.225.681.132.614.094L.486.02a.12.12 0 00-.03-.013L.451.006.442.004.44.003.422.001H.404A.099.099 0 00.38.004L.354.01.342.014A.26.26 0 00.3.033L.286.041a.48.48 0 00-.075.056L.193.113a.515.515 0 00-.032.034L.15.161.14.172.13.185.116.204l.518.297z",
    fill: "#C7C7C7"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M.688.28C.688.197.67.125.614.093L.486.019A.12.12 0 00.452.005L.442.003.44.002A.11.11 0 00.422 0H.404A.098.098 0 00.38.003a1.053 1.053 0 01-.026.006L.342.013A.26.26 0 00.3.032L.286.04a.027.027 0 00-.005.004L.688.28z",
    fill: "#FDFDFD"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M.228.805c.11.064.29-.043.403-.237C.743.373.745.164.636.1.526.037.346.143.233.338.12.532.118.742.228.805z",
    fill: "#A8A7A2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 285.557,
    y: 343.215,
    width: 2.773,
    height: 1.417,
    viewBox: "0 0 2.761 1.453",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M.496.607a.165.165 0 00-.13-.008v.632a.645.645 0 00.125-.157C.604.88.606.67.496.607z",
    fill: "#C7C7C7"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M.12.789l.062.17.353-.201L.46.588S.265.534.12.789z",
    fill: "#F5F5F5"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M.182.96v.223l-.112.119s-.082-.07-.068-.214c.017-.18.117-.3.117-.3L.182.96zM2.76.156c-.046.01-.08.054-.104.102a.387.387 0 00-.352.017l-1.383.8a.216.216 0 01-.216 0L.182.96v.223l.315.174a.767.767 0 00.728.008L2.69.515A.137.137 0 002.76.39V.156z",
    fill: "#C7C7C7"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M.66 1.425a.766.766 0 00.407.002V1.14H.66v.284z",
    fill: "#A8A7A2"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M.66 1.067L.183.96v.223l.315.174a.775.775 0 00.164.067v-.357z",
    fill: "#A8A7A2"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M.182.96l.315.175a.767.767 0 00.728.008L2.69.293a.139.139 0 000-.241.388.388 0 00-.387 0L.92.852a.216.216 0 01-.216 0L.535.759.182.96z",
    fill: "#FDFDFD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 288.251,
    y: 325.997,
    width: 4.279,
    height: 6.157,
    viewBox: "0 0 4.3 6.153",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 1.9L2.552 0 .834.99 0 1.467l4.3 4.686V1.9z",
    fill: "#273D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 285.715,
    y: 328.122,
    width: 6.259,
    height: 7.247,
    viewBox: "0 0 6.198 7.216",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M6.198 5.334L1.302 0 0 .755v3.247l2.949 3.214 3.249-1.882z",
    fill: "#273D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 320.103,
    y: 341.798,
    width: 3.169,
    height: 3.705,
    viewBox: "0 0 3.12 3.667",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M.362.322l.43.701 1.046 1.708.517.843.37-.213.017-.01.02-.012c.15-.098.258-.26.315-.475.006-.023.012-.046.016-.069l.008-.049a1.028 1.028 0 00.014-.123c.003-.043.005-.087.004-.133C3.11 1.637 2.487.602 1.731.18a1.774 1.774 0 00-.123-.063C1.283-.032.992-.035.776.087L.774.082l-.412.24z",
    fill: "url(#paint0_linear_0_13627)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.176c.01.853.632 1.888 1.388 2.311.756.423 1.361.075 1.35-.778C2.728 1.856 2.106.821 1.35.4.594-.026-.01.322 0 1.175z",
    fill: "#454545"
  })), _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_13627",
    x1: 2.963,
    x2: 1.056,
    y1: 3.223,
    y2: -0.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#707070"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 320.499,
    y: 342.18,
    width: 48.491,
    height: 29.75,
    viewBox: "0 0 48.43 29.748",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M.476 0l47.953 27.581-.475.27L0 .271.476 0z",
    fill: "#F9F9F9"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M47.954 27.851l.001 1.897L.001 2.168 0 .271l47.954 27.58z",
    fill: "#DADADA"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M48.429 27.58l-.475.271.001 1.897.475-.27-.001-1.898z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 319.152,
    y: 342.398,
    width: 3.09,
    height: 3.705,
    viewBox: "0 0 3.119 3.666",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M.361.321l.43.701L1.836 2.73l.517.844.37-.213.016-.01.02-.012c.15-.098.258-.26.315-.475.006-.023.012-.046.016-.069l.01-.049.01-.08.003-.043c.003-.043.005-.087.004-.133C3.108 1.637 2.486.602 1.73.18a1.773 1.773 0 00-.123-.063C1.282-.032.991-.035.775.087L.773.082.361.321z",
    fill: "url(#paint0_linear_0_9571)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.175c.01.853.632 1.888 1.388 2.311.756.423 1.361.075 1.35-.778C2.728 1.855 2.106.82 1.35.398.594-.027-.01.321 0 1.174z",
    fill: "#454545"
  })), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9571",
    x1: 2.963,
    x2: 1.056,
    y1: 3.222,
    y2: -0.081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#707070"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 322.48,
    y: 344.141,
    width: 46.193,
    height: 26.808,
    viewBox: "0 0 2.544 1.91",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M2.544.738L1.285 1.91 0 1.172 1.259 0l1.285.738z",
    fill: "#B0131F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 323.747,
    y: 344.141,
    width: 1.902,
    height: 0.872,
    viewBox: "0 0 1.923 0.916",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M1.923.738l-.638.178L0 .178.639 0l1.284.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 325.57,
    y: 345.885,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.181 2.089",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M2.543.917L1.284 2.089 0 1.351 1.259.179l1.284.738z",
    fill: "#B0131F"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M3.181.738l-.639.177L1.258.177 1.896 0l1.285.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 328.58,
    y: 347.628,
    width: 3.249,
    height: 2.125,
    viewBox: "0 0 3.18 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M2.542.916L1.284 2.088 0 1.351 1.259.179l1.283.737z",
    fill: "#B0131F"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18.737l-.639.177L1.258.177 1.896 0 3.18.737z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 331.671,
    y: 349.426,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.179 2.089",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M2.541.916L1.283 2.089 0 1.351 1.259.179l1.282.737z",
    fill: "#B0131F"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M3.179.738L2.54.915 1.257.177 1.896 0l1.283.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 334.761,
    y: 351.17,
    width: 3.169,
    height: 2.125,
    viewBox: "0 0 3.178 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54.916L1.282 2.088 0 1.351 1.259.179 2.54.916z",
    fill: "#B0131F"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M3.178.738l-.639.176L1.257.177 1.896 0l1.282.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 337.851,
    y: 352.968,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.178 2.089",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M2.539.916L1.281 2.089 0 1.351 1.258.179l1.281.737z",
    fill: "#B0131F"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M3.178.738l-.64.177L1.257.178 1.896 0l1.282.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 340.862,
    y: 354.712,
    width: 3.249,
    height: 2.071,
    viewBox: "0 0 3.177 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M2.538.915L1.28 2.088 0 1.351 1.258.179l1.28.736z",
    fill: "#B0131F"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M3.177.738l-.64.176-1.28-.737L1.896 0l1.281.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 343.952,
    y: 356.51,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.177 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M2.538.915L1.28 2.088 0 1.352 1.259.18l1.279.735z",
    fill: "#B0131F"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M3.177.738l-.64.176L1.258.178 1.897 0l1.28.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 347.042,
    y: 358.253,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.176 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M2.537.915L1.28 2.088 0 1.351 1.259.179l1.278.736z",
    fill: "#B0131F"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M3.176.738l-.64.176L1.258.177 1.896 0l1.28.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 350.132,
    y: 359.997,
    width: 3.169,
    height: 2.125,
    viewBox: "0 0 3.175 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M2.536.915L1.279 2.088 0 1.352 1.259.18l1.277.735z",
    fill: "#B0131F"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M3.175.738l-.64.176L1.258.178 1.896 0l1.279.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 353.222,
    y: 361.795,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.175 2.087",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M2.535.914L1.278 2.087 0 1.351 1.259.179l1.276.735z",
    fill: "#B0131F"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M3.175.738l-.641.176L1.258.177 1.896 0l1.279.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 356.233,
    y: 363.539,
    width: 3.169,
    height: 2.125,
    viewBox: "0 0 3.174 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M2.534.914L1.277 2.088 0 1.352 1.259.18l1.275.734z",
    fill: "#B0131F"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M3.174.738l-.64.176L1.258.178 1.896 0l1.278.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 359.323,
    y: 365.337,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.173 2.087",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M2.533.914L1.276 2.087 0 1.351 1.259.179l1.274.735z",
    fill: "#B0131F"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M3.173.738l-.641.175L1.257.177 1.896 0l1.277.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 362.413,
    y: 367.08,
    width: 3.169,
    height: 2.071,
    viewBox: "0 0 3.173 2.088",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M2.532.914L1.275 2.088 0 1.352 1.258.18l1.274.734z",
    fill: "#B0131F"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M3.173.738l-.641.176L1.257.178 1.896 0l1.277.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 365.503,
    y: 368.824,
    width: 3.169,
    height: 2.125,
    viewBox: "0 0 3.173 2.087",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M2.532.913L1.276 2.087 0 1.351 1.259.179l1.273.734z",
    fill: "#B0131F"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M3.173.738l-.641.175L1.258.177 1.897 0l1.276.738z",
    fill: "#FFA6A6"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 329.611,
    y: 345.939,
    width: 1.347,
    height: 2.125,
    viewBox: "0 0 0.476 0.966",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.811V.12L.208.274v.692L.476.811z",
    fill: "#DDD"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M.208.274L0 .155v.692l.208.119V.274z",
    fill: "#B3B3B3"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.12L.208.274 0 .155.269 0l.207.12z",
    fill: "#DDD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 329.611,
    y: 345.939,
    width: 1.347,
    height: 1.58,
    viewBox: "0 0 1.374 1.618",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M.16.144l.188.308.461.752.228.37.163-.093.007-.004.01-.005V1.47a.344.344 0 00.145-.24l.004-.021a.417.417 0 00.004-.035l.002-.02.002-.058C1.37.72 1.096.266.764.079A.68.68 0 00.708.052C.566-.014.44-.015.343.038V.037L.158.144z",
    fill: "url(#paint0_linear_0_9531)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .52c.004.377.278.832.611 1.019.333.186.6.033.594-.343C1.2.82.927.365.595.179.26-.008-.006.145 0 .52z",
    fill: "#D98B2A"
  })), _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9531",
    x1: 1.305,
    x2: 0.465,
    y1: 1.422,
    y2: -0.033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#E3AD38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FFC340"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 338.802,
    y: 351.17,
    width: 1.347,
    height: 2.179,
    viewBox: "0 0 0.475 0.967",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M.475.811V.12L.207.274v.693L.475.811z",
    fill: "#DDD"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M.207.274L0 .155v.692l.207.12V.274z",
    fill: "#B3B3B3"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M.475.12L.207.274 0 .155.268 0l.207.12z",
    fill: "#DDD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 338.802,
    y: 351.17,
    width: 1.347,
    height: 1.635,
    viewBox: "0 0 1.375 1.617",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M.16.144l.189.308.461.752.228.37.163-.093.007-.004.009-.005V1.47a.344.344 0 00.146-.24l.004-.021a.374.374 0 00.004-.035l.002-.02.002-.058C1.37.72 1.097.266.764.079A.68.68 0 00.71.052C.567-.014.44-.015.343.038L.342.037.16.144z",
    fill: "url(#paint0_linear_0_9524)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .52c.005.376.278.83.611 1.018.333.186.6.033.594-.343C1.2.819.927.364.595.177.261-.01-.005.145 0 .52z",
    fill: "#D98B2A"
  })), _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9524",
    x1: 1.305,
    x2: 0.465,
    y1: 1.421,
    y2: -0.033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#E3AD38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FFC340"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 347.993,
    y: 356.455,
    width: 1.426,
    height: 2.179,
    viewBox: "0 0 0.476 0.967",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.811V.12L.207.274v.693L.476.811z",
    fill: "#DDD"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M.207.274L0 .155v.692l.207.12V.274z",
    fill: "#B3B3B3"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M.476.12L.207.274 0 .155.268 0l.208.12z",
    fill: "#DDD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 347.993,
    y: 356.455,
    width: 1.426,
    height: 1.635,
    viewBox: "0 0 1.374 1.616",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M.16.143L.347.45l.461.752.228.37.163-.093.007-.004.01-.005V1.47a.344.344 0 00.145-.24l.004-.021.004-.035.002-.02.002-.058C1.369.72 1.096.265.764.079A.68.68 0 00.708.052C.566-.014.44-.015.342.038V.037L.158.143z",
    fill: "url(#paint0_linear_0_9521)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .519c.005.376.278.83.611 1.018.333.186.6.033.595-.343C1.201.818.928.363.596.176.261-.011-.005.143 0 .519z",
    fill: "#D98B2A"
  })), _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9521",
    x1: 1.304,
    x2: 0.465,
    y1: 1.42,
    y2: -0.034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#E3AD38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FFC340"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 357.184,
    y: 361.741,
    width: 1.426,
    height: 2.125,
    viewBox: "0 0 0.475 0.966",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M.475.811V.12L.207.274v.692L.475.811z",
    fill: "#DDD"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M.207.274L0 .155v.692l.207.119V.274z",
    fill: "#B3B3B3"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M.475.12L.207.274 0 .155.268 0l.207.12z",
    fill: "#DDD"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 357.184,
    y: 361.741,
    width: 1.426,
    height: 1.635,
    viewBox: "0 0 1.374 1.616",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M.159.142l.19.308.46.752.228.372.163-.094.007-.004.009-.005a.347.347 0 00.146-.241l.004-.021.004-.035.002-.02.002-.057C1.369.72 1.096.266.763.079A.679.679 0 00.709.052C.566-.014.438-.015.342.038L.341.037.159.142z",
    fill: "url(#paint0_linear_0_9518)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .519c.005.376.278.83.611 1.018.333.186.599.033.595-.343C1.201.818.928.363.595.176.262-.01-.004.143 0 .519z",
    fill: "#D98B2A"
  })), _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9518",
    x1: 1.305,
    x2: 0.465,
    y1: 1.42,
    y2: -0.035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#E3AD38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FFC240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#FFC340"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 339.99,
    y: 351.606,
    width: 7.765,
    height: 11.115,
    viewBox: "0 0 7.804 11.067",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85 2.146L2.098 0 .532 1.289.508 4.864l1.947 3.74 3.759 2.143 1.573-1.261.017-3.571L5.85 2.146z",
    fill: "#EEE"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M5.697 2.255L1.945.108.024 1.61 0 5.184l1.948 3.74 3.758 2.143 1.928-1.473.017-3.571-1.954-3.768z",
    fill: "#A80808"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M2.153 8.717L.283 5.11l.022-3.337L1.946.433l3.545 2.029 1.878 3.636-.016 3.333-1.648 1.311-3.552-2.025z",
    fill: "#DADADA"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M2.359 8.51L.565 5.035l.021-3.1L1.947.758l3.338 1.911 1.802 3.505-.015 3.094-1.368 1.149L2.359 8.51z",
    fill: "#A80808"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M7.804 5.915l-.153.108-.017 3.571.153-.108.017-3.571z",
    fill: "#C4C4C4"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85 2.146l-.153.109 1.954 3.768.153-.108L5.85 2.146z",
    fill: "#DEDEDE"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 340.941,
    y: 355.039,
    width: 5.705,
    height: 4.631,
    viewBox: "0 0 5.662 4.652",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#DADADA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.089 1.914c0 .193-.052.311-.155.355-.103.043-.253.01-.447-.102A2.006 2.006 0 010 1.782v-.38c.164.194.314.33.451.41.077.044.137.057.175.04.04-.018.059-.063.059-.133a.472.472 0 00-.07-.228 2.527 2.527 0 00-.232-.323A2.406 2.406 0 01.169.87 1.247 1.247 0 01.057.616a.9.9 0 01-.04-.265c0-.177.052-.288.156-.33.104-.045.245-.017.42.084.168.096.329.232.484.41L.942.746A3.147 3.147 0 00.792.59.855.855 0 00.623.462C.557.424.506.416.471.436.436.457.418.502.418.573c0 .07.021.142.064.22.042.075.117.176.222.303.143.172.242.321.298.448.059.126.087.25.087.37zM2.03 3.023l-.406-.232V1.064l-.419-.24V.487l1.244.713v.337l-.419-.24v1.726zM4.149 3.202c0 .341-.068.565-.204.671-.136.106-.33.087-.583-.058a1.472 1.472 0 01-.584-.609 1.938 1.938 0 01-.204-.908c0-.342.068-.564.204-.669.136-.105.331-.084.587.062.253.145.446.347.581.608.136.26.203.56.203.903zm-1.158-.664c0 .236.031.433.094.592a.66.66 0 00.277.344c.246.141.369-.03.369-.512s-.122-.793-.366-.932c-.124-.07-.217-.063-.28.024-.062.086-.094.248-.094.484zM5.662 3.674c0 .22-.059.354-.176.403-.118.05-.287.011-.509-.115l-.102-.058v.748l-.407-.233V2.355l.556.32c.425.241.638.575.638 1zm-.787-.104l.078.045c.1.057.174.074.223.05.049-.024.073-.095.073-.213a.549.549 0 00-.067-.279.549.549 0 00-.209-.198l-.099-.057v.652h.001z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 235.244,
    y: 318.968,
    width: 0.872,
    height: 6.702,
    viewBox: "0 0 0.901 6.711",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v6.455c0 .1.103.187.252.229a.405.405 0 00.05.012l.02.004.015.003.017.002.043.004a.121.121 0 00.019.001l.034.001.034-.001.019-.001a.571.571 0 00.043-.004l.018-.002.015-.003a.47.47 0 00.142-.041l.015-.006c.012-.006.024-.011.034-.018l.015-.009a.338.338 0 00.041-.031l.01-.009.021-.021.016-.021a.15.15 0 00.018-.035l.001-.003.003-.009.001-.005a.15.15 0 00.005-.037V0H0z",
    fill: "url(#paint0_linear_0_11880)"
  })), _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_11880",
    x1: 0.902,
    x2: -0.001,
    y1: 3.355,
    y2: 3.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#CBD7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#C3CDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BEC8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#98A3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#98A3C1"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 213.296,
    y: 306.49,
    width: 0.872,
    height: 6.702,
    viewBox: "0 0 0.903 6.71",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v6.455c0 .101.103.187.253.229a.405.405 0 00.05.012l.02.004.015.002.017.002.043.004.019.002h.068l.019-.002a.625.625 0 00.043-.004l.018-.002L.58 6.7a.47.47 0 00.142-.041l.015-.006c.012-.006.024-.011.034-.018l.015-.009a.334.334 0 00.041-.03l.011-.009.021-.021a.292.292 0 00.026-.038.142.142 0 00.008-.018l.001-.003.003-.009.001-.005a.15.15 0 00.005-.037V.001L0 0z",
    fill: "url(#paint0_linear_0_15151)"
  })), _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_15151",
    x1: 0.902,
    x2: 0,
    y1: 3.355,
    y2: 3.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#CFDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#CBD7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#C3CDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BEC8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#BDC6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#98A3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#98A3C1"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 209.81,
    y: 302.458,
    width: 31.218,
    height: 23.702,
    viewBox: "0 0 31.221 23.718",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.355V.574l30.235 17.354.007 5.79L0 6.355z",
    fill: "#CF9219"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .574l30.236 17.354.985-.55L1.003 0 0 .574z",
    fill: "#FFEF75"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M30.239 23.718l.982-.55v-5.79l-.982.55v5.79z",
    fill: "#F1C839"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#2A3443"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.498 7.91c0 .354-.094.572-.284.652-.189.08-.462.019-.82-.186l-.164-.094v1.207l-.658-.376v-3.33l.897.513c.687.394 1.029.931 1.029 1.614zM7.23 7.744l.126.073c.161.092.281.119.36.08.079-.038.119-.152.119-.342a.889.889 0 00-.109-.451.877.877 0 00-.336-.318l-.16-.092v1.05zM10.515 11.371l-.202-.956-.921-.528-.202.725-.657-.376.874-2.843.892.511.877 3.845-.661-.378zm-.326-1.576L10 8.912a35.205 35.205 0 01-.076-.397 10.398 10.398 0 01-.072-.421 7.636 7.636 0 01-.079.386c-.032.139-.116.45-.251.933l.667.382zM12.143 11.007v1.296l-.657-.376v-3.33l.86.493c.364.208.633.444.805.705.173.262.26.559.26.893 0 .421-.15.628-.452.623l.679 1.848-.702-.402-.558-1.616-.235-.134zm0-.533l.169.097c.154.088.266.111.333.066.068-.043.102-.148.102-.312a.782.782 0 00-.107-.424.925.925 0 00-.333-.299l-.164-.095v.967zM16.161 14.604l-.7-.401-.58-1.755-.264.097v1.175l-.657-.377v-3.33l.657.376v1.651l.23-.367.601-.808.703.402-.817.974.827 2.363zM16.591 14.85v-3.33l.618.354v3.33l-.618-.354zM20.429 17.048l-.802-.459-1.092-3.038-.031-.018c.041.207.061.416.061.626v1.82l-.609-.349V12.3l.808.463 1.082 3.006.027.015a3.47 3.47 0 01-.046-.596V13.37l.604.346v3.332h-.002zM22.121 16.169l1.08.619v1.708a2.99 2.99 0 01-.976-.375 2.4 2.4 0 01-.948-.985c-.221-.421-.332-.909-.332-1.463 0-.535.126-.88.38-1.037.254-.156.608-.105 1.064.156.282.161.551.384.807.667l-.208.387a2.377 2.377 0 00-.561-.485c-.25-.143-.447-.151-.593-.024-.146.127-.219.372-.219.734 0 .374.053.69.159.95.105.259.258.446.46.562.106.06.214.109.323.146v-.763l-.437-.25.001-.547z"
  }))), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 19.883l-1.899-3.138-1.898.946 1.023.59v1.975l1.675.967v-1.974l1.099.634zM4.857 6.162L2.958 3.024l-1.898.945 1.023.591v1.974l1.675.967V5.527l1.099.635z",
    fill: "#2A3443"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 159.655,
    y: 101.837,
    width: 326.6,
    height: 188.798,
    viewBox: "0 0 326.611 188.824",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#F4F4F4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.329 103.268l52.905-30.544 34.924 20.163-52.937 30.464 1.835 1.057 52.934-30.463 34.461 19.896-52.337 30.746 1.825 1.051 54.148-31.811L98.234 70.61l-54.738 31.603 1.833 1.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.44 104.474l-1.83 1.052-5.463-3.157 1.83-1.052 5.463 3.157zM83.839 125.406l-1.83 1.052-5.463-3.157 1.83-1.052 5.463 3.157zM120.718 146.661l-1.83 1.053-5.463-3.157 1.83-1.053 5.463 3.157z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#F4F4F4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.595 67.087L200.69 97.631l-34.924-20.163 52.937-30.465-1.835-1.056-52.934 30.463-34.461-19.896 52.336-30.746-1.825-1.051-54.147 31.811 74.853 43.217 54.738-31.603-1.833-1.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.484 65.881l1.83-1.052 5.463 3.157-1.83 1.052-5.463-3.157zM215.085 44.949l1.83-1.053 5.463 3.157-1.83 1.053-5.463-3.157zM178.206 23.694l1.83-1.053 5.463 3.157-1.831 1.052-5.462-3.156z"
  }))), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M99.656 65.718v-2.282L17.37 110.749v2.426l82.286-47.457z",
    fill: "#EAC72F"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M17.37 110.749L0 100.753v2.37l17.37 10.052v-2.426z",
    fill: "#C19424"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M99.66 63.437l-82.293 47.312L0 100.754l82.293-47.373L99.66 63.437z",
    fill: "#FFEF75"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M97.881 66.71v-2.282l211.36 121.97.001 2.426L97.881 66.71z",
    fill: "#C19424"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M309.242 186.399l17.369-9.997v2.371l-17.369 10.051v-2.425z",
    fill: "#EAC72F"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M80.506 54.409l228.738 131.989 17.367-9.995L97.872 44.353 80.506 54.409z",
    fill: "#FFEF75"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M85.735 54.401l223.509 128.987 12.137-6.985-135.568-78.379L126.58 63.93 97.881 47.373l-12.146 7.028z",
    fill: "#DBDBDB"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M102.943 58.489l-85.576 49.249-12.137-6.984 10.573-6.083 59.233-34.093 15.761-9.117 12.146 7.028z",
    fill: "#DBDBDB"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.307 12.337v-2.282l-77.068 44.293 2.107 1.221 74.961-43.232z",
    fill: "#EAC72F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.311 10.056l-77.072 44.292-17.367-9.995L174.944 0l17.367 10.056z",
    fill: "#FFEF75"
  }))), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M186.825 10.055l-76.807 44.302-12.137-6.984 10.573-6.083 59.233-34.093 6.993-4.17 12.145 7.028z",
    fill: "#DBDBDB"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M118.898 96.815c.08-.04 7.423-4.469 7.411-4.527-.612-2.753-14.394-12.679-15.714-15.183l-2.572 1.339.375-1.658-1.643-2.581-.955.461-3.791-2.984-18.498 8.323c-.333.147-1.279-.137-1.63-.171-1.333-.13-2.669-.238-4.006-.318-2.842-.171-5.933-.714-8.698.035-1.436.389-2.881 1.614-4.194 2.312a98.183 98.183 0 00-5.168 2.984 151.62 151.62 0 00-5.956 3.823l-.515 7.153-5.904 3.675.787 1.512 1.682 1.414 2.364 1.204.111-.01-.725.505c-.044.068 26.119 15.314 27.346 15.274 1.32-.043 3.457-1.52 4.598-2.05 1.96-.909 29.898-17.836 35.295-20.532z",
    fill: "url(#paint0_linear_0_14697)"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.535 104.995s.747.673 1.017.872c6.158 4.538 17.772 10.265 17.772 10.265l-1.318-1.267-17.471-9.87z",
    fill: "#141E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.118 91.091l-6.444-3.576 6.809-1.004-.365 4.58zM89.187 111.424l-6.445-3.576 6.81-2.496-.365 6.072z",
    fill: "#293237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.596 108.098l-1.132 1.847-2.76 4.504-1.363 2.224-1.806-1.046-.044-.026-.053-.031.002-.004c-.395-.257-.684-.682-.833-1.25a2.573 2.573 0 01-.043-.183l-.022-.128a3.47 3.47 0 01-.027-.211l-.011-.114a3.99 3.99 0 01-.011-.35c.027-2.249 1.666-4.977 3.66-6.094.11-.061.218-.115.325-.163.857-.394 1.623-.402 2.195-.081l.004-.008 1.919 1.114z",
    fill: "url(#paint1_linear_0_14697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.55 110.352c-.028 2.249-1.666 4.977-3.66 6.094-1.994 1.116-3.588.197-3.56-2.052.028-2.249 1.666-4.977 3.66-6.094 1.993-1.116 3.587-.197 3.56 2.052z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.497 110.94a3.88 3.88 0 01-.067.653c-.122.661-.407 1.343-.796 1.952a5.712 5.712 0 01-.845 1.042c-.277.27-.576.498-.884.671a2.714 2.714 0 01-.705.283c-.399.096-.76.06-1.05-.091l-.026-.016a1.145 1.145 0 01-.296-.231 1.346 1.346 0 01-.241-.366 1.408 1.408 0 01-.109-.283 1.13 1.13 0 01-.026-.088 2.168 2.168 0 01-.052-.311 2.496 2.496 0 01-.018-.353c0-.039.003-.075.005-.114a3.585 3.585 0 01.13-.846c.049-.194.114-.389.189-.583.106-.275.236-.544.386-.806 0-.002.003-.002.003-.005a5.79 5.79 0 01.801-1.089l.005-.005c.044-.054.096-.106.148-.156a4.332 4.332 0 01.925-.713c.08-.047.161-.085.238-.122.098-.044.197-.08.29-.111a1.89 1.89 0 01.49-.095c.135-.01.262-.005.384.018.132.023.254.067.368.13.347.187.594.539.697 1.037.041.18.059.38.056.598z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.597 110.004a3.88 3.88 0 01-.067.653c-.122.661-.407 1.343-.796 1.952a5.712 5.712 0 01-.845 1.042c-.277.27-.576.498-.884.671a2.867 2.867 0 01-.526.233c-.01-.029-.049-.207-.057-.238-.023-.096-.011-.05-.021-.161a2.496 2.496 0 01-.018-.353 3.95 3.95 0 01.049-.568c.021-.13.049-.259.086-.392a5.716 5.716 0 01.695-1.592c.202-.322.433-.627.69-.897.044-.054.096-.106.148-.156.288-.288.599-.531.926-.713.08-.047.161-.085.238-.122.098-.044.197-.08.29-.111.016.049.028.101.039.153.038.181.056.381.053.599z",
    fill: "#293237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.586 109.233c.34.298.541.803.533 1.481-.02 1.594-1.181 3.527-2.593 4.318-.615.344-1.175.415-1.612.254.461.403 1.178.427 1.99-.027 1.413-.791 2.574-2.724 2.593-4.318.012-.901-.344-1.5-.911-1.708z",
    fill: "url(#paint2_linear_0_14697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.803 111.139l-1.594.92.739 2.376c-.04.121-.473-.137-.473-.137l-1.099-1.181-.804 1.97c-.254.062-.083.467-.299.423a1.11 1.11 0 01-.482-.348l.472-1.981-.876.508c.005-.15.018-.301.044-.454.021-.13.105-.565.218-.823l.754-.554-.254-.504a5.79 5.79 0 01.746-.994l.34.441.63-1.252c.088-.062.015-.011.109-.063.08-.047.161-.085.238-.122.098-.044.197-.08.29-.111a1.89 1.89 0 01.49-.095l-.646 1.579 1.698-.674s.426.215.424.432c0 .213-.624.424-.665.644z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.468 111.424l-1.632 1.089.599 1.326c-.244.384-.201.319-.514.622l-.917-.89-.941 1.998c-.399.096-.499.092-.789-.058l.617-1.875-1.458.747c-.049-.197-.053-.335-.051-.579.003-.187 0-.252.031-.444l1.618-1.047-.703-1.245c.241-.386.259-.406.573-.712l.962.9 1.01-2.086c.353-.052.407-.061.713.063l-.611 1.958 1.495-.696c.039.179.03.226.027.444-.002.213.012.265-.029.485z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.502 112.058c-.004.35-.259.775-.57.948-.31.174-.558.031-.554-.319.004-.35.259-.775.57-.949.31-.173.558-.03.554.32z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.603 88.468l-1.132 1.847-2.76 4.504-1.363 2.224-1.806-1.047-.044-.026-.053-.031.002-.004c-.395-.257-.684-.682-.833-1.25a2.573 2.573 0 01-.065-.311 3.37 3.37 0 01-.027-.211l-.011-.114a3.99 3.99 0 01-.011-.35c.027-2.249 1.666-4.977 3.66-6.094.11-.061.218-.115.325-.163.857-.394 1.623-.402 2.195-.081l.004-.008 1.919 1.115z",
    fill: "url(#paint3_linear_0_14697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.557 90.722c-.027 2.249-1.666 4.978-3.66 6.094-1.994 1.116-3.588.198-3.56-2.052.027-2.249 1.666-4.977 3.66-6.094 1.994-1.116 3.588-.197 3.56 2.052z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.505 91.309a3.88 3.88 0 01-.067.653c-.122.661-.407 1.343-.796 1.952a5.754 5.754 0 01-.845 1.042c-.277.27-.576.498-.884.671a2.714 2.714 0 01-.705.283c-.399.096-.76.06-1.05-.091l-.026-.016a1.162 1.162 0 01-.296-.231 1.346 1.346 0 01-.241-.366 1.432 1.432 0 01-.109-.283 1.13 1.13 0 01-.026-.088 2.168 2.168 0 01-.052-.311 2.49 2.49 0 01-.018-.352c0-.039.003-.075.005-.114a3.518 3.518 0 01.13-.845c.049-.194.114-.389.189-.583.106-.275.236-.544.386-.806 0-.003.003-.003.003-.005a5.734 5.734 0 01.802-1.089l.005-.005c.044-.055.096-.106.148-.156a4.273 4.273 0 01.925-.713 2.701 2.701 0 01.729-.287c.098-.021.197-.036.29-.042.135-.01.262-.005.384.018.132.023.254.067.368.13.347.187.594.539.697 1.037.039.18.057.38.054.597z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.605 90.374a3.88 3.88 0 01-.067.653c-.122.661-.407 1.343-.796 1.952a5.712 5.712 0 01-.845 1.042c-.277.27-.576.498-.884.671a2.867 2.867 0 01-.526.233c-.01-.029-.049-.207-.057-.238-.023-.096-.011-.05-.021-.161a2.49 2.49 0 01-.018-.352 3.95 3.95 0 01.049-.568c.021-.13.049-.259.086-.391a5.716 5.716 0 01.695-1.592c.202-.322.433-.627.69-.897.044-.055.096-.106.148-.156.288-.288.599-.531.926-.713a2.701 2.701 0 01.529-.233c.016.049.028.101.039.153.036.179.054.379.052.597z",
    fill: "#293237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.594 89.603c.34.298.541.803.533 1.481-.02 1.594-1.181 3.527-2.593 4.318-.615.344-1.176.415-1.612.254.461.404 1.178.427 1.99-.027 1.413-.791 2.574-2.724 2.593-4.318.011-.901-.344-1.5-.911-1.708z",
    fill: "url(#paint4_linear_0_14697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.81 91.509l-1.594.92.739 2.376c-.04.121-.473-.137-.473-.137l-1.099-1.181-.804 1.97c-.254.062-.083.467-.298.423-.304-.106-.482-.348-.482-.348l.472-1.981-.876.508c.005-.15.018-.301.044-.454.021-.13.105-.565.218-.823l.754-.554-.254-.504a5.734 5.734 0 01.747-.994l.34.441.63-1.252c.088-.062.015-.011.109-.063a2.701 2.701 0 01.729-.287c.098-.021.197-.036.29-.042l-.646 1.579 1.698-.674s.426.215.424.432c-.002.214-.626.425-.668.645z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.476 91.794l-1.632 1.089.599 1.326c-.244.384-.201.319-.514.622l-.917-.89-.941 1.998c-.399.096-.499.092-.789-.058l.617-1.875-1.458.747c-.049-.197-.053-.335-.051-.579.003-.187 0-.252.031-.444l1.618-1.047-.703-1.245c.241-.386.259-.406.573-.712l.962.9 1.01-2.085c.353-.052.407-.061.713.062l-.611 1.958 1.495-.696c.039.179.03.226.027.444-.002.213.012.265-.029.485z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.509 92.428c-.004.35-.259.775-.57.949-.31.174-.559.031-.554-.319.004-.35.259-.775.57-.949.311-.174.559-.031.554.319z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.031 105.268l-5.131-1.56.026-1.708-.026-3.224.513-1.063 7.277-5.124 4.244-8.822 15.067-8.306 7.538 2.42 13.241-5.755-.98 5.053 2.11-1.142-1.559 3.996-1.633 1.872-40.687 23.363z",
    fill: "#6EDAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.024 85.967l-1.565 3.99-.32.366a3.844 3.844 0 00-.256-1.171 2.744 2.744 0 00-.558-.851 2.331 2.331 0 00-.677-.476 2.31 2.31 0 00-.833-.201c-.073-.018-.146-.018-.22-.018-.604 0-1.235.183-1.885.549-1.126.631-2.141 1.702-2.855 2.937a8.134 8.134 0 00-1.007 2.626 6.726 6.726 0 00-.11 1.043c0 .384.037.75.119 1.08L89.126 110.61c.018-.092.018-.192.018-.284.009-.741-.137-1.373-.421-1.885h-.009v-.018a2.332 2.332 0 00-.403-.531 2.014 2.014 0 00-.512-.384 2.026 2.026 0 00-.641-.247.172.172 0 00-.064-.018h-.009a3.057 3.057 0 00-.494-.046c-.604 0-1.235.183-1.894.549a6.96 6.96 0 00-1.693 1.373 7.52 7.52 0 00-.714.888c-.613.86-1.08 1.83-1.327 2.809a6.082 6.082 0 00-.229 1.537c0 .238.009.458.046.677l-5.307-2.315v-.998l.54-3.01.512-1.061 7.275-5.124 4.246-8.83s11.438-9.956 15.648-8.501c2.763.952 6.954 2.626 6.954 2.626l13.241-5.765-.43 3.917-.101.887.641-.339 1.025-.55z",
    fill: "#4B9F1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.574 81.947l-12.922 5.861-26.849 14.708-7.277 5.124-.513 1.063 47.842-26.312.038-.338-.319-.106z",
    fill: "#7CC53F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.82 112.158l6.184-3.04a7.52 7.52 0 00-.714.888c-.613.86-1.08 1.83-1.327 2.809a6.082 6.082 0 00-.229 1.537c0 .238.009.458.046.677.009.119.027.238.064.357l-2.425 1.391-1.135-.604-.961-.037-1.318-1.061v-2.096l.467-.265 1.348-.556z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.739 94.761c0 .384-.067.794.015 1.124L89.126 110.61c.018-.092.018-.192.018-.284.009-.741-.137-1.373-.421-1.885h-.009v-.018a2.332 2.332 0 00-.403-.531 2.014 2.014 0 00-.512-.384 2.026 2.026 0 00-.641-.247l25.64-14.449 3.056-1.72a8.134 8.134 0 00-1.007 2.626 6.82 6.82 0 00-.108 1.043z",
    fill: "#4A9922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.779 109.139l-.143-3.549v-3.84l-1.599-5.092 9.173-1.169.937 2.285.438 5.93 9.582-5.801.102-4.608-1.006-3.288.24-.073 1.018 3.326-.105 4.786-.059.036-9.992 6.049-.467-6.318-.847-2.05-8.684 1.106 1.52 4.861v3.855l.143 3.544-.251.01z",
    fill: "#406E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.572 84.94l.803.496.649.531-2.141 3.184a2.744 2.744 0 00-.558-.851 2.331 2.331 0 00-.677-.476 2.31 2.31 0 00-.833-.201c-.055-.046-.11-.073-.165-.101l1.711-.97 1.098-.586.113-1.026z",
    fill: "#546672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.49 111.58l2.8-1.574c-.613.86-1.08 1.83-1.327 2.809l-1.473.824v-2.059zM86.847 100.861l2.066-7.069 14.584-8.083 6.117 2.657-.231 1.605-19.928 11.007-2.608-.117z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.01 88.739l-.128.879-2.26 1.254-.394.21-7.347 4.063-.733.403-6.57 3.623-.915.513-1.44.805-1.116-.449 1.248-5.865.402-.229.622-.338 6.323-3.523.01-.009.713-.403 6.127-3.363 5.458 2.429z",
    fill: "#529BA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.578 99.171l-.915.513-.906-5.738.622-.338 1.199 5.563zM98.881 95.145l-.733.403-1.446-5.463.01-.009.713-.403 1.456 5.472zM106.402 91.085l-.393.21-1.796-4.88.549.192 1.64 4.478zM124.942 88.163l-1.482 1.794.302.769-.631.366c.009-.119.018-.247.018-.366 0-.137 0-.274-.009-.403a3.844 3.844 0 00-.256-1.171 2.744 2.744 0 00-.558-.851 2.331 2.331 0 00-.677-.476l1.711-.97.641-.339 1.025-.549-.084 2.196zM88.723 108.441h-.009v-.018c0 .009.009.009.009.018z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.69 92.641l17.113 9.927-7.277 5.072-17.113-9.927 7.277-5.072z",
    fill: "#8FD747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.951 83.791l-4.261 8.85s4.444 5.244 17.113 9.927l4.244-8.874-17.096-9.903z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.323 93.827l-3.862 8.062c-10.642-3.98-15.218-8.391-16.087-9.297l3.889-8.071s.229.192.659.531c.201.146.439.329.723.531.201.156.421.32.668.494a68.15 68.15 0 003.614 2.407c2.682 1.656 6.214 3.614 10.396 5.343z",
    fill: "#3D7D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.228 91.43l-1.561.556-.292.606c.869.906 5.445 5.317 16.087 9.297l.761-1.588c-9.853-3.864-14.157-7.997-14.995-8.871z",
    fill: "#5B949C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.416 75.034c-.687-.269-15.465 8.705-15.465 8.705s5.678 5.337 17.1 9.956l15.643-8.508S92.58 77.448 86.416 75.034z",
    fill: "#8FD747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.535 102.796l17.471 10.185v2.094c.424-.139-5.968-1.258-17.471-10.08-.437-.335 0-2.199 0-2.199z",
    fill: "#293237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.526 107.64l-.513 1.063L58.9 98.776l.513-1.063 17.113 9.927z",
    fill: "#55A12B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.26 102.127c-.273.157-1.046.453-.527.878 6.577 5.384 17.004 9.822 17.273 9.977l.469-.27-17.215-10.585z",
    fill: "#546672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.494 110.674l-.018.009-.869.43-3.999 1.958a1.563 1.563 0 01-1.217.055l-.384-.146 1.025-.577 4.996-2.379.037-.018.421.659.008.009z",
    fill: "#546672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.013 108.706l-.54 3.011v.997l-17.112-9.928v-.989l.54-3.01v-.009l.009.009.568.329 16.535 9.59z",
    fill: "#35790F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.112 100.988l10.769 6.206-.141 3.212-3.558-4.246-5.053-2.922-3.319.269 1.302-2.519z",
    fill: "#246400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.478 99.446v1.4c0 .119-.046.284-.128.485-.018.036-.027.064-.046.092-.101.21-.238.284-.329.357-.009.009-.009.009-.018.009a1.538 1.538 0 01-.146.101c-.073.046-.156.082-.229.128-.146.091-.073.018-.22.11v-.54l.43-2.233.055-.275.055.037h.009l.567.329z",
    fill: "#E08A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.361 102.127l2.449 1.38a.59.59 0 00.821-.254l.661-1.343a.775.775 0 00-.308-1.014l-2.507-1.45-1.116 2.681zM75.454 111.91l-2.893-1.604c-.187-.11-.349-.535-.355-.93l-.028-1.741c-.007-.475.161-.744.385-.617l3.419 1.884-.528 3.008z",
    fill: "#E08A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.983 108.903c.144-.103.081-.069.218-.155.119-.075.215-.044.277-.002.08.053.093.164.093.336v1.545c0 .123-.045.283-.133.489-.013.03-.026.06-.041.09-.103.211-.24.282-.329.352-.138.107-.264.166-.392.244-.148.09-.074.019-.222.109v-.54l.529-2.468z",
    fill: "#E08A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.097 105.593c-.237-.139-.43-.462-.43-.721v-1.321c0-.259.193-.356.43-.218l3.185 1.861c.237.138.43.462.43.72v1.321c0 .259-.193.357-.429.219l-3.186-1.861z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.283 107.366l-3.185-1.861c-.193-.113-.349-.374-.349-.585v-1.321c0-.21.156-.29.349-.177l3.185 1.861c.193.113.349.375.349.585v1.321c0 .21-.157.29-.349.177z",
    fill: "#EFEC82"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D3A944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.63 105.858a.757.757 0 00-.347-.576l-3.185-1.861c-.19-.111-.343-.034-.347.17l3.879 2.267zM64.75 104.929a.76.76 0 00.347.576l3.185 1.861c.19.111.343.034.347-.17l-3.879-2.267z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.889 82.05l-13.237 5.761s-1.199-1.135-3.111-2.645c-2.306-1.83-5.664-4.2-9.215-5.774-1.583-.705-3.203-1.244-4.786-1.51 0 0 12.084-6.109 13.237-5.761 1.034.311 2.031.668 2.992 1.043 4.914 1.94 8.858 4.603 11.319 6.506 1.804 1.392 2.801 2.38 2.801 2.38z",
    fill: "#7CC53F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.827 79.371s6.339 2.752 9.713 5.796c3.374 3.044.219-.033.219-.033s-2.307-4.054-9.331-6.075c-7.024-2.021-.637-1.063-.637-1.063l.036 1.375z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.889 82.05l-13.237 5.762-.019-.01-2.102-1.733 12.558-6.398 2.8 2.379z",
    fill: "#8FD747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.77 73.165l-11.942 6.206c-1.583-.704-2.785-.753-4.368-1.018 0 0 12.536-6.351 13.689-6.003 1.034.312 1.66.44 2.621.815z",
    fill: "#72A03E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.77 73.165l-12.314 5.978c-1.583-.705-2.333-.994-3.916-1.26 0 0 12.084-6.109 13.237-5.761a39.66 39.66 0 012.993 1.043z",
    fill: "#8FD747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.268 78.545l.315-.169a.786.786 0 01.615-.012l2.544 1.171c.317.148.286.393-.065.528l-.292.112a.804.804 0 01-.558-.009l-2.52-1.132c-.289-.131-.306-.345-.039-.489z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7CC53F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.544 78.416l-.213-.063-1.378.647.164.093 1.427-.677zM102.096 78.627l-.213-.063-1.378.647.164.093 1.427-.677zM102.648 78.838l-.212-.062-1.379.646.165.094 1.426-.678zM103.201 79.049l-.213-.062-1.378.646.164.094 1.427-.678zM103.709 79.279l-.212-.062-1.379.647.165.093 1.426-.678zM104.114 79.561l-.212-.062-1.378.646.164.094 1.426-.678z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.346 84.29l-.309.178c-.158.091-.396.075-.517-.035l-1.814-1.618c-.225-.204-.134-.497.196-.63l.275-.111c.156-.063.356-.039.464.056l1.804 1.568c.207.182.163.441-.099.592z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7CC53F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.245 84.343l.161.092 1.326-.667-.112-.126-1.375.701zM107.839 84.044l.161.092 1.327-.667-.113-.126-1.375.701zM107.434 83.744l.161.093 1.326-.668-.112-.125-1.375.7zM107.029 83.445l.161.092 1.326-.667-.112-.126-1.375.701zM106.666 83.126l.16.092 1.327-.667-.113-.126-1.374.701zM106.402 82.754l.161.092 1.326-.667-.112-.126-1.375.701z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.807 89.661l-.532.295a.464.464 0 00-.232.401v.198c0 .178.193.289.347.2l.532-.298a.462.462 0 00.231-.4v-.195a.231.231 0 00-.346-.201z",
    fill: "#E06E18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.904 89.737l-.532.295a.464.464 0 00-.232.401v.197c0 .178.193.29.347.201l.532-.298a.462.462 0 00.231-.4v-.195a.23.23 0 00-.346-.201z",
    fill: "#E0AB35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.517 85.007c-2.306-1.83-5.683-3.948-9.192-5.614-4.005-1.901-11.909-4.359-11.909-4.359 6.164 2.414 17.277 10.154 17.277 10.154l6.958 2.624s-1.221-1.296-3.134-2.805z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.758 85.017c-.061-.048-8.185-5.691-14.359-8.821 2.661.891 6.466 2.232 8.847 3.362 3.29 1.562 6.713 3.652 9.156 5.592 1.1.868 1.975 1.671 2.515 2.189l-6.159-2.322z",
    fill: "#88D5DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.928 88.483L73.35 90.46l-.037-4.383a69.358 69.358 0 003.615 2.406zM72.646 85.582l-.21 5.39-1.949 1.071-1.116-.448 2.214-6.369.339-.174c.2.146.438.329.722.53z",
    fill: "#95C9B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.552 106.477v1.516l24.935-15.705-.343-.2-24.592 14.389z",
    fill: "#546672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.895 106.677v1.516l24.592-14.389v-1.516l-24.592 14.389z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.895 106.677v1.516l-.343-.2v-1.516l.343.2z",
    fill: "#293237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.114 109.998c.018.177.037.355.036.545 0 .183-.018.375-.037.558l25.814-14.824a4.026 4.026 0 01-.163-1.009l-25.65 14.73z",
    fill: "#546672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.114 110.356c.018.177.037.355.036.545 0 .183-.018.375-.037.558l25.814-14.824a4.026 4.026 0 01-.163-1.009l-25.65 14.73z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.806 108.249c-.247-.448-.686-.897-1.464-1.171-.229-.082-1.977-.906-4.585 1.858a8.432 8.432 0 00-1.272 1.729c-.009.009-.009.009-.009.018l-.869.43c.082-.219.174-.457.265-.714.046-.128.101-.256.156-.375.961-2.169 3.157-3.834 5.49-3.761 1.327.037 1.976 1.052 2.288 1.986z",
    fill: "#546672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.098 109.768s-.027-.732-.293-1.519c.421.759.293 1.519.293 1.519z",
    fill: "#546672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.845 115.386s-.45-3.504 2.16-6.268c2.609-2.765 4.586-1.74 4.795-1.611.209.13 1.316 1.03 1.315 2.491l-.001 1.461.439-1.264s-.11-3.427-2.58-3.498c-2.47-.072-4.784 1.794-5.642 4.132-.858 2.338-1.216 3.007-1.216 3.007l.73 1.55z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.697 87.134c-1.359-.108-2.577-1.117-5.308 1.442s-2.207 7.043-2.207 7.043l.133.087c.091-.051.21.077.299.023a6.726 6.726 0 01.127-2.827c.454-1.717 1.753-3.543 3.393-4.748 1.64-1.206 3.324-.561 3.324-.561s1.598-.351.239-.459z",
    fill: "#546672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.709 87.789s-1.684-.645-3.324.561-2.939 3.032-3.393 4.748c-.454 1.717-.065 3.122-.065 3.122v.415l-.493-.82s-.462-4.228 2.268-6.788c2.731-2.559 4.182-1.65 5.542-1.542 1.359.11-.535.304-.535.304z",
    fill: "#414C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.426 108.054l.004.314c.002.14.079.27.202.341l1.335.777a.158.158 0 00.239-.138l-.001-.088-1.117-.65a.401.401 0 01-.201-.341l-.003-.226-.217-.125c-.11-.062-.243.015-.241.136z",
    fill: "#246400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.882 108.044l.003.226c.002.14.079.27.201.341l1.117.65-.003-.224a.407.407 0 00-.201-.344l-1.117-.649z",
    fill: "#BED5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.602 99.886c-.128.056-.13.307-.159.47l-.116.661-.147.833a.367.367 0 00.187.386c.184.099.356.221.554.292.281.102.302-.063.343-.305l.251-1.497.018-.109a.366.366 0 00-.177-.377c-.185-.108-.368-.228-.559-.325-.086-.044-.149-.049-.195-.029z",
    fill: "#E03835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.762 100.57c-.13.062-.129.325-.153.462l-.117.664-.148.843a.367.367 0 00.187.386l.363.196c.169.091.421.286.498-.001.063-.231.081-.484.121-.719l.184-1.095a.366.366 0 00-.177-.377c-.195-.114-.4-.277-.611-.355-.063-.023-.11-.021-.147-.004z",
    fill: "#E0C5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.734 107.442c-.123.059-.099.326-.111.498l-.049.7-.062.883a.438.438 0 00.226.409c.194.105.378.234.583.309.291.107.296-.066.312-.323l.099-1.587.007-.115a.439.439 0 00-.215-.399c-.196-.114-.391-.242-.592-.345-.091-.046-.154-.051-.198-.03z",
    fill: "#E03835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.963 108.167c-.123.066-.096.345-.106.49l-.049.704-.063.893a.438.438 0 00.226.409l.383.208c.178.097.45.303.498-.001.039-.244.032-.512.048-.762l.073-1.161a.441.441 0 00-.215-.4c-.207-.12-.428-.293-.647-.376-.065-.024-.113-.022-.148-.004z",
    fill: "#E0C5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.938 89.056c.098.252.166.516.102.788a1.878 1.878 0 01-.169.413c-.088.172-.155.412-.326.508-.138.078-.305.181-.47.167-.19-.015-.39-.118-.552-.212-.466-.268-.958-.521-1.386-.849-.143-.11-.254-.287-.448-.25-.164.032-.21.074-.376-.027a.824.824 0 01-.314-.34c-.098-.204-.13-.547.076-.69.133-.093.28-.169.421-.249a.903.903 0 01.083-.04c.105-.044.254-.075.316-.182.066-.113.05-.244.171-.328a.47.47 0 01.168-.065c.205-.05.412-.125.625-.128.218-.003.37.105.554.214.416.247.814.521 1.196.818.058.045.116.091.163.146.076.089.124.198.166.306z",
    fill: "#246400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.602 88.195c.767.466 1.745.745 1.843 1.288.101.547-.126 1.247-.767 1.037-.613-.199-1.57-.879-1.57-.879s-.277-1.916.494-1.446z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.315 100.711l-1.835 1.077c-.001-.352-.06-.559.304-.772 0 0 .566-.391 1.082-.654.484-.245.449.349.449.349zM102.654 95.7l-1.835 1.077c-.001-.352-.06-.559.304-.772 0 0 .566-.391 1.082-.654.485-.245.449.349.449.349z",
    fill: "#414C5C"
  }))), _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_14697",
    x1: 111.31,
    x2: 86.158,
    y1: 72.824,
    y2: 138.444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_14697",
    x1: 80.32,
    x2: 85.35,
    y1: 115.508,
    y2: 106.796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_0_14697",
    x1: 83.924,
    x2: 87.483,
    y1: 115.895,
    y2: 109.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint3_linear_0_14697",
    x1: 114.328,
    x2: 119.357,
    y1: 95.878,
    y2: 87.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint4_linear_0_14697",
    x1: 117.931,
    x2: 121.491,
    y1: 96.265,
    y2: 90.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 262.896,
    y: 138.506,
    width: 30.346,
    height: 39.394,
    viewBox: "0 0 29.655 17.119",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M23.316 17.119L0 3.658 6.31 0l23.345 13.478-6.339 3.641z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 280.486,
    y: 138.506,
    width: 12.757,
    height: 39.394,
    viewBox: "0 0 12.197 8.124",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M12.197 3.916V2.864l-7.251 4.17v1.09l7.251-4.208z",
    fill: "#CCD2D6"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M4.946 7.034L.001 4.185V5.26l4.945 2.864v-1.09z",
    fill: "#8E9C9E"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M12.197 2.864l-7.251 4.17L0 4.184 7.253 0l4.944 2.864z",
    fill: "#EBEBEB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 281.595,
    y: 143.192,
    width: 10.617,
    height: 33.074,
    viewBox: "0 0 10.636 33.089",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M10.635 29.42l.001-26.923-6.323 3.636v26.956l6.322-3.669z",
    fill: "#D9DEE1"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M10.635 4.819l.001-1.041-6.323 3.636v1.074l6.322-3.669z",
    fill: "#EAC72F"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 6.133L0 3.649v26.943l4.313 2.497V6.133z",
    fill: "#8E9C9E"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 7.414L0 4.93v1.062l4.313 2.496V7.414z",
    fill: "#CF9219"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M10.635 28.812l.001-1.041-6.323 3.636v1.074l6.322-3.669z",
    fill: "#EAC72F"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 31.407L0 28.923v1.061l4.313 2.497v-1.074z",
    fill: "#CF9219"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 2.497L4.312 6.133 0 3.648 6.324 0l4.312 2.497z",
    fill: "#3D7EE3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 280.486,
    y: 138.506,
    width: 12.519,
    height: 10.026,
    viewBox: "0 0 12.586 10.039",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 10.039L0 4.569v-.352L12.586 5.47v.353L5.3 10.039z",
    fill: "#555D69"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 9.687L0 4.217 7.285 0l5.301 5.47L5.3 9.687z",
    fill: "#6B777F"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M5.382 9.351L.522 4.262 7.203.394l4.861 5.09-6.682 3.867z",
    fill: "#5E4F4B"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.996 3.986l.092-.053 4.861 5.089-.092.053L.996 3.986zM1.631 3.618l.092-.053 4.861 5.09-.092.053-4.861-5.09zM2.266 3.251l.092-.053 4.861 5.089-.092.053-4.861-5.089zM2.901 2.883l.092-.053 4.861 5.09-.092.053-4.861-5.09zM3.536 2.516l.092-.054 4.861 5.09-.092.053-4.861-5.089zM4.171 2.148l.092-.053 4.861 5.09-.092.053-4.861-5.09zM4.807 1.781l.091-.054 4.861 5.09-.092.053-4.86-5.089zM5.441 1.413l.092-.053 4.861 5.09-.092.053-4.861-5.09zM6.077 1.046l.091-.054 4.861 5.09-.092.053-4.86-5.089zM6.712.678l.091-.053 4.861 5.089-.092.054-4.86-5.09z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.64 5.051l.111.096L5.07 9.014l-.111-.096 6.681-3.867zM10.504 3.866l.111.096-6.682 3.867-.111-.096 6.682-3.867zM9.362 2.684l.111.097-6.682 3.867-.111-.097 6.682-3.867zM7.678.891l.111.097-6.682 3.867-.111-.097L7.678.891zM8.466 1.717l.111.097L1.895 5.68l-.111-.096 6.682-3.867z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 280.486,
    y: 142.756,
    width: 5.229,
    height: 5.776,
    viewBox: "0 0 5.3 5.822",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 5.822V5.47L0 0v.352l5.3 5.47z",
    fill: "#3A4044"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 280.486,
    y: 143.083,
    width: 5.388,
    height: 6.212,
    viewBox: "0 0 5.456 6.23",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l1.144 3.745L5.456 6.23 5.3 5.47 0 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 285.715,
    y: 144.337,
    width: 7.289,
    height: 4.958,
    viewBox: "0 0 7.286 4.976",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M7.286 0L6.48 1.34.156 4.976 0 4.216 7.286 0z",
    fill: "#8A9B9E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 282.15,
    y: 152.564,
    width: 2.852,
    height: 6.103,
    viewBox: "0 0 2.83 6.129",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83 5.901V1.913c0-.187-.203-.536-.365-.628L.272.044C.103-.051 0 .01 0 .205v4.018c0 .187.202.536.365.628L2.527 6.08c.187.106.303.039.303-.179z",
    fill: "#3A8ABF"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M.263 4.682c-.108-.123-.195-.311-.195-.419V.283c0-.17.091-.223.238-.14l2.162 1.224a.4.4 0 01.098.085c.108.123.195.311.195.419v3.92c0 .212-.114.278-.297.174L.36 4.767a.416.416 0 01-.097-.085z",
    fill: "#F4FAFC"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M.358.291C.242.225.171.268.171.401v3.98a.37.37 0 00.138.238l2.103 1.198c.152.086.246.031.246-.144v-3.92a.369.369 0 00-.139-.239L.358.291z",
    fill: "#3A8ABF"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M2.314 3.108c0 .305-.061.504-.182.599-.121.094-.296.077-.526-.052L.931 3.28v1.04L.51 4.083V1.215l1.144.64c.44.246.66.664.66 1.253zM.932 2.816l.65.361c.103.058.18.065.231.022.051-.043.076-.147.076-.31a.873.873 0 00-.07-.374.499.499 0 00-.215-.23l-.672-.374v.905z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.666,
    y: 149.676,
    width: 4.833,
    height: 10.462,
    viewBox: "0 0 4.82 10.419",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0v7.619L0 10.419V2.771L4.041.449 4.82 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.666,
    y: 152.455,
    width: 4.833,
    height: 7.683,
    viewBox: "0 0 4.82 7.658",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 4.848v.011L0 7.658V0l3.57 3.884 1.25.964z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.666,
    y: 150.766,
    width: 3.565,
    height: 7.683,
    viewBox: "0 0 3.57 7.671",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.671l3.57-2.074v-.01L2.964 0 0 1.703v5.968z",
    fill: "#9CDBE5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.666,
    y: 152.074,
    width: 2.298,
    height: 5.013,
    viewBox: "0 0 2.329 5.005",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.005l2.329-1.353v-.007L1.933 0 0 1.112v3.893z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.508,
    y: 157.958,
    width: 4.992,
    height: 5.285,
    viewBox: "0 0 4.981 5.311",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M4.981.09L4.82 0 0 2.772v2.449l.161.09L4.981.09z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.983,
    y: 162.481,
    width: 4.199,
    height: 10.625,
    viewBox: "0 0 4.232 10.627",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.627V2.433l.031-.018L4.232 0v8.172l-.03.017L0 10.627zm.122-8.123v7.912L4.11 8.102V.211L.122 2.504z",
    fill: "#A8A8A8"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 281.674,
    y: 150.712,
    width: 3.882,
    height: 22.449,
    viewBox: "0 0 3.904 22.472",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M3.903 22.472L0 20.259V0l3.904 2.235v20.237h-.001zM.121 20.188l3.66 2.075V2.306L.121.21v19.978z",
    fill: "#768E91"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 288.805,
    y: 170.545,
    width: 0.713,
    height: 0.872,
    viewBox: "0 0 0.714 0.855",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.233a.728.728 0 01-.337.562C.144.898-.003.813 0 .606A.722.722 0 01.337.044C.521-.059.668.025.665.233z",
    fill: "#929DA6"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M.714.32a.637.637 0 01-.297.496C.255.907.125.832.128.649A.635.635 0 01.425.154C.587.063.716.138.714.321z",
    fill: "#BFBFBF"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.348a.534.534 0 01-.248.413C.282.837.174.774.176.622A.534.534 0 01.424.209C.559.133.667.196.665.348z",
    fill: "#CECECE"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M.52.429a.216.216 0 01-.1.167C.365.627.322.601.322.54a.217.217 0 01.1-.167C.477.343.52.368.52.429z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.666,
    y: 158.013,
    width: 4.833,
    height: 5.231,
    viewBox: "0 0 4.82 5.221",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 2.424V0L0 2.772v2.449l4.82-2.797z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.745,
    y: 158.231,
    width: 4.596,
    height: 4.795,
    viewBox: "0 0 4.6 4.75",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.645L4.6 0v2.08L0 4.75V2.645z",
    fill: "#EAC72F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.904,
    y: 158.449,
    width: 4.358,
    height: 4.304,
    viewBox: "0 0 4.33 4.302",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.484L4.33 0v1.796L0 4.302V2.484z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.666,
    y: 149.676,
    width: 4.833,
    height: 3.978,
    viewBox: "0 0 4.82 3.969",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0L3.087 2.204 0 3.969V2.771L4.82 0z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 287.141,
    y: 160.247,
    width: 1.505,
    height: 2.016,
    viewBox: "0 0 1.524 2.016",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M1.524 1.135V0L0 .868v1.148l1.524-.881z",
    fill: "#DCE0E3"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.729V.181L.042.846v.557L1.208.729z",
    fill: "#9AA7B0"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M1.076.521V.455l-1.002.573v.073l1.002-.58z",
    fill: "#555D69"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.729l.316.406V0l-.316.181v.548z",
    fill: "#77888B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 289.36,
    y: 158.83,
    width: 1.585,
    height: 1.308,
    viewBox: "0 0 1.627 1.306",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M1.627.365V0L0 .927v.379L1.627.365z",
    fill: "#A6EA5B"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M1.491.323v-.09l-1.345.773v.097l1.345-.78z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 286.508,
    y: 160.683,
    width: 0.158,
    height: 2.561,
    viewBox: "0 0 0.161 2.539",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l.161.09v2.449L0 2.449V0z",
    fill: "#202A32"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 289.36,
    y: 160.138,
    width: 0.555,
    height: 1.035,
    viewBox: "0 0 0.533 1.066",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M.533.758V0L0 .304v.762L.533.758z",
    fill: "#B6BFC6"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M.322.77L.194.846.191.309.323.232.322.77z",
    fill: "#DCE0E3"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M.292.743l-.06.036V.334L.293.297.292.743z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 282.15,
    y: 157.849,
    width: 2.852,
    height: 2.343,
    viewBox: "0 0 2.844 2.357",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "#F4FAFC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.316.404C.316.482.3.532.269.556.238.58.193.575.135.541L.108.526v.265L0 .73V0l.147.084c.113.063.169.17.169.32zM.108.408L.129.42c.027.015.046.017.059.006C.201.415.207.389.207.347A.22.22 0 00.189.252a.133.133 0 00-.055-.06L.108.177v.231zM.647 1.099L.613.895.462.809.429.974.321.912.464.261.61.345l.144.815-.107-.061zM.593.764L.562.576.549.491.537.401C.534.428.529.457.524.488A8.441 8.441 0 01.483.7l.11.064zM.931.82l.077-.244.113.065L.984 1v.293l-.106-.061V.944L.741.423l.113.065.077.332zM1.73 1.72l-.107-.062v-.32l-.142-.081v.32l-.108-.062v-.73l.108.062v.29l.142.081v-.29L1.73.99v.73zM2.093 1.927l-.261-.149v-.73l.261.15v.117l-.153-.088v.174l.142.081V1.6l-.142-.081v.202l.153.087v.119zM2.286 1.753v.284l-.108-.062v-.73l.141.081c.06.034.104.077.132.129a.381.381 0 01.043.188c0 .092-.024.143-.074.151l.112.384-.116-.066-.091-.337-.039-.022zm0-.117l.028.016c.025.015.043.016.055.004.011-.012.017-.035.017-.072a.195.195 0 00-.018-.09.136.136 0 00-.054-.055l-.027-.015-.001.212zM2.844 2.357l-.261-.149v-.73l.261.149v.117l-.153-.088v.174l.142.081v.118l-.142-.081v.202l.153.087v.12z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 284.685,
    y: 163.244,
    width: 0.634,
    height: 0.654,
    viewBox: "0 0 0.568 0.68",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.185a.576.576 0 00.268.447C.453.714.57.646.568.482A.576.576 0 00.3.035C.154-.048.037.02.039.185z",
    fill: "#D1D6DA"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .255A.507.507 0 00.237.65c.129.072.232.013.23-.133A.509.509 0 00.23.122C.101.05-.002.11 0 .255z",
    fill: "#ABABAB"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.276c.002.121.09.268.197.33.108.06.193.01.192-.112A.422.422 0 00.231.166C.123.106.037.156.039.276z",
    fill: "#BABABA"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M.155.341a.17.17 0 00.08.133C.278.498.313.478.313.43a.168.168 0 00-.08-.133C.189.272.154.292.155.341z",
    fill: "#5C656B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 66.16,
    y: 234.84,
    width: 30.426,
    height: 39.394,
    viewBox: "0 0 29.655 17.119",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M23.316 17.119L0 3.658 6.31 0l23.345 13.478-6.339 3.641z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 83.75,
    y: 234.84,
    width: 12.836,
    height: 39.394,
    viewBox: "0 0 12.197 8.123",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M12.197 3.915V2.863l-7.251 4.17v1.09l7.251-4.208z",
    fill: "#CCD2D6"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M4.946 7.033L.001 4.184v1.075l4.945 2.864v-1.09z",
    fill: "#8E9C9E"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M12.197 2.863l-7.251 4.17L0 4.184 7.253 0l4.944 2.863z",
    fill: "#EBEBEB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 84.938,
    y: 239.526,
    width: 10.617,
    height: 33.074,
    viewBox: "0 0 10.635 33.089",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M10.635 29.42V2.497L4.313 6.133v26.956l6.322-3.669z",
    fill: "#D9DEE1"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M10.635 4.819V3.778L4.313 7.414v1.075l6.322-3.67z",
    fill: "#EAC72F"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 6.133L.001 3.649v26.943l4.312 2.497V6.133z",
    fill: "#8E9C9E"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 7.414L.001 4.93v1.062l4.312 2.497V7.414z",
    fill: "#CF9219"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M10.635 28.812v-1.041l-6.322 3.636v1.075l6.322-3.67z",
    fill: "#EAC72F"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 31.407L.001 28.923v1.062l4.312 2.497v-1.075z",
    fill: "#CF9219"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M10.635 2.497L4.312 6.133 0 3.649 6.324 0l4.311 2.497z",
    fill: "#3D7EE3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 83.75,
    y: 234.84,
    width: 12.598,
    height: 10.026,
    viewBox: "0 0 12.586 10.039",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 10.039L0 4.569v-.352l12.586 1.254v.352L5.3 10.039z",
    fill: "#555D69"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 9.687L0 4.217 7.285 0l5.301 5.471L5.3 9.687z",
    fill: "#6B777F"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M5.382 9.351L.522 4.262 7.203.395l4.861 5.089-6.682 3.867z",
    fill: "#5E4F4B"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.996 3.986l.092-.053 4.861 5.089-.092.053L.996 3.986zM1.631 3.618l.092-.053 4.861 5.09-.092.053-4.861-5.09zM2.266 3.251l.092-.053 4.861 5.089-.092.053-4.861-5.089zM2.901 2.883l.092-.053 4.861 5.09-.092.053-4.861-5.09zM3.536 2.516l.092-.053 4.861 5.089-.092.053-4.861-5.089zM4.171 2.148l.092-.053 4.861 5.09-.092.053-4.861-5.09zM4.807 1.781l.091-.053 4.861 5.089-.092.053-4.86-5.089zM5.442 1.413l.091-.053 4.861 5.09-.092.053-4.86-5.09zM6.077 1.046l.091-.053 4.861 5.089-.092.053-4.86-5.089zM6.712.678l.091-.053 4.861 5.09-.092.053-4.86-5.09z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.64 5.051l.111.096L5.07 9.014l-.111-.096 6.681-3.867zM10.504 3.866l.111.096-6.681 3.867-.112-.096 6.682-3.867zM9.362 2.684l.111.097-6.682 3.867-.111-.097 6.682-3.867zM7.678.892l.111.096-6.682 3.867-.111-.096L7.678.892zM8.466 1.718l.111.096-6.682 3.867-.111-.096 6.682-3.867z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 83.75,
    y: 239.035,
    width: 5.309,
    height: 5.83,
    viewBox: "0 0 5.3 5.822",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 5.822V5.47L0 0v.352l5.3 5.47z",
    fill: "#3A4044"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 83.75,
    y: 239.417,
    width: 5.467,
    height: 6.212,
    viewBox: "0 0 5.456 6.23",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l1.144 3.746L5.456 6.23 5.3 5.47 0 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 89.058,
    y: 240.67,
    width: 7.289,
    height: 4.958,
    viewBox: "0 0 7.286 4.976",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M7.286 0l-.807 1.34L.156 4.976 0 4.216 7.286 0z",
    fill: "#8A9B9E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 85.493,
    y: 248.898,
    width: 2.773,
    height: 6.103,
    viewBox: "0 0 2.83 6.129",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83 5.901V1.913c0-.187-.203-.536-.365-.628L.272.044C.103-.051 0 .01 0 .205v4.018c0 .187.202.536.365.628L2.527 6.08c.187.106.303.038.303-.179z",
    fill: "#3A8ABF"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M.263 4.681C.155 4.558.068 4.37.068 4.262V.282c0-.17.091-.223.238-.14l2.162 1.224a.4.4 0 01.098.085c.108.123.195.311.195.419v3.92c0 .212-.114.278-.297.174L.36 4.766a.416.416 0 01-.097-.085z",
    fill: "#F4FAFC"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M.358.29C.242.225.171.267.171.4v3.98c0 .071.077.203.138.239l2.103 1.198c.152.086.246.031.246-.144v-3.92a.369.369 0 00-.139-.239L.358.29z",
    fill: "#3A8ABF"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M2.314 3.107c0 .305-.061.504-.182.599-.121.094-.296.077-.526-.052l-.675-.375v1.04L.51 4.082V1.214l1.144.64c.44.246.66.664.66 1.253zM.932 2.815l.65.361c.103.058.18.065.231.022.051-.043.076-.147.076-.31a.873.873 0 00-.07-.374.499.499 0 00-.215-.23L.932 1.91v.905z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 89.93,
    y: 246.01,
    width: 4.833,
    height: 10.462,
    viewBox: "0 0 4.82 10.419",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0v7.619L0 10.419V2.772L4.041.449 4.82 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 89.93,
    y: 248.789,
    width: 4.833,
    height: 7.683,
    viewBox: "0 0 4.82 7.657",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 4.847v.011L0 7.657V0l3.571 3.883 1.249.964z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 89.93,
    y: 247.099,
    width: 3.645,
    height: 7.683,
    viewBox: "0 0 3.571 7.671",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.671l3.571-2.074v-.01L2.964 0 0 1.704v5.967z",
    fill: "#9CDBE5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 89.93,
    y: 248.407,
    width: 2.377,
    height: 5.013,
    viewBox: "0 0 2.329 5.005",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.005l2.329-1.353v-.007L1.933 0 0 1.112v3.893z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 89.771,
    y: 254.292,
    width: 4.992,
    height: 5.285,
    viewBox: "0 0 4.981 5.31",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M4.981.089L4.82 0 0 2.771V5.22l.161.09L4.981.089z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 90.247,
    y: 258.814,
    width: 4.279,
    height: 10.625,
    viewBox: "0 0 4.232 10.627",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.627V2.433l.031-.018L4.232 0v8.171l-.03.018L0 10.627zm.122-8.123v7.912L4.11 8.102V.211L.122 2.504z",
    fill: "#A8A8A8"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 84.938,
    y: 247.045,
    width: 3.962,
    height: 22.449,
    viewBox: "0 0 3.904 22.472",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M3.903 22.472L0 20.259V0l3.904 2.235v20.237h-.001zM.121 20.188l3.66 2.075V2.306L.121.21v19.978z",
    fill: "#768E91"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 92.148,
    y: 266.878,
    width: 0.713,
    height: 0.872,
    viewBox: "0 0 0.714 0.855",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.233a.728.728 0 01-.337.562C.144.898-.003.813 0 .605A.728.728 0 01.337.045C.521-.06.668.026.665.233z",
    fill: "#929DA6"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M.714.32a.637.637 0 01-.297.496C.255.906.125.832.128.649A.633.633 0 01.426.154C.587.063.716.138.714.32z",
    fill: "#BFBFBF"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.348A.534.534 0 01.417.76C.282.837.174.774.176.62A.534.534 0 01.424.21C.559.134.667.196.665.348z",
    fill: "#CECECE"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M.52.43a.217.217 0 01-.1.167C.365.627.322.602.322.54a.216.216 0 01.1-.167C.477.343.52.368.52.43z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 89.93,
    y: 254.346,
    width: 4.833,
    height: 5.231,
    viewBox: "0 0 4.82 5.221",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 2.424V0L0 2.772v2.449l4.82-2.797z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 90.088,
    y: 254.564,
    width: 4.596,
    height: 4.795,
    viewBox: "0 0 4.6 4.75",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.645L4.6 0v2.08L0 4.75V2.645z",
    fill: "#EAC72F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 90.247,
    y: 254.782,
    width: 4.279,
    height: 4.304,
    viewBox: "0 0 4.33 4.302",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.484L4.33 0v1.796L0 4.302V2.484z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 89.93,
    y: 246.01,
    width: 4.833,
    height: 3.978,
    viewBox: "0 0 4.82 3.97",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0L3.087 2.204 0 3.97V2.772L4.82 0z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 90.484,
    y: 256.58,
    width: 1.505,
    height: 2.016,
    viewBox: "0 0 1.524 2.016",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M1.524 1.135V0L0 .869v1.147l1.524-.881z",
    fill: "#DCE0E3"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.729V.181L.042.846v.557L1.208.729z",
    fill: "#9AA7B0"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M1.076.522V.455l-1.001.573v.073L1.076.522z",
    fill: "#555D69"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.729l.316.406V0l-.316.181v.548z",
    fill: "#77888B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 92.624,
    y: 255.164,
    width: 1.664,
    height: 1.308,
    viewBox: "0 0 1.627 1.305",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M1.627.364V0L0 .926v.379L1.627.364z",
    fill: "#A6EA5B"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M1.491.322V.233l-1.345.772v.097l1.345-.78z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 89.771,
    y: 257.016,
    width: 0.158,
    height: 2.561,
    viewBox: "0 0 0.161 2.539",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l.161.09v2.449L0 2.449V0z",
    fill: "#202A32"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 92.624,
    y: 256.471,
    width: 0.555,
    height: 1.035,
    viewBox: "0 0 0.533 1.066",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M.533.758V0L0 .304v.762L.533.758z",
    fill: "#B6BFC6"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M.322.771L.194.846.191.309.323.232.322.771z",
    fill: "#DCE0E3"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M.292.743l-.06.036V.334L.294.298.292.743z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 85.493,
    y: 254.183,
    width: 2.852,
    height: 2.343,
    viewBox: "0 0 2.843 2.357",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "#F4FAFC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.315.404c0 .078-.016.128-.046.152C.238.58.193.575.135.541L.108.526v.265L0 .73V0l.147.084c.112.063.168.17.168.32zM.107.408L.128.42c.027.015.046.017.059.006C.2.415.207.389.207.347A.217.217 0 00.189.252a.133.133 0 00-.055-.06L.108.177.107.408zM.646 1.099L.612.895.461.809.428.974.321.912.464.261.61.345l.144.815-.108-.061zM.592.764L.561.576A2.824 2.824 0 01.549.491L.537.401C.534.428.529.457.524.488a9.175 9.175 0 01-.041.213l.109.063zM.93.82l.077-.244.113.065L.983 1v.292l-.106-.061V.944L.74.423l.113.065L.93.82zM1.729 1.72l-.107-.062v-.32l-.142-.081v.32l-.108-.062v-.73l.108.062v.29l.142.081v-.29l.107.062v.73zM2.092 1.927l-.261-.149v-.73l.261.149v.117l-.153-.088V1.4l.142.081v.118l-.142-.081v.202l.153.087v.12zM2.285 1.753v.284l-.108-.062v-.73l.141.081c.06.034.104.077.132.129a.393.393 0 01.043.188c0 .092-.024.143-.074.151l.112.384-.116-.066-.091-.337-.039-.022zm0-.117l.028.016c.025.015.043.016.055.004.011-.012.017-.036.017-.072a.195.195 0 00-.018-.09.136.136 0 00-.054-.055l-.027-.015-.001.212zM2.843 2.357l-.261-.149v-.73l.261.149v.117l-.153-.088v.174l.142.081v.118l-.142-.081v.202l.153.087v.12z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 88.028,
    y: 259.577,
    width: 0.555,
    height: 0.654,
    viewBox: "0 0 0.568 0.68",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.185a.576.576 0 00.268.447C.453.714.57.646.568.482A.576.576 0 00.3.033C.154-.046.037.02.039.185z",
    fill: "#D1D6DA"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .255A.509.509 0 00.237.65c.129.072.232.013.23-.133A.509.509 0 00.23.122C.101.05-.002.11 0 .255z",
    fill: "#ABABAB"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.277c.001.121.09.268.197.328.108.06.193.011.192-.11A.425.425 0 00.231.165C.123.106.037.156.039.277z",
    fill: "#BABABA"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M.155.341a.17.17 0 00.08.133C.278.498.313.478.313.43a.17.17 0 00-.08-.133C.189.272.154.292.155.341z",
    fill: "#5C656B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 431.98,
    y: 208.795,
    width: 96.902,
    height: 56.122,
    viewBox: "0 0 96.9 56.08",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.013L38.331 56.08l1.746-1.05L93.18 24.471l1.883 1.088 1.837-1.056-5.484-3.169-1.837 1.056 1.762 1.018-53.103 30.56-34.589-19.97L56.173 3.142l1.873 1.083 1.837-1.056L54.4 0l-1.837 1.056 1.782 1.03L0 34.013z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 358.372,
    y: 166.458,
    width: 133.429,
    height: 77.426,
    viewBox: "0 0 133.434 77.39",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.013L75.131 77.39l54.925-31.71 1.541.89 1.837-1.056-5.484-3.169-1.837 1.056 2.107 1.217-53.089 30.651-35.054-20.238 53.103-30.56 1.883 1.089 1.837-1.057-5.484-3.168-1.837 1.056 1.762 1.018-53.103 30.56-34.589-19.97L56.173 3.143l1.873 1.082 1.837-1.056L54.4 0l-1.837 1.057 1.782 1.029L0 34.013z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 273.117,
    y: 214.789,
    width: 96.823,
    height: 56.067,
    viewBox: "0 0 96.9 56.08",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9 22.067L58.568 0l-1.746 1.05L3.72 31.609l-1.883-1.088L0 31.577l5.483 3.169L7.32 33.69l-1.762-1.019L58.661 2.112l34.589 19.97-52.523 30.856-1.874-1.083-1.837 1.056L42.5 56.08l1.837-1.056-1.782-1.03L96.9 22.067z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 310.119,
    y: 235.821,
    width: 133.429,
    height: 77.372,
    viewBox: "0 0 133.434 77.39",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M133.434 43.377L58.303 0 3.378 31.711l-1.541-.89L0 31.877l5.484 3.169 1.837-1.056-2.107-1.218L58.303 2.121 93.356 22.36 40.254 52.919l-1.883-1.088-1.837 1.056 5.484 3.169 1.837-1.057-1.762-1.017 53.103-30.561 34.589 19.97-52.524 30.857-1.873-1.083-1.837 1.056 5.483 3.169 1.837-1.056-1.782-1.03 54.345-31.927z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 425.879,
    y: 232.388,
    width: 30.426,
    height: 39.394,
    viewBox: "0 0 29.655 17.12",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M23.316 17.12L0 3.658 6.31 0l23.345 13.478-6.339 3.642z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 443.469,
    y: 232.388,
    width: 12.836,
    height: 39.394,
    viewBox: "0 0 12.197 8.123",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M12.197 3.915V2.863l-7.251 4.17v1.09l7.251-4.208z",
    fill: "#CCD2D6"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M4.946 7.033L.001 4.184v1.075l4.945 2.864v-1.09z",
    fill: "#8E9C9E"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M12.197 2.863l-7.251 4.17L0 4.184 7.253 0l4.944 2.863z",
    fill: "#EBEBEB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 444.578,
    y: 237.074,
    width: 10.696,
    height: 33.074,
    viewBox: "0 0 10.636 33.09",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 29.42V2.497L4.313 6.133V33.09l6.323-3.67z",
    fill: "#D9DEE1"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 4.819V3.778L4.313 7.414v1.075l6.323-3.67z",
    fill: "#EAC72F"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 6.134L.001 3.649v26.944l4.312 2.497V6.134z",
    fill: "#8E9C9E"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 7.414L.001 4.93v1.062l4.312 2.497V7.414z",
    fill: "#CF9219"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 28.812v-1.041l-6.323 3.636v1.075l6.323-3.67z",
    fill: "#EAC72F"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 31.407L.001 28.923v1.062l4.312 2.497v-1.075z",
    fill: "#CF9219"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 2.497L4.313 6.133 0 3.649 6.324 0l4.312 2.497z",
    fill: "#3D7EE3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 443.469,
    y: 232.388,
    width: 12.598,
    height: 10.026,
    viewBox: "0 0 12.586 10.038",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 10.038L0 4.568v-.352L12.586 5.47v.352L5.3 10.038z",
    fill: "#555D69"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 9.686L0 4.216 7.286 0l5.3 5.47L5.3 9.686z",
    fill: "#6B777F"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M5.383 9.35L.522 4.261 7.203.394l4.861 5.089L5.383 9.35z",
    fill: "#5E4F4B"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.997 3.985l.091-.053 4.861 5.089-.092.054-4.86-5.09zM1.631 3.617l.092-.053 4.861 5.09-.092.053-4.861-5.09zM2.267 3.25l.091-.053 4.861 5.089-.092.054-4.86-5.09zM2.902 2.882l.091-.053 4.861 5.09-.092.053-4.86-5.09zM3.537 2.515l.091-.053 4.861 5.089-.092.054-4.86-5.09zM4.172 2.147l.091-.053 4.861 5.09-.092.053-4.86-5.09zM4.807 1.78l.091-.053 4.861 5.089-.091.054-4.861-5.09zM5.442 1.412l.091-.053 4.861 5.09-.092.053-4.86-5.09zM6.077 1.045l.091-.053 4.861 5.089-.092.053-4.86-5.089zM6.712.677l.091-.053 4.861 5.09-.092.053-4.86-5.09z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.64 5.05l.111.096L5.07 9.013l-.111-.096L11.64 5.05zM10.504 3.865l.111.096-6.681 3.867-.111-.096 6.681-3.867zM9.362 2.684l.111.096-6.682 3.867-.111-.096 6.682-3.867zM7.678.891l.111.096-6.681 3.867-.111-.096L7.678.891zM8.466 1.717l.111.096L1.895 5.68l-.111-.096 6.682-3.867z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 443.469,
    y: 236.583,
    width: 5.309,
    height: 5.83,
    viewBox: "0 0 5.3 5.822",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 5.822V5.47L0 0v.352l5.3 5.47z",
    fill: "#3A4044"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 443.469,
    y: 236.965,
    width: 5.467,
    height: 6.212,
    viewBox: "0 0 5.457 6.23",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l1.144 3.746L5.457 6.23 5.3 5.47 0 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 448.777,
    y: 238.218,
    width: 7.289,
    height: 4.958,
    viewBox: "0 0 7.286 4.976",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M7.286 0L6.48 1.34.157 4.976 0 4.216 7.286 0z",
    fill: "#8A9B9E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 445.212,
    y: 246.391,
    width: 2.773,
    height: 6.157,
    viewBox: "0 0 2.83 6.129",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83 5.901V1.913c0-.187-.203-.536-.365-.628L.272.044C.103-.051 0 .01 0 .205v4.018c0 .187.202.536.365.628L2.527 6.08c.187.106.303.038.303-.179z",
    fill: "#3A8ABF"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M.264 4.682c-.108-.123-.195-.311-.195-.419V.283c0-.17.091-.224.238-.14l2.162 1.224a.4.4 0 01.098.085c.108.123.195.311.195.419v3.92c0 .212-.114.279-.298.174L.361 4.767a.4.4 0 01-.097-.085z",
    fill: "#F4FAFC"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M.358.29C.242.224.171.266.171.4v3.98a.37.37 0 00.138.238l2.103 1.198c.152.086.246.031.246-.144v-3.92a.369.369 0 00-.139-.239L.358.29z",
    fill: "#3A8ABF"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M2.314 3.107c0 .305-.061.504-.182.599-.121.094-.297.077-.526-.052l-.675-.375v1.04L.51 4.082V1.214l1.144.64c.441.246.66.664.66 1.253zM.932 2.816l.65.361c.103.058.18.065.231.022.051-.043.076-.147.076-.31a.873.873 0 00-.07-.374.499.499 0 00-.215-.23l-.672-.374v.905z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.649,
    y: 243.558,
    width: 4.833,
    height: 10.407,
    viewBox: "0 0 4.82 10.419",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0v7.62L0 10.419V2.772L4.041.449 4.82 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.649,
    y: 246.337,
    width: 4.833,
    height: 7.683,
    viewBox: "0 0 4.82 7.657",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 4.848v.01L0 7.657V0l3.571 3.883 1.249.965z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.649,
    y: 244.648,
    width: 3.565,
    height: 7.683,
    viewBox: "0 0 3.571 7.672",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.672l3.571-2.074v-.011L2.964 0 0 1.704v5.968z",
    fill: "#9CDBE5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.649,
    y: 245.955,
    width: 2.377,
    height: 5.013,
    viewBox: "0 0 2.329 5.005",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.005l2.329-1.353v-.007L1.933 0 0 1.112v3.893z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.491,
    y: 251.785,
    width: 4.992,
    height: 5.34,
    viewBox: "0 0 4.981 5.31",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M4.981.09L4.82 0 0 2.771V5.22l.161.09L4.981.09z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.966,
    y: 256.362,
    width: 4.199,
    height: 10.625,
    viewBox: "0 0 4.231 10.627",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.627V2.433l.03-.018L4.231 0v8.172l-.03.017L0 10.627zm.121-8.124v7.912l3.988-2.314V.21L.121 2.503z",
    fill: "#A8A8A8"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 444.657,
    y: 244.593,
    width: 3.882,
    height: 22.449,
    viewBox: "0 0 3.904 22.472",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M3.903 22.472L0 20.259V0l3.904 2.235v20.237h-.001zM.121 20.188l3.66 2.075V2.306L.121.21v19.978z",
    fill: "#768E91"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 451.868,
    y: 264.426,
    width: 0.713,
    height: 0.872,
    viewBox: "0 0 0.714 0.855",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.233a.728.728 0 01-.337.562C.144.898-.003.813 0 .605A.728.728 0 01.337.045C.521-.06.668.026.665.233z",
    fill: "#929DA6"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M.714.32a.635.635 0 01-.297.496C.255.906.125.832.128.649A.635.635 0 01.425.154C.587.063.716.138.714.32z",
    fill: "#BFBFBF"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.348A.534.534 0 01.417.76C.282.837.174.774.176.62A.534.534 0 01.424.21C.559.134.667.196.665.348z",
    fill: "#CECECE"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M.52.43a.216.216 0 01-.1.167C.365.627.322.602.322.54a.217.217 0 01.1-.167C.477.343.521.368.52.43z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.649,
    y: 251.894,
    width: 4.833,
    height: 5.231,
    viewBox: "0 0 4.82 5.22",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 2.423V0L0 2.771V5.22l4.82-2.797z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.807,
    y: 252.112,
    width: 4.596,
    height: 4.74,
    viewBox: "0 0 4.6 4.75",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.645L4.6 0v2.08L0 4.75V2.645z",
    fill: "#EAC72F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.887,
    y: 252.33,
    width: 4.358,
    height: 4.304,
    viewBox: "0 0 4.33 4.301",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.483L4.33 0v1.796L0 4.301V2.483z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.649,
    y: 243.558,
    width: 4.833,
    height: 3.978,
    viewBox: "0 0 4.82 3.97",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0L3.087 2.204 0 3.97V2.772L4.82 0z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 450.124,
    y: 254.128,
    width: 1.585,
    height: 2.016,
    viewBox: "0 0 1.525 2.016",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M1.525 1.135V0L0 .868v1.148l1.525-.881z",
    fill: "#DCE0E3"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.728V.18L.043.845v.557L1.208.728z",
    fill: "#9AA7B0"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M1.076.521V.454l-1.001.573V1.1L1.076.521z",
    fill: "#555D69"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.728l.317.407V0l-.317.18v.548z",
    fill: "#77888B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 452.343,
    y: 252.712,
    width: 1.664,
    height: 1.308,
    viewBox: "0 0 1.627 1.305",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M1.627.365V0L0 .926v.379l1.627-.94z",
    fill: "#A6EA5B"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M1.491.323v-.09l-1.344.773v.096L1.491.323z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 449.491,
    y: 254.564,
    width: 0.158,
    height: 2.561,
    viewBox: "0 0 0.161 2.539",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l.161.09v2.449L0 2.449V0z",
    fill: "#202A32"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 452.343,
    y: 254.019,
    width: 0.555,
    height: 1.035,
    viewBox: "0 0 0.533 1.066",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M.533.758V0L0 .304v.762L.533.758z",
    fill: "#B6BFC6"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M.322.771L.194.846.192.309.323.232.322.771z",
    fill: "#DCE0E3"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M.292.743l-.06.036V.334L.294.298.292.743z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 445.212,
    y: 251.731,
    width: 2.852,
    height: 2.343,
    viewBox: "0 0 2.843 2.357",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "#F4FAFC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.315.404c0 .078-.016.128-.047.152C.237.58.192.575.134.541L.107.526v.265L0 .73V0l.147.084c.112.063.168.17.168.32zM.107.408L.128.42c.027.015.046.017.059.006C.2.415.207.389.207.347A.22.22 0 00.189.252a.133.133 0 00-.055-.06L.108.177v.231H.107zM.646 1.099L.612.895.461.809.428.974.32.912.463.261l.146.084.144.816-.107-.062zM.592.764L.561.576A2.789 2.789 0 01.549.491L.537.401A8.497 8.497 0 01.482.7l.11.064zM.93.82l.077-.244.113.065L.983 1v.292l-.106-.061V.944L.74.423l.113.065L.93.82zM1.729 1.72l-.108-.062v-.32l-.142-.081v.32l-.108-.062v-.73l.108.062v.29l.142.081v-.29l.108.062v.73zM2.093 1.927l-.261-.149v-.73l.261.149v.117l-.153-.088V1.4l.142.081v.118l-.142-.081v.202l.153.087v.12zM2.285 1.753v.284l-.108-.062v-.73l.141.081c.06.034.104.077.132.129a.392.392 0 01.042.188c0 .092-.024.143-.074.151l.112.384-.116-.066-.091-.337-.038-.022zm0-.117l.027.016c.025.015.043.016.055.004.011-.012.017-.035.017-.071a.195.195 0 00-.018-.09.136.136 0 00-.054-.055l-.027-.015v.211zM2.843 2.357l-.261-.149v-.73l.261.149v.117l-.153-.088v.174l.142.081v.118l-.142-.081v.202l.153.087v.12z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 447.747,
    y: 257.071,
    width: 0.555,
    height: 0.708,
    viewBox: "0 0 0.568 0.68",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.185a.576.576 0 00.268.447C.453.714.57.646.568.482A.576.576 0 00.3.035C.154-.047.037.02.039.185z",
    fill: "#D1D6DA"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .255a.507.507 0 00.237.394c.129.072.232.013.23-.133A.509.509 0 00.23.122C.102.05-.001.109 0 .255z",
    fill: "#ABABAB"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.277c.001.121.09.268.197.329.108.06.193.011.192-.111A.422.422 0 00.231.167C.124.106.038.155.039.277z",
    fill: "#BABABA"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M.155.342a.17.17 0 00.08.133C.278.499.313.479.313.43a.17.17 0 00-.08-.133C.189.272.154.292.155.342z",
    fill: "#5C656B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 398.623,
    y: 71.869,
    width: 30.346,
    height: 39.394,
    viewBox: "0 0 29.655 17.119",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M23.316 17.119L0 3.658 6.31 0l23.345 13.478-6.339 3.641z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 416.213,
    y: 71.869,
    width: 12.757,
    height: 39.394,
    viewBox: "0 0 12.197 8.124",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M12.197 3.916V2.864l-7.251 4.17v1.09l7.251-4.208z",
    fill: "#CCD2D6"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M4.946 7.034L.001 4.185V5.26l4.945 2.864v-1.09z",
    fill: "#8E9C9E"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M12.197 2.864l-7.251 4.17L0 4.185 7.253 0l4.944 2.864z",
    fill: "#EBEBEB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 417.322,
    y: 76.555,
    width: 10.617,
    height: 33.074,
    viewBox: "0 0 10.636 33.089",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 29.42V2.497L4.313 6.133v26.956l6.323-3.669z",
    fill: "#D9DEE1"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 4.819V3.778L4.313 7.414v1.075l6.323-3.67z",
    fill: "#EAC72F"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 6.133L.001 3.649v26.943l4.312 2.497V6.133z",
    fill: "#8E9C9E"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 7.414L.001 4.93v1.062l4.312 2.497V7.414z",
    fill: "#CF9219"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 28.812v-1.041l-6.323 3.636v1.074l6.323-3.669z",
    fill: "#EAC72F"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 31.407L.001 28.923v1.062l4.312 2.496v-1.074z",
    fill: "#CF9219"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 2.497L4.313 6.133 0 3.649 6.324 0l4.312 2.497z",
    fill: "#3D7EE3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 416.213,
    y: 71.869,
    width: 12.519,
    height: 10.026,
    viewBox: "0 0 12.586 10.039",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 10.039L0 4.569v-.352l12.586 1.254v.352L5.3 10.039z",
    fill: "#555D69"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 9.687L0 4.217 7.286 0l5.3 5.471L5.3 9.687z",
    fill: "#6B777F"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M5.383 9.351L.522 4.262 7.203.395l4.861 5.089-6.681 3.867z",
    fill: "#5E4F4B"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.996 3.986l.092-.053 4.861 5.089-.092.053L.996 3.986zM1.632 3.618l.091-.053 4.861 5.09-.092.053-4.86-5.09zM2.267 3.251l.091-.053 4.861 5.089-.092.053-4.86-5.089zM2.902 2.883l.091-.053 4.861 5.09-.092.053-4.86-5.09zM3.537 2.516l.091-.053 4.861 5.089-.092.053-4.86-5.089zM4.172 2.148l.091-.053 4.861 5.09-.092.053-4.86-5.09zM4.807 1.781l.091-.053 4.861 5.089-.092.053-4.86-5.089zM5.442 1.413l.091-.053 4.861 5.09-.092.053-4.86-5.09zM6.077 1.046l.091-.053 4.861 5.089-.091.053-4.861-5.089zM6.712.678l.091-.053 4.861 5.09-.092.053-4.86-5.09z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.641 5.051l.111.096L5.07 9.014l-.111-.096 6.682-3.867zM10.504 3.866l.111.096-6.681 3.867-.111-.096 6.681-3.867zM9.362 2.684l.111.097-6.681 3.867-.112-.097 6.682-3.867zM7.678.892l.111.096-6.681 3.867-.112-.097L7.678.892zM8.466 1.717l.111.097-6.682 3.867-.111-.096 6.682-3.868z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 416.213,
    y: 76.119,
    width: 5.229,
    height: 5.776,
    viewBox: "0 0 5.3 5.822",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 5.822V5.47L0 0v.352l5.3 5.47z",
    fill: "#3A4044"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 416.213,
    y: 76.446,
    width: 5.388,
    height: 6.212,
    viewBox: "0 0 5.457 6.23",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l1.144 3.746L5.457 6.23 5.3 5.47 0 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 421.442,
    y: 77.699,
    width: 7.289,
    height: 4.958,
    viewBox: "0 0 7.286 4.976",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M7.286 0L6.48 1.34.157 4.976 0 4.216 7.286 0z",
    fill: "#8A9B9E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 417.876,
    y: 85.926,
    width: 2.852,
    height: 6.103,
    viewBox: "0 0 2.83 6.129",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83 5.901V1.913c0-.187-.203-.536-.365-.628L.272.044C.103-.051 0 .01 0 .205v4.018c0 .187.202.536.365.628L2.527 6.08c.187.106.303.038.303-.179z",
    fill: "#3A8ABF"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M.264 4.681C.156 4.558.069 4.37.069 4.262V.282c0-.17.091-.224.238-.14l2.162 1.224c.03.017.064.047.098.086.108.123.195.311.195.419v3.92c0 .212-.114.279-.297.174L.361 4.767a.407.407 0 01-.097-.086z",
    fill: "#F4FAFC"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M.358.29C.242.224.171.266.171.4v3.98c0 .071.077.203.138.239l2.103 1.198c.152.086.246.031.246-.144v-3.92a.369.369 0 00-.139-.239L.358.29z",
    fill: "#3A8ABF"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M2.314 3.107c0 .305-.061.504-.182.599-.121.094-.296.077-.526-.052l-.675-.375v1.04L.51 4.082V1.214l1.144.64c.44.246.66.664.66 1.253zM.932 2.815l.65.361c.103.058.18.065.231.022.051-.043.076-.147.076-.31a.873.873 0 00-.07-.374.499.499 0 00-.215-.23L.932 1.91v.905z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.393,
    y: 83.038,
    width: 4.833,
    height: 10.462,
    viewBox: "0 0 4.82 10.419",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0v7.619L0 10.419V2.772L4.041.449 4.82 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.393,
    y: 85.817,
    width: 4.833,
    height: 7.683,
    viewBox: "0 0 4.82 7.657",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 4.847v.011L0 7.657V0l3.571 3.883 1.249.964z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.393,
    y: 84.128,
    width: 3.565,
    height: 7.683,
    viewBox: "0 0 3.571 7.671",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.671l3.571-2.074v-.01L2.964 0 0 1.704v5.967z",
    fill: "#9CDBE5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.393,
    y: 85.49,
    width: 2.298,
    height: 4.958,
    viewBox: "0 0 2.329 5.005",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.005l2.329-1.353v-.007L1.933 0 0 1.112v3.893z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.234,
    y: 91.321,
    width: 4.992,
    height: 5.285,
    viewBox: "0 0 4.981 5.31",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M4.981.089L4.82 0 0 2.771V5.22l.161.09L4.981.089z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.71,
    y: 95.843,
    width: 4.199,
    height: 10.625,
    viewBox: "0 0 4.232 10.628",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.628V2.434l.031-.018L4.232 0v8.172l-.03.018L0 10.628zm.121-8.124v7.912l3.988-2.314V.211L.121 2.504z",
    fill: "#A8A8A8"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 417.401,
    y: 84.074,
    width: 3.882,
    height: 22.449,
    viewBox: "0 0 3.904 22.472",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M3.903 22.472L0 20.259V0l3.904 2.235-.001 20.237zM.121 20.188l3.66 2.075V2.306L.121.21v19.978z",
    fill: "#768E91"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 424.532,
    y: 103.907,
    width: 0.713,
    height: 0.872,
    viewBox: "0 0 0.714 0.854",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.233a.728.728 0 01-.337.562C.144.898-.003.813 0 .605A.728.728 0 01.337.045C.521-.06.668.026.665.233z",
    fill: "#929DA6"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M.714.32a.635.635 0 01-.297.496C.255.906.125.832.128.649A.635.635 0 01.425.154C.587.063.717.138.714.32z",
    fill: "#BFBFBF"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.348A.534.534 0 01.417.76C.282.837.174.774.177.62A.534.534 0 01.423.21C.559.133.667.196.665.348z",
    fill: "#CECECE"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M.52.43a.217.217 0 01-.1.167C.365.627.322.602.322.54a.217.217 0 01.1-.167C.477.343.522.368.52.43z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.393,
    y: 91.375,
    width: 4.833,
    height: 5.231,
    viewBox: "0 0 4.82 5.221",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 2.424V0L0 2.772v2.449l4.82-2.797z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.472,
    y: 91.647,
    width: 4.596,
    height: 4.74,
    viewBox: "0 0 4.6 4.75",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.645L4.6 0v2.08L0 4.75V2.645z",
    fill: "#EAC72F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.63,
    y: 91.811,
    width: 4.358,
    height: 4.304,
    viewBox: "0 0 4.33 4.302",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.484L4.33 0v1.796L0 4.302V2.484z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.393,
    y: 83.038,
    width: 4.833,
    height: 3.978,
    viewBox: "0 0 4.82 3.97",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0L3.087 2.204 0 3.97V2.772L4.82 0z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.868,
    y: 93.609,
    width: 1.505,
    height: 2.016,
    viewBox: "0 0 1.524 2.016",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M1.524 1.135V0L0 .869v1.147l1.524-.881z",
    fill: "#DCE0E3"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.729V.181L.043.846v.557L1.208.729z",
    fill: "#9AA7B0"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M1.076.522V.455l-1.001.573v.073L1.076.522z",
    fill: "#555D69"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.729l.316.406V0l-.316.181v.548z",
    fill: "#77888B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 425.087,
    y: 92.247,
    width: 1.585,
    height: 1.253,
    viewBox: "0 0 1.627 1.306",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M1.627.365V0L0 .927v.379L1.627.365z",
    fill: "#A6EA5B"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M1.491.324V.233l-1.344.773v.097L1.491.324z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 422.234,
    y: 94.045,
    width: 0.158,
    height: 2.561,
    viewBox: "0 0 0.161 2.539",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l.161.09v2.449L0 2.449V0z",
    fill: "#202A32"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 425.087,
    y: 93.5,
    width: 0.555,
    height: 1.035,
    viewBox: "0 0 0.533 1.066",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M.533.758V0L0 .304v.762L.533.758z",
    fill: "#B6BFC6"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M.322.771L.194.846.192.309.323.232.322.771z",
    fill: "#DCE0E3"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M.292.743l-.06.036V.334L.294.297.292.743z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 417.876,
    y: 91.212,
    width: 2.852,
    height: 2.343,
    viewBox: "0 0 2.843 2.358",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "#F4FAFC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.315.405c0 .078-.016.128-.047.152C.237.581.192.576.134.542L.107.527v.265L0 .73V0l.147.084c.112.064.168.171.168.321zM.107.409l.021.012c.027.015.046.017.059.006C.2.416.206.39.206.348A.22.22 0 00.188.253a.133.133 0 00-.055-.06L.107.178v.231zM.646 1.1L.612.896.461.81.428.975.32.913.463.262l.146.084.144.815L.646 1.1zM.592.765L.561.577.548.492.536.402C.533.429.528.458.523.489a8.5 8.5 0 01-.041.212l.11.064zM.931.821l.077-.244.113.065-.137.359v.293l-.106-.061V.946L.741.425.854.49l.077.331zM1.729 1.721l-.107-.062v-.32l-.142-.081v.32l-.108-.062v-.73l.108.062v.29l.142.081v-.29l.107.062v.73zM2.093 1.928l-.261-.149v-.73l.261.149v.117l-.153-.088v.174l.142.081V1.6l-.142-.081v.202l.153.087v.12zM2.285 1.754v.284l-.108-.062v-.73l.141.081c.06.034.104.077.132.129a.381.381 0 01.043.188c0 .092-.024.143-.074.151l.112.384-.116-.066-.091-.337-.039-.022zm0-.117l.027.016c.025.015.043.016.055.004.011-.012.017-.035.017-.071a.195.195 0 00-.018-.09.136.136 0 00-.054-.055l-.027-.015v.211zM2.843 2.358l-.261-.149v-.73l.261.149v.117l-.153-.088v.174l.142.081v.118l-.142-.081v.202l.153.087v.12z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 420.412,
    y: 96.606,
    width: 0.634,
    height: 0.654,
    viewBox: "0 0 0.568 0.68",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.185a.576.576 0 00.268.447C.453.714.57.647.568.482A.576.576 0 00.3.035C.154-.048.037.02.039.185z",
    fill: "#D1D6DA"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .255A.509.509 0 00.237.65c.129.072.232.013.23-.133A.507.507 0 00.23.122C.102.05-.001.11 0 .255z",
    fill: "#ABABAB"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.277c.002.121.09.268.197.328.108.06.193.011.192-.11A.42.42 0 00.231.165C.124.106.038.156.039.277z",
    fill: "#BABABA"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M.155.341a.17.17 0 00.08.133C.278.498.313.478.313.43a.17.17 0 00-.08-.133C.189.272.154.292.155.341z",
    fill: "#5C656B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 561.606,
    y: 165.75,
    width: 30.426,
    height: 39.394,
    viewBox: "0 0 29.655 17.12",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M23.316 17.12L0 3.658 6.311 0l23.344 13.479-6.339 3.641z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 579.195,
    y: 165.75,
    width: 12.836,
    height: 39.394,
    viewBox: "0 0 12.196 8.123",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M12.196 3.915V2.863l-7.251 4.17v1.09l7.251-4.208z",
    fill: "#CCD2D6"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M4.945 7.033L0 4.184V5.26l4.945 2.863v-1.09z",
    fill: "#8E9C9E"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M12.196 2.863l-7.251 4.17L0 4.184 7.252 0l4.944 2.863z",
    fill: "#EBEBEB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 580.305,
    y: 170.436,
    width: 10.696,
    height: 33.074,
    viewBox: "0 0 10.636 33.09",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 29.42V2.498L4.313 6.133V33.09l6.323-3.67z",
    fill: "#D9DEE1"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 4.819V3.778L4.313 7.414v1.075l6.323-3.67z",
    fill: "#EAC72F"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 6.134L.001 3.649v26.944l4.312 2.497V6.134z",
    fill: "#8E9C9E"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 7.414L.001 4.93v1.062l4.312 2.497V7.414z",
    fill: "#CF9219"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 28.812v-1.041l-6.323 3.636v1.075l6.323-3.67z",
    fill: "#EAC72F"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M4.313 31.407L.001 28.923v1.062l4.312 2.497v-1.075z",
    fill: "#CF9219"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M10.636 2.498L4.313 6.133 0 3.649 6.324 0l4.312 2.498z",
    fill: "#3D7EE3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 579.195,
    y: 165.75,
    width: 12.598,
    height: 10.026,
    viewBox: "0 0 12.586 10.039",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 10.039L0 4.568v-.352L12.586 5.47v.352L5.3 10.039z",
    fill: "#555D69"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 9.686L0 4.216 7.286 0l5.3 5.47L5.3 9.686z",
    fill: "#6B777F"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M5.383 9.35L.522 4.261 7.204.394l4.86 5.09L5.383 9.35z",
    fill: "#5E4F4B"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.997 3.985l.091-.053 4.861 5.09-.092.053-4.86-5.09zM1.632 3.617l.091-.053 4.861 5.09-.092.053-4.86-5.09zM2.267 3.25l.092-.053 4.86 5.09-.091.053-4.861-5.09zM2.902 2.883l.091-.054 4.861 5.09-.091.053-4.861-5.089zM3.537 2.515l.091-.053 4.861 5.09-.091.053-4.861-5.09zM4.172 2.148l.091-.054 4.861 5.09-.091.053-4.861-5.089zM4.807 1.78l.092-.053 4.86 5.089-.091.054-4.861-5.09zM5.442 1.413l.092-.054 4.86 5.09-.091.053-4.861-5.089zM6.077 1.045l.092-.053 4.86 5.089-.091.054-4.861-5.09zM6.712.677l.092-.053 4.86 5.09-.091.053L6.712.677z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    fill: "#857658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.641 5.05l.111.097L5.07 9.014l-.111-.097 6.682-3.867zM10.505 3.865l.111.097-6.682 3.867-.111-.097 6.682-3.867zM9.362 2.684l.111.096-6.681 3.867-.111-.096 6.681-3.867zM7.678.891l.111.096-6.681 3.867-.111-.096L7.678.891zM8.466 1.717l.111.096L1.896 5.68l-.111-.096 6.681-3.867z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 579.195,
    y: 169.946,
    width: 5.309,
    height: 5.83,
    viewBox: "0 0 5.3 5.823",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 5.823V5.47L0 0v.352l5.3 5.471z",
    fill: "#3A4044"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 579.195,
    y: 170.327,
    width: 5.467,
    height: 6.212,
    viewBox: "0 0 5.457 6.23",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l1.144 3.746L5.457 6.23 5.3 5.471 0 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 584.504,
    y: 171.58,
    width: 7.289,
    height: 4.958,
    viewBox: "0 0 7.286 4.976",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M7.286 0L6.48 1.341.157 4.976 0 4.217 7.286 0z",
    fill: "#8A9B9E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 580.939,
    y: 179.808,
    width: 2.773,
    height: 6.103,
    viewBox: "0 0 2.83 6.129",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83 5.901V1.913c0-.187-.203-.536-.365-.628L.272.044C.103-.051 0 .01 0 .205v4.018c0 .187.203.536.365.628L2.527 6.08c.188.106.303.038.303-.179z",
    fill: "#3A8ABF"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M.264 4.682c-.108-.123-.195-.311-.195-.419V.283c0-.17.09-.223.238-.14l2.162 1.224c.03.017.064.047.098.085.108.123.195.311.195.419v3.92c0 .212-.114.279-.297.174L.362 4.767a.403.403 0 01-.098-.085z",
    fill: "#F4FAFC"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M.358.29C.242.225.171.267.171.4v3.98a.37.37 0 00.138.238l2.103 1.198c.152.086.246.031.246-.144v-3.92a.367.367 0 00-.138-.238L.358.29z",
    fill: "#3A8ABF"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M2.315 3.107c0 .305-.061.504-.182.599-.121.094-.297.077-.526-.052l-.675-.375v1.04L.51 4.082V1.214l1.144.64c.44.246.66.664.66 1.253zM.932 2.816l.65.361c.103.058.18.065.231.022.051-.043.076-.147.076-.31a.873.873 0 00-.07-.374.504.504 0 00-.215-.23l-.672-.374v.905z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.376,
    y: 176.92,
    width: 4.833,
    height: 10.462,
    viewBox: "0 0 4.82 10.419",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0v7.62L0 10.419V2.772L4.041.449 4.82 0z",
    fill: "#707E80"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.376,
    y: 179.699,
    width: 4.833,
    height: 7.683,
    viewBox: "0 0 4.82 7.657",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 4.848v.01L0 7.657V0l3.571 3.883 1.249.965z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.376,
    y: 178.01,
    width: 3.565,
    height: 7.683,
    viewBox: "0 0 3.571 7.672",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.672l3.571-2.074v-.011L2.964 0 0 1.704v5.968z",
    fill: "#9CDBE5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.376,
    y: 179.317,
    width: 2.377,
    height: 5.013,
    viewBox: "0 0 2.33 5.004",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.004l2.33-1.353v-.006L1.934 0 0 1.111v3.893z",
    fill: "#F4FAFC"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.217,
    y: 185.148,
    width: 4.992,
    height: 5.34,
    viewBox: "0 0 4.981 5.31",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M4.981.09L4.82 0 0 2.771V5.22l.161.09L4.981.09z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.693,
    y: 189.724,
    width: 4.199,
    height: 10.625,
    viewBox: "0 0 4.232 10.627",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.627V2.433l.031-.018L4.232 0v8.172l-.03.018L0 10.627zm.122-8.124v7.912L4.11 8.101V.21L.122 2.503z",
    fill: "#A8A8A8"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 580.384,
    y: 177.955,
    width: 3.882,
    height: 22.449,
    viewBox: "0 0 3.904 22.472",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M3.903 22.472L0 20.259V0l3.904 2.235-.001 20.237zM.122 20.188l3.66 2.075V2.306L.122.21v19.978z",
    fill: "#768E91"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 587.594,
    y: 197.789,
    width: 0.713,
    height: 0.872,
    viewBox: "0 0 0.714 0.855",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.233a.725.725 0 01-.337.562C.144.898-.003.813 0 .605A.728.728 0 01.337.045C.52-.06.667.026.665.233z",
    fill: "#929DA6"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M.714.32a.635.635 0 01-.297.496C.255.906.125.832.128.649A.637.637 0 01.425.154C.587.063.716.138.714.32z",
    fill: "#BFBFBF"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M.665.348A.534.534 0 01.417.76C.282.837.174.774.177.62A.534.534 0 01.423.21C.558.134.667.196.665.348z",
    fill: "#CECECE"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M.519.43a.217.217 0 01-.1.167C.364.627.321.602.321.54a.216.216 0 01.1-.167C.476.343.52.368.519.43z",
    fill: "#6B777F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.376,
    y: 185.256,
    width: 4.833,
    height: 5.231,
    viewBox: "0 0 4.82 5.22",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 2.423V0L0 2.771V5.22l4.82-2.797z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.534,
    y: 185.474,
    width: 4.596,
    height: 4.795,
    viewBox: "0 0 4.6 4.749",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.644L4.6 0v2.079L0 4.749V2.644z",
    fill: "#EAC72F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.613,
    y: 185.692,
    width: 4.358,
    height: 4.304,
    viewBox: "0 0 4.331 4.301",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.483L4.331 0v1.796L0 4.301V2.483z",
    fill: "#969BA3"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.376,
    y: 176.92,
    width: 4.833,
    height: 3.978,
    viewBox: "0 0 4.82 3.97",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 0L3.087 2.204 0 3.97V2.772L4.82 0z",
    fill: "#ADB1B5"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.851,
    y: 187.49,
    width: 1.585,
    height: 2.016,
    viewBox: "0 0 1.525 2.016",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M1.525 1.135V0L0 .868v1.148l1.525-.881z",
    fill: "#DCE0E3"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.728V.18L.043.845v.557L1.208.728z",
    fill: "#9AA7B0"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M1.076.521V.455l-1.001.572V1.1L1.076.521z",
    fill: "#555D69"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M1.208.728l.317.407V0l-.317.18v.548z",
    fill: "#77888B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 588.07,
    y: 186.074,
    width: 1.664,
    height: 1.308,
    viewBox: "0 0 1.627 1.305",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M1.627.365V0L0 .926v.379l1.627-.94z",
    fill: "#A6EA5B"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M1.491.323v-.09l-1.344.773v.096L1.491.323z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 585.217,
    y: 187.926,
    width: 0.158,
    height: 2.561,
    viewBox: "0 0 0.161 2.539",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l.161.09v2.449L0 2.449V0z",
    fill: "#202A32"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 588.07,
    y: 187.381,
    width: 0.555,
    height: 1.035,
    viewBox: "0 0 0.534 1.067",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M.534.758V0L0 .304v.763L.534.758z",
    fill: "#B6BFC6"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M.322.771L.194.846.192.309.323.232.322.771z",
    fill: "#DCE0E3"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M.292.743L.233.779.232.334.294.298.292.743z",
    fill: "#464F5C"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 580.939,
    y: 185.093,
    width: 2.852,
    height: 2.343,
    viewBox: "0 0 2.844 2.357",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "#F4FAFC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.316.404C.316.482.3.532.269.556.238.58.193.575.135.541L.108.526v.265L0 .73V0l.147.084c.113.063.169.17.169.32zM.109.408L.13.42c.026.015.046.017.059.006.013-.011.02-.037.02-.079A.217.217 0 00.191.252a.133.133 0 00-.055-.06L.11.177.109.408zM.647 1.099L.613.895.462.809.429.974.321.912.464.261.61.345l.144.815-.107-.061zM.593.764L.562.576.549.491.537.401C.534.428.529.457.524.488.519.52.505.59.483.7l.11.064zM.932.82l.077-.244.113.065L.985 1v.292l-.106-.061V.944L.742.423l.113.065.077.332zM1.731 1.72l-.108-.062v-.32l-.142-.081v.32l-.108-.062v-.73l.108.062v.29l.142.081v-.29l.108.062v.73zM2.094 1.928l-.261-.149v-.731l.261.149v.117l-.153-.088V1.4l.142.081v.118l-.142-.081v.202l.153.087v.121zM2.286 1.754v.284l-.108-.062v-.73l.141.081c.06.034.104.077.132.129a.392.392 0 01.042.188c0 .092-.025.143-.074.151l.112.384-.116-.066-.091-.337-.038-.022zm0-.117l.027.016c.025.015.043.016.055.004.011-.012.017-.035.017-.072a.195.195 0 00-.018-.09.136.136 0 00-.054-.055l-.026-.015-.001.212zM2.844 2.357l-.261-.149v-.73l.261.149v.117l-.153-.088v.174l.142.081v.118l-.142-.081v.202l.153.087v.12z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 583.474,
    y: 190.433,
    width: 0.555,
    height: 0.708,
    viewBox: "0 0 0.568 0.68",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.185a.576.576 0 00.268.447C.453.714.57.647.568.482A.576.576 0 00.3.035C.154-.047.037.02.039.185z",
    fill: "#D1D6DA"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .255a.509.509 0 00.237.394c.129.072.232.013.23-.133A.507.507 0 00.23.122C.102.05-.001.11 0 .255z",
    fill: "#ABABAB"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M.039.277c.001.121.09.268.197.328.107.06.193.011.192-.111A.422.422 0 00.231.166C.124.106.038.156.039.277z",
    fill: "#BABABA"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M.155.342a.17.17 0 00.08.133C.279.499.313.479.313.43a.17.17 0 00-.08-.133C.189.273.155.293.155.342z",
    fill: "#5C656B"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 347.993,
    y: 258.814,
    width: 83.75,
    height: 48.875,
    viewBox: "0 0 83.762 48.793",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M75.892 24.809c.086-.043 7.884-4.746 7.87-4.808-.651-2.923-15.287-13.466-16.689-16.125l-2.731 1.423.398-1.761L62.996.797l-1.015.49L53.935 0 38.309 6.957c-.353.156-1.358-.145-1.731-.182a116.456 116.456 0 00-4.255-.338c-3.019-.181-6.301-.758-9.238.037-1.525.413-3.06 1.714-4.454 2.456-1.865.992-3.687 2.066-5.489 3.169a161.646 161.646 0 00-6.325 4.06l-.547 7.597L0 27.659l.836 1.605 1.787 1.502 2.51 1.279.118-.011-.77.537c-.047.073 27.74 16.264 29.043 16.222 1.402-.046 3.672-1.614 4.883-2.177 2.082-.967 31.754-18.945 37.485-21.807z",
    fill: "url(#paint0_linear_0_14445)"
  })), _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_14445",
    x1: 67.833,
    x2: 42.834,
    y1: 1.168,
    y2: 68.903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 359.878,
    y: 258.814,
    width: 69.805,
    height: 46.205,
    viewBox: "0 0 69.812 46.221",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M.2 33.922s.771.695 1.049.9C7.601 39.502 19.58 45.41 19.58 45.41l-1.36-1.306L.2 33.922z",
    fill: "#141E25"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M67.846 19.58l-6.647-3.688 7.023-1.035-.376 4.724zM32.847 40.553l-6.647-3.69 7.024-2.573-.377 6.263z",
    fill: "#293237"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M31.206 37.123l-1.167 1.905-2.847 4.646-1.406 2.294-1.863-1.08-.045-.026-.054-.033.002-.004c-.407-.265-.705-.704-.859-1.29a2.614 2.614 0 01-.067-.32 3.597 3.597 0 01-.028-.218c-.004-.04-.009-.077-.011-.117a4.696 4.696 0 01-.012-.361c.029-2.32 1.719-5.134 3.775-6.285.113-.063.225-.12.335-.17.884-.405 1.674-.413 2.264-.083l.005-.008 1.978 1.15z",
    fill: "url(#paint0_linear_0_12972)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M32.19 39.447c-.028 2.32-1.718 5.134-3.775 6.285-2.056 1.15-3.7.204-3.672-2.116.028-2.32 1.718-5.134 3.775-6.285 2.056-1.152 3.7-.204 3.672 2.116z",
    fill: "#414C5C"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M31.105 40.053a3.935 3.935 0 01-.07.674c-.125.682-.42 1.385-.821 2.014a5.914 5.914 0 01-.872 1.075 4.507 4.507 0 01-.912.693 2.778 2.778 0 01-.727.292c-.412.099-.784.062-1.083-.094l-.027-.016a1.193 1.193 0 01-.305-.238 1.375 1.375 0 01-.184-.251.598.598 0 01-.064-.126 1.437 1.437 0 01-.112-.292.806.806 0 01-.027-.091 2.15 2.15 0 01-.053-.321 2.503 2.503 0 01-.019-.364c0-.04.003-.077.005-.117a3.803 3.803 0 01.134-.872 5.4 5.4 0 01.195-.602c.11-.283.243-.562.399-.832 0-.003.003-.003.003-.005a6.047 6.047 0 01.826-1.123l.005-.005c.046-.056.099-.11.152-.16a4.505 4.505 0 01.955-.736c.083-.048.166-.088.246-.126.102-.046.203-.083.299-.115a2.154 2.154 0 01.505-.099c.139-.011.27-.005.396.019.136.024.262.069.38.134.358.192.612.556.719 1.07.041.184.059.39.057.614z",
    fill: "#A1A1A1"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M29.145 39.088a3.844 3.844 0 01-.069.674c-.126.682-.42 1.385-.821 2.013a5.917 5.917 0 01-.871 1.075 4.465 4.465 0 01-.912.692 2.958 2.958 0 01-.543.24c-.011-.028-.051-.212-.059-.245-.024-.1-.011-.051-.021-.166a2.503 2.503 0 01-.019-.364 4.07 4.07 0 01.139-.99 5.94 5.94 0 01.716-1.642c.209-.332.447-.647.711-.925.046-.056.099-.11.152-.16.297-.297.617-.548.955-.735a3.38 3.38 0 01.246-.126c.102-.046.203-.083.299-.115a2.747 2.747 0 01.097.774z",
    fill: "#293237"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M30.165 38.293c.351.308.559.828.55 1.527-.02 1.644-1.218 3.638-2.675 4.454-.634.355-1.212.428-1.662.262.475.416 1.214.44 2.052-.028 1.457-.816 2.655-2.81 2.675-4.454.011-.93-.356-1.546-.94-1.761z",
    fill: "url(#paint1_linear_0_12972)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M30.388 40.259l-1.644.949.762 2.45c-.042.125-.487-.141-.487-.141l-1.133-1.218-.829 2.032c-.262.064-.086.482-.308.437-.313-.11-.497-.36-.497-.36l.487-2.042-.904.524c.005-.155.019-.31.046-.468.021-.134.108-.583.225-.85l.778-.57-.262-.52a6.046 6.046 0 01.77-1.026l.35.454.65-1.291c.091-.064.016-.011.112-.065a3.38 3.38 0 01.246-.126c.102-.046.203-.083.299-.115a2.154 2.154 0 01.505-.099l-.666 1.628 1.752-.696s.44.22.437.446c-.003.222-.646.44-.689.667z",
    fill: "#A1A1A1"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M31.074 40.553l-1.683 1.124.618 1.368c-.252.395-.207.328-.53.64l-.946-.917-.97 2.06c-.412.1-.515.096-.814-.06l.637-1.933-1.504.77c-.051-.202-.055-.345-.052-.596.003-.192 0-.26.032-.458l1.669-1.08-.725-1.284c.249-.398.268-.42.591-.734l.992.928 1.042-2.151c.365-.054.42-.063.735.065l-.63 2.02 1.542-.718c.04.185.031.234.028.458-.004.217.011.27-.032.498z",
    fill: "#D3D3D3"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M29.046 41.207c-.004.36-.267.799-.587.978-.32.179-.576.032-.571-.33.004-.36.267-.798.587-.977.32-.18.576-.032.571.329z",
    fill: "#B6B6B6"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M66.283 16.875l-1.167 1.905-2.847 4.646-1.406 2.294L59 24.64c-.015-.007-.03-.017-.045-.026l-.054-.032.002-.004c-.407-.265-.705-.703-.859-1.29a2.744 2.744 0 01-.067-.32 3.606 3.606 0 01-.027-.218c-.004-.04-.009-.077-.011-.117a4.696 4.696 0 01-.012-.361c.028-2.32 1.718-5.134 3.775-6.285.113-.063.225-.12.335-.17.884-.405 1.674-.413 2.264-.083l.005-.008 1.977 1.149z",
    fill: "url(#paint2_linear_0_12972)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M67.267 19.2c-.028 2.32-1.719 5.134-3.775 6.285-2.056 1.15-3.701.204-3.672-2.116.028-2.32 1.718-5.134 3.775-6.285 2.056-1.152 3.7-.204 3.672 2.116z",
    fill: "#414C5C"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M66.182 19.806c-.003.22-.027.447-.07.674-.125.682-.42 1.385-.821 2.013a5.88 5.88 0 01-.872 1.075 4.47 4.47 0 01-.912.693 2.778 2.778 0 01-.727.292c-.412.099-.783.06-1.083-.094l-.027-.016a1.193 1.193 0 01-.305-.238 1.428 1.428 0 01-.249-.377 1.45 1.45 0 01-.112-.291.806.806 0 01-.027-.091 2.283 2.283 0 01-.054-.321 2.814 2.814 0 01-.019-.363c0-.04.003-.078.005-.118a3.75 3.75 0 01.134-.872 5.4 5.4 0 01.195-.602c.11-.283.244-.562.399-.832 0-.003.003-.003.003-.005a5.983 5.983 0 01.826-1.123l.005-.005a4.487 4.487 0 011.107-.896c.083-.048.165-.088.246-.126a3.05 3.05 0 01.3-.115 2.19 2.19 0 01.506-.099c.139-.011.27-.005.396.019.136.024.262.07.38.134.358.193.612.556.719 1.07.041.183.059.389.057.614z",
    fill: "#A1A1A1"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M64.222 18.84c-.003.22-.027.447-.07.674-.126.682-.42 1.385-.821 2.013a5.917 5.917 0 01-.871 1.075 4.47 4.47 0 01-.912.693 3.028 3.028 0 01-.543.24c-.011-.028-.05-.212-.059-.245-.024-.1-.011-.051-.022-.167a2.814 2.814 0 01-.019-.363 4.058 4.058 0 01.139-.99 5.94 5.94 0 01.716-1.642c.208-.332.447-.647.711-.925a1.92 1.92 0 01.152-.161c.297-.297.618-.548.955-.735.083-.048.165-.088.246-.126a3.05 3.05 0 01.3-.115 2.698 2.698 0 01.098.774z",
    fill: "#293237"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M65.242 18.045c.351.308.559.829.55 1.528-.02 1.644-1.218 3.638-2.675 4.454-.634.355-1.212.428-1.662.262.475.416 1.215.44 2.052-.028 1.457-.816 2.655-2.81 2.675-4.454.011-.93-.356-1.547-.94-1.762z",
    fill: "url(#paint3_linear_0_12972)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M65.465 20.012l-1.645.949.763 2.45c-.042.125-.488-.141-.488-.141l-1.133-1.218-.829 2.032c-.262.064-.086.482-.308.436-.314-.11-.498-.36-.498-.36l.487-2.042-.904.524c.005-.155.019-.31.046-.468.021-.134.108-.583.225-.85l.778-.57-.262-.52a5.983 5.983 0 01.77-1.025l.35.455.65-1.291c.091-.064.016-.011.112-.064.083-.048.165-.088.246-.126a3.05 3.05 0 01.3-.115 2.19 2.19 0 01.506-.099l-.666 1.628 1.751-.695s.44.22.437.446c-.002.219-.645.437-.688.664z",
    fill: "#A1A1A1"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M66.151 20.305l-1.684 1.124.618 1.368c-.251.396-.207.329-.53.64l-.946-.917-.97 2.06c-.412.1-.514.096-.814-.06l.637-1.933-1.504.77c-.051-.202-.055-.345-.052-.596.003-.193 0-.26.032-.458l1.669-1.08-.725-1.284c.249-.4.268-.42.591-.734l.992.928 1.042-2.151c.365-.054.42-.063.735.064l-.63 2.02 1.542-.718c.04.184.031.233.028.458-.003.219.012.272-.031.499z",
    fill: "#D3D3D3"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M64.123 20.959c-.004.36-.267.799-.587.978-.32.179-.576.032-.572-.33.004-.36.267-.798.587-.977.32-.18.576-.032.572.329z",
    fill: "#B6B6B6"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M6.901 34.203l-5.293-1.61.027-1.761-.027-3.326.529-1.095 7.506-5.285 4.377-9.1 15.542-8.567 7.775 2.496L50.993.019l-1.01 5.212 2.176-1.178-1.609 4.12-1.683 1.933L6.901 34.203z",
    fill: "#6EDAE0"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M69.811 14.295l-1.614 4.115-.33.378a4.014 4.014 0 00-.264-1.208 2.847 2.847 0 00-.576-.878 2.405 2.405 0 00-.698-.491 2.387 2.387 0 00-.859-.208c-.076-.02-.151-.02-.227-.02-.623 0-1.274.19-1.944.567-1.161.65-2.209 1.756-2.945 3.03a8.386 8.386 0 00-1.038 2.709 6.893 6.893 0 00-.113 1.076c0 .396.038.774.123 1.114l-26.54 15.234c.019-.094.019-.198.019-.293.009-.764-.142-1.416-.434-1.944h-.009v-.02a2.377 2.377 0 00-.415-.546 2.109 2.109 0 00-.528-.397 2.105 2.105 0 00-.661-.255.183.183 0 00-.066-.02h-.009a3.141 3.141 0 00-.51-.046c-.623 0-1.274.189-1.954.566-.623.349-1.218.84-1.746 1.416a7.616 7.616 0 00-.736.915c-.632.887-1.114 1.888-1.369 2.898a6.243 6.243 0 00-.236 1.586c0 .245.01.472.047.698l-5.474-2.388v-1.03l.557-3.104.528-1.095 7.504-5.286 4.379-9.108s11.798-10.27 16.139-8.768c2.85.982 7.173 2.709 7.173 2.709l13.657-5.946-.443 4.04-.104.915.661-.35 1.055-.565z",
    fill: "#40A6BA"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M68.316 10.149l-13.328 6.045-27.694 15.17-7.506 5.286-.529 1.096 49.346-27.14.04-.348-.329-.11z",
    fill: "#6EDAE0"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M20.092 41.31l6.379-3.136a7.616 7.616 0 00-.736.915c-.632.887-1.114 1.888-1.369 2.898a6.243 6.243 0 00-.236 1.586c0 .245.01.472.047.698.009.123.028.245.066.368l-2.501 1.435-1.17-.623-.991-.038-1.359-1.095v-2.161l.481-.274 1.389-.573z",
    fill: "#414C5C"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M59.202 23.365c0 .396-.069.819.015 1.159L32.784 39.712c.019-.094.019-.198.019-.293.009-.764-.142-1.416-.434-1.944h-.009v-.02a2.377 2.377 0 00-.415-.546 2.109 2.109 0 00-.528-.397 2.105 2.105 0 00-.661-.255l26.447-14.903 3.152-1.774a8.386 8.386 0 00-1.038 2.709 6.791 6.791 0 00-.115 1.076z",
    fill: "#479FB4"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M35.519 38.196l.259-.01-.145-3.661-.006-4.01-1.564-4.974 8.958-1.143.876 2.116.479 6.517.182-.11 10.182-6.166.003-.071.108-4.866-1.048-3.432-.247.077 1.036 3.392-.105 4.752-9.883 5.982-.46-6.155-.956-2.317-.099.013-9.365 1.192 1.65 5.252v3.956l.145 3.666z",
    fill: "#2E8989"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M68.313 13.236l.828.51.67.549-2.209 3.285a2.847 2.847 0 00-.576-.878 2.405 2.405 0 00-.698-.491 2.387 2.387 0 00-.859-.208c-.057-.047-.113-.075-.17-.104l1.765-1.001 1.133-.604.116-1.058z",
    fill: "#546672"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M22.846 40.713l2.888-1.623c-.632.887-1.114 1.888-1.369 2.898l-1.52.849v-2.124h.001zM30.434 29.658l2.131-7.292 15.042-8.337 6.31 2.74-.238 1.656-20.555 11.353-2.69-.12z",
    fill: "#414C5C"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M53.294 17.155l-.132.906-2.331 1.293-.406.217-7.579 4.19-.755.416-6.777 3.738-.944.528-1.485.83-1.152-.462 1.288-6.05.414-.236.642-.35 6.522-3.633.01-.01.736-.414 6.319-3.47 5.63 2.507z",
    fill: "#529BA3"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M35.314 27.915l-.944.528-.935-5.918.642-.35 1.237 5.74zM42.846 23.762l-.755.415-1.492-5.635.01-.01.736-.414 1.501 5.644zM50.604 19.574l-.406.217-1.852-5.033.567.198 1.691 4.618zM69.726 16.56l-1.529 1.85.311.793-.651.378c.009-.123.019-.255.019-.378 0-.142 0-.283-.009-.415a4.014 4.014 0 00-.264-1.208 2.847 2.847 0 00-.576-.878 2.405 2.405 0 00-.698-.491l1.765-1.001.661-.35 1.057-.565-.086 2.265zM32.369 37.476h-.009v-.02c0 .01.009.01.009.02z",
    fill: "#414C5C"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M9.643 21.179l17.651 10.239-7.506 5.232L2.137 26.41l7.506-5.231z",
    fill: "#7AF2F2"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M14.038 12.05L9.643 21.18s4.584 5.41 17.651 10.239l4.377-9.153L14.038 12.05z",
    fill: "#414C5C"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M30.925 22.403l-3.983 8.315c-10.977-4.106-15.696-8.655-16.592-9.59l4.011-8.325s.236.198.68.547c.207.15.453.34.745.547.208.16.434.33.689.51a70.655 70.655 0 003.728 2.482c2.766 1.71 6.409 3.73 10.722 5.514z",
    fill: "#3D7D87"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M12.261 19.93l-1.61.574-.301.625c.896.934 5.616 5.484 16.592 9.59l.785-1.638c-10.163-3.987-14.601-8.25-15.466-9.151z",
    fill: "#5B949C"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M29.99 3.018c-.708-.278-15.952 8.979-15.952 8.979s5.857 5.504 17.637 10.269L47.81 13.49S36.347 5.508 29.99 3.018z",
    fill: "#7AF2F2"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M.2 31.654l18.02 10.505v2.159c.437-.143-6.156-1.298-18.02-10.397-.45-.344 0-2.267 0-2.267z",
    fill: "#293237"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M19.788 36.65l-.529 1.096-17.651-10.24.529-1.095L19.788 36.65z",
    fill: "#52ABBC"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M.948 30.963c-.281.16-1.079.467-.544.905 6.783 5.553 17.539 10.13 17.816 10.29l.485-.278L.948 30.963zM24.913 39.779l-.019.009-.896.444-4.125 2.02a1.609 1.609 0 01-1.255.056l-.396-.151 1.057-.595 5.153-2.454.038-.02.434.68.009.01z",
    fill: "#546672"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M19.259 37.749l-.557 3.105v1.029L1.053 31.643v-1.02l.557-3.105v-.01l.009.01.585.34 17.055 9.89z",
    fill: "#2B8394"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M4.922 29.788l11.107 6.4-.146 3.314-3.67-4.38-5.211-3.013-3.424.277 1.344-2.598z",
    fill: "#066C7F"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M2.204 28.198v1.444c0 .123-.047.293-.132.5-.019.038-.028.066-.047.094-.104.217-.245.293-.34.368-.009.009-.009.009-.019.009a1.362 1.362 0 01-.151.104c-.076.047-.16.085-.236.132-.151.094-.076.019-.227.113v-.557l.444-2.303.057-.283.056.038h.01l.585.34z",
    fill: "#E08A35"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M1.053 30.963l2.525 1.423a.61.61 0 00.846-.262l.682-1.386a.8.8 0 00-.317-1.046l-2.586-1.495-1.15 2.766zM18.683 41.054L15.699 39.4c-.193-.114-.36-.552-.367-.96l-.028-1.795c-.008-.49.166-.768.398-.637l3.527 1.944-.546 3.102z",
    fill: "#E08A35"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M19.228 37.953c.148-.106.083-.071.225-.16.123-.077.221-.046.286-.002.082.055.096.169.096.347v1.592c0 .127-.047.292-.138.505a1.27 1.27 0 01-.042.093c-.106.218-.247.292-.34.363-.142.11-.273.17-.405.25-.153.094-.076.02-.229.114v-.556l.547-2.546z",
    fill: "#E08A35"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M8 34.538c-.244-.143-.443-.476-.443-.743v-1.362c0-.267.199-.368.443-.225l3.286 1.92c.244.143.443.476.443.743v1.362c0 .267-.199.368-.443.226L8 34.538z",
    fill: "#D3D3D3"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 36.367l-3.285-1.92c-.199-.116-.36-.386-.36-.604V32.48c0-.217.161-.3.359-.183l3.286 1.92c.199.116.36.386.36.603v1.362c0 .218-.161.3-.36.184z",
    fill: "#EFEC82"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    fill: "#D3A944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.644 34.812a.782.782 0 00-.358-.594L8 32.298c-.196-.114-.353-.035-.358.175l4.002 2.339zM7.642 33.854a.779.779 0 00.358.593l3.285 1.92c.196.114.354.035.358-.175l-4.001-2.338z"
  }))), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M68.641 10.255l-13.654 5.943s-1.236-1.17-3.209-2.728c-2.379-1.888-5.842-4.332-9.505-5.956-1.633-.727-3.303-1.283-4.936-1.557 0 0 12.464-6.301 13.654-5.942 1.066.32 2.095.689 3.086 1.076 5.069 2 9.137 4.748 11.676 6.71 1.859 1.435 2.888 2.454 2.888 2.454z",
    fill: "#6EDAE0"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M41.759 7.492s6.538 2.839 10.019 5.978c3.48 3.139.225-.034.225-.034s-2.379-4.182-9.624-6.266c-7.245-2.084-.657-1.097-.657-1.097l.037 1.419z",
    fill: "#414C5C"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M65.753 7.802L52.8 14.4l2.168 1.789.019.009 13.654-5.943-2.888-2.453z",
    fill: "#7AF2F2"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M54.077 1.09L41.759 7.493c-1.633-.727-2.872-.776-4.505-1.05 0 0 12.93-6.55 14.119-6.191 1.068.32 1.713.453 2.704.84z",
    fill: "#69BBB8"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M54.077 1.09L41.376 7.258c-1.633-.727-2.406-1.025-4.039-1.3 0 0 12.464-6.3 13.654-5.941 1.066.32 2.095.688 3.086 1.075z",
    fill: "#7AF2F2"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M44.277 6.64l.324-.175a.815.815 0 01.634-.013l2.624 1.208c.326.152.295.405-.068.544l-.302.116a.837.837 0 01-.576-.01l-2.6-1.167c-.294-.134-.311-.355-.036-.503z",
    fill: "#3E2F37"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    fill: "#6EDAE0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.592 6.507l-.218-.065-1.422.667.169.097 1.471-.7zM46.162 6.724l-.219-.064-1.422.667.17.096 1.471-.7zM46.732 6.942l-.219-.064-1.422.667.169.096 1.472-.7zM47.302 7.16l-.219-.064-1.422.666.169.097 1.472-.7zM47.826 7.397l-.219-.064L46.185 8l.169.096 1.472-.7zM48.244 7.688l-.219-.065-1.422.668.17.096 1.471-.7z"
  }))), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M53.641 12.566l-.318.184c-.163.094-.408.077-.534-.036l-1.871-1.67c-.232-.21-.138-.511.203-.65l.283-.114c.161-.065.367-.04.479.058l1.861 1.617c.212.188.166.455-.103.61z",
    fill: "#3E2F37"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    fill: "#6EDAE0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.504 12.62l.167.096 1.367-.69-.116-.13-1.418.724zM52.086 12.312l.166.095 1.368-.688-.116-.13-1.418.723zM51.668 12.003l.166.095 1.368-.688-.115-.13-1.419.723zM51.25 11.694l.167.095 1.367-.688-.116-.13-1.418.723zM50.875 11.365l.166.095 1.368-.687-.116-.13-1.418.722zM50.604 10.98l.166.097 1.368-.69-.116-.128-1.418.722z"
  }))), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M58.241 18.106l-.548.304a.477.477 0 00-.239.413v.204c0 .184.199.298.358.207l.548-.307a.476.476 0 00.238-.413v-.201a.238.238 0 00-.357-.207z",
    fill: "#E06E18"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M58.341 18.184l-.548.304a.477.477 0 00-.239.413v.204c0 .184.199.298.358.207l.549-.307a.476.476 0 00.238-.413v-.201a.239.239 0 00-.358-.207z",
    fill: "#E0AB35"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M51.754 13.305c-2.379-1.888-5.862-4.072-9.48-5.79C38.143 5.554 29.99 3.019 29.99 3.019c6.358 2.49 17.821 10.473 17.821 10.473l7.177 2.707s-1.261-1.337-3.234-2.894z",
    fill: "#414C5C"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M47.877 13.315c-.063-.05-8.442-5.87-14.81-9.098 2.745.92 6.67 2.302 9.126 3.468 3.393 1.61 6.924 3.767 9.444 5.768a35.536 35.536 0 012.594 2.258l-6.354-2.396z",
    fill: "#88D5DE"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M20.203 16.89l-3.69 2.04-.038-4.521a70.655 70.655 0 003.728 2.482zM15.786 13.899l-.217 5.559-2.01 1.104-1.152-.463 2.284-6.57.349-.178c.208.15.453.34.746.548z",
    fill: "#95C9B1"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M33.224 35.45v1.563l25.719-16.198-.353-.206-25.366 14.84z",
    fill: "#546672"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M33.578 35.657v1.563l25.365-14.842v-1.563L33.578 35.657z",
    fill: "#414C5C"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M33.578 35.657v1.563l-.354-.207V35.45l.354.207z",
    fill: "#293237"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M32.772 39.082c.019.183.039.365.037.562 0 .189-.019.387-.038.576l26.625-15.29a4.175 4.175 0 01-.168-1.041L32.772 39.082z",
    fill: "#546672"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M32.772 39.45c.019.184.039.367.037.563 0 .189-.019.387-.038.576l26.625-15.29a4.175 4.175 0 01-.168-1.041L32.772 39.45z",
    fill: "#414C5C"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M32.454 37.277c-.255-.462-.708-.925-1.51-1.208-.236-.085-2.039-.935-4.729 1.916a8.715 8.715 0 00-1.312 1.784c-.01.01-.01.01-.01.019l-.896.444c.085-.227.179-.472.274-.736.047-.132.104-.264.16-.387.991-2.237 3.256-3.955 5.663-3.88 1.369.038 2.039 1.086 2.36 2.048zM32.756 38.844s-.029-.755-.302-1.567c.434.784.302 1.567.302 1.567z",
    fill: "#546672"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M24.243 44.639s-.464-3.614 2.227-6.465c2.691-2.852 4.73-1.795 4.946-1.661.215.134 1.357 1.063 1.356 2.569l-.001 1.507.453-1.304s-.114-3.534-2.662-3.608c-2.547-.074-4.935 1.85-5.819 4.262-.885 2.412-1.254 3.102-1.254 3.102l.754 1.598z",
    fill: "#414C5C"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M66.38 15.499c-1.402-.112-2.658-1.152-5.475 1.487-2.817 2.64-2.276 7.265-2.276 7.265l.137.09c.094-.053.216.08.308.024a6.941 6.941 0 01.131-2.916c.469-1.77 1.808-3.654 3.5-4.897 1.692-1.244 3.428-.578 3.428-.578s1.648-.364.247-.475z",
    fill: "#546672"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M66.392 16.175s-1.736-.665-3.428.578c-1.692 1.243-3.031 3.127-3.5 4.898-.468 1.77-.068 3.22-.068 3.22v.428l-.508-.846s-.477-4.361 2.34-7.001c2.817-2.64 4.314-1.702 5.716-1.59 1.401.112-.552.313-.552.313z",
    fill: "#414C5C"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M12.465 37.077l.004.324a.416.416 0 00.208.352l1.377.8a.162.162 0 00.246-.141l-.001-.091-1.153-.67a.416.416 0 01-.208-.352l-.003-.233-.224-.13a.162.162 0 00-.246.14z",
    fill: "#066C7F"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M12.935 37.066l.003.233a.417.417 0 00.208.352l1.153.67-.003-.231a.416.416 0 00-.208-.354l-1.153-.67z",
    fill: "#BED5DF"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M2.333 28.652c-.133.057-.134.317-.164.485l-.12.682-.151.859a.377.377 0 00.192.398c.189.102.367.227.571.3.29.106.312-.063.354-.314l.259-1.544.019-.112a.378.378 0 00-.183-.39c-.191-.11-.379-.234-.576-.334-.089-.046-.154-.051-.201-.03z",
    fill: "#E03835"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M3.529 29.358c-.134.064-.133.335-.158.476l-.12.685-.153.87a.378.378 0 00.192.398l.375.202c.175.095.434.295.514-.001.065-.238.084-.5.125-.742l.19-1.13a.378.378 0 00-.183-.39c-.202-.116-.413-.285-.63-.365-.065-.023-.114-.022-.152-.003z",
    fill: "#E0C5A0"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M15.877 36.445c-.127.06-.102.336-.114.514l-.051.722-.064.91c-.012.17.082.34.233.423.2.108.391.24.602.319.3.11.305-.07.322-.334l.102-1.636.008-.12a.452.452 0 00-.222-.411c-.203-.118-.403-.25-.611-.355-.094-.048-.159-.054-.205-.032z",
    fill: "#E03835"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M17.145 37.194c-.127.068-.099.355-.109.505l-.051.726-.065.92c-.012.17.082.34.233.423.132.07.263.143.395.214.184.1.464.312.514-.001.04-.252.033-.528.049-.786l.075-1.197a.453.453 0 00-.222-.412c-.213-.125-.442-.303-.667-.388-.067-.025-.116-.024-.152-.004z",
    fill: "#E0C5A0"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M57.345 17.48c.101.26.172.533.106.813a1.93 1.93 0 01-.175.426c-.09.178-.16.425-.336.524-.142.08-.314.186-.484.173-.196-.016-.402-.122-.569-.22-.48-.276-.989-.536-1.43-.875-.147-.113-.262-.296-.462-.257-.169.033-.216.076-.387-.028a.844.844 0 01-.324-.351c-.102-.21-.134-.564.079-.712.137-.096.288-.174.434-.257a.618.618 0 01.086-.041c.108-.046.262-.077.326-.187.068-.117.051-.251.176-.338a.507.507 0 01.173-.067c.211-.052.425-.13.645-.132.226-.003.381.108.571.22.429.255.84.539 1.234.845.059.047.119.094.168.15.076.092.126.204.169.315z",
    fill: "#066C7F"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M54.935 16.593c.792.48 1.8.769 1.901 1.329.104.564-.13 1.286-.791 1.069-.632-.206-1.619-.907-1.619-.907s-.285-1.975.509-1.491z",
    fill: "#D3D3D3"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M38.137 29.502l-1.893 1.11c-.001-.362-.062-.575.314-.795 0 0 .584-.403 1.116-.674.499-.253.463.359.463.359zM46.738 24.334l-1.893 1.11c-.001-.362-.061-.575.314-.795 0 0 .584-.403 1.116-.674.5-.254.463.359.463.359z",
    fill: "#414C5C"
  })), _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12972",
    x1: 23.702,
    x2: 28.89,
    y1: 44.764,
    y2: 35.779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_12972",
    x1: 27.419,
    x2: 31.09,
    y1: 45.164,
    y2: 38.805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_0_12972",
    x1: 58.779,
    x2: 63.967,
    y1: 24.517,
    y2: 15.531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint3_linear_0_12972",
    x1: 62.495,
    x2: 66.167,
    y1: 24.917,
    y2: 18.558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 329.848,
    y: 141.885,
    width: 80.343,
    height: 51.817,
    viewBox: "0 0 80.375 51.828",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M49.345 20.657c-.247.157-.499.31-.76.462-.174.422-1.996 1.157-2.567 1.49L43.29 24.19c-1.562.908-2.905 1.884-4.436 2.814l-.123.075c-2.016 1.229-3.986 2.53-5.945 3.846l-1.508 1.016c-.55.37-.664.343-.677.968-.021 1.03 42.222-17.551 42.451-16.551.96 4.185 4.446 4.123 6.736 7.74.252.398-46.175 26.814-47.162 27.244-.566.247-1.154.5-1.771.484-.557-.014-1.082-.243-1.59-.47l-13.323-5.934c-2.726-1.215-12.47-6.188-13.029-6.543-.207-.13-.639-.358-.714-.617-.053-.184.299-.825.452-.658L0 34.727l15.235-11.039c.271-.198.176-.855.229-1.09.2-.892.427-1.782.689-2.669.557-1.886.721-3.982 2.39-5.697.866-.892 2.763-1.678 3.978-2.447a112.574 112.574 0 015.067-2.999 185.822 185.822 0 016.313-3.404l8.944.6 5.364-2.712 1.649.714 1.287 1.288.845 1.707-.042.072.818-.409c.096-.02 2.684 3.715 2.875 4.066.294.543.728 1.066.918 1.623.27.787.994 1.952.615 2.752-.409.86-2.051 1.39-3.012 2.069-1.65 1.167-3.075 2.396-4.817 3.504z",
    fill: "url(#paint0_linear_0_9803)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M26.686 17.68s.972-1.19-.26-3.012c-1.052-1.554-1.843-1.043-1.843-1.043s-1.206.835-.422 2.299c.497.93.983 2.194 1.324 2.192.342 0 .527 1.137.527 1.137l.989-1.029-.315-.544z",
    fill: "#066C7F"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M41.833 42.767L35.045 39l8.191-3.422-1.403 7.19zM77.651 22.22l-6.788-3.767 8.192-3.423-1.404 7.19z",
    fill: "#293237"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M40.236 39.803l-1.192 1.945-2.907 4.745h-.001L34.7 48.834l-1.902-1.102-.046-.026-.056-.034.002-.003c-.416-.27-.72-.718-.877-1.316a2.724 2.724 0 01-.069-.328 3.735 3.735 0 01-.028-.222l-.011-.12a4.892 4.892 0 01-.012-.37c.029-2.369 1.755-5.242 3.854-6.418.116-.064.23-.122.342-.172.902-.414 1.71-.422 2.312-.085l.005-.008 2.022 1.172z",
    fill: "url(#paint1_linear_0_9803)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M41.241 42.175c-.029 2.37-1.755 5.244-3.855 6.419-2.1 1.175-3.779.207-3.75-2.162.029-2.369 1.755-5.242 3.855-6.418 2.099-1.175 3.778-.208 3.75 2.161z",
    fill: "#414C5C"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M40.132 42.794a3.997 3.997 0 01-.071.689c-.129.696-.429 1.415-.838 2.056-.257.404-.56.777-.89 1.097a4.554 4.554 0 01-.931.707 2.842 2.842 0 01-.743.298c-.42.102-.8.064-1.106-.096-.008-.005-.019-.01-.027-.016a1.185 1.185 0 01-.311-.243 1.328 1.328 0 01-.188-.257.648.648 0 01-.066-.128 1.498 1.498 0 01-.115-.298 2.22 2.22 0 01-.082-.421 2.601 2.601 0 01-.019-.37c0-.041.003-.08.006-.12a3.901 3.901 0 01.136-.89c.052-.206.12-.41.199-.615.112-.29.249-.573.407-.85 0 0 .003-.003.003-.006a6.072 6.072 0 01.844-1.147l.005-.005c.046-.058.101-.113.156-.165.219-.219.448-.413.688-.574.093-.064.189-.122.287-.176.085-.05.169-.09.251-.129.104-.045.208-.084.306-.116a2.108 2.108 0 01.516-.101c.142-.012.276-.007.404.018.139.026.268.072.388.136.366.197.625.569.735 1.092.04.191.059.401.056.63z",
    fill: "#A1A1A1"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M38.131 41.81a3.997 3.997 0 01-.071.688c-.128.697-.429 1.415-.838 2.056-.256.404-.56.777-.89 1.097a4.554 4.554 0 01-.931.707 3.111 3.111 0 01-.554.247c-.011-.03-.051-.218-.06-.25-.025-.101-.011-.053-.022-.17a2.601 2.601 0 01-.019-.372 4.083 4.083 0 01.142-1.01c.128-.496.339-.996.609-1.468a6.123 6.123 0 01.849-1.153c.046-.057.101-.112.156-.164.303-.303.631-.56.975-.752.085-.048.169-.09.251-.127.104-.047.208-.086.306-.117.016.052.03.107.041.16.039.188.058.398.056.627z",
    fill: "#293237"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M39.173 40.996c.359.314.57.846.562 1.56-.021 1.68-1.244 3.716-2.732 4.549-.647.362-1.238.437-1.697.268.485.425 1.24.45 2.096-.03 1.488-.833 2.711-2.869 2.731-4.548.011-.948-.364-1.578-.96-1.799z",
    fill: "url(#paint2_linear_0_9803)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 43.005l-1.68.97.778 2.502c-.042.127-.497-.144-.497-.144l-1.157-1.244-.846 2.075c-.268.064-.088.492-.314.445a1.177 1.177 0 01-.508-.366l.497-2.086-.923.536c.005-.158.019-.316.046-.478.022-.138.111-.596.23-.868l.794-.583-.267-.53a6.072 6.072 0 01.787-1.047l.358.464.664-1.319c.093-.065.016-.01.114-.066.085-.048.169-.09.251-.127.104-.047.208-.086.306-.117a2.108 2.108 0 01.516-.101l-.68 1.662 1.789-.71s.449.227.446.457c-.003.22-.66.443-.704.675z",
    fill: "#A1A1A1"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M40.101 43.306l-1.719 1.147.631 1.396c-.257.405-.211.337-.542.656l-.965-.939-.991 2.104c-.42.102-.525.097-.831-.06l.65-1.975-1.536.787c-.052-.208-.056-.353-.054-.61.003-.197 0-.265.033-.468l1.704-1.102-.74-1.313c.254-.407.273-.428.603-.75l1.013.948 1.064-2.197c.372-.054.429-.063.751.066l-.643 2.063 1.574-.732c.041.188.031.238.028.468-.002.224.014.277-.03.51z",
    fill: "#D3D3D3"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M38.03 43.974c-.004.369-.273.816-.6.998-.327.184-.588.033-.584-.336.004-.369.273-.816.6-.998.327-.184.588-.033.584.336z",
    fill: "#B6B6B6"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M76.055 19.127l-1.193 1.945-2.907 4.744-1.436 2.341-1.902-1.102-.046-.026-.056-.034.002-.004c-.416-.27-.72-.718-.877-1.316a2.862 2.862 0 01-.097-.55c-.004-.04-.009-.078-.011-.12a4.892 4.892 0 01-.012-.368c.029-2.37 1.755-5.244 3.854-6.419.116-.064.23-.122.342-.171.902-.416 1.71-.424 2.312-.087l.005-.008 2.022 1.174z",
    fill: "url(#paint3_linear_0_9803)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M77.06 21.5c-.029 2.369-1.755 5.242-3.855 6.418-2.1 1.175-3.779.207-3.75-2.162.029-2.369 1.755-5.241 3.855-6.418 2.1-1.175 3.778-.207 3.75 2.162z",
    fill: "#414C5C"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M75.951 22.12a3.997 3.997 0 01-.071.688c-.129.695-.429 1.413-.838 2.055-.257.404-.56.779-.89 1.099a4.581 4.581 0 01-.931.707 2.842 2.842 0 01-.743.297c-.42.101-.8.063-1.106-.096-.008-.006-.019-.01-.027-.017a1.206 1.206 0 01-.312-.243 1.328 1.328 0 01-.188-.256.648.648 0 01-.066-.128 1.498 1.498 0 01-.115-.299 2.22 2.22 0 01-.082-.421 2.601 2.601 0 01-.019-.37c0-.041.003-.08.005-.12a3.901 3.901 0 01.136-.89 5.41 5.41 0 01.199-.614c.112-.29.249-.573.407-.85 0-.002.003-.002.003-.005a6.129 6.129 0 01.844-1.147l.005-.005c.046-.056.101-.111.156-.163a4.616 4.616 0 01.975-.752 3.015 3.015 0 01.767-.302c.104-.021.208-.038.306-.044.142-.01.276-.006.404.02.139.024.268.07.388.136.366.197.625.568.735 1.091.042.189.061.399.058.628z",
    fill: "#A1A1A1"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M73.95 21.134a3.997 3.997 0 01-.071.688c-.128.697-.429 1.415-.838 2.056-.257.404-.56.777-.89 1.098a4.554 4.554 0 01-.931.707 3.111 3.111 0 01-.554.245c-.011-.03-.052-.218-.06-.25-.024-.102-.011-.053-.022-.17a2.601 2.601 0 01-.019-.371 4.083 4.083 0 01.142-1.01c.128-.497.339-.997.609-1.47a6.029 6.029 0 01.849-1.152c.046-.056.101-.111.156-.163.303-.303.631-.56.975-.752a3.015 3.015 0 01.557-.245c.017.053.03.108.041.162.04.186.058.397.056.627z",
    fill: "#293237"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M74.992 20.322c.358.314.57.846.562 1.56-.021 1.678-1.244 3.714-2.732 4.547-.647.363-1.238.438-1.697.269.485.424 1.24.45 2.096-.03 1.488-.832 2.711-2.869 2.731-4.547.011-.95-.364-1.58-.96-1.8z",
    fill: "url(#paint4_linear_0_9803)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M75.22 22.33l-1.679.969.779 2.502c-.043.127-.498-.144-.498-.144l-1.157-1.244-.846 2.075c-.268.066-.088.492-.314.445-.32-.111-.508-.366-.508-.366l.497-2.085-.923.535c.005-.16.019-.317.046-.479.022-.137.111-.595.23-.866l.794-.584-.267-.53a6.129 6.129 0 01.787-1.048l.358.464.664-1.319c.093-.065.016-.01.114-.066a3.015 3.015 0 01.767-.302c.104-.021.208-.037.306-.043l-.68 1.663 1.789-.71s.449.226.446.456c-.005.223-.662.445-.705.677z",
    fill: "#A1A1A1"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M75.92 22.63l-1.719 1.146.631 1.398c-.256.404-.211.335-.542.654l-.966-.938-.991 2.104c-.42.102-.525.098-.831-.06l.65-1.976-1.536.788c-.052-.208-.056-.354-.053-.61.003-.197 0-.265.033-.467l1.704-1.104-.74-1.31c.254-.407.273-.428.603-.75l1.013.947 1.064-2.198c.372-.055.429-.064.751.066l-.644 2.064 1.574-.733c.041.189.031.239.028.468 0 .224.015.279-.029.51z",
    fill: "#D3D3D3"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M73.849 23.297c-.004.37-.273.816-.6 1-.327.183-.588.032-.584-.337.004-.369.273-.816.6-.998.327-.183.589-.034.584.335z",
    fill: "#B6B6B6"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M79.422 14.049l.036 2.061-2.273 3.305a3.704 3.704 0 00-.375-.473 2.348 2.348 0 00-.848-.55 2.51 2.51 0 00-.974-.183c-.627 0-1.301.203-1.986.579-1.176.665-2.236 1.793-2.988 3.075-.723 1.233-1.176 2.611-1.185 3.884 0 .52.058.992.193 1.407L41.833 42.767c.019-.193.039-.395.039-.588.01-1.079-.289-1.965-.877-2.553a2.527 2.527 0 00-1.822-.742c-.636 0-1.301.202-1.986.587-1.291.724-2.438 1.996-3.2 3.442-.598 1.137-.964 2.36-.973 3.518-.01.472.048.916.164 1.31v.01l-.766.407-2.533-.59-1.638-2.323.863-.541-1.031-4.136 16.135-10.732s3.494-8.21 5.955-10.555c3.146-3 15.583-8.578 15.583-8.578l6.851 2.556 5.246-2.309 1.04 1.228.539 1.87z",
    fill: "#40A6BA"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M78.882 12.177l-50.42 28.56 15.744-10.84 28.39-16.637 5.246-2.31 1.04 1.227z",
    fill: "#6EDAE0"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M68.829 25.747c0 .52.058.992.193 1.407L41.833 42.767c.019-.193.039-.395.039-.588.01-1.079-.289-1.965-.877-2.553a2.385 2.385 0 00-.617-.453l29.637-17.31c-.723 1.233-1.176 2.611-1.186 3.884z",
    fill: "#479FB4"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M46.992 38.788l-.006-.215-.108-4.824-.638-3.438.259-.049.641 3.46.105 4.628 11.571-6.28.469-5.043-.808-4.393.025-.044 4.534-7.877 4.51 2.693 1.006 4.454-.007.026-.987 5.562-.259-.047.981-5.535-.969-4.291-4.182-2.497-4.375 7.602.796 4.355-.481 5.201-.065.033-12.012 6.52z",
    fill: "#2E8989"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M41.834 41.228c.019.188.039.374.037.575 0 .193-.019.395-.039.588l27.189-15.614c-.104-.319-.15-.681-.171-1.064L41.834 41.228z",
    fill: "#546672"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M41.871 41.019c.009-.95-.235-1.736-.69-2.316l-.803.47c.231.115.434.27.617.453.477.477.753 1.157.839 1.97.018-.19.037-.387.037-.577z",
    fill: "#409E4E"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M41.834 41.605c.019.188.039.375.037.575 0 .193-.019.395-.039.587l27.189-15.614c-.104-.317-.15-.68-.171-1.063L41.834 41.605zM80.375 15.83v1.551l-.53 1.62-1.33 1.358-.588 1.688-.299.172a4.51 4.51 0 00.058-.713c.01-.819-.164-1.532-.501-2.09a3.704 3.704 0 00-.375-.473 2.348 2.348 0 00-.848-.55l2.564-1.503.54-.309 1.309-.752zM70.465 14.508l-.845 2.122-1.909 1.088-.212.116-.222.134-.588.358-.482.288-.298.183-.405.241-.328.194-6.756 4.058-.868.52-9.107 5.465-.424.25-2.294 1.379-.261-1.465 3.721-6.796.414-.76 1.224-2.238 13.628-7.487.154-.098.448-.242 5.41 2.69z",
    fill: "#414C5C"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M64.806 12.395l4.478 2.805-.168 1.28-23.11 13.806-.134-.777 5.234-9.584 13.7-7.53z",
    fill: "#529BA3"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M67.428 17.744l-.299.308-.212.116-.222.134-2.959-5.473.135-.338.154-.096.328.164 3.075 5.185zM58.941 22.805l-.867.52-1.481-6.492.878-.434 1.47 6.406zM49.707 21.825v6.469l-.424.25-.096-5.9.414-.761.106-.058z",
    fill: "#414C5C"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M42.512 37.934v1.596l26.264-16.542-.361-.21-25.903 15.156z",
    fill: "#546672"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M42.874 38.144v1.596l25.902-15.156v-1.596L42.874 38.145z",
    fill: "#414C5C"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M11.462 34.478l-.402-3.618 17.175 9.62.77 3.836s-11.429-2.8-17.543-9.838z",
    fill: "#293237"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M28.844 43.72l-.122-.61c-1.371-.483-10-3.666-17.131-9.67-.125-.104-.158-.631-.158-.631l-.077.066.031.538.045-.038s.033.526.158.632c7.4 6.229 16.41 9.422 17.254 9.714z",
    fill: "#293237"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M28.844 42.88l-.122-.61c-1.371-.484-10-3.668-17.131-9.67-.125-.105-.158-.633-.158-.633l-.077.066.031.54.045-.038s.033.528.158.632c7.4 6.228 16.41 9.422 17.254 9.712z",
    fill: "#293237"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M28.844 42.04l-.122-.61c-1.371-.483-10-3.667-17.131-9.67-.125-.106-.158-.633-.158-.633l-.077.067.031.54.045-.04s.033.527.158.633c7.4 6.227 16.41 9.422 17.254 9.712z",
    fill: "#293237"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M28.844 43.871l-.122-.61c-1.371-.483-10-3.667-17.131-9.67-.125-.105-.158-.633-.158-.633l-.077.067.031.54.045-.04s.033.529.158.633c7.4 6.228 16.41 9.422 17.254 9.713z",
    fill: "#546672"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M28.844 43.032l-.122-.61c-1.371-.483-10-3.667-17.131-9.67-.125-.105-.158-.634-.158-.634l-.077.066.031.54.045-.038s.033.528.158.633c7.4 6.227 16.41 9.421 17.254 9.712z",
    fill: "#546672"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M28.844 42.19l-.122-.61c-1.371-.483-10-3.666-17.131-9.67-.125-.105-.158-.633-.158-.633l-.077.066.031.54.045-.038s.033.528.158.633C18.99 38.704 28 41.9 28.844 42.19z",
    fill: "#546672"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M28.722 40.74c-1.365-.48-9.924-3.64-17.037-9.594a3.5 3.5 0 00-.173.34.342.342 0 00.079.151C18.99 37.865 28 41.06 28.844 41.35l-.122-.61z",
    fill: "#546672"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M12.309 39.16l17.415 9.914.154-1.506-17.412-9.92-.157 1.512z",
    fill: "#141E25"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M33.014 46.43c-.01.473.048.916.164 1.312l-.79.414-2.66.915.154-1.503-.549-.04c-.54-.038-1.06.35-1.551.129-.116-.058-.232-.116-.337-.174l-16.182-9.185a1.424 1.424 0 01-.444-.387 1.423 1.423 0 01-.299-.76l-.125-2.21.424.23 16.963 9.398.462.26v.068l5.744-2.237v.252c-.598 1.138-.964 2.361-.974 3.519z",
    fill: "#414C5C"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M27.781 44.57v3.084c-.116-.059-.232-.117-.337-.174 0 0-3.306-1.107-7.441-3.305a52.575 52.575 0 01-4.212-2.477 40.454 40.454 0 01-4.53-3.403c-.145-.126-.328-.23-.444-.386v-2.736l16.964 9.396z",
    fill: "#293237"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M28.435 41.102l-3.158-1.5c-.223-.1-.521.108-.501.352l.097 1.166c.033.394.262.719.622.884l2.695 1.232.245-2.134zM14.237 33.486l-2.421-1.89.188 2.588 2.349 1.843a.3.3 0 00.484-.258l-.096-1.337a1.321 1.321 0 00-.504-.946z",
    fill: "#9CB7D2"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M12.004 31.742c.081-.212-.832-.732-.832-.732-.439 1.689.263 2.634.263 2.634l.568.54s-.172-1.988.001-2.441z",
    fill: "#E08A35"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M18.907 37.033c.005.434.321.962.706 1.176.385.215.692.038.687-.396-.005-.434-.322-.96-.706-1.175-.385-.215-.692-.038-.687.395z",
    fill: "#768A99"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M18.708 37.13c.005.433.322.96.706 1.175.385.215.692.038.687-.395-.005-.434-.322-.961-.706-1.176-.384-.217-.692-.038-.687.395z",
    fill: "#C4C4C4"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M33.482 42.404l.505.256-5.091 2.318a1.465 1.465 0 01-1.273-.084s-12.761-5.07-17.01-9.645c-.212-.23-.308-.53-.072-.735l.891-.769s.033.529.158.633c7.77 6.54 17.324 9.736 17.324 9.736l4.568-1.71zM24.951 44.514v.44a.44.44 0 00.281.423l1.883.731c.152.06.341-.084.341-.256v-.124l-1.577-.611a.442.442 0 01-.28-.424v-.316l-.306-.119c-.152-.059-.342.085-.342.255z",
    fill: "#546672"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M25.599 44.377v.316c0 .196.108.357.28.424l1.577.61v-.313a.444.444 0 00-.28-.428l-1.577-.61z",
    fill: "#BED5DF"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M11.142 36.309v.325c0 .173.064.335.168.422l1.127.954c.091.077.205-.02.205-.174v-.11l-.944-.797c-.103-.087-.167-.248-.167-.422v-.215l-.184-.154c-.091-.078-.205.02-.205.17z",
    fill: "#546672"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53 36.29v.215c0 .174.064.335.167.423l.944.797v-.212c0-.177-.065-.338-.168-.425l-.943-.797z",
    fill: "#BED5DF"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M20.022 42.661v1.389a.469.469 0 01-.019.125 52.575 52.575 0 01-4.212-2.477.382.382 0 01-.029-.136v-1.387c0-.28.202-.377.453-.232l3.354 1.957c.251.145.453.492.453.761z",
    fill: "#12181D"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M16.213 42.041c-.25-.145-.452-.485-.452-.758V39.89c0-.273.203-.375.452-.23l3.355 1.96c.249.146.453.486.453.758v1.392c0 .273-.203.376-.452.23l-3.356-1.96z",
    fill: "#D3D3D3"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M19.568 43.908l-3.355-1.96c-.203-.117-.367-.395-.367-.615V39.94c0-.222.164-.305.367-.187l3.355 1.96c.203.119.368.395.368.617v1.39c-.001.223-.165.307-.368.188z",
    fill: "#EFEC82"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "#D3A944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.933 42.32c-.004-.22-.166-.489-.366-.605l-3.355-1.96c-.2-.117-.361-.037-.366.178l4.087 2.388zM15.847 41.342c.005.22.166.49.366.605l3.355 1.96c.2.118.361.037.366-.178l-4.087-2.387z"
  }))), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M60.017.635L77.842 10.95l-5.246 2.309L53.678 2.306 57.761.51a2.498 2.498 0 012.256.125z",
    fill: "#7AF2F2"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M28.435 41.102l-2.963-1.41.078.944c.033.393.262.718.622.883l1.948.892.315-1.31zM14.741 34.432a1.321 1.321 0 00-.504-.945L12.586 32.2l.086 1.187c.025.341.193.656.462.868l1.688 1.326-.081-1.148z",
    fill: "#BED5DF"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M53.679 2.308C60.132 4.564 72.597 13.26 72.597 13.26l-6.851-2.556L47.548.007s4.404 1.697 6.131 2.301z",
    fill: "#414C5C"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M65.674 10.438c-8.303-5.533-14.848-9.043-14.848-9.043 1.042.388 2.032.8 2.621 1.005 4.73 1.654 12.481 6.806 16.684 9.596 0 0-3.475-.904-4.457-1.559z",
    fill: "#88D5DE"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M11.474 31.11c7.342 5.657 16.988 9.627 16.988 9.627l15.745-10.902-18.925-10.942-14.161 11.945.353.272z",
    fill: "#6EDAE0"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M27.412 21.346s.643 2.078 5.342 4.73c4.698 2.65 7.254 2.57 7.254 2.57l4.198 1.252-18.704-11.006 1.91 2.454z",
    fill: "#414C5C"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M32.151 8.793s5.418 5.18 18.01 10.486c0 0-3.196 5.116-5.955 10.555 0 0-11.246-4.11-18.925-10.942 0 0 3.095-4.702 6.87-10.099z",
    fill: "#414C5C"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M49.707 19.404c-.848 1.119-3.306 5.523-5.638 10.073-1.658-.637-11.508-4.569-18.428-10.66.453-.945 3.402-4.954 6.554-9.61.145.125.357.3.626.521a51.333 51.333 0 004.453 3.2c2.863 1.831 6.94 4.136 12.433 6.476z",
    fill: "#3D7D87"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M14.704 32.809l12.708-11.462s-1.872-2.139-2.462-1.74c-6.769 4.584-12.558 10.658-12.558 10.658l2.312 2.544z",
    fill: "#69BBB8"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M14.704 32.809l12.465-11.782-1.887-2.134c-6.769 4.584-14.221 11.968-14.221 11.968l3.643 1.948zM28.035 40.569l16.171-10.672-4.198-1.25-16.017 9.659 4.044 2.263z",
    fill: "#7AF2F2"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.321 29.44l-.289.191c-.148.099-.445.104-.644.014l-2.971-1.322c-.37-.166-.399-.442-.062-.595l.28-.126a.803.803 0 01.59.011l2.936 1.277c.335.146.406.387.16.55z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6EDAE0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.011 29.587l.238.07 1.292-.73-.197-.105-1.333.765zM35.376 29.349l.239.07 1.291-.73-.196-.105-1.334.765zM34.742 29.11l.239.07 1.291-.73-.196-.105-1.334.765zM34.108 28.872l.239.07 1.291-.73-.196-.105-1.334.765zM33.515 28.611l.239.07 1.291-.73-.196-.105-1.334.765zM33.018 28.294l.239.07 1.291-.73-.196-.105-1.334.765z"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.332 22.956l.28-.201c.143-.104.398-.085.554.04l2.313 1.825c.288.23.264.56-.05.711l-.262.125a.513.513 0 01-.503-.064l-2.29-1.77c-.262-.203-.28-.494-.042-.666z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6EDAE0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.479 22.896l-.192-.104-1.231.753.149.142 1.274-.79zM27.98 23.235l-.192-.104-1.231.753.149.142 1.274-.791zM28.482 23.573l-.193-.105-1.231.753.15.142 1.274-.79zM28.983 23.91l-.193-.105-1.231.753.15.143 1.274-.791zM29.445 24.27l-.192-.104-1.232.753.15.142 1.274-.79zM29.815 24.69l-.192-.105-1.231.753.149.142 1.274-.79z"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    fill: "#95C9B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.733 11.36l-4.477 6.68.134.777 3.43-2.044.913-5.412zM37.274 12.928l-6.024 3.595.993-5.926.578-.868a51.602 51.602 0 004.453 3.2z"
  }))), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M47.547.006c-.723-.283-15.396 8.787-15.396 8.787s5.98 5.622 18.01 10.486l15.583-8.578S54.039 2.55 47.547.006z",
    fill: "#7AF2F2"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M80.375 15.83l-.941-1.114-.052.789-4.06 2.492.639.395 4.414-2.563z",
    fill: "#546672"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M78.882 12.177c-.147.09-.083.039-.223.136-.122.085-.22.248-.284.378a.99.99 0 00-.095.482V14.8a.464.464 0 00.178.37c.105.082.245-.031.336-.082.141-.076.27-.188.401-.282.152-.11.076-.081.227-.19v-.57l-.54-1.87z",
    fill: "#E08A35"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M42.874 38.144v1.596l-.362-.21v-1.596l.362.21z",
    fill: "#293237"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M33.987 42.913s1.987-2.954 3.64-3.663c1.652-.71 2.963-.148 3.367.377.404.524.888 1.094.863 2.117l-.025 1.025.183-2.03s-.286-3.278-3.689-2.804c-3.404.472-5.307 4.645-5.307 4.645l.968.333z",
    fill: "#546672"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M40.665 38.36c-.48-.19-1.076-.276-1.834-.172-3.404.474-5.261 4.843-5.261 4.843l.333.044c.424-.603 2.292-3.212 3.724-3.827 1.341-.575 2.449-.311 3.038.089.39.137.989 1.125 1.168 3.43l.615-.353c-.238-2.288-.79-3.39-1.783-4.055z",
    fill: "#414C5C"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M76.055 18.43s-2.19-.352-3.492.633c-1.302.984-2.992 3.005-3.173 4.962l-.539 2.067-.225-.247s.221-1.72.397-2.444c.176-.723.557-2.927 3.069-4.65 1.75-1.2 3.231-.753 3.231-.753l.732.432z",
    fill: "#546672"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M69.022 27.154l.326-.23s-.195-1.701.256-3.334c.452-1.631 1.747-3.483 3.223-4.221 1.476-.738 2.6-.863 3.228-.53.627.335 1.359.913 1.52 1.565.161.651.463-.252.463-.252l-1.144-1.759-.838.038s-1.251-.29-2.517.098c-1.265.389-3.446 2.332-4.183 5.063-.575 2.129-.505 2.5-.505 2.5l-.436.954.607.108z",
    fill: "#414C5C"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M40.597 35.313l-.56.311a.487.487 0 00-.244.422v.209c0 .188.203.304.365.21l.56-.314a.485.485 0 00.243-.422v-.204a.243.243 0 00-.364-.212z",
    fill: "#E06E18"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M40.699 35.394l-.56.31a.487.487 0 00-.244.422v.209c0 .188.203.304.365.21l.56-.314a.486.486 0 00.243-.422v-.204a.243.243 0 00-.364-.211z",
    fill: "#E0AB35"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M28.217 40.996l.219.104c.023.014.223-.123.266-.132.338-.07.382.291.447.502.079.258.265.43.344.688.07.23.208.75.036 1.014-.069.106-.544.424-.657.372l-.681-.31s-.426-1.227.026-2.238z",
    fill: "#E08A35"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M29.103 18.302c-.208.058-1.598.4-3.088-.122a7.049 7.049 0 00-.374.637c6.92 6.091 16.77 10.024 18.428 10.66.243-.474.755-1.457.999-1.925-3.613-2.215-8.248-4.902-15.965-9.25z",
    fill: "#5B949C"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M52.03 28.976s.068 1.137-1.079 1.446a2.406 2.406 0 01-.685.087c-1.176-.02-2.65.145-2.882-.183-.241-.319-1.388.058-1.388.058a.788.788 0 01-.279-.617.79.79 0 01.279-.617l.241-.202.703.029s.029-.107.106-.27c.231-.483.954-1.456 2.834-1.119 2.449.442 2.15 1.387 2.15 1.387z",
    fill: "#2B8394"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M58.274 25.613l-1.933 1.134c-.001-.372-.063-.59.32-.814 0 0 .596-.41 1.14-.688.51-.259.473.367.473.367zM67.057 20.334l-1.933 1.136c-.001-.371-.063-.59.321-.813 0 0 .596-.413 1.14-.69.51-.258.472.367.472.367z",
    fill: "#414C5C"
  })), _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9803",
    x1: 64.615,
    x2: 38.907,
    y1: 4.434,
    y2: 71.11
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_9803",
    x1: 32.572,
    x2: 37.87,
    y1: 47.606,
    y2: 38.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_0_9803",
    x1: 36.368,
    x2: 40.117,
    y1: 48.015,
    y2: 41.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint3_linear_0_9803",
    x1: 68.391,
    x2: 73.689,
    y1: 26.93,
    y2: 17.755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint4_linear_0_9803",
    x1: 72.187,
    x2: 75.936,
    y1: 27.339,
    y2: 20.845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 403.06,
    y: 184.548,
    width: 79.788,
    height: 51.055,
    viewBox: "0 0 79.788 51.028",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M49.344 19.857c-.247.157-.499.31-.76.462-.174.422-1.996 1.159-2.567 1.49l-2.728 1.582c-1.562.908-2.905 1.884-4.436 2.814l-.123.075c-2.016 1.229-3.986 2.53-5.945 3.845-.503.338-1.005.678-1.508 1.017-.55.37-.664.343-.677.967-.021 1.032 42.222-17.55 42.451-16.55.96 4.187 4.446 4.124 6.736 7.74.252.398-46.175 26.813-47.162 27.245-.566.247-1.154.498-1.772.484-.556-.014-1.082-.245-1.59-.471L15.94 44.623c-2.726-1.215-12.47-6.188-13.029-6.542-.207-.132-.638-.36-.713-.619-.054-.184.299-.824.452-.658L0 33.927 15.235 22.89c.271-.2.176-.857.229-1.091.2-.892.427-1.782.689-2.668.557-1.887.722-3.983 2.39-5.699.866-.89 2.763-1.677 3.978-2.447a112.564 112.564 0 015.067-2.998 185.822 185.822 0 016.313-3.404l8.944.6 5.364-2.712 1.649.714 1.287 1.288.845 1.708-.042.072.818-.409c.096-.02 2.684 3.714 2.875 4.066.294.543.727 1.066.918 1.623.27.787.995 1.954.615 2.754-.409.86-2.051 1.388-3.011 2.068-1.652 1.165-3.077 2.393-4.819 3.502z",
    fill: "url(#paint0_linear_0_10202)"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M25.455 17.678s.972-1.19-.26-3.01c-1.051-1.554-1.843-1.043-1.843-1.043s-1.206.835-.422 2.297c.497.93.983 2.194 1.324 2.194.342-.002.527 1.137.527 1.137l.989-1.029-.315-.546z",
    fill: "#2A6A00"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M40.602 42.767L33.814 39l8.192-3.422-1.404 7.19zM76.42 22.218l-6.787-3.767 8.191-3.421-1.404 7.188z",
    fill: "#293237"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M39.005 39.801l-1.192 1.945-2.907 4.744-1.436 2.343-1.902-1.102-.046-.028-.056-.033.002-.004c-.416-.27-.72-.717-.877-1.316a2.862 2.862 0 01-.069-.328 3.726 3.726 0 01-.029-.221l-.011-.12a4.892 4.892 0 01-.012-.37c.029-2.368 1.755-5.242 3.855-6.417a4.56 4.56 0 01.342-.172c.903-.416 1.71-.424 2.312-.087l.005-.008 2.021 1.174z",
    fill: "url(#paint1_linear_0_10202)"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M40.01 42.175c-.029 2.37-1.755 5.244-3.855 6.419-2.1 1.175-3.779.207-3.75-2.162.029-2.369 1.755-5.242 3.855-6.418 2.099-1.175 3.778-.208 3.75 2.161z",
    fill: "#414C5C"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M38.901 42.794a3.9 3.9 0 01-.071.689c-.129.696-.429 1.414-.838 2.056-.257.404-.56.777-.89 1.097a4.554 4.554 0 01-.931.707 2.842 2.842 0 01-.743.298c-.42.102-.8.064-1.106-.096-.008-.005-.019-.01-.027-.016a1.185 1.185 0 01-.311-.243 1.328 1.328 0 01-.188-.257.625.625 0 01-.065-.129 1.498 1.498 0 01-.115-.297 2.22 2.22 0 01-.082-.421 2.61 2.61 0 01-.019-.371c0-.041.003-.08.005-.12a3.901 3.901 0 01.137-.89c.052-.206.12-.41.199-.614a6.17 6.17 0 01.407-.85c0-.003.003-.003.003-.005a6.072 6.072 0 01.844-1.147l.005-.005c.046-.056.101-.111.156-.163.219-.219.448-.413.688-.574.092-.066.188-.122.286-.176a2.992 2.992 0 01.768-.303c.104-.023.208-.038.306-.044.142-.012.276-.006.404.018.139.026.268.072.388.137.366.197.625.569.735 1.092.039.188.058.398.055.627z",
    fill: "#A1A1A1"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 41.809a4.099 4.099 0 01-.071.688c-.128.696-.429 1.413-.838 2.056-.256.404-.56.778-.89 1.098a4.554 4.554 0 01-.931.706 3.111 3.111 0 01-.554.246c-.011-.03-.052-.218-.06-.25-.024-.1-.011-.053-.022-.17a2.61 2.61 0 01-.019-.37 4.083 4.083 0 01.142-1.01c.128-.497.339-.997.609-1.47a6.029 6.029 0 01.849-1.153c.046-.056.101-.111.156-.163.303-.303.631-.56.975-.752a2.992 2.992 0 01.558-.245c.016.051.03.105.041.16.038.188.058.4.055.629z",
    fill: "#293237"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M37.942 40.996c.359.314.57.846.562 1.56-.021 1.68-1.244 3.716-2.732 4.549-.647.363-1.238.437-1.697.268.485.425 1.24.45 2.096-.029 1.488-.833 2.711-2.87 2.731-4.547.011-.95-.364-1.58-.96-1.8z",
    fill: "url(#paint2_linear_0_10202)"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M38.17 43.005l-1.68.968.779 2.502c-.043.127-.498-.144-.498-.144l-1.157-1.244-.846 2.075c-.268.066-.088.492-.314.447a1.177 1.177 0 01-.508-.367l.497-2.085-.923.535c.005-.16.019-.318.047-.478.022-.137.111-.596.23-.867l.794-.584-.268-.53a6.072 6.072 0 01.787-1.047l.358.464.664-1.319c.093-.066.016-.01.114-.066a2.992 2.992 0 01.768-.303c.104-.022.208-.038.306-.044l-.68 1.663 1.789-.71s.449.226.446.456c-.005.224-.662.446-.705.678z",
    fill: "#A1A1A1"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M38.87 43.304l-1.719 1.148.631 1.397c-.257.404-.211.335-.541.655l-.966-.938-.991 2.103c-.42.102-.525.098-.831-.06l.65-1.976-1.536.787c-.052-.208-.056-.352-.053-.61.003-.197 0-.265.033-.467l1.704-1.103-.74-1.31c.254-.407.273-.428.603-.75l1.013.947 1.064-2.198c.372-.055.429-.064.751.066l-.643 2.063 1.574-.733c.041.188.031.237.028.467-.002.227.013.28-.031.512z",
    fill: "#D3D3D3"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M36.799 43.972c-.004.37-.273.816-.6 1-.327.182-.588.032-.584-.337.004-.368.273-.816.6-.998.327-.184.589-.032.584.335z",
    fill: "#B6B6B6"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M74.824 19.127l-1.192 1.945-2.907 4.744-1.436 2.343-1.902-1.102c-.016-.008-.031-.018-.046-.027l-.056-.034.002-.003c-.416-.27-.72-.72-.877-1.316a2.862 2.862 0 01-.069-.328 3.837 3.837 0 01-.029-.223c-.004-.04-.009-.079-.011-.12a4.892 4.892 0 01-.012-.369c.029-2.369 1.755-5.242 3.855-6.418a4.21 4.21 0 01.342-.172c.902-.415 1.71-.422 2.312-.085l.005-.009 2.021 1.174z",
    fill: "url(#paint3_linear_0_10202)"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M75.829 21.5c-.029 2.369-1.755 5.242-3.855 6.418-2.1 1.175-3.779.207-3.75-2.162.029-2.369 1.755-5.241 3.855-6.418 2.1-1.175 3.779-.207 3.75 2.162z",
    fill: "#414C5C"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M74.72 22.119a3.997 3.997 0 01-.071.688c-.129.697-.429 1.415-.838 2.056-.257.404-.56.777-.89 1.098a4.554 4.554 0 01-.931.707 2.842 2.842 0 01-.743.297c-.421.102-.8.064-1.106-.095-.008-.006-.019-.01-.027-.015a1.185 1.185 0 01-.311-.244 1.352 1.352 0 01-.188-.256.683.683 0 01-.066-.128 1.498 1.498 0 01-.115-.299 2.37 2.37 0 01-.082-.42 2.616 2.616 0 01-.019-.372c0-.04.003-.078.005-.12a3.957 3.957 0 01.136-.89c.052-.204.12-.41.199-.614a6.17 6.17 0 01.407-.849c0-.003.003-.003.003-.003a6.072 6.072 0 01.844-1.149l.005-.005c.046-.058.101-.111.156-.163a4.678 4.678 0 01.974-.752 3.137 3.137 0 01.557-.245 2.108 2.108 0 01.516-.101c.142-.012.276-.006.404.018.139.024.268.071.388.136.366.197.625.569.734 1.092.043.189.062.399.059.628z",
    fill: "#A1A1A1"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M72.719 21.133a3.997 3.997 0 01-.071.688c-.128.695-.429 1.413-.838 2.055-.257.404-.56.778-.89 1.098a4.554 4.554 0 01-.931.707 3.041 3.041 0 01-.554.246c-.011-.03-.052-.218-.06-.25-.024-.101-.011-.052-.022-.17a2.616 2.616 0 01-.019-.373 4.083 4.083 0 01.142-1.01c.129-.496.339-.996.609-1.468a6.029 6.029 0 01.849-1.153c.046-.058.101-.113.156-.165.303-.303.631-.56.975-.75a3.137 3.137 0 01.557-.247c.016.052.03.107.041.162.04.19.059.4.056.63z",
    fill: "#293237"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M73.761 20.32c.359.314.57.846.562 1.56-.021 1.68-1.243 3.716-2.732 4.549-.647.363-1.238.437-1.697.268.485.425 1.24.45 2.096-.03 1.488-.833 2.711-2.869 2.731-4.548.011-.947-.363-1.578-.96-1.799z",
    fill: "url(#paint4_linear_0_10202)"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M73.989 22.328l-1.68.97.779 2.503c-.043.127-.498-.144-.498-.144l-1.157-1.244-.846 2.075c-.268.066-.088.492-.315.445-.32-.111-.508-.366-.508-.366l.497-2.087-.923.535c.005-.159.019-.317.046-.477.022-.137.111-.596.23-.867l.794-.584-.268-.53a6.072 6.072 0 01.787-1.047l.358.463.664-1.317c.093-.066.016-.011.114-.066a3.137 3.137 0 01.557-.247 2.108 2.108 0 01.516-.101l-.68 1.664 1.789-.71s.449.226.446.454c-.001.225-.658.447-.702.678z",
    fill: "#A1A1A1"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M74.69 22.628l-1.719 1.148.631 1.396c-.256.404-.211.335-.541.655l-.966-.938-.991 2.105c-.42.102-.525.098-.831-.06l.65-1.976-1.536.788c-.052-.207-.056-.354-.053-.61.003-.197 0-.265.033-.467l1.704-1.104-.74-1.312c.254-.407.273-.427.603-.75l1.013.948 1.064-2.197c.372-.055.429-.064.751.066l-.643 2.063 1.574-.732c.041.188.031.238.028.468-.003.224.012.277-.031.51z",
    fill: "#D3D3D3"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M72.618 23.297c-.004.369-.273.816-.6.998-.327.183-.588.032-.584-.336.004-.369.273-.816.6-.998.328-.183.589-.032.584.336z",
    fill: "#B6B6B6"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M78.192 14.047l.036 2.063-2.273 3.305a3.623 3.623 0 00-.376-.473 2.332 2.332 0 00-.848-.549 2.508 2.508 0 00-.973-.183c-.626 0-1.301.203-1.986.578-1.176.665-2.236 1.793-2.988 3.075-.723 1.233-1.176 2.611-1.186 3.884 0 .52.058.992.193 1.407L40.602 42.767c.019-.193.039-.395.039-.588.01-1.079-.289-1.965-.877-2.553a2.527 2.527 0 00-1.822-.742c-.636 0-1.301.202-1.986.587-1.291.724-2.438 1.996-3.2 3.442-.597 1.137-.964 2.36-.973 3.518-.01.472.048.916.164 1.31v.01l-.766.407-2.533-.59-1.638-2.323.863-.541-1.031-4.136 16.135-10.732s3.494-8.21 5.955-10.555c3.146-3 15.583-8.58 15.583-8.58l6.851 2.557 5.245-2.308 1.04 1.226.541 1.871z",
    fill: "#52A51E"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M77.651 12.175l-50.42 28.562 15.745-10.84 28.39-16.639 5.245-2.308 1.04 1.226z",
    fill: "#84CB41"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M67.598 25.747c0 .52.058.992.193 1.407L40.602 42.767c.019-.193.039-.395.039-.588.01-1.079-.289-1.965-.877-2.553a2.385 2.385 0 00-.617-.453l29.637-17.31c-.723 1.233-1.176 2.611-1.186 3.884z",
    fill: "#519E24"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M45.763 38.788l-.006-.215-.111-4.824-.636-3.438.259-.05.639 3.46.108 4.63 11.567-6.282.472-5.042-.808-4.393.025-.044 4.534-7.877 4.507 2.691 1.006 4.454-.006.027-.987 5.563-.259-.047.98-5.535-.968-4.291-4.18-2.497-4.374 7.604.796 4.352-.484 5.203-.065.032-12.009 6.52z",
    fill: "#477413"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M40.603 41.228c.019.188.039.373.037.575 0 .193-.019.395-.039.588L67.79 26.777c-.104-.319-.15-.68-.172-1.064L40.603 41.228z",
    fill: "#546672"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M40.641 41.017c.009-.949-.235-1.736-.69-2.315l-.804.47c.231.116.434.27.617.453.477.477.753 1.157.839 1.97.018-.188.038-.387.038-.578z",
    fill: "#409E4E"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M40.603 41.605c.019.188.039.373.037.575 0 .193-.019.395-.039.587L67.79 27.153c-.104-.317-.15-.68-.172-1.063L40.603 41.605zM79.145 15.829v1.552L78.615 19l-1.33 1.358-.588 1.688-.299.172c.039-.24.058-.471.058-.712.01-.82-.164-1.532-.501-2.091a3.623 3.623 0 00-.376-.473 2.332 2.332 0 00-.848-.549l2.564-1.503.539-.31 1.311-.751zM69.234 14.508l-.845 2.12-1.909 1.09-.212.116-.221.134-.588.357-.482.29-.299.183-.405.24-.327.192-6.757 4.058-.867.52-9.108 5.465-.424.252-2.294 1.378-.26-1.465 3.72-6.794.414-.762 1.224-2.237 13.629-7.489.154-.096.447-.242 5.41 2.69z",
    fill: "#414C5C"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M63.576 12.393l4.478 2.806-.169 1.281-23.11 13.805-.134-.776 5.234-9.585 13.701-7.53z",
    fill: "#529BA3"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M66.197 17.744l-.299.308-.212.116-.222.134-2.959-5.474.135-.337.154-.098.328.164 3.075 5.187zM57.711 22.805l-.868.52-1.48-6.494.877-.433 1.471 6.407zM48.476 21.823v6.47l-.424.25-.096-5.9.414-.762.106-.058z",
    fill: "#414C5C"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M41.281 37.932v1.597l26.264-16.54-.361-.212-25.903 15.155z",
    fill: "#546672"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M41.643 38.144v1.596l25.902-15.156v-1.596L41.643 38.145z",
    fill: "#414C5C"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M10.232 34.478L9.83 30.86l17.175 9.621.77 3.834s-11.43-2.8-17.543-9.837z",
    fill: "#293237"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M27.613 43.72l-.123-.61c-1.371-.483-9.999-3.666-17.131-9.67-.125-.104-.158-.633-.158-.633l-.077.066.032.54.045-.038s.033.526.158.633c7.4 6.227 16.41 9.421 17.254 9.712z",
    fill: "#293237"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M27.613 42.88l-.123-.61c-1.371-.484-9.999-3.668-17.131-9.67-.125-.105-.158-.634-.158-.634l-.077.066.032.54.045-.04s.033.528.158.634c7.4 6.229 16.41 9.423 17.254 9.714z",
    fill: "#293237"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M27.613 42.04l-.123-.61c-1.371-.483-9.999-3.667-17.131-9.67-.125-.106-.158-.634-.158-.634l-.077.066.032.54.045-.04s.033.529.158.633c7.4 6.23 16.41 9.422 17.254 9.714z",
    fill: "#293237"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M27.613 43.871l-.123-.61c-1.371-.483-9.999-3.667-17.131-9.67-.125-.105-.158-.632-.158-.632l-.077.066.032.54.045-.038s.033.527.158.631c7.4 6.228 16.41 9.422 17.254 9.713z",
    fill: "#546672"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M27.613 43.03l-.123-.61c-1.371-.483-9.999-3.666-17.131-9.67-.125-.105-.158-.632-.158-.632l-.077.066.032.54.045-.038s.033.528.158.632c7.4 6.227 16.41 9.422 17.254 9.713z",
    fill: "#546672"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M27.613 42.19l-.123-.61c-1.371-.483-9.999-3.666-17.131-9.67-.125-.105-.158-.631-.158-.631l-.077.066.032.54.045-.04s.033.529.158.633c7.4 6.227 16.41 9.422 17.254 9.712z",
    fill: "#546672"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M27.491 40.74c-1.365-.48-9.924-3.642-17.037-9.594a3.5 3.5 0 00-.173.34c.021.069.046.124.079.151 7.399 6.228 16.409 9.422 17.254 9.713l-.123-.61z",
    fill: "#546672"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M11.078 39.16l17.415 9.913.155-1.507-17.412-9.92-.158 1.514z",
    fill: "#141E25"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M31.783 46.43c-.01.471.048.916.164 1.31l-.79.414-2.66.916.154-1.502-.549-.04c-.54-.038-1.06.35-1.552.129-.116-.058-.232-.116-.337-.173l-16.182-9.186a1.419 1.419 0 01-.443-.385 1.415 1.415 0 01-.299-.76l-.125-2.21.424.23 16.963 9.398.462.26v.067l5.744-2.237v.252c-.598 1.136-.964 2.36-.974 3.517z",
    fill: "#414C5C"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M26.55 44.57v3.084c-.116-.059-.232-.117-.337-.174 0 0-3.306-1.107-7.441-3.305a52.877 52.877 0 01-4.212-2.477 40.332 40.332 0 01-4.53-3.403c-.145-.125-.328-.23-.443-.385v-2.736l16.963 9.395z",
    fill: "#293237"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M27.204 41.1l-3.158-1.498c-.223-.102-.521.107-.501.35l.097 1.166c.033.395.262.72.622.884l2.695 1.232.245-2.134zM13.007 33.486l-2.422-1.89.188 2.588 2.348 1.843a.3.3 0 00.485-.258l-.096-1.337a1.32 1.32 0 00-.503-.946z",
    fill: "#9CB7D2"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M10.774 31.742c.081-.212-.832-.732-.832-.732-.439 1.69.263 2.634.263 2.634l.569.54s-.174-1.988 0-2.441z",
    fill: "#E08A35"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M17.676 37.033c.005.434.322.962.706 1.176.385.215.692.038.687-.396-.005-.434-.322-.96-.706-1.175-.385-.216-.692-.038-.687.395z",
    fill: "#768A99"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M17.478 37.129c.005.434.321.96.706 1.175.385.215.692.038.687-.396-.005-.434-.322-.96-.706-1.175-.385-.215-.693-.038-.687.396z",
    fill: "#C4C4C4"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M32.251 42.404l.505.256-5.091 2.318a1.468 1.468 0 01-1.273-.084s-12.76-5.07-17.01-9.645c-.212-.23-.308-.53-.072-.735l.891-.768s.033.527.158.633c7.77 6.54 17.324 9.738 17.324 9.738l4.568-1.712zM23.72 44.514v.44a.44.44 0 00.28.423l1.883.732c.152.06.341-.084.341-.257v-.123l-1.577-.611a.442.442 0 01-.28-.425v-.316l-.307-.117c-.15-.06-.34.084-.34.254z",
    fill: "#546672"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M24.368 44.377v.316a.44.44 0 00.28.424l1.577.61v-.313a.444.444 0 00-.28-.428l-1.577-.61z",
    fill: "#BED5DF"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M9.911 36.309v.325c0 .173.065.335.168.422l1.127.954c.091.077.205-.021.205-.174v-.11l-.944-.797c-.103-.087-.167-.248-.167-.424v-.215l-.184-.154c-.091-.077-.205.021-.205.172z",
    fill: "#546672"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M10.299 36.29v.215c0 .174.064.337.167.423l.944.797v-.212c0-.177-.065-.338-.168-.425l-.943-.797z",
    fill: "#BED5DF"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M18.791 42.661v1.389a.483.483 0 01-.019.126 52.877 52.877 0 01-4.212-2.477.382.382 0 01-.029-.136v-1.388c0-.28.202-.375.453-.23l3.354 1.956c.251.143.453.49.453.76z",
    fill: "#12181D"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M14.982 42.041c-.25-.145-.452-.485-.452-.758V39.89c0-.273.203-.375.453-.23l3.355 1.96c.25.146.453.486.453.758v1.392c0 .273-.203.376-.452.23l-3.357-1.96z",
    fill: "#D3D3D3"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M18.337 43.908l-3.355-1.96c-.203-.118-.367-.395-.367-.617v-1.39c0-.223.165-.306.367-.188l3.355 1.96c.203.118.368.395.368.617v1.39c-.001.224-.165.306-.368.188z",
    fill: "#EFEC82"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    fill: "#D3A944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.702 42.32c-.004-.22-.166-.489-.366-.605l-3.355-1.96c-.2-.117-.361-.037-.366.178l4.087 2.388zM14.616 41.342a.8.8 0 00.366.605l3.355 1.96c.2.118.361.037.366-.178l-4.087-2.387z"
  }))), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M58.786.634L76.611 10.95l-5.245 2.309L52.448 2.306 56.531.51a2.5 2.5 0 012.255.124z",
    fill: "#98DD49"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M27.204 41.1l-2.962-1.41.078.945c.033.394.262.718.622.884l1.948.89.314-1.309zM13.51 34.431a1.321 1.321 0 00-.504-.944l-1.651-1.29.086 1.186c.025.342.193.657.462.87l1.688 1.324-.081-1.145z",
    fill: "#BED5DF"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M52.448 2.307c6.453 2.256 18.918 10.951 18.918 10.951l-6.851-2.556L46.317.005s4.404 1.698 6.131 2.301z",
    fill: "#414C5C"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M64.443 10.438C56.14 4.904 49.596 1.395 49.596 1.395c1.042.39 2.032.8 2.621 1.005 4.731 1.655 12.481 6.807 16.684 9.596 0 0-3.475-.905-4.458-1.559z",
    fill: "#88D5DE"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M10.243 31.11c7.342 5.657 16.988 9.627 16.988 9.627l15.745-10.902-18.925-10.943L9.889 30.837l.354.273z",
    fill: "#84CB41"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M26.181 21.346s.643 2.078 5.342 4.73c4.699 2.65 7.254 2.57 7.254 2.57l4.199 1.252-18.704-11.006 1.909 2.454z",
    fill: "#414C5C"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M30.921 8.793s5.418 5.18 18.01 10.488c0 0-3.196 5.114-5.955 10.555 0 0-11.246-4.111-18.925-10.942 0 0 3.095-4.705 6.87-10.1z",
    fill: "#414C5C"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M48.476 19.404c-.848 1.119-3.306 5.523-5.638 10.073-1.658-.637-11.508-4.57-18.428-10.66.453-.945 3.402-4.954 6.554-9.61.145.125.357.3.626.52a51.492 51.492 0 004.453 3.2c2.863 1.832 6.94 4.136 12.433 6.477z",
    fill: "#3D7D87"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M13.473 32.807l12.708-11.462s-1.872-2.137-2.461-1.738c-6.769 4.582-12.558 10.658-12.558 10.658l2.311 2.542z",
    fill: "#79A63F"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M13.473 32.807l12.465-11.782-1.887-2.133C17.282 23.476 9.83 30.86 9.83 30.86l3.643 1.947zM26.805 40.568l16.171-10.67-4.199-1.253-16.017 9.66 4.045 2.263z",
    fill: "#98DD49"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.091 29.44l-.289.19c-.148.099-.445.105-.644.015l-2.971-1.322c-.37-.168-.399-.444-.062-.596l.28-.125a.808.808 0 01.59.01l2.936 1.277c.335.146.405.389.16.55z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#84CB41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.78 29.585l.239.072 1.291-.73-.196-.107-1.334.765zM34.145 29.348l.239.07 1.292-.73-.196-.105-1.335.765zM33.511 29.11l.239.07 1.292-.73-.197-.105-1.334.765zM32.877 28.87l.239.072 1.291-.73-.196-.105-1.334.764zM32.284 28.61l.239.072 1.291-.73-.196-.106-1.334.764zM31.787 28.294l.239.07 1.292-.73-.197-.105-1.334.765z"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.101 22.956l.28-.203c.143-.102.398-.084.554.04l2.313 1.826c.288.23.264.56-.05.712l-.262.125a.513.513 0 01-.503-.064l-2.29-1.77c-.261-.203-.28-.495-.042-.666z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#84CB41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.248 22.896l-.192-.104-1.231.753.149.142 1.274-.79zM26.75 23.235l-.193-.104-1.231.752.15.142 1.274-.79zM27.251 23.572l-.193-.104-1.231.753.15.142 1.274-.791zM27.752 23.91l-.192-.105-1.232.753.15.143 1.274-.791zM28.214 24.27l-.192-.104-1.231.753.149.142 1.274-.791zM28.584 24.69l-.192-.105-1.231.753.149.142 1.274-.79z"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    fill: "#95C9B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.502 11.36l-4.477 6.68.134.776 3.43-2.043.913-5.412zM36.043 12.928l-6.024 3.595.993-5.928.578-.867a51.543 51.543 0 004.453 3.2z"
  }))), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M46.316.006C45.593-.277 30.92 8.793 30.92 8.793s5.98 5.622 18.01 10.488l15.583-8.58S52.808 2.548 46.316.006z",
    fill: "#98DD49"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M79.145 15.829l-.942-1.115-.051.79-4.061 2.493.64.395 4.414-2.563z",
    fill: "#546672"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M77.651 12.175c-.147.09-.083.04-.223.136-.122.085-.22.25-.284.38a.99.99 0 00-.095.481V14.8a.464.464 0 00.178.37c.105.082.245-.031.336-.082.141-.076.27-.188.401-.281.152-.11.076-.082.227-.19v-.569l-.54-1.873z",
    fill: "#E08A35"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M41.643 38.144v1.596l-.362-.21v-1.598l.362.212z",
    fill: "#293237"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M32.757 42.911s1.987-2.953 3.64-3.663c1.652-.71 2.963-.148 3.367.377.404.525.888 1.094.863 2.117l-.025 1.024.183-2.03s-.286-3.278-3.69-2.804c-3.404.474-5.307 4.645-5.307 4.645l.969.334z",
    fill: "#546672"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M39.435 38.36c-.48-.19-1.076-.276-1.834-.172-3.403.473-5.261 4.843-5.261 4.843l.333.044c.424-.603 2.292-3.212 3.724-3.827 1.341-.575 2.449-.311 3.038.089.39.137.989 1.125 1.168 3.43l.615-.353c-.238-2.288-.79-3.39-1.783-4.055z",
    fill: "#414C5C"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M74.824 18.43s-2.19-.352-3.492.631c-1.302.985-2.992 3.006-3.173 4.962l-.539 2.067-.225-.247s.221-1.72.397-2.444c.176-.723.557-2.927 3.069-4.65 1.75-1.2 3.231-.752 3.231-.752l.732.433z",
    fill: "#546672"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M67.791 27.154l.327-.23s-.196-1.703.256-3.334 1.747-3.483 3.223-4.221c1.476-.738 2.6-.863 3.228-.53.627.334 1.359.913 1.52 1.565.162.651.463-.253.463-.253l-1.144-1.758-.838.038s-1.251-.29-2.517.098c-1.265.389-3.446 2.332-4.183 5.061-.575 2.13-.505 2.502-.505 2.502l-.436.953.606.108z",
    fill: "#414C5C"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M39.366 35.313l-.56.311a.487.487 0 00-.244.422v.209c0 .188.203.304.366.21l.56-.314a.487.487 0 00.244-.422v-.204a.245.245 0 00-.366-.212z",
    fill: "#E06E18"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M39.468 35.392l-.56.311a.487.487 0 00-.244.422v.209c0 .188.203.304.366.21l.56-.313a.486.486 0 00.243-.422v-.204a.244.244 0 00-.365-.212z",
    fill: "#E0AB35"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M26.986 40.996l.218.104c.023.014.223-.123.266-.132.338-.069.382.291.447.502.079.258.265.43.344.688.07.23.208.75.036 1.014-.069.105-.544.424-.657.372l-.681-.31s-.425-1.229.027-2.238z",
    fill: "#E08A35"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M27.872 18.302c-.208.058-1.598.4-3.088-.122a7.049 7.049 0 00-.374.637c6.92 6.091 16.77 10.024 18.428 10.66.243-.474.755-1.459.999-1.925-3.613-2.215-8.248-4.902-15.965-9.25z",
    fill: "#5B949C"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M50.799 28.976s.068 1.137-1.079 1.446a2.404 2.404 0 01-.684.087c-1.176-.02-2.651.145-2.882-.183-.241-.319-1.388.058-1.388.058a.79.79 0 01-.279-.617c0-.232.087-.453.279-.617l.241-.203.704.029s.029-.107.106-.27c.232-.482.954-1.456 2.834-1.119 2.447.444 2.148 1.389 2.148 1.389z",
    fill: "#3B7E10"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M57.043 25.611l-1.933 1.136c-.001-.37-.063-.59.32-.814 0 0 .596-.412 1.14-.689.51-.258.473.367.473.367zM65.827 20.334l-1.933 1.136c-.001-.37-.063-.59.321-.813 0 0 .596-.413 1.14-.689.509-.26.472.366.472.366z",
    fill: "#414C5C"
  })), _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_10202",
    x1: 64.615,
    x2: 38.906,
    y1: 3.634,
    y2: 70.309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_10202",
    x1: 31.341,
    x2: 36.639,
    y1: 47.606,
    y2: 38.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_0_10202",
    x1: 35.137,
    x2: 38.886,
    y1: 48.014,
    y2: 41.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint3_linear_0_10202",
    x1: 67.161,
    x2: 72.459,
    y1: 26.93,
    y2: 17.754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint4_linear_0_10202",
    x1: 70.957,
    x2: 74.706,
    y1: 27.338,
    y2: 20.845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 278.822,
    y: 214.244,
    width: 79.788,
    height: 51.327,
    viewBox: "0 0 79.79 51.299",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M49.345 20.128c-.247.157-.499.31-.76.462-.174.422-1.996 1.159-2.567 1.49l-2.728 1.583c-1.562.907-2.904 1.883-4.436 2.813l-.123.075c-2.016 1.229-3.986 2.53-5.945 3.846l-1.508 1.016c-.55.37-.664.343-.677.967-.021 1.031 42.222-17.55 42.451-16.55.96 4.187 4.446 4.123 6.736 7.74.252.398-46.176 26.813-47.162 27.245-.566.247-1.154.498-1.772.483-.556-.014-1.082-.244-1.59-.47l-13.323-5.934c-2.726-1.215-12.47-6.188-13.029-6.542-.207-.131-.638-.36-.714-.618-.054-.184.299-.825.452-.659L0 34.198 15.236 23.16c.271-.198.176-.855.229-1.09.2-.892.427-1.782.689-2.669.557-1.886.722-3.982 2.39-5.697.866-.892 2.763-1.678 3.978-2.447a112.057 112.057 0 015.068-2.999 185.822 185.822 0 016.313-3.404l8.944.6 5.364-2.712 1.649.714 1.287 1.288.845 1.707-.042.072.818-.409c.096-.02 2.684 3.713 2.875 4.066.294.542.727 1.066.918 1.623.27.786.994 1.952.615 2.752-.409.86-2.051 1.39-3.012 2.069-1.653 1.167-3.077 2.396-4.819 3.504z",
    fill: "url(#paint0_linear_0_9249)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M26.101 17.678s.972-1.19-.26-3.012c-1.051-1.553-1.844-1.043-1.844-1.043s-1.206.836-.422 2.3c.496.93.983 2.193 1.324 2.193.342-.002.527 1.136.527 1.136l.989-1.028-.314-.546z",
    fill: "#920D01"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M41.248 42.767L34.46 39l8.191-3.422-1.403 7.19zM77.066 22.218l-6.788-3.765 8.192-3.423-1.404 7.188z",
    fill: "#293237"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 39.801l-1.192 1.945-2.908 4.745-1.436 2.343-1.902-1.103a1.873 1.873 0 01-.046-.026l-.056-.033.003-.005c-.416-.27-.72-.718-.877-1.316a2.71 2.71 0 01-.069-.328 3.735 3.735 0 01-.028-.222l-.011-.12a4.417 4.417 0 01-.012-.368c.029-2.37 1.755-5.244 3.854-6.419.116-.063.23-.121.342-.172.902-.415 1.71-.422 2.312-.086l.005-.008 2.021 1.173z",
    fill: "url(#paint1_linear_0_9249)"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M40.655 42.175c-.029 2.37-1.755 5.244-3.855 6.419-2.1 1.175-3.779.207-3.75-2.162.029-2.369 1.755-5.242 3.855-6.418 2.1-1.175 3.779-.208 3.75 2.161z",
    fill: "#414C5C"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M39.547 42.794a3.997 3.997 0 01-.071.689c-.128.696-.429 1.415-.838 2.056-.257.404-.56.777-.89 1.097a4.554 4.554 0 01-.931.707 2.842 2.842 0 01-.743.298c-.42.102-.8.064-1.106-.096-.008-.005-.019-.01-.027-.017a1.185 1.185 0 01-.311-.242 1.328 1.328 0 01-.188-.258.648.648 0 01-.066-.127 1.498 1.498 0 01-.115-.299 2.22 2.22 0 01-.082-.421 2.601 2.601 0 01-.019-.37c0-.041.003-.08.006-.12a3.974 3.974 0 01.136-.891c.052-.206.12-.41.199-.616.112-.288.248-.572.407-.848 0 0 .003-.003.003-.005a6.129 6.129 0 01.844-1.147l.005-.006c.046-.057.101-.112.156-.164.218-.22.448-.414.688-.575.093-.065.189-.123.287-.176.085-.05.169-.09.251-.13.104-.046.208-.085.306-.117a2.128 2.128 0 01.517-.101c.142-.01.276-.005.404.02.139.024.268.07.388.136.366.197.625.568.735 1.092.039.192.058.402.055.632z",
    fill: "#A1A1A1"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M37.545 41.809a3.997 3.997 0 01-.071.688c-.128.697-.429 1.413-.838 2.056-.257.404-.56.778-.89 1.098a4.554 4.554 0 01-.931.706 3.143 3.143 0 01-.554.246c-.011-.03-.051-.218-.06-.25-.025-.1-.011-.053-.022-.17a2.601 2.601 0 01-.019-.37 4.083 4.083 0 01.142-1.012c.128-.497.339-.997.609-1.468a6.029 6.029 0 01.849-1.152c.046-.057.101-.112.156-.164.303-.303.631-.56.975-.752.085-.048.169-.09.251-.129.104-.046.208-.085.306-.117.017.053.03.107.041.162.04.188.059.399.056.628z",
    fill: "#293237"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M38.588 40.996c.359.314.57.846.561 1.56-.02 1.68-1.243 3.716-2.731 4.549-.648.362-1.238.437-1.698.267.485.425 1.241.45 2.096-.03 1.488-.832 2.711-2.868 2.731-4.547.012-.948-.363-1.578-.959-1.799z",
    fill: "url(#paint2_linear_0_9249)"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M38.815 43.005l-1.679.968.778 2.502c-.042.127-.498-.144-.498-.144l-1.157-1.244-.847 2.075c-.268.066-.088.492-.314.447a1.177 1.177 0 01-.508-.367l.497-2.085-.923.535a3.56 3.56 0 01.046-.478c.022-.137.111-.596.23-.867l.794-.584-.268-.53a6.129 6.129 0 01.787-1.048l.358.463.664-1.318c.093-.064.016-.01.115-.066.085-.049.169-.09.251-.129.104-.045.208-.084.306-.116a2.128 2.128 0 01.517-.101l-.68 1.662 1.789-.71s.449.227.446.456c-.003.224-.66.447-.704.678z",
    fill: "#A1A1A1"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M39.516 43.304l-1.719 1.148.631 1.397c-.257.404-.211.335-.542.655l-.966-.938-.991 2.103c-.421.102-.525.098-.831-.06l.65-1.976-1.536.788c-.052-.207-.056-.353-.053-.61.003-.197 0-.264.033-.467l1.704-1.102-.74-1.313c.254-.407.273-.428.604-.75l1.013.948 1.064-2.197c.372-.054.428-.063.751.066l-.643 2.063 1.574-.732c.041.189.031.239.028.468-.003.224.013.277-.031.51z",
    fill: "#D3D3D3"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M37.445 43.972c-.004.37-.273.816-.6 1-.327.182-.588.032-.583-.337.005-.368.273-.816.6-.998.326-.184.587-.034.583.335z",
    fill: "#B6B6B6"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M75.47 19.127l-1.193 1.945-2.908 4.744-1.436 2.341-1.902-1.102-.046-.026-.056-.034.002-.004c-.416-.27-.72-.718-.877-1.316a2.862 2.862 0 01-.097-.55l-.011-.12a4.892 4.892 0 01-.012-.368c.029-2.37 1.755-5.244 3.854-6.419.116-.064.23-.122.342-.171.903-.416 1.71-.424 2.312-.087l.004-.008 2.024 1.174z",
    fill: "url(#paint3_linear_0_9249)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M76.475 21.5c-.029 2.369-1.755 5.242-3.855 6.418-2.1 1.175-3.778.207-3.75-2.162.029-2.369 1.755-5.241 3.855-6.418 2.099-1.175 3.778-.207 3.75 2.162z",
    fill: "#414C5C"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M75.366 22.119a3.997 3.997 0 01-.071.688c-.128.696-.429 1.415-.838 2.056-.257.404-.56.777-.89 1.098a4.554 4.554 0 01-.931.707 2.842 2.842 0 01-.743.297c-.421.102-.8.064-1.106-.096l-.027-.015a1.185 1.185 0 01-.311-.244 1.328 1.328 0 01-.188-.256.707.707 0 01-.066-.128 1.498 1.498 0 01-.115-.299 2.22 2.22 0 01-.082-.421 2.616 2.616 0 01-.019-.372c0-.04.003-.079.006-.12.005-.159.019-.316.046-.477a5.41 5.41 0 01.289-1.027c.112-.29.249-.573.407-.85 0-.003.003-.003.003-.005a6.072 6.072 0 01.844-1.147l.005-.005c.046-.056.101-.111.156-.163a4.566 4.566 0 01.975-.752c.085-.049.169-.09.251-.129.104-.046.208-.084.306-.116a2.108 2.108 0 01.516-.101c.142-.012.276-.006.404.018.139.025.268.071.388.137.366.198.625.569.735 1.093.04.19.059.4.056.629z",
    fill: "#A1A1A1"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M73.365 21.133a3.997 3.997 0 01-.071.688c-.128.696-.429 1.414-.838 2.055-.257.404-.56.778-.89 1.098a4.554 4.554 0 01-.931.707 3.111 3.111 0 01-.554.246c-.011-.03-.052-.218-.06-.25-.025-.1-.011-.052-.022-.17a2.616 2.616 0 01-.019-.372 4.083 4.083 0 01.142-1.01c.128-.497.339-.997.609-1.47a6.029 6.029 0 01.849-1.153c.046-.056.101-.111.156-.163.303-.303.631-.56.975-.752.085-.049.169-.09.251-.128.104-.046.208-.085.306-.117.016.052.03.106.041.16.039.192.058.402.056.63z",
    fill: "#293237"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M74.407 20.32c.359.314.57.846.561 1.56-.02 1.68-1.243 3.716-2.731 4.549-.647.363-1.238.437-1.698.268.485.425 1.241.45 2.096-.03 1.488-.833 2.711-2.869 2.731-4.548.012-.947-.363-1.578-.959-1.799z",
    fill: "url(#paint4_linear_0_9249)"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M74.634 22.328l-1.679.97.778 2.502c-.042.127-.498-.145-.498-.145l-1.157-1.244-.847 2.075c-.268.066-.088.492-.314.447a1.177 1.177 0 01-.508-.366l.497-2.087-.923.535c.005-.159.019-.317.046-.477.022-.137.111-.596.23-.867l.794-.584-.268-.53a6.072 6.072 0 01.787-1.047l.357.463.664-1.319c.093-.064.016-.01.115-.066.085-.049.169-.09.251-.129.104-.046.208-.084.306-.116a2.108 2.108 0 01.516-.101l-.68 1.662 1.789-.71s.449.227.446.457c-.001.224-.658.445-.702.677z",
    fill: "#A1A1A1"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M75.335 22.628l-1.719 1.148.631 1.396c-.257.404-.211.335-.542.655l-.966-.938-.991 2.105c-.421.1-.525.096-.831-.061l.65-1.976-1.535.788c-.052-.207-.056-.353-.054-.61.003-.197 0-.265.033-.466l1.704-1.104-.74-1.31c.254-.407.273-.428.603-.75l1.013.947 1.064-2.198c.372-.055.429-.064.751.066l-.643 2.064 1.574-.733c.041.189.031.239.028.468-.002.224.014.277-.03.51z",
    fill: "#D3D3D3"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M73.264 23.297c-.004.369-.273.816-.6.998-.327.183-.588.033-.584-.336.004-.369.273-.816.6-.998.327-.183.589-.032.584.336z",
    fill: "#B6B6B6"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M78.837 14.047l.036 2.063-2.273 3.303a3.623 3.623 0 00-.376-.471 2.348 2.348 0 00-.848-.55 2.504 2.504 0 00-.973-.183c-.627 0-1.301.201-1.986.578-1.176.665-2.236 1.793-2.988 3.075-.723 1.234-1.176 2.612-1.186 3.884 0 .52.058.992.193 1.407L41.247 42.767c.019-.194.038-.397.038-.589.01-1.078-.289-1.965-.877-2.553a2.368 2.368 0 00-.617-.453 2.524 2.524 0 00-1.205-.29c-.636 0-1.301.203-1.985.589-1.292.723-2.438 1.995-3.2 3.44-.598 1.139-.964 2.361-.974 3.518-.01.472.048.916.164 1.311v.01l-.766.407-2.533-.59-1.638-2.324.862-.54-1.031-4.135L43.62 29.837s3.494-8.21 5.955-10.555c3.146-3 15.583-8.578 15.583-8.578l6.851 2.556 5.246-2.309 1.039 1.228.543 1.87z",
    fill: "#CD3528"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M78.296 12.175L27.877 40.737l15.744-10.84 28.39-16.639 5.246-2.308 1.039 1.226z",
    fill: "#E65C56"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M68.244 25.747c0 .52.058.992.193 1.407L41.248 42.767c.019-.193.038-.396.038-.588.01-1.079-.289-1.965-.877-2.553a2.368 2.368 0 00-.617-.453l29.637-17.31c-.722 1.233-1.176 2.61-1.185 3.884z",
    fill: "#991509"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M46.407 38.79l-.006-.216-.108-4.825-.638-3.439.259-.048.642 3.459.104 4.63 11.568-6.28.472-5.044-.808-4.395.024-.043 4.535-7.876 4.51 2.69 1.003 4.456-.006.025-.985 5.564-.259-.047.978-5.537-.965-4.29-4.183-2.498-4.374 7.604.796 4.354-.485 5.203-.065.032-12.009 6.52z",
    fill: "#9C1E1C"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M41.248 41.228c.02.188.04.373.038.575 0 .193-.019.395-.038.588l27.189-15.614c-.104-.319-.151-.68-.172-1.064L41.248 41.228z",
    fill: "#546672"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M41.286 41.017c.009-.949-.235-1.736-.69-2.315l-.804.47c.232.116.434.27.617.453.477.477.753 1.157.839 1.97.019-.188.038-.387.038-.578z",
    fill: "#409E4E"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M41.248 41.605c.02.187.04.373.038.574 0 .192-.019.395-.038.587l27.189-15.613c-.104-.319-.151-.681-.172-1.063L41.248 41.605zM79.79 15.829v1.552L79.26 19l-1.33 1.358-.588 1.688-.299.172c.039-.24.058-.471.058-.712.009-.82-.164-1.534-.501-2.091a3.623 3.623 0 00-.376-.473 2.348 2.348 0 00-.848-.55l2.564-1.503.54-.308 1.31-.752zM69.88 14.508l-.846 2.12-1.908 1.09-.212.116-.222.134-.588.358-.482.288-.299.183-.404.241-.328.192-6.756 4.058-.868.52-9.108 5.465-.424.252-2.294 1.378-.26-1.465 3.721-6.796.414-.76 1.224-2.237 13.628-7.489.154-.096.448-.242 5.41 2.69z",
    fill: "#414C5C"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M64.221 12.393l4.478 2.806-.168 1.281-23.11 13.805-.134-.776 5.234-9.585 13.7-7.53z",
    fill: "#529BA3"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M66.842 17.742l-.298.31-.213.116-.221.134-2.959-5.474.135-.337.154-.098.328.164 3.074 5.185zM58.356 22.805l-.867.52-1.481-6.494.877-.433 1.471 6.407zM49.122 21.823v6.47l-.424.25-.096-5.9.414-.762.106-.058z",
    fill: "#414C5C"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M41.927 37.932v1.596l26.264-16.54-.362-.21-25.902 15.154z",
    fill: "#546672"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M42.288 38.144v1.596l25.903-15.156v-1.596L42.288 38.144z",
    fill: "#414C5C"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M10.877 34.478l-.402-3.618 17.175 9.62.77 3.836s-11.43-2.8-17.543-9.838z",
    fill: "#293237"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M28.259 43.72l-.123-.61c-1.371-.483-9.999-3.667-17.131-9.67-.125-.105-.158-.633-.158-.633l-.077.066.032.54.045-.038s.033.526.158.632c7.4 6.229 16.41 9.422 17.254 9.712z",
    fill: "#293237"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M28.259 42.88l-.123-.61c-1.371-.484-9.999-3.668-17.131-9.67-.125-.105-.158-.633-.158-.633l-.077.066.032.54.045-.038s.033.528.158.632c7.4 6.227 16.41 9.422 17.254 9.712z",
    fill: "#293237"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M28.259 42.038l-.123-.61c-1.371-.482-9.999-3.666-17.131-9.67-.125-.104-.158-.631-.158-.631l-.077.066.032.54.045-.04s.033.528.158.632c7.4 6.23 16.41 9.422 17.254 9.713z",
    fill: "#293237"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M28.259 43.871l-.123-.61c-1.371-.483-9.999-3.667-17.131-9.67-.125-.105-.158-.633-.158-.633l-.077.067.032.54.045-.04s.033.529.158.633c7.4 6.228 16.41 9.422 17.254 9.713z",
    fill: "#546672"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M28.259 43.03l-.123-.61c-1.371-.483-9.999-3.666-17.131-9.67-.125-.105-.158-.632-.158-.632l-.077.066.032.54.045-.038s.033.528.158.633c7.4 6.226 16.41 9.42 17.254 9.712z",
    fill: "#546672"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M28.259 42.19l-.123-.61c-1.371-.483-9.999-3.666-17.131-9.67-.125-.105-.158-.633-.158-.633l-.077.066.032.54.045-.038s.033.528.158.633c7.4 6.227 16.41 9.422 17.254 9.712z",
    fill: "#546672"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M28.136 40.74c-1.365-.482-9.923-3.642-17.037-9.595a3.5 3.5 0 00-.173.34.342.342 0 00.079.152c7.399 6.227 16.41 9.422 17.254 9.712l-.123-.61z",
    fill: "#546672"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M11.724 39.16l17.415 9.913.154-1.507-17.412-9.92-.157 1.514z",
    fill: "#141E25"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M32.429 46.43c-.01.471.048.916.164 1.31l-.79.414-2.66.915.154-1.503-.549-.038c-.54-.04-1.06.35-1.552.128a13.004 13.004 0 01-.337-.173l-16.182-9.185a1.413 1.413 0 01-.444-.387 1.423 1.423 0 01-.299-.76l-.125-2.21.424.23 16.963 9.398.463.26v.068l5.744-2.237v.252c-.598 1.138-.965 2.361-.974 3.517z",
    fill: "#414C5C"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M27.195 44.57v3.084a13.004 13.004 0 01-.337-.174s-3.306-1.107-7.44-3.305a52.575 52.575 0 01-4.212-2.477 40.454 40.454 0 01-4.53-3.403c-.145-.125-.328-.23-.444-.386v-2.736l16.963 9.396z",
    fill: "#293237"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M27.85 41.1l-3.158-1.498c-.223-.101-.521.107-.501.35l.097 1.166c.033.395.262.72.622.884l2.695 1.232.245-2.134zM13.652 33.486l-2.421-1.89.188 2.588 2.349 1.843a.3.3 0 00.484-.258l-.096-1.337a1.321 1.321 0 00-.504-.946z",
    fill: "#9CB7D2"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M11.419 31.741c.082-.212-.832-.732-.832-.732-.439 1.688.264 2.633.264 2.633l.568.541s-.174-1.987 0-2.442z",
    fill: "#E08A35"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M18.322 37.033c.005.434.322.962.706 1.176.385.215.692.038.687-.396-.005-.434-.322-.96-.706-1.175-.385-.215-.692-.038-.687.395z",
    fill: "#768A99"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M18.123 37.129c.005.434.322.96.706 1.175.385.215.692.038.687-.396-.005-.434-.321-.96-.706-1.175-.385-.215-.692-.038-.687.396z",
    fill: "#C4C4C4"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M32.897 42.404l.505.256-5.091 2.318a1.465 1.465 0 01-1.273-.084s-12.761-5.07-17.01-9.645c-.212-.23-.308-.53-.072-.735l.891-.768s.033.529.158.633c7.77 6.54 17.324 9.736 17.324 9.736l4.568-1.71zM24.366 44.514v.44a.44.44 0 00.28.423l1.883.731c.152.06.342-.084.342-.256v-.124l-1.577-.611a.442.442 0 01-.28-.424v-.316l-.307-.117c-.152-.06-.341.084-.341.254z",
    fill: "#546672"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M25.014 44.377v.316a.44.44 0 00.28.424l1.577.61v-.313a.444.444 0 00-.28-.428l-1.577-.61z",
    fill: "#BED5DF"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M10.557 36.309v.325c0 .173.065.334.168.422l1.127.954c.091.077.204-.021.204-.174v-.11l-.944-.797c-.103-.087-.167-.248-.167-.422v-.215l-.184-.154c-.091-.078-.204.02-.204.17z",
    fill: "#546672"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M10.945 36.29v.215c0 .174.064.335.167.423l.944.797v-.212c0-.177-.064-.338-.167-.425l-.944-.797z",
    fill: "#BED5DF"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M19.437 42.661v1.389a.469.469 0 01-.019.125 52.575 52.575 0 01-4.212-2.477.382.382 0 01-.029-.136v-1.387c0-.28.202-.377.453-.232l3.354 1.956c.25.145.453.492.453.762z",
    fill: "#12181D"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M15.627 42.041c-.249-.145-.453-.485-.453-.758V39.89c0-.273.203-.375.452-.23l3.355 1.96c.249.146.452.486.452.758v1.392c0 .273-.203.376-.452.23l-3.354-1.96z",
    fill: "#D3D3D3"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M18.983 43.908l-3.355-1.96c-.203-.117-.367-.395-.367-.615V39.94c0-.222.165-.305.368-.187l3.355 1.96c.203.119.367.395.367.617v1.391c-.001.221-.165.304-.368.186z",
    fill: "#EFEC82"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    fill: "#D3A944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.348 42.32c-.004-.22-.166-.489-.366-.605l-3.355-1.96c-.2-.117-.361-.037-.366.178l4.087 2.388zM15.262 41.342c.005.22.166.49.366.605l3.355 1.96c.2.118.361.037.365-.178l-4.086-2.387z"
  }))), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M59.432.634L77.257 10.95l-5.246 2.309L53.094 2.306 57.177.51a2.502 2.502 0 012.255.125z",
    fill: "#F26D6B"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M27.85 41.1l-2.962-1.41.078.945c.033.394.262.718.622.884l1.949.89.313-1.309zM14.156 34.431a1.321 1.321 0 00-.504-.944l-1.651-1.29.087 1.188c.025.342.193.657.462.869l1.688 1.324-.082-1.147z",
    fill: "#BED5DF"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M53.094 2.307c6.453 2.256 18.917 10.951 18.917 10.951l-6.851-2.556L46.962.005s4.405 1.697 6.132 2.301z",
    fill: "#414C5C"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M65.088 10.438c-8.303-5.533-14.847-9.043-14.847-9.043 1.042.388 2.032.8 2.621 1.005 4.73 1.655 12.481 6.807 16.684 9.596 0 0-3.475-.904-4.458-1.559z",
    fill: "#88D5DE"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M10.888 31.11c7.342 5.657 16.988 9.627 16.988 9.627l15.745-10.902-18.925-10.942-14.161 11.945.353.272z",
    fill: "#E65C56"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M26.827 21.346s.643 2.078 5.341 4.73c4.699 2.65 7.254 2.57 7.254 2.57l4.199 1.252-18.704-11.006 1.91 2.454z",
    fill: "#414C5C"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M31.566 8.793s5.418 5.18 18.01 10.486c0 0-3.196 5.116-5.955 10.555 0 0-11.247-4.11-18.925-10.942 0 0 3.095-4.704 6.87-10.099z",
    fill: "#414C5C"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M49.122 19.404c-.848 1.119-3.306 5.523-5.638 10.073-1.658-.637-11.508-4.569-18.428-10.66.453-.945 3.402-4.954 6.554-9.61.144.125.357.3.626.521a51.333 51.333 0 004.453 3.2c2.862 1.83 6.939 4.134 12.433 6.476z",
    fill: "#3D7D87"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M14.119 32.807l12.708-11.462s-1.872-2.137-2.462-1.738c-6.769 4.582-12.558 10.657-12.558 10.657l2.312 2.543z",
    fill: "#BA2A2A"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M14.119 32.807l12.465-11.782-1.887-2.133C17.928 23.476 10.476 30.86 10.476 30.86l3.643 1.947zM27.45 40.568l16.171-10.67-4.198-1.252-16.017 9.658 4.044 2.264z",
    fill: "#F26D6B"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.736 29.44l-.289.19c-.148.099-.444.105-.644.015l-2.971-1.322c-.37-.168-.399-.444-.062-.596l.28-.127a.803.803 0 01.59.01l2.936 1.277c.335.148.406.39.16.552z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E65C56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.425 29.585l.239.072 1.291-.73-.196-.105-1.334.764zM34.791 29.348l.239.07 1.291-.73-.196-.105-1.334.765zM34.157 29.11l.239.07 1.291-.73-.196-.105-1.334.765zM33.523 28.87l.239.072 1.291-.73-.196-.105-1.334.764zM32.93 28.61l.239.072 1.291-.73-.196-.106-1.334.764zM32.433 28.294l.239.07 1.291-.73-.196-.105-1.334.765z"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.747 22.956l.28-.203c.143-.102.398-.084.553.04l2.313 1.826c.288.23.265.56-.05.712l-.262.125a.513.513 0 01-.503-.064l-2.29-1.77c-.261-.203-.279-.495-.041-.666z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E65C56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.894 22.896l-.193-.104-1.23.752.149.143 1.274-.79zM27.395 23.235l-.192-.105-1.231.753.149.142 1.274-.79zM27.896 23.572l-.192-.104-1.231.753.149.142 1.274-.791zM28.397 23.91l-.192-.105-1.231.753.149.143 1.274-.791zM28.86 24.27l-.193-.104-1.231.753.15.142 1.274-.791zM29.229 24.69l-.192-.105-1.231.753.15.142 1.273-.79z"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    fill: "#95C9B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.148 11.36l-4.477 6.678.134.777 3.429-2.043.914-5.412zM36.689 12.928l-6.024 3.595.993-5.928.578-.867a51.602 51.602 0 004.453 3.2z"
  }))), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M46.962.006c-.723-.283-15.396 8.787-15.396 8.787s5.98 5.622 18.01 10.486l15.583-8.578S53.454 2.548 46.962.006z",
    fill: "#F26D6B"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M79.79 15.829l-.941-1.115-.052.79-4.06 2.493.639.395 4.414-2.563z",
    fill: "#546672"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M78.296 12.175c-.147.09-.082.04-.222.136-.122.085-.22.25-.284.38a.98.98 0 00-.096.481V14.8a.464.464 0 00.178.37c.105.082.245-.032.336-.082.141-.076.27-.188.401-.282.151-.11.076-.082.227-.19v-.569l-.54-1.87z",
    fill: "#E08A35"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M42.288 38.144v1.596l-.361-.212v-1.596l.361.212z",
    fill: "#293237"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M33.402 42.911s1.987-2.953 3.639-3.663c1.653-.71 2.964-.148 3.367.377.404.525.888 1.094.863 2.117l-.025 1.024.183-2.03s-.286-3.278-3.69-2.804c-3.403.472-5.307 4.645-5.307 4.645l.97.334z",
    fill: "#546672"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M40.08 38.36c-.48-.19-1.076-.276-1.834-.172-3.404.474-5.261 4.843-5.261 4.843l.333.044c.423-.603 2.292-3.212 3.724-3.828 1.342-.575 2.449-.312 3.038.089.39.138.99 1.126 1.168 3.43l.615-.352c-.238-2.288-.79-3.39-1.783-4.055z",
    fill: "#414C5C"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M75.47 18.43s-2.19-.352-3.492.633c-1.302.984-2.993 3.005-3.173 4.962l-.54 2.067-.225-.247s.221-1.72.397-2.444c.176-.723.557-2.927 3.069-4.65 1.75-1.2 3.23-.753 3.23-.753l.734.432z",
    fill: "#546672"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M68.437 27.154l.326-.23s-.196-1.703.256-3.334 1.747-3.483 3.223-4.221c1.476-.738 2.6-.863 3.228-.53.627.334 1.359.912 1.52 1.564.161.652.463-.252.463-.252l-1.145-1.759-.838.038s-1.251-.29-2.517.099c-1.266.387-3.446 2.331-4.183 5.061-.575 2.13-.506 2.502-.506 2.502l-.436.953.609.108z",
    fill: "#414C5C"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M40.012 35.313l-.56.311a.487.487 0 00-.244.422v.209c0 .188.203.304.366.21l.56-.314a.488.488 0 00.243-.422v-.204a.244.244 0 00-.365-.212z",
    fill: "#E06E18"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M40.114 35.392l-.56.311a.487.487 0 00-.244.422v.209c0 .188.203.304.365.21l.56-.313a.486.486 0 00.243-.422v-.206a.243.243 0 00-.364-.21z",
    fill: "#E0AB35"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M27.631 40.996l.218.104c.023.014.223-.123.266-.132.338-.069.382.291.447.502.079.258.265.431.344.688.07.23.208.75.036 1.014-.069.105-.544.424-.656.372l-.681-.31s-.426-1.229.026-2.238z",
    fill: "#E08A35"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M28.518 18.302c-.208.056-1.598.4-3.088-.122a7.049 7.049 0 00-.374.637c6.92 6.09 16.77 10.023 18.428 10.66.243-.474.755-1.459.999-1.927-3.613-2.213-8.248-4.902-15.965-9.248z",
    fill: "#5B949C"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M51.445 28.976s.067 1.137-1.08 1.446a2.404 2.404 0 01-.684.087c-1.176-.02-2.651.145-2.882-.183-.241-.319-1.388.058-1.388.058a.789.789 0 01-.28-.617c0-.232.087-.453.28-.617l.241-.202.703.029s.029-.107.106-.27c.231-.483.954-1.456 2.834-1.119 2.449.442 2.15 1.387 2.15 1.387z",
    fill: "#A62317"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M57.689 25.613l-1.933 1.134c-.001-.37-.063-.588.321-.814 0 0 .596-.41 1.14-.688.509-.259.472.367.472.367zM66.472 20.334l-1.933 1.136c-.001-.37-.063-.59.321-.813 0 0 .596-.413 1.139-.69.51-.258.473.367.473.367z",
    fill: "#414C5C"
  })), _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9249",
    x1: 64.615,
    x2: 38.907,
    y1: 3.905,
    y2: 70.581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_9249",
    x1: 31.987,
    x2: 37.285,
    y1: 47.606,
    y2: 38.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_0_9249",
    x1: 35.783,
    x2: 39.532,
    y1: 48.014,
    y2: 41.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint3_linear_0_9249",
    x1: 67.806,
    x2: 73.104,
    y1: 26.93,
    y2: 17.754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint4_linear_0_9249",
    x1: 71.602,
    x2: 75.351,
    y1: 27.338,
    y2: 20.844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 117.978,
    y: 233.532,
    width: 83.75,
    height: 48.875,
    viewBox: "0 0 83.764 48.873",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M75.894 24.888c.085-.043 7.884-4.746 7.87-4.808-.651-2.923-15.287-13.466-16.689-16.125l-2.731 1.423.398-1.761L62.998.876l-1.015.49L53.962.23 38.31 7.037c-.353.156-1.358-.145-1.731-.182a116.456 116.456 0 00-4.255-.338c-3.019-.181-6.301-.758-9.238.037-1.525.413-3.06 1.714-4.454 2.456-1.865.992-3.687 2.066-5.489 3.169a162.435 162.435 0 00-6.326 4.06l-.546 7.597L0 27.739l.836 1.605 1.787 1.502 2.51 1.279.118-.011-.77.537c-.047.073 27.74 16.264 29.043 16.222 1.402-.046 3.672-1.614 4.883-2.177 2.084-.968 31.756-18.945 37.487-21.808z",
    fill: "url(#paint0_linear_0_9144)"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M11.649 33.92s.771.696 1.049.9c6.352 4.68 18.331 10.588 18.331 10.588l-1.36-1.307-18.02-10.18z",
    fill: "#141E25"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M79.295 19.58l-6.647-3.69 7.024-1.034-.377 4.724zM44.297 40.552l-6.648-3.69 7.024-2.573-.376 6.263z",
    fill: "#293237"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M42.655 37.122l-1.168 1.905-2.847 4.646-1.407 2.294-1.863-1.08c-.015-.007-.03-.017-.045-.026l-.055-.032.003-.004c-.407-.265-.705-.703-.859-1.29-.016-.061-.032-.123-.045-.188-.009-.043-.016-.088-.023-.132a4.62 4.62 0 01-.028-.218l-.011-.117a4.247 4.247 0 01-.011-.361c.028-2.32 1.718-5.134 3.775-6.285.113-.063.224-.12.335-.17.884-.405 1.674-.413 2.264-.083l.004-.008 1.981 1.149z",
    fill: "url(#paint1_linear_0_9144)"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M43.639 39.446c-.029 2.32-1.718 5.134-3.775 6.285-2.056 1.15-3.7.204-3.672-2.116.028-2.32 1.718-5.134 3.775-6.285 2.056-1.151 3.701-.204 3.672 2.116z",
    fill: "#414C5C"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M42.554 40.052a3.932 3.932 0 01-.069.674c-.126.682-.42 1.385-.821 2.013a5.88 5.88 0 01-.872 1.075 4.47 4.47 0 01-.912.693 2.739 2.739 0 01-.727.29c-.412.1-.783.062-1.083-.093-.008-.005-.019-.01-.027-.016a1.193 1.193 0 01-.305-.238 1.38 1.38 0 01-.249-.376 1.5 1.5 0 01-.113-.292.806.806 0 01-.027-.091 2.15 2.15 0 01-.053-.321 2.652 2.652 0 01-.014-.482 3.75 3.75 0 01.134-.872 5.4 5.4 0 01.195-.602c.11-.283.243-.562.398-.832 0-.003.003-.003.003-.005a6.046 6.046 0 01.826-1.123l.005-.005c.045-.056.099-.11.152-.16a4.505 4.505 0 01.955-.736 3.023 3.023 0 01.545-.241 2.175 2.175 0 01.505-.099c.139-.011.27-.005.396.019.136.024.262.069.38.134.358.193.612.556.719 1.069.043.187.062.392.059.617z",
    fill: "#A1A1A1"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M40.594 39.087c-.003.22-.027.447-.069.674-.126.682-.42 1.385-.821 2.013a5.922 5.922 0 01-.872 1.075 4.47 4.47 0 01-.912.693 2.958 2.958 0 01-.543.24c-.011-.028-.05-.212-.058-.245-.024-.1-.011-.051-.022-.166a2.652 2.652 0 01-.019-.364 3.92 3.92 0 01.139-.99 5.94 5.94 0 01.596-1.44 5.883 5.883 0 01.831-1.128c.045-.055.099-.11.152-.16.297-.296.618-.547.955-.734a3.023 3.023 0 01.545-.241 2.618 2.618 0 01.098.773z",
    fill: "#293237"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M41.615 38.292c.351.308.559.829.55 1.528-.02 1.644-1.218 3.638-2.675 4.454-.634.355-1.212.428-1.662.262.475.416 1.215.44 2.052-.028 1.457-.816 2.655-2.81 2.675-4.454.011-.93-.356-1.547-.94-1.762z",
    fill: "url(#paint2_linear_0_9144)"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M41.837 40.258l-1.645.95.762 2.45c-.041.125-.487-.141-.487-.141l-1.133-1.218-.829 2.032c-.262.064-.086.482-.308.436a1.154 1.154 0 01-.497-.36l.487-2.042-.904.524c.005-.155.019-.31.046-.468.021-.134.108-.583.225-.85l.778-.57-.262-.52a6.046 6.046 0 01.77-1.025l.35.455.65-1.291c.091-.064.016-.011.112-.064a3.023 3.023 0 01.545-.241 2.175 2.175 0 01.505-.099l-.666 1.628 1.752-.696s.44.22.437.446c-.002.219-.645.437-.688.664z",
    fill: "#A1A1A1"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M42.523 40.552l-1.683 1.124.618 1.368c-.251.396-.206.329-.53.642l-.946-.918-.97 2.06c-.412.1-.514.096-.814-.06l.637-1.933-1.504.77c-.051-.202-.055-.345-.052-.596.002-.193 0-.26.032-.458l1.669-1.08-.725-1.284c.249-.4.267-.42.591-.734l.992.928 1.042-2.151c.364-.054.42-.063.735.064l-.63 2.02 1.542-.718c.04.184.031.233.028.458-.003.217.011.27-.032.498z",
    fill: "#D3D3D3"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M40.495 41.206c-.004.36-.268.799-.587.978-.32.179-.576.032-.572-.33.004-.36.268-.798.587-.977.321-.18.577-.032.572.329z",
    fill: "#B6B6B6"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M77.732 16.874l-1.168 1.905-2.847 4.646-1.407 2.294-1.863-1.08-.045-.026-.055-.033.002-.004c-.407-.265-.705-.703-.859-1.29a2.744 2.744 0 01-.068-.32 3.597 3.597 0 01-.028-.218l-.011-.117a4.247 4.247 0 01-.011-.361c.028-2.32 1.718-5.134 3.774-6.285a4.21 4.21 0 01.335-.17c.884-.405 1.674-.413 2.264-.083l.005-.008 1.982 1.15z",
    fill: "url(#paint3_linear_0_9144)"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M78.716 19.199c-.029 2.32-1.718 5.134-3.775 6.285-2.056 1.15-3.7.204-3.672-2.116.028-2.32 1.718-5.134 3.775-6.285 2.056-1.152 3.7-.204 3.672 2.116z",
    fill: "#414C5C"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M77.631 19.805a4.035 4.035 0 01-.069.674c-.126.682-.42 1.385-.821 2.014a5.88 5.88 0 01-.872 1.075 4.507 4.507 0 01-.912.693 2.773 2.773 0 01-.727.29c-.412.1-.783.063-1.083-.093l-.027-.016a1.155 1.155 0 01-.305-.238 1.38 1.38 0 01-.249-.377 1.437 1.437 0 01-.112-.292.806.806 0 01-.027-.091 2.15 2.15 0 01-.053-.321 2.82 2.82 0 01-.019-.364c0-.04.003-.077.005-.117a3.578 3.578 0 01.133-.872 5.973 5.973 0 01.593-1.433c0-.003.003-.003.003-.005a5.983 5.983 0 01.826-1.123l.005-.005c.046-.056.099-.11.153-.16a4.505 4.505 0 01.955-.736 3.38 3.38 0 01.246-.126c.102-.046.203-.083.299-.115.072-.021.139-.04.206-.056.102-.022.203-.038.299-.043.139-.01.27-.005.396.019.137.024.262.07.38.134.358.192.612.556.719 1.07.042.183.061.389.058.614z",
    fill: "#A1A1A1"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M75.671 18.839a4.035 4.035 0 01-.069.674c-.126.682-.42 1.385-.821 2.014a5.88 5.88 0 01-.872 1.075 4.507 4.507 0 01-.912.693 2.951 2.951 0 01-.543.24c-.011-.03-.051-.213-.058-.245-.024-.1-.011-.051-.022-.166a2.82 2.82 0 01-.019-.364 4.2 4.2 0 01.05-.585 3.75 3.75 0 01.088-.404c.126-.486.332-.976.596-1.44a5.87 5.87 0 01.831-1.128c.046-.055.099-.11.153-.16.297-.296.617-.547.955-.734a3.38 3.38 0 01.246-.126c.102-.046.203-.083.299-.115a2.601 2.601 0 01.098.771z",
    fill: "#293237"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M76.691 18.044c.351.308.559.829.55 1.528-.02 1.644-1.217 3.638-2.675 4.454-.634.355-1.212.428-1.662.262.475.416 1.215.44 2.052-.028 1.457-.816 2.655-2.81 2.675-4.454.012-.93-.356-1.546-.94-1.762z",
    fill: "url(#paint4_linear_0_9144)"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M76.914 20.01l-1.644.95.762 2.45c-.042.125-.487-.14-.487-.14l-1.133-1.218-.829 2.032c-.262.064-.086.482-.308.436-.313-.11-.497-.36-.497-.36l.487-2.042-.904.524c.005-.155.019-.31.045-.468.021-.134.108-.583.225-.85l.778-.57-.262-.52a5.983 5.983 0 01.77-1.026l.35.454.65-1.291c.091-.064.016-.011.112-.064a3.38 3.38 0 01.246-.126c.102-.046.203-.083.299-.115.072-.021.139-.04.206-.056.102-.022.203-.038.299-.043l-.666 1.629 1.752-.696s.44.222.437.446c-.002.22-.645.437-.688.665z",
    fill: "#A1A1A1"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6 20.305l-1.683 1.124.617 1.368c-.251.396-.207.328-.53.642l-.946-.918-.97 2.06c-.412.1-.514.096-.814-.06l.637-1.933-1.504.77c-.051-.202-.055-.345-.052-.596.003-.192 0-.26.032-.457l1.669-1.08-.725-1.285c.249-.398.268-.42.591-.734l.992.928 1.042-2.151c.364-.054.42-.063.735.064l-.63 2.02 1.542-.717c.04.184.03.233.028.458-.003.216.012.269-.031.497z",
    fill: "#D3D3D3"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M75.572 20.959c-.005.36-.268.799-.588.978-.32.179-.576.032-.572-.33.004-.36.268-.798.588-.977.321-.18.577-.032.572.329z",
    fill: "#B6B6B6"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M18.35 34.202l-5.293-1.61.028-1.761-.028-3.325.53-1.096 7.505-5.285 4.378-9.1 15.541-8.567 7.775 2.496L62.443.018 61.432 5.23l2.176-1.18L62 8.174l-1.683 1.932L18.35 34.202z",
    fill: "#6EDAE0"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M81.26 14.294l-1.614 4.115-.33.378a3.977 3.977 0 00-.264-1.208 2.847 2.847 0 00-.576-.878 2.405 2.405 0 00-.698-.491 2.387 2.387 0 00-.859-.208c-.076-.02-.151-.02-.227-.02-.623 0-1.274.19-1.945.567-1.161.65-2.209 1.756-2.945 3.03a8.372 8.372 0 00-1.038 2.709 6.88 6.88 0 00-.113 1.076c0 .396.038.774.123 1.114L44.233 39.71c.019-.094.019-.198.019-.293.009-.765-.142-1.416-.434-1.944h-.009v-.02a2.433 2.433 0 00-.415-.547 2.103 2.103 0 00-.529-.396 2.081 2.081 0 00-.661-.255.183.183 0 00-.066-.02h-.009a3.033 3.033 0 00-.51-.046c-.623 0-1.274.189-1.953.566-.623.349-1.218.84-1.746 1.416a7.626 7.626 0 00-.736.916c-.632.887-1.114 1.888-1.368 2.898a6.243 6.243 0 00-.236 1.586c0 .245.009.472.047.699l-5.474-2.388v-1.03l.557-3.104.528-1.095 7.503-5.286 4.379-9.108s11.798-10.27 16.14-8.768c2.85.98 7.173 2.709 7.173 2.709l13.657-5.946-.443 4.04-.104.915.661-.35 1.056-.566z",
    fill: "#AC291C"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M79.765 10.148l-13.328 6.045-27.694 15.17-7.505 5.286-.53 1.096 49.347-27.14.039-.348-.329-.11z",
    fill: "#D2463F"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M31.541 41.309l6.379-3.136a7.626 7.626 0 00-.736.916c-.632.887-1.114 1.888-1.368 2.898a6.243 6.243 0 00-.236 1.586c0 .245.009.472.047.699.009.122.028.245.066.368l-2.501 1.435-1.17-.623-.991-.038-1.359-1.095v-2.161l.481-.274 1.388-.575z",
    fill: "#414C5C"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M70.652 23.365c0 .396-.069.819.016 1.159L44.234 39.712c.019-.094.019-.198.019-.293.009-.765-.142-1.416-.434-1.944h-.009v-.02a2.433 2.433 0 00-.415-.547 2.103 2.103 0 00-.529-.396 2.081 2.081 0 00-.661-.255l26.446-14.903 3.152-1.775a8.372 8.372 0 00-1.038 2.709 6.906 6.906 0 00-.113 1.077z",
    fill: "#781005"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M46.969 38.194l-.148-3.66v-3.96l-1.647-5.254.154-.018 9.307-1.185.965 2.355.453 6.116 9.884-5.983.105-4.752-1.037-3.39.247-.077 1.049 3.45-.111 4.917-.059.037-10.306 6.239-.481-6.516-.876-2.115-8.955 1.14 1.567 5.015v3.977l.148 3.655-.259.009z",
    fill: "#7B1613"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M79.763 13.234l.828.512.669.548-2.208 3.285a2.847 2.847 0 00-.576-.878 2.405 2.405 0 00-.698-.491 2.387 2.387 0 00-.859-.208c-.057-.047-.113-.075-.17-.104l1.765-1 1.133-.604.116-1.06z",
    fill: "#546672"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M34.295 40.712l2.888-1.623c-.632.887-1.114 1.888-1.368 2.898l-1.52.849v-2.124zM41.883 29.657l2.131-7.292 15.042-8.337 6.31 2.74-.238 1.656-20.555 11.353-2.69-.12z",
    fill: "#414C5C"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M64.743 17.154l-.132.906-2.331 1.293-.406.217-7.579 4.19-.755.416-6.777 3.738-.944.528-1.485.83-1.151-.462 1.287-6.05.415-.235.642-.35 6.522-3.633.009-.01.736-.415 6.32-3.47 5.629 2.507z",
    fill: "#529BA3"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M46.763 27.914l-.944.528-.934-5.917.642-.35 1.236 5.739zM54.295 23.76l-.755.416-1.491-5.634.009-.01.736-.415 1.501 5.644zM62.053 19.573l-.406.217-1.851-5.033.566.198 1.691 4.618zM81.176 16.559l-1.529 1.85.311.793-.651.378c.009-.123.019-.255.019-.378 0-.141 0-.283-.009-.415a3.977 3.977 0 00-.264-1.208 2.847 2.847 0 00-.576-.878 2.405 2.405 0 00-.698-.491l1.765-1 .661-.35 1.057-.565-.086 2.264zM43.818 37.475h-.009v-.02c0 .01.009.01.009.02z",
    fill: "#414C5C"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M21.092 21.178l17.651 10.239-7.505 5.232-17.651-10.24 7.505-5.231z",
    fill: "#E46766"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M25.488 12.05l-4.395 9.128s4.584 5.409 17.651 10.239l4.377-9.153L25.488 12.05z",
    fill: "#414C5C"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M42.374 22.402l-3.983 8.315c-10.977-4.105-15.696-8.655-16.593-9.59l4.011-8.324s.236.198.679.547c.208.15.453.34.746.547.208.16.434.33.689.509a70.38 70.38 0 003.728 2.483c2.767 1.709 6.41 3.729 10.723 5.513z",
    fill: "#3D7D87"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71 19.929l-1.61.574-.301.625c.897.934 5.616 5.484 16.593 9.589l.784-1.638c-10.162-3.985-14.601-8.25-15.466-9.15z",
    fill: "#5B949C"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M41.439 3.017c-.708-.277-15.951 8.979-15.951 8.979s5.856 5.505 17.637 10.27L59.26 13.49S47.796 5.507 41.439 3.017z",
    fill: "#E46766"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M11.649 31.653l18.02 10.505v2.16c.437-.143-6.156-1.298-18.02-10.397-.45-.345 0-2.268 0-2.268z",
    fill: "#293237"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M31.238 36.649l-.53 1.096-17.651-10.24.53-1.095 17.651 10.239z",
    fill: "#AE1F13"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M12.397 30.962c-.281.162-1.079.467-.544.905 6.783 5.553 17.539 10.13 17.816 10.29l.484-.278-17.756-10.917zM36.362 39.778l-.019.009-.897.444-4.124 2.02a1.609 1.609 0 01-1.255.057l-.396-.151 1.057-.595 5.154-2.454.038-.02.434.68.008.01z",
    fill: "#546672"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M30.709 37.749l-.557 3.105v1.029l-17.65-10.241v-1.02l.557-3.105v-.01l.009.01.586.34 17.055 9.892z",
    fill: "#861910"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M16.371 29.788l11.108 6.4-.146 3.313-3.67-4.38-5.212-3.012-3.423.277 1.343-2.598z",
    fill: "#590404"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M13.654 28.197v1.444c0 .123-.047.293-.132.5-.019.038-.028.066-.047.094-.104.217-.245.293-.34.368-.009.009-.009.009-.019.009a1.361 1.361 0 01-.151.104c-.075.047-.16.085-.236.132-.151.094-.076.019-.227.113v-.557l.443-2.303.057-.283.057.038h.009l.586.34z",
    fill: "#E08A35"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M12.502 30.962l2.525 1.423a.61.61 0 00.846-.262l.682-1.385a.8.8 0 00-.317-1.046l-2.586-1.495-1.15 2.765zM30.132 41.053l-2.983-1.654c-.193-.114-.36-.552-.367-.96l-.029-1.795c-.008-.49.166-.768.398-.637l3.527 1.944-.546 3.102z",
    fill: "#E08A35"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M30.677 37.952c.148-.106.083-.071.225-.16.123-.077.221-.045.286-.002.082.055.096.169.096.346v1.593c0 .127-.047.292-.137.505l-.042.093c-.106.218-.247.292-.339.363-.142.11-.273.17-.405.25-.153.094-.076.02-.229.114v-.556l.545-2.546z",
    fill: "#E08A35"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M19.45 34.538c-.244-.143-.443-.476-.443-.743v-1.363c0-.267.199-.368.443-.225l3.286 1.92c.244.142.443.476.443.743v1.362c0 .267-.199.368-.443.225l-3.286-1.92z",
    fill: "#D3D3D3"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M22.735 36.366l-3.286-1.92c-.198-.115-.359-.386-.36-.603V32.48c0-.217.161-.3.36-.183l3.286 1.92c.199.116.36.386.36.603v1.362c0 .217-.161.299-.36.183z",
    fill: "#EFEC82"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    fill: "#D3A944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.093 34.81a.782.782 0 00-.358-.593l-3.286-1.92c-.196-.114-.354-.035-.358.175l4.002 2.339zM19.091 33.853a.786.786 0 00.358.594l3.286 1.92c.196.115.354.035.358-.175l-4.002-2.34z"
  }))), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M80.09 10.255l-13.654 5.942s-1.236-1.17-3.209-2.727c-2.379-1.888-5.842-4.332-9.505-5.956-1.633-.727-3.303-1.284-4.936-1.557 0 0 12.464-6.301 13.654-5.942 1.067.32 2.096.689 3.087 1.076 5.068 2 9.136 4.747 11.675 6.71 1.859 1.434 2.888 2.454 2.888 2.454z",
    fill: "#D2463F"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M53.209 7.492s6.538 2.838 10.018 5.978c3.48 3.14.225-.034.225-.034s-2.38-4.182-9.624-6.266c-7.245-2.084-.657-1.097-.657-1.097l.038 1.419z",
    fill: "#414C5C"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M80.09 10.255l-13.654 5.942-.019-.01-2.168-1.788 12.953-6.6 2.888 2.456z",
    fill: "#E46766"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M65.527 1.09l-12.318 6.4c-1.633-.726-2.872-.775-4.505-1.05 0 0 12.93-6.55 14.12-6.19 1.066.32 1.712.453 2.703.84z",
    fill: "#AD4848"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M65.527 1.09L52.826 7.256c-1.633-.727-2.406-1.026-4.039-1.3 0 0 12.464-6.3 13.654-5.941a40.49 40.49 0 013.086 1.075z",
    fill: "#E46766"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M55.726 6.639l.325-.175a.815.815 0 01.634-.013l2.624 1.208c.327.152.295.405-.068.544l-.301.115a.832.832 0 01-.576-.01l-2.599-1.166c-.297-.134-.314-.355-.039-.503z",
    fill: "#3E2F37"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    fill: "#D2463F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.042 6.505l-.219-.064-1.422.667.169.097 1.472-.7zM57.612 6.723l-.22-.064-1.421.667.169.097 1.472-.7zM58.181 6.94l-.219-.063-1.421.667.169.096 1.471-.7zM58.751 7.159l-.219-.064-1.422.667.169.096 1.472-.7zM59.275 7.397l-.219-.065-1.421.667.169.097 1.471-.7zM59.694 7.687l-.22-.064-1.421.667.169.096 1.472-.7z"
  }))), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M65.09 12.565l-.318.184c-.163.094-.408.078-.533-.036l-1.871-1.67c-.232-.21-.138-.511.203-.65l.283-.114c.161-.065.367-.04.479.058l1.861 1.618c.211.187.166.454-.104.61z",
    fill: "#3E2F37"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    fill: "#D2463F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.954 12.619l.166.096 1.368-.69-.116-.128-1.418.722zM63.536 12.31l.166.096 1.368-.688-.116-.13-1.418.723zM63.118 12.002l.166.095 1.368-.688-.116-.13-1.418.723zM62.7 11.693l.166.095 1.367-.688-.115-.13-1.418.723zM62.325 11.364l.166.096 1.367-.69-.115-.13-1.418.724zM62.053 10.98l.166.096 1.368-.69-.116-.128-1.418.722z"
  }))), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M69.69 18.105l-.548.304a.477.477 0 00-.239.414v.203c0 .184.199.299.358.207l.549-.307a.478.478 0 00.238-.413v-.201a.239.239 0 00-.358-.207z",
    fill: "#E06E18"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M69.79 18.183l-.548.304a.477.477 0 00-.239.413v.204c0 .184.199.299.358.207l.548-.307a.477.477 0 00.239-.413v-.201a.239.239 0 00-.358-.207z",
    fill: "#E0AB35"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M63.204 13.304c-2.379-1.888-5.862-4.072-9.481-5.79-4.131-1.961-12.284-4.497-12.284-4.497C47.796 5.507 59.26 13.49 59.26 13.49l7.176 2.706s-1.26-1.335-3.232-2.892z",
    fill: "#414C5C"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M59.326 13.315c-.063-.05-8.442-5.871-14.81-9.098 2.745.919 6.67 2.302 9.125 3.468 3.393 1.61 6.924 3.767 9.445 5.768a35.754 35.754 0 012.594 2.258l-6.354-2.396z",
    fill: "#88D5DE"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M31.652 16.89l-3.69 2.039-.038-4.521a71.505 71.505 0 003.728 2.482zM27.235 13.898l-.217 5.559-2.011 1.104-1.151-.463 2.284-6.57.349-.178c.208.15.454.34.746.548z",
    fill: "#95C9B1"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M44.673 35.449v1.564l25.72-16.2-.354-.205-25.366 14.84z",
    fill: "#546672"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M45.027 35.655v1.564l25.366-14.841v-1.564l-25.366 14.84z",
    fill: "#414C5C"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M45.027 35.655v1.564l-.354-.206v-1.564l.354.206z",
    fill: "#293237"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M44.221 39.08c.019.184.038.367.037.564 0 .189-.019.387-.038.576l26.626-15.29c-.102-.312-.147-.667-.168-1.041L44.221 39.08z",
    fill: "#546672"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M44.221 39.45c.019.183.038.366.037.562 0 .188-.019.387-.038.576l26.626-15.29c-.102-.312-.147-.667-.168-1.041L44.221 39.45z",
    fill: "#414C5C"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M43.903 37.277c-.255-.462-.708-.925-1.51-1.208-.236-.085-2.039-.934-4.729 1.916a8.679 8.679 0 00-1.312 1.784c-.009.01-.009.01-.009.019l-.897.444c.085-.226.179-.472.274-.736.047-.132.104-.265.161-.387.991-2.237 3.256-3.954 5.663-3.88 1.368.037 2.039 1.085 2.359 2.048zM44.206 38.843s-.029-.755-.302-1.567c.434.784.302 1.567.302 1.567z",
    fill: "#546672"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M35.692 44.638s-.464-3.614 2.228-6.465c2.691-2.851 4.73-1.795 4.946-1.661.215.134 1.357 1.062 1.356 2.569l-.001 1.507.453-1.304s-.114-3.534-2.661-3.608c-2.548-.074-4.935 1.85-5.819 4.262-.885 2.412-1.254 3.102-1.254 3.102l.752 1.598z",
    fill: "#414C5C"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M77.829 15.498c-1.402-.112-2.658-1.152-5.475 1.487-2.817 2.64-2.276 7.265-2.276 7.265l.137.09c.094-.053.216.079.308.024a6.941 6.941 0 01.131-2.916c.469-1.771 1.808-3.654 3.5-4.898 1.692-1.243 3.428-.578 3.428-.578s1.649-.363.247-.474z",
    fill: "#546672"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M77.841 16.174s-1.736-.665-3.428.578c-1.692 1.243-3.031 3.127-3.5 4.897-.469 1.77-.068 3.22-.068 3.22v.428l-.509-.845s-.477-4.361 2.34-7.001c2.817-2.64 4.314-1.702 5.716-1.59 1.402.112-.551.313-.551.313z",
    fill: "#414C5C"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M23.914 37.076l.004.324a.417.417 0 00.208.352l1.377.8a.162.162 0 00.246-.141l-.001-.091-1.153-.67a.416.416 0 01-.208-.352l-.003-.233-.224-.13a.162.162 0 00-.246.14z",
    fill: "#590404"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M24.384 37.065l.003.233a.417.417 0 00.208.352l1.153.67-.003-.231a.416.416 0 00-.208-.354l-1.153-.67z",
    fill: "#BED5DF"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M13.782 28.65c-.133.059-.134.318-.164.486l-.12.682-.151.859a.377.377 0 00.193.398c.189.102.367.227.571.3.29.106.312-.063.354-.314l.259-1.544.019-.112a.377.377 0 00-.182-.39c-.191-.111-.38-.234-.577-.334-.09-.045-.154-.051-.202-.03z",
    fill: "#E03835"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M14.978 29.357c-.134.063-.132.335-.157.476l-.121.685-.153.87c-.028.16.049.32.193.398l.375.202c.175.094.434.295.514-.001.065-.238.084-.5.124-.742l.189-1.13a.38.38 0 00-.182-.39c-.202-.116-.413-.284-.63-.364-.065-.024-.114-.022-.152-.004z",
    fill: "#E0C5A0"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M27.326 36.444c-.127.06-.102.336-.115.514l-.051.722-.064.91a.451.451 0 00.233.422c.2.108.39.24.601.319.3.11.305-.068.322-.334l.102-1.636.007-.12a.453.453 0 00-.222-.411c-.203-.118-.403-.25-.611-.356-.091-.046-.156-.052-.202-.03z",
    fill: "#E03835"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M28.594 37.193c-.127.068-.099.356-.109.505l-.051.726-.065.92c-.012.17.082.34.233.423.132.07.263.143.395.214.184.1.464.312.514-.001.04-.252.033-.528.049-.786l.075-1.197a.453.453 0 00-.222-.412c-.213-.124-.442-.302-.667-.388-.067-.025-.116-.024-.152-.004z",
    fill: "#E0C5A0"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M68.794 17.48c.101.26.172.533.105.813-.035.15-.105.29-.174.426-.09.177-.16.425-.336.524-.142.08-.314.186-.484.173-.196-.016-.402-.122-.569-.22-.48-.276-.988-.536-1.43-.875-.147-.113-.262-.296-.462-.258-.17.033-.217.076-.388-.027a.857.857 0 01-.324-.351c-.101-.21-.134-.564.079-.712.137-.096.288-.174.434-.257a.678.678 0 01.086-.041c.108-.046.262-.078.326-.187.068-.117.051-.252.176-.338a.525.525 0 01.174-.067c.211-.052.425-.13.645-.132.225-.003.381.108.572.22.429.255.84.539 1.233.845.06.047.119.094.168.15.077.09.126.203.169.315z",
    fill: "#590404"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M66.385 16.593c.791.48 1.799.769 1.901 1.329.104.564-.131 1.286-.792 1.069-.632-.206-1.619-.906-1.619-.906s-.285-1.977.51-1.492z",
    fill: "#D3D3D3"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M49.586 29.502l-1.893 1.11c-.001-.362-.061-.575.314-.795 0 0 .584-.403 1.116-.674.499-.254.463.359.463.359zM58.188 24.333l-1.893 1.11c-.001-.362-.062-.575.314-.795 0 0 .584-.403 1.116-.674.499-.254.463.359.463.359z",
    fill: "#414C5C"
  })), _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_9144",
    x1: 67.834,
    x2: 42.972,
    y1: 1.395,
    y2: 68.971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_9144",
    x1: 35.151,
    x2: 40.339,
    y1: 44.764,
    y2: 35.778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_0_9144",
    x1: 38.868,
    x2: 42.539,
    y1: 45.163,
    y2: 38.804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint3_linear_0_9144",
    x1: 70.228,
    x2: 75.416,
    y1: 24.516,
    y2: 15.531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint4_linear_0_9144",
    x1: 73.945,
    x2: 77.616,
    y1: 24.916,
    y2: 18.557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 690.518,
    y: 259.686,
    width: 33.199,
    height: 18.907,
    viewBox: "0 0 33.217 18.887",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M28.091 18.887l5.126-3.032L5.139 0 0 3.025l28.091 15.862z",
    fill: "url(#paint0_linear_0_14456)"
  })), _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_14456",
    x1: 0,
    x2: 33.218,
    y1: 9.444,
    y2: 9.444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#B4B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#B0AEBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#A3A1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#8E8C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828091"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 718.567,
    y: 242.087,
    width: 14.658,
    height: 41.574,
    viewBox: "0 0 14.597 41.568",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.532v-1.259l8.678 4.991v1.304L0 36.532z",
    fill: "#8E9C9E"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M8.678 40.264l5.918-3.41v1.287l-5.918 3.427v-1.304z",
    fill: "#CCD2D6"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.273l8.678 4.991 5.919-3.41-8.68-5.008L0 35.273z",
    fill: "#EBEBEB"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M1.229 35.21V2.989L8.796 7.34v32.261L1.229 35.21z",
    fill: "#8E9C9E"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M1.229 5.768V4.522l7.567 4.351v1.286L1.229 5.768z",
    fill: "#CF9219"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M8.796 7.341l5.16-2.973v32.245l-5.16 2.988V7.341z",
    fill: "#D9DEE1"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M8.796 8.873l5.16-2.973v1.271l-5.16 2.988V8.873z",
    fill: "#EAC72F"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M1.229 34.482v-1.246l7.567 4.351v1.287l-7.567-4.392z",
    fill: "#CF9219"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M8.796 37.588l5.16-2.974v1.271l-5.16 2.989v-1.286z",
    fill: "#EAC72F"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M1.229 2.989L8.796 7.34l5.161-2.973L6.389 0l-5.16 2.989z",
    fill: "#EBEBEB"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 16.322v-4.773a.287.287 0 00-.437-.245l-2.625 1.561a.664.664 0 00-.326.57v4.809c0 .224.242.36.436.245l2.587-1.532a.736.736 0 00.365-.635z",
    fill: "#3A8ABF"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M10.179 18.427a.23.23 0 01-.234-.23v-4.763c0-.203.109-.394.285-.499l2.588-1.538a.232.232 0 01.351.197v4.691a.725.725 0 01-.356.622l-2.518 1.488a.241.241 0 01-.116.032z",
    fill: "#F4FAFC"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M10.292 13.041a.458.458 0 00-.224.391v4.763c0 .085.092.137.166.093l2.517-1.488a.6.6 0 00.294-.514v-4.691a.109.109 0 00-.166-.093l-2.587 1.539z",
    fill: "#3A8ABF"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M12.633 13.694c0 .365-.073.688-.218.97a1.644 1.644 0 01-.629.668l-.808.488v1.244l-.504.301v-3.432l1.369-.824c.527-.314.79-.119.79.585zm-1.655 1.572l.778-.47a.696.696 0 00.276-.294 1.07 1.07 0 00.091-.477c0-.18-.028-.297-.083-.35-.056-.054-.142-.046-.258.023l-.804.486v1.082z",
    fill: "#F4FAFC"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 7.805v9.118l5.769 3.351v-9.152l-4.836-2.78-.933-.537z",
    fill: "#D9DEE1"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 16.923v.013l5.769 3.35v-9.164l-4.274 4.647-1.495 1.154z",
    fill: "#ADB1B5"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M7.897 18.264l-4.274-2.482v-.013l.727-6.686 3.547 2.039v7.142z",
    fill: "#9CDBE5"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M7.897 16.668l-2.788-1.619v-.008l.474-4.363 2.314 1.331v4.659z",
    fill: "#F4FAFC"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 17.766l.193-.108 5.768 3.317v2.931l-.192.108-5.769-6.248z",
    fill: "#EBEBEB"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M2.516 32.887l-.036-.021v-9.78l5.027 2.891.036.021v9.806l-5.027-2.917zm.11-9.548v9.444l4.773 2.77v-9.469l-4.773-2.745z",
    fill: "#768E91"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.208 11.68l4.672-2.675V33.25l-4.672 2.648V11.68zm4.527-2.424l-4.381 2.508v23.884l4.38-2.483.001-23.909z",
    fill: "#A8A8A8"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.49 33.055a.865.865 0 00.404.672c.22.123.396.022.393-.226a.865.865 0 00-.404-.672c-.22-.123-.396-.022-.393.226z",
    fill: "#929DA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.432 33.161a.765.765 0 00.356.593c.194.109.349.019.346-.199a.765.765 0 00-.356-.593c-.194-.109-.349-.02-.346.199z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49 33.193a.636.636 0 00.297.494c.162.09.291.016.289-.166a.635.635 0 00-.297-.494c-.162-.09-.291-.016-.289.166z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.664 33.291a.26.26 0 00.12.2c.066.037.118.007.117-.067a.26.26 0 00-.12-.2c-.065-.037-.117-.007-.117.067z",
    fill: "#6B777F"
  }))), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 20.666v-2.9l5.769 3.317v2.931l-5.769-3.348z",
    fill: "#AEB3BD"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M7.765 21.212L2.26 18.047v2.489l5.505 3.195v-2.519z",
    fill: "#EAC72F"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M7.603 21.27l-5.182-2.973v2.15l5.182 2.998V21.27z",
    fill: "#AEB3BD"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 7.805l2.074 2.637 3.695 2.114v-1.434L2.128 7.805z",
    fill: "#ADB1B5"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.494 21.793v-1.358l1.824 1.039v1.373l-1.824-1.054z",
    fill: "#DCE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.873 21.307v-.656l1.395.796v.666l-1.395-.806z",
    fill: "#9AA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.031 21.058v-.079l1.198.685v.088l-1.198-.694z",
    fill: "#555D69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.873 21.307l-.379.486v-1.358l.379.216v.656z",
    fill: "#77888B"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.736 19.198v-.436l1.947 1.109v.453l-1.947-1.126z",
    fill: "#A6EA5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.899 19.148v-.107l1.609.925v.115l-1.609-.933z",
    fill: "#464F5C"
  }))), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M8.089 20.975l-.192.108v2.931l.192-.108v-2.931z",
    fill: "#D9DEE1"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.045 21.193v-.907l.638.364v.912l-.638-.369z",
    fill: "#B6BFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.298 21.208l.153.09.003-.642-.157-.092.001.644z",
    fill: "#DCE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.334 21.175l.071.043v-.532l-.073-.044.002.533z",
    fill: "#464F5C"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.18 24.209a.689.689 0 01-.321.535c-.175.098-.315.017-.313-.18a.69.69 0 01.321-.535c.175-.098.315-.018.313.18z",
    fill: "#D1D6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.227 24.292a.61.61 0 01-.283.472c-.154.086-.278.015-.276-.159a.61.61 0 01.283-.472c.154-.086.278-.015.276.159z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.18 24.319a.506.506 0 01-.236.393c-.129.072-.232.013-.23-.132a.508.508 0 01.236-.393c.129-.073.232-.014.23.132z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.041 24.396a.203.203 0 01-.096.159c-.052.029-.094.005-.093-.054a.205.205 0 01.096-.159c.052-.029.094-.005.093.054z",
    fill: "#5C656B"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 504.241,
    y: 365.119,
    width: 33.199,
    height: 18.853,
    viewBox: "0 0 33.218 18.886",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M28.092 18.886l5.126-3.032L5.14 0 0 3.024l28.092 15.862z",
    fill: "url(#paint0_linear_0_12089)"
  })), _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_12089",
    x1: 0.001,
    x2: 33.218,
    y1: 9.443,
    y2: 9.443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#B4B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#B0AEBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#A3A1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#8E8C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828091"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 532.289,
    y: 347.465,
    width: 14.658,
    height: 41.574,
    viewBox: "0 0 14.597 41.567",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.531v-1.258l8.678 4.99v1.304L0 36.531z",
    fill: "#8E9C9E"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M8.678 40.263l5.918-3.409v1.286l-5.918 3.427v-1.304z",
    fill: "#CCD2D6"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.273l8.678 4.99 5.919-3.41-8.68-5.007L0 35.273z",
    fill: "#EBEBEB"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M1.229 35.209V2.988L8.795 7.34v32.261l-7.566-4.392z",
    fill: "#8E9C9E"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M1.229 5.767V4.521l7.566 4.351v1.287L1.229 5.767z",
    fill: "#CF9219"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M8.795 7.34l5.161-2.973v32.245l-5.161 2.989V7.34z",
    fill: "#D9DEE1"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M8.795 8.873l5.161-2.974V7.17l-5.161 2.989V8.873z",
    fill: "#EAC72F"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M1.229 34.482v-1.247l7.566 4.352v1.286l-7.566-4.391z",
    fill: "#CF9219"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M8.795 37.587l5.161-2.973v1.271l-5.161 2.988v-1.286z",
    fill: "#EAC72F"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M1.229 2.988L8.796 7.34l5.161-2.974L6.388 0 1.229 2.988z",
    fill: "#EBEBEB"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 16.321v-4.773a.287.287 0 00-.437-.245l-2.625 1.561a.664.664 0 00-.326.57v4.809c0 .224.242.36.436.245l2.587-1.532a.738.738 0 00.365-.635z",
    fill: "#3A8ABF"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M10.179 18.427a.23.23 0 01-.234-.23v-4.763c0-.203.109-.394.285-.499l2.588-1.538a.232.232 0 01.351.197v4.691a.725.725 0 01-.356.622l-2.517 1.488a.26.26 0 01-.117.032z",
    fill: "#F4FAFC"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M10.292 13.04a.457.457 0 00-.224.391v4.763c0 .085.092.137.166.093l2.517-1.488a.6.6 0 00.294-.514v-4.691a.109.109 0 00-.166-.093l-2.587 1.539z",
    fill: "#3A8ABF"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M12.633 13.694c0 .365-.073.688-.218.97a1.644 1.644 0 01-.629.668l-.808.488v1.244l-.504.301v-3.432l1.369-.824c.527-.314.79-.119.79.585zm-1.655 1.571l.778-.47a.703.703 0 00.276-.294 1.07 1.07 0 00.091-.477c0-.18-.028-.297-.083-.35-.055-.054-.141-.046-.258.023l-.804.486v1.082z",
    fill: "#F4FAFC"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 7.804v9.119l5.769 3.35v-9.152L3.06 8.341l-.932-.537z",
    fill: "#D9DEE1"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 16.923v.012l5.769 3.35v-9.164l-4.274 4.648-1.495 1.154z",
    fill: "#ADB1B5"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M7.897 18.263l-4.274-2.482v-.012l.727-6.687 3.547 2.039v7.142z",
    fill: "#9CDBE5"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M7.897 16.667l-2.788-1.619v-.008l.474-4.362 2.314 1.33v4.659z",
    fill: "#F4FAFC"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 17.765l.193-.107 5.768 3.317v2.93l-.192.108-5.769-6.248z",
    fill: "#EBEBEB"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M2.516 32.887l-.036-.021v-9.78l5.027 2.891.036.021v9.806l-5.027-2.917zm.11-9.549v9.444l4.773 2.77v-9.469l-4.773-2.745z",
    fill: "#768E91"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.208 11.679l4.672-2.675v24.245l-4.671 2.648-.001-24.218zm4.527-2.423l-4.381 2.508v23.884l4.38-2.483.001-23.909z",
    fill: "#A8A8A8"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.49 33.055a.865.865 0 00.404.672c.22.123.396.022.393-.226a.865.865 0 00-.404-.672c-.22-.124-.396-.022-.393.226z",
    fill: "#929DA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.432 33.16a.765.765 0 00.356.593c.194.109.349.019.346-.199a.765.765 0 00-.356-.593c-.194-.109-.349-.02-.346.199z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49 33.193a.635.635 0 00.297.494c.162.09.291.016.289-.166a.635.635 0 00-.297-.494c-.162-.091-.291-.017-.289.166z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.664 33.29a.26.26 0 00.12.2c.065.037.118.006.117-.067a.26.26 0 00-.12-.2c-.065-.037-.118-.006-.117.067z",
    fill: "#6B777F"
  }))), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 20.665v-2.9l5.768 3.318.001 2.93-5.769-3.348z",
    fill: "#AEB3BD"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M7.765 21.212L2.26 18.046v2.489l5.505 3.195v-2.518z",
    fill: "#EAC72F"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M7.603 21.269l-5.182-2.972v2.149l5.182 2.999v-2.176z",
    fill: "#AEB3BD"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M2.128 7.804l2.074 2.637 3.695 2.114v-1.434L2.128 7.804z",
    fill: "#ADB1B5"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.494 21.792v-1.358l1.824 1.039v1.374l-1.824-1.055z",
    fill: "#DCE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.873 21.306v-.656l1.395.796v.667l-1.395-.807z",
    fill: "#9AA7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.031 21.058v-.079l1.198.685v.087l-1.198-.693z",
    fill: "#555D69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.873 21.306l-.379.486v-1.358l.379.216v.656z",
    fill: "#77888B"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.736 19.198v-.437l1.947 1.109v.453l-1.947-1.125z",
    fill: "#A6EA5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.899 19.148v-.108l1.609.925v.115l-1.609-.932z",
    fill: "#464F5C"
  }))), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M8.089 20.975l-.193.108.001 2.93.192-.108v-2.93z",
    fill: "#D9DEE1"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.045 21.192v-.907l.638.364v.912l-.638-.369z",
    fill: "#B6BFC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.298 21.207l.153.09.003-.642-.157-.092.001.644z",
    fill: "#DCE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.334 21.174l.071.043v-.532l-.073-.044.002.533z",
    fill: "#464F5C"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.18 24.208a.687.687 0 01-.321.535c-.175.098-.315.017-.313-.18a.688.688 0 01.321-.535c.175-.098.315-.017.313.18z",
    fill: "#D1D6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.226 24.292a.61.61 0 01-.283.472c-.154.087-.278.015-.276-.159a.61.61 0 01.283-.472c.155-.087.279-.015.276.159z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.18 24.318a.506.506 0 01-.236.393c-.129.072-.232.013-.23-.132a.506.506 0 01.236-.393c.129-.072.232-.013.23.132z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.041 24.395a.204.204 0 01-.095.159c-.052.029-.094.005-.093-.054a.203.203 0 01.096-.159c.051-.028.093-.004.092.054z",
    fill: "#5C656B"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 632.519,
    y: 236.039,
    width: 70.359,
    height: 49.583,
    viewBox: "0 0 70.371 39.355",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M29.862 8.78c.242.153.49.304.745.452.17.414 1.958 1.136 2.518 1.461l2.676 1.553c1.532.89 2.849 1.846 4.351 2.76l.121.073c1.977 1.205 3.91 2.481 5.831 3.773.493.331.986.664 1.479.997.539.363.652.337.664.95.02 1.011-41.414-17.215-41.639-16.235C5.666 8.671 2.247 8.61.001 12.156c-.247.391 45.292 26.301 46.259 26.724.555.242 1.132.49 1.738.474.546-.014 1.061-.24 1.559-.462l13.068-5.82c2.674-1.19 6.783-5.814 7.331-6.162.03-.019.18-.045.415-.077.009-.234-.259-.567-.25-.8A248.9 248.9 0 0150.623 14.31c-2.73-1.816-5.43-3.69-7.931-5.81-1.596-1.354-3.112-2.809-4.818-4.02-1.443-1.027-3.007-1.87-4.566-2.709-1.315-.708-2.66-1.427-4.132-1.68-1.935-.332-3.294.217-4.135 2.074-.88 1.942-.738 2.736.859 4.033 1.23.997 2.632 1.735 3.962 2.581z",
    fill: "url(#paint0_linear_0_14583)"
  })), _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_14583",
    x1: 56.989,
    x2: 37.448,
    y1: 0.942,
    y2: 56.092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 633.787,
    y: 236.039,
    width: 67.982,
    height: 47.676,
    viewBox: "0 0 67.937 47.66",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M52.121 17.162s-.944-1.156.253-2.924c1.021-1.508 1.79-1.013 1.79-1.013s1.17.811.41 2.232c-.482.902-.954 2.13-1.285 2.13-.332-.002-.511 1.102-.511 1.102l-.96-.998.303-.529z",
    fill: "#920D01"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M37.416 41.518l6.59-3.657-7.952-3.323 1.362 6.98zM2.645 21.57l6.589-3.657-7.952-3.323 1.363 6.98z",
    fill: "#293237"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M38.967 38.64l1.157 1.887 2.823 4.606 1.394 2.274 1.846-1.07.045-.027.054-.032-.003-.004c.404-.262.699-.697.852-1.278a3.41 3.41 0 00.095-.533l.011-.117c.008-.116.013-.234.011-.358-.028-2.3-1.703-5.09-3.742-6.23a4.125 4.125 0 00-.332-.168c-.876-.403-1.66-.41-2.244-.083l-.005-.008-1.962 1.14z",
    fill: "url(#paint0_linear_0_8970)"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M37.991 40.943c.028 2.3 1.703 5.09 3.742 6.231 2.038 1.141 3.668.202 3.64-2.098-.028-2.3-1.703-5.089-3.742-6.23-2.038-1.142-3.668-.203-3.64 2.097z",
    fill: "#414C5C"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M39.067 41.544c.003.217.026.443.069.668.125.676.416 1.373.814 1.996.249.393.543.756.864 1.066.284.276.589.51.904.687.249.141.493.236.721.29.408.097.777.06 1.073-.094l.026-.016c.111-.06.212-.138.302-.236.069-.074.13-.156.183-.249a.591.591 0 00.064-.125c.047-.09.082-.185.111-.289a2.108 2.108 0 00.079-.408c.013-.114.021-.233.019-.36 0-.04-.003-.077-.006-.117a3.751 3.751 0 00-.133-.865 5.864 5.864 0 00-.589-1.42s-.003-.003-.003-.005a5.942 5.942 0 00-.819-1.113l-.005-.006a1.735 1.735 0 00-.151-.159 4.486 4.486 0 00-.946-.729 2.823 2.823 0 00-.745-.295 2.001 2.001 0 00-.297-.042 1.499 1.499 0 00-.393.018c-.135.024-.26.07-.376.132-.355.191-.607.551-.713 1.06a2.972 2.972 0 00-.053.611z",
    fill: "#A1A1A1"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M41.01 40.587c.003.217.027.442.069.668.125.676.416 1.373.814 1.996.249.392.543.755.864 1.066.284.276.588.51.904.687.183.103.366.183.538.24.01-.03.05-.213.058-.244.024-.098.011-.05.021-.165.013-.114.021-.233.019-.36a3.751 3.751 0 00-.138-.982 5.891 5.891 0 00-.71-1.627 5.837 5.837 0 00-.705-.918 1.735 1.735 0 00-.151-.159 4.342 4.342 0 00-.946-.729 2.823 2.823 0 00-.541-.239c-.016.05-.029.103-.04.156-.04.183-.058.387-.056.61z",
    fill: "#293237"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 39.798c-.348.305-.553.822-.545 1.515.02 1.63 1.207 3.607 2.652 4.415.629.352 1.202.424 1.648.26-.471.413-1.204.437-2.035-.028-1.445-.809-2.632-2.785-2.652-4.415-.011-.92.353-1.533.932-1.747z",
    fill: "url(#paint1_linear_0_8970)"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M39.778 41.748l1.63.941-.756 2.43c.041.123.483-.14.483-.14l1.123-1.208.822 2.015c.26.063.085.478.305.433.311-.108.493-.356.493-.356l-.483-2.025.896.52a3.356 3.356 0 00-.045-.464c-.021-.133-.108-.578-.223-.842l-.771-.566.26-.516a5.942 5.942 0 00-.764-1.017l-.347.45-.644-1.28c-.09-.063-.016-.01-.111-.064a2.823 2.823 0 00-.745-.295 2.001 2.001 0 00-.297-.042l.66 1.614-1.737-.69s-.436.22-.433.442c.004.22.641.434.684.66z",
    fill: "#A1A1A1"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M39.098 42.04l1.669 1.113-.612 1.356c.249.392.205.326.526.636l.937-.91.962 2.043c.408.098.51.095.807-.06l-.631-1.917 1.49.764c.05-.2.055-.343.053-.592-.003-.19 0-.258-.032-.454l-1.654-1.07.719-1.274c-.247-.395-.265-.415-.586-.728l-.984.92-1.033-2.132c-.361-.053-.416-.062-.729.064l.625 2.003-1.528-.71c-.039.182-.03.231-.028.453.001.216-.014.27.029.494z",
    fill: "#D3D3D3"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M41.108 42.688c.004.358.265.792.583.97.317.178.57.032.566-.327-.004-.358-.265-.792-.582-.97-.318-.177-.571-.03-.567.327z",
    fill: "#B6B6B6"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M4.194 18.567l1.158 1.89 2.823 4.605 1.394 2.274 1.846-1.07.045-.026.054-.032-.003-.004c.404-.263.699-.697.852-1.278a2.686 2.686 0 00.067-.318c.011-.07.02-.142.028-.216l.011-.116c.008-.116.013-.234.011-.358-.028-2.3-1.703-5.089-3.742-6.23a4.127 4.127 0 00-.332-.168c-.876-.403-1.66-.41-2.244-.083l-.004-.008-1.964 1.138z",
    fill: "url(#paint2_linear_0_8970)"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M3.218 20.871c.028 2.3 1.703 5.09 3.742 6.231 2.038 1.141 3.668.202 3.64-2.098-.028-2.299-1.703-5.089-3.742-6.23-2.038-1.142-3.667-.203-3.64 2.097z",
    fill: "#414C5C"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M4.295 21.472c.003.217.026.442.069.668.125.676.416 1.373.814 1.996.249.392.543.756.864 1.066.284.276.589.51.904.687.249.141.493.236.721.29.408.097.777.06 1.074-.094l.026-.016c.111-.06.212-.138.302-.236.069-.074.13-.156.183-.249a.609.609 0 00.064-.124 1.43 1.43 0 00.11-.289c.01-.029.019-.058.027-.09.024-.098.043-.204.053-.318.013-.114.021-.233.019-.36 0-.04-.003-.078-.006-.118a3.727 3.727 0 00-.132-.864 5.978 5.978 0 00-.589-1.42c0-.003-.003-.003-.003-.005a5.943 5.943 0 00-.819-1.114l-.005-.005a1.615 1.615 0 00-.151-.159 4.537 4.537 0 00-.668-.557 2.864 2.864 0 00-.279-.172 2.823 2.823 0 00-.745-.295 1.983 1.983 0 00-.297-.042 1.499 1.499 0 00-.393.018c-.135.024-.26.07-.376.133-.355.191-.607.551-.713 1.06a2.805 2.805 0 00-.054.61z",
    fill: "#A1A1A1"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M6.238 20.515c.003.217.027.443.069.668.125.676.416 1.373.814 1.996.249.392.543.755.864 1.066.284.276.588.51.904.687.183.103.366.183.538.238.01-.029.05-.212.058-.243.024-.098.011-.05.021-.165.013-.114.021-.233.019-.36a3.99 3.99 0 00-.138-.982 5.891 5.891 0 00-.591-1.426 5.842 5.842 0 00-.824-1.119 1.615 1.615 0 00-.151-.159 4.342 4.342 0 00-.946-.729 2.823 2.823 0 00-.541-.239 2.658 2.658 0 00-.096.767z",
    fill: "#293237"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M5.226 19.727c-.348.305-.554.822-.545 1.514.02 1.63 1.207 3.607 2.652 4.415.628.352 1.202.424 1.648.26-.471.413-1.204.437-2.035-.028-1.445-.809-2.632-2.785-2.652-4.415-.011-.92.353-1.533.932-1.746z",
    fill: "url(#paint3_linear_0_8970)"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M5.005 21.676l1.63.941-.756 2.43c.041.123.483-.14.483-.14l1.124-1.209.822 2.015c.26.064.085.478.305.433.311-.109.493-.356.493-.356l-.483-2.025.896.52a3.356 3.356 0 00-.045-.464c-.021-.132-.107-.578-.223-.842l-.771-.566.26-.516a5.942 5.942 0 00-.764-1.017l-.347.451-.644-1.28c-.09-.063-.016-.01-.111-.064a2.823 2.823 0 00-.745-.295 1.983 1.983 0 00-.297-.042l.66 1.614-1.737-.69s-.436.22-.433.443c.003.218.64.434.683.66z",
    fill: "#A1A1A1"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M4.325 21.967l1.669 1.114-.612 1.356c.249.392.205.326.526.636l.937-.91.962 2.043c.408.098.51.094.807-.059l-.631-1.917 1.491.764c.051-.202.055-.343.052-.592-.003-.19 0-.258-.032-.454l-1.654-1.07.718-1.273c-.246-.395-.265-.415-.586-.728l-.983.92-1.033-2.132c-.361-.053-.416-.062-.729.064l.625 2.002-1.528-.71c-.039.182-.03.23-.028.453 0 .215-.014.268.029.493z",
    fill: "#D3D3D3"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M6.335 22.616c.004.358.265.792.582.97.317.178.57.032.567-.327-.004-.358-.265-.792-.582-.97-.317-.177-.571-.03-.567.327z",
    fill: "#B6B6B6"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M.925 13.637L.89 15.64l2.207 3.208c.112-.169.234-.318.365-.458a2.28 2.28 0 01.823-.534c.29-.12.608-.178.945-.178.608 0 1.263.196 1.928.561 1.141.646 2.171 1.741 2.901 2.985.702 1.197 1.141 2.535 1.151 3.771 0 .505-.056.964-.187 1.366l26.395 15.158a5.76 5.76 0 01-.037-.57c-.009-1.049.281-1.91.852-2.48.177-.178.374-.328.599-.44a2.454 2.454 0 011.169-.28c.617 0 1.263.196 1.927.57 1.254.702 2.367 1.937 3.106 3.34.58 1.104.936 2.293.945 3.415.009.458-.047.89-.16 1.273v.01l.745.394 2.459-.573 1.591-2.255-.837-.526 1.001-4.014-15.664-10.419s-3.392-7.969-5.781-10.247c-3.054-2.91-15.128-8.328-15.128-8.328l-6.651 2.483-5.093-2.242-1.009 1.191-.527 1.817z",
    fill: "#CD3528"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45 11.82l48.947 27.727-15.285-10.523-27.56-16.153-5.093-2.242L1.45 11.82z",
    fill: "#E65C56"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M11.209 24.994c0 .505-.056.964-.187 1.366l26.395 15.158a5.76 5.76 0 01-.037-.57c-.01-1.049.281-1.91.852-2.48.177-.178.374-.328.599-.44L10.06 21.224c.7 1.197 1.139 2.535 1.149 3.77z",
    fill: "#991509"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M32.407 37.656l.006-.21.105-4.683.62-3.338-.251-.048-.624 3.36-.101 4.493-11.23-6.097-.458-4.896.784-4.266-.024-.042-4.402-7.646-4.378 2.612-.973 4.325.006.025.955 5.401.252-.045-.95-5.376.938-4.165 4.06-2.424 4.247 7.38-.773 4.227.47 5.052.063.031 11.658 6.33z",
    fill: "#9C1E1C"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M37.415 40.024a4.768 4.768 0 00-.036.557c0 .187.019.384.037.571L11.021 25.994c.101-.309.146-.66.167-1.032l26.227 15.062z",
    fill: "#546672"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M37.379 39.82c-.008-.922.229-1.686.67-2.248l.78.455a2.31 2.31 0 00-.599.44c-.463.463-.731 1.124-.815 1.914a5.888 5.888 0 01-.036-.562z",
    fill: "#409E4E"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M37.415 40.39c-.019.181-.038.362-.036.556 0 .187.019.384.037.571L11.021 26.36c.101-.309.146-.66.167-1.032L37.415 40.39zM0 15.366v1.507l.515 1.572 1.291 1.32.57 1.636.291.168a4.363 4.363 0 01-.056-.692c-.009-.795.159-1.488.487-2.03.112-.169.234-.318.365-.458a2.28 2.28 0 01.823-.534l-2.489-1.46-.524-.299L0 15.366zM9.62 14.083l.822 2.06 1.852 1.057.206.112.215.131.57.346.469.281.29.178.393.234.318.187 6.559 3.94.842.504 8.842 5.306.411.243L33.636 30l.253-1.423-3.612-6.596-.402-.739-1.188-2.17-13.23-7.27-.15-.094-.434-.236-5.253 2.611z",
    fill: "#414C5C"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M15.114 12.031l-4.347 2.724L10.93 16l22.435 13.402.13-.754-5.081-9.304-13.3-7.312z",
    fill: "#529BA3"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M12.569 17.224l.29.3.206.112.216.131 2.872-5.315-.131-.327-.15-.094-.318.16-2.985 5.033zM20.808 22.14l.842.504 1.437-6.304-.852-.422-1.427 6.221zM29.772 21.186v6.28l.412.243.093-5.728-.402-.739-.103-.056z",
    fill: "#414C5C"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M36.757 36.824v1.55L11.26 22.316l.351-.204 25.146 14.712z",
    fill: "#546672"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M36.406 37.03v1.55L11.26 23.865v-1.55L36.406 37.03z",
    fill: "#414C5C"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M66.899 33.471l.39-3.512-16.673 9.34-.748 3.722s11.097-2.719 17.031-9.55z",
    fill: "#293237"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 42.443l.119-.592c1.331-.469 9.707-3.56 16.63-9.388.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.047-15.93 9.147-16.748 9.43z",
    fill: "#293237"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 41.626l.119-.592c1.331-.469 9.707-3.56 16.63-9.388.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.047-15.93 9.148-16.748 9.43z",
    fill: "#293237"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 40.811l.119-.592c1.331-.469 9.707-3.56 16.63-9.388.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.046-15.93 9.147-16.748 9.43z",
    fill: "#293237"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 42.59l.119-.593c1.331-.469 9.707-3.56 16.63-9.387.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.046-15.93 9.147-16.748 9.43z",
    fill: "#546672"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 41.773l.119-.592c1.331-.469 9.707-3.56 16.63-9.387.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.046-15.93 9.147-16.748 9.43z",
    fill: "#546672"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M50.026 40.957l.119-.592c1.331-.469 9.707-3.56 16.63-9.387.121-.102.153-.614.153-.614l.074.064-.031.524-.044-.038s-.032.512-.153.614c-7.182 6.046-15.93 9.147-16.748 9.43z",
    fill: "#546672"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M50.145 39.55c1.325-.468 9.633-3.536 16.539-9.315.063.106.117.218.168.33a.335.335 0 01-.077.147c-7.183 6.046-15.93 9.147-16.75 9.43l.12-.593z",
    fill: "#546672"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M66.077 38.016L49.171 47.64l-.149-1.462 16.903-9.63.152 1.47z",
    fill: "#141E25"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M45.978 45.073c.009.458-.047.89-.159 1.273l.767.402 2.582.89-.15-1.46.533-.037c.524-.038 1.029.34 1.507.124.112-.056.224-.112.328-.168l15.709-8.917c.169-.094.318-.224.43-.374.168-.215.27-.477.29-.739l.122-2.146-.412.224-16.467 9.122-.45.253v.066l-5.575-2.172v.244c.58 1.104.935 2.292.945 3.415z",
    fill: "#414C5C"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M51.058 43.267v2.994c.112-.056.224-.112.328-.168 0 0 3.209-1.076 7.223-3.209a51.412 51.412 0 004.089-2.404 39.006 39.006 0 004.397-3.303c.14-.122.318-.225.43-.374v-2.657l-16.467 9.121z",
    fill: "#293237"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M50.423 39.9l3.066-1.456c.217-.098.506.104.486.341l-.094 1.132a1.017 1.017 0 01-.604.858l-2.616 1.196-.238-2.07zM64.205 32.508l2.351-1.836-.182 2.513-2.28 1.79a.291.291 0 01-.47-.25l.093-1.299a1.28 1.28 0 01.488-.918z",
    fill: "#9CB7D2"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M66.374 30.814c-.08-.205.807-.71.807-.71.426 1.638-.256 2.555-.256 2.555l-.552.525s.17-1.93 0-2.37z",
    fill: "#E08A35"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M59.673 35.951c-.005.422-.312.933-.686 1.142-.373.21-.672.037-.667-.384.005-.42.312-.932.686-1.142.373-.209.672-.037.667.384z",
    fill: "#768A99"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M59.865 36.044c-.005.421-.312.932-.686 1.142-.373.21-.672.037-.667-.385.005-.42.312-.932.686-1.142.374-.209.672-.037.667.385z",
    fill: "#C4C4C4"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M45.523 41.165l-.49.248 4.942 2.25c.403.164.858.134 1.236-.08 0 0 12.388-4.923 16.513-9.366.206-.222.299-.515.07-.712l-.865-.746s-.032.512-.153.614c-7.543 6.35-16.818 9.453-16.818 9.453l-4.435-1.66zM53.805 43.212v.427a.43.43 0 01-.272.412l-1.828.71c-.148.058-.332-.082-.332-.25v-.12l1.531-.593a.43.43 0 00.272-.412v-.307l.298-.114c.147-.057.331.083.331.247z",
    fill: "#546672"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M53.176 43.08v.306a.43.43 0 01-.272.412l-1.531.593v-.304a.43.43 0 01.272-.415l1.531-.593z",
    fill: "#BED5DF"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M67.211 35.247v.316c0 .17-.063.326-.163.41l-1.094.925c-.088.075-.198-.02-.198-.169v-.107l.916-.773c.1-.085.163-.24.163-.41v-.21l.178-.149c.087-.074.198.021.198.167z",
    fill: "#546672"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M66.834 35.23v.21c0 .168-.063.325-.163.41l-.916.773v-.206c0-.172.063-.328.163-.413l.916-.774z",
    fill: "#BED5DF"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M58.59 41.415v1.347c0 .047.009.084.019.121a51.412 51.412 0 004.089-2.404.364.364 0 00.028-.13V39c0-.27-.196-.365-.44-.225l-3.256 1.9c-.243.14-.44.477-.44.74z",
    fill: "#12181D"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M62.288 40.813c.242-.142.439-.472.439-.737v-1.35c0-.266-.197-.366-.439-.224l-3.257 1.903c-.242.141-.439.472-.439.736v1.35c0 .265.197.365.439.224l3.257-1.902z",
    fill: "#D3D3D3"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M59.03 42.625l3.258-1.903c.197-.115.357-.383.357-.598v-1.35c0-.215-.16-.297-.357-.18l-3.257 1.902c-.197.115-.357.383-.357.598v1.351c0 .214.16.295.357.18z",
    fill: "#EFEC82"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    fill: "#D3A944"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.676 41.084a.777.777 0 01.355-.589l3.257-1.903c.194-.113.35-.035.355.174l-3.967 2.318zM62.643 40.133a.778.778 0 01-.355.59l-3.257 1.902c-.194.113-.351.035-.355-.174l3.967-2.318z"
  }))), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M19.764.616L2.46 10.63l5.093 2.242 18.365-10.63L21.954.495a2.422 2.422 0 00-2.19.12z",
    fill: "#F26D6B"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M50.423 39.9l2.876-1.369-.076.916a1.019 1.019 0 01-.604.858l-1.892.865-.304-1.27zM63.716 33.425c.026-.36.204-.695.489-.918l1.603-1.252-.084 1.153a1.182 1.182 0 01-.449.844l-1.639 1.286.08-1.113z",
    fill: "#BED5DF"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M25.916 2.24C19.651 4.43 7.551 12.871 7.551 12.871l6.651-2.483L31.868.005s-4.276 1.65-5.952 2.235z",
    fill: "#414C5C"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M14.272 10.132c8.06-5.37 14.414-8.778 14.414-8.778-1.012.377-1.973.776-2.544.976-4.592 1.606-12.117 6.608-16.197 9.316 0 0 3.373-.878 4.327-1.514z",
    fill: "#88D5DE"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M66.889 30.201c-7.127 5.491-16.492 9.346-16.492 9.346L35.112 28.963 53.484 18.34l13.748 11.596-.343.265z",
    fill: "#E65C56"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M51.415 20.722s-.624 2.02-5.185 4.592c-4.561 2.573-7.042 2.496-7.042 2.496l-4.076 1.215 18.157-10.683-1.854 2.38z",
    fill: "#414C5C"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M46.815 8.536s-5.26 5.028-17.484 10.18c0 0 3.103 4.966 5.781 10.247 0 0 10.918-3.99 18.372-10.623 0 0-3.004-4.566-6.67-9.804z",
    fill: "#414C5C"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M29.772 18.837c.823 1.086 3.209 5.361 5.473 9.778 1.609-.617 11.172-4.435 17.89-10.348-.44-.917-3.303-4.809-6.362-9.329-.14.122-.346.29-.608.505a49.616 49.616 0 01-4.323 3.106c-2.779 1.778-6.737 4.015-12.07 6.288z",
    fill: "#3D7D87"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M63.753 31.85L51.416 20.721s1.817-2.076 2.39-1.688c6.571 4.45 12.19 10.346 12.19 10.346l-2.243 2.47z",
    fill: "#BA2A2A"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M63.753 31.85L51.652 20.41l1.832-2.07c6.57 4.448 13.805 11.617 13.805 11.617l-3.536 1.891zM50.811 39.382L35.112 29.024l4.076-1.215 15.549 9.377-3.926 2.196z",
    fill: "#F26D6B"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.796 28.58l.281.185c.143.095.431.101.625.014l2.884-1.283c.359-.162.387-.43.06-.578l-.272-.122a.778.778 0 00-.573.01l-2.85 1.24c-.325.141-.393.376-.155.533z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E65C56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.069 28.721l-.232.068-1.254-.708.19-.102 1.296.742zM43.685 28.49l-.233.068-1.253-.708.19-.103 1.296.743zM44.3 28.258l-.232.07-1.253-.71.19-.102 1.295.742zM44.916 28.027l-.232.068-1.254-.708.191-.102 1.295.742zM45.491 27.775l-.232.068-1.253-.709.19-.102 1.295.743zM45.974 27.466l-.233.068-1.253-.708.19-.102 1.296.742z"
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.464 22.285l-.272-.196c-.139-.1-.387-.082-.537.038L49.41 23.9c-.279.224-.257.544.048.691l.254.122a.496.496 0 00.488-.062l2.223-1.718c.255-.197.272-.48.041-.647z",
    fill: "#3E2F37"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E65C56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.351 22.227l.187-.1 1.195.73-.146.138-1.236-.768zM50.864 22.555l.187-.1 1.195.73-.145.138-1.237-.768zM50.377 22.883l.187-.1 1.196.73-.146.138-1.237-.768zM49.891 23.211l.187-.1 1.195.73-.145.138-1.237-.768zM49.442 23.56l.187-.1 1.195.73-.145.138-1.237-.768zM49.083 23.968l.187-.1 1.195.73-.145.138-1.237-.768z"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    fill: "#95C9B1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.22 11.028l4.347 6.484-.13.754-3.329-1.984-.887-5.254zM41.842 12.55l5.848 3.49-.964-5.754-.561-.842a50.383 50.383 0 01-4.323 3.106z"
  }))), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M31.869.006c.702-.275 14.946 8.53 14.946 8.53s-5.806 5.457-17.484 10.18l-15.128-8.328S25.567 2.474 31.869.006z",
    fill: "#F26D6B"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.366l.914-1.082.05.767 3.942 2.42-.621.384L0 15.366z",
    fill: "#546672"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45 11.82c.143.087.08.037.216.132.118.082.213.242.275.368.079.16.093.292.093.468v1.579a.455.455 0 01-.173.36c-.102.08-.238-.03-.327-.079-.137-.075-.262-.183-.389-.274-.147-.105-.074-.079-.22-.185v-.552l.525-1.817z",
    fill: "#E08A35"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M36.406 37.03v1.55l.351-.206v-1.55l-.351.205z",
    fill: "#293237"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M45.033 41.658s-1.929-2.867-3.533-3.557c-1.604-.689-2.877-.144-3.269.366-.392.51-.862 1.063-.838 2.057l.024.993-.177-1.97s.278-3.183 3.582-2.724c3.304.46 5.152 4.51 5.152 4.51l-.941.325z",
    fill: "#546672"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M38.55 37.238c.466-.183 1.045-.268 1.78-.166 3.304.46 5.107 4.701 5.107 4.701l-.324.043c-.411-.585-2.225-3.119-3.615-3.716-1.303-.559-2.378-.303-2.949.085-.379.134-.961 1.093-1.134 3.331l-.597-.343c.232-2.22.768-3.29 1.732-3.935z",
    fill: "#414C5C"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M4.194 17.892s2.126-.342 3.39.613c1.264.955 2.905 2.917 3.081 4.817l.524 2.006.218-.24s-.214-1.67-.385-2.372-.541-2.842-2.98-4.515c-1.699-1.165-3.136-.73-3.136-.73l-.712.421z",
    fill: "#546672"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M11.022 26.36l-.317-.223s.19-1.652-.249-3.236c-.439-1.584-1.696-3.382-3.128-4.099-1.433-.716-2.524-.837-3.134-.514-.609.324-1.319.886-1.476 1.518-.157.633-.449-.244-.449-.244l1.11-1.707.815.037s1.215-.28 2.443.095c1.229.376 3.345 2.264 4.06 4.914.558 2.066.491 2.428.491 2.428l.423.925-.589.106z",
    fill: "#414C5C"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M38.616 34.282l.543.302a.47.47 0 01.237.41v.202a.237.237 0 01-.355.205l-.544-.305a.473.473 0 01-.236-.409v-.199a.237.237 0 01.355-.206z",
    fill: "#E06E18"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M38.517 34.36l.543.301a.47.47 0 01.237.41v.202a.237.237 0 01-.355.205l-.544-.305a.472.472 0 01-.236-.409v-.199a.237.237 0 01.355-.206z",
    fill: "#E0AB35"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M50.635 39.798l-.212.101c-.022.013-.217-.12-.258-.128-.328-.067-.371.283-.434.487-.076.25-.258.418-.334.668-.068.223-.202.728-.035.983.067.102.528.411.637.362l.661-.3s.414-1.193-.025-2.173z",
    fill: "#E08A35"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M49.774 17.767c.202.055 1.551.39 2.998-.119.169.266.297.48.363.618-6.718 5.913-16.28 9.731-17.89 10.348-.236-.46-.733-1.416-.97-1.87 3.508-2.147 8.008-4.757 15.499-8.977z",
    fill: "#5B949C"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M27.517 28.128s-.065 1.104 1.048 1.403c.187.056.41.084.664.084 1.14-.019 2.573.141 2.798-.178.234-.309 1.347.056 1.347.056a.766.766 0 00.271-.599.766.766 0 00-.271-.599l-.234-.197-.683.028s-.028-.103-.103-.262c-.225-.468-.926-1.413-2.751-1.085-2.376.432-2.086 1.35-2.086 1.35z",
    fill: "#A62317"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M21.456 24.863l1.877 1.101c.001-.36.061-.57-.311-.789 0 0-.579-.399-1.106-.668-.497-.25-.46.356-.46.356zM12.929 19.74l1.877 1.102c.001-.36.061-.57-.311-.789 0 0-.579-.4-1.106-.669-.496-.25-.46.356-.46.356z",
    fill: "#414C5C"
  })), _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_0_8970",
    x1: 46.406,
    x2: 41.263,
    y1: 46.215,
    y2: 37.307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_0_8970",
    x1: 42.721,
    x2: 39.082,
    y1: 46.611,
    y2: 40.307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_0_8970",
    x1: 11.634,
    x2: 6.491,
    y1: 26.143,
    y2: 17.236
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#2A3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#3C4851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#556773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#51626E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint3_linear_0_8970",
    x1: 7.949,
    x2: 4.309,
    y1: 26.54,
    y2: 20.235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#B7B7B7"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 324.777,
    y: 408.981,
    width: 22.344,
    height: 13.131,
    viewBox: "0 0 22.335 13.115",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M19.239 13.115L.661 12.734 0 2.009l5.185 2.993L13.848 0l8.487 4.9-8.663 5.001 5.567 3.214z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 293.005,
    y: 393.343,
    width: 22.344,
    height: 13.131,
    viewBox: "0 0 22.335 13.114",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M3.097 0l18.577.381.661 10.725-5.184-2.993-8.663 5.001L0 8.215l8.664-5.002L3.097 0z",
    fill: "#F4F4F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingIllustration);
export default __webpack_public_path__ + "static/media/parking_illustration.cb176d019eba4cade19234a1d06bca85.svg";
export { ForwardRef as ReactComponent };